/*! jQuery v3.3.1 | (c) JS Foundation and other contributors | jquery.org/license */
!(function (e, t) {
  'use strict';
  'object' == typeof module && 'object' == typeof module.exports
    ? (module.exports = e.document
        ? t(e, !0)
        : function (e) {
            if (!e.document) throw new Error('jQuery requires a window with a document');
            return t(e);
          })
    : t(e);
})('undefined' != typeof window ? window : this, function (e, t) {
  'use strict';
  var n = [],
    r = e.document,
    i = Object.getPrototypeOf,
    o = n.slice,
    a = n.concat,
    s = n.push,
    u = n.indexOf,
    l = {},
    c = l.toString,
    f = l.hasOwnProperty,
    p = f.toString,
    d = p.call(Object),
    h = {},
    g = function e(t) {
      return 'function' == typeof t && 'number' != typeof t.nodeType;
    },
    y = function e(t) {
      return null != t && t === t.window;
    },
    v = {type: !0, src: !0, noModule: !0};
  function m(e, t, n) {
    var i,
      o = (t = t || r).createElement('script');
    if (((o.text = e), n)) for (i in v) n[i] && (o[i] = n[i]);
    t.head.appendChild(o).parentNode.removeChild(o);
  }
  function x(e) {
    return null == e
      ? e + ''
      : 'object' == typeof e || 'function' == typeof e
      ? l[c.call(e)] || 'object'
      : typeof e;
  }
  var b = '3.3.1',
    w = function (e, t) {
      return new w.fn.init(e, t);
    },
    T = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
  (w.fn = w.prototype =
    {
      jquery: '3.3.1',
      constructor: w,
      length: 0,
      toArray: function () {
        return o.call(this);
      },
      get: function (e) {
        return null == e ? o.call(this) : e < 0 ? this[e + this.length] : this[e];
      },
      pushStack: function (e) {
        var t = w.merge(this.constructor(), e);
        return (t.prevObject = this), t;
      },
      each: function (e) {
        return w.each(this, e);
      },
      map: function (e) {
        return this.pushStack(
          w.map(this, function (t, n) {
            return e.call(t, n, t);
          })
        );
      },
      slice: function () {
        return this.pushStack(o.apply(this, arguments));
      },
      first: function () {
        return this.eq(0);
      },
      last: function () {
        return this.eq(-1);
      },
      eq: function (e) {
        var t = this.length,
          n = +e + (e < 0 ? t : 0);
        return this.pushStack(n >= 0 && n < t ? [this[n]] : []);
      },
      end: function () {
        return this.prevObject || this.constructor();
      },
      push: s,
      sort: n.sort,
      splice: n.splice
    }),
    (w.extend = w.fn.extend =
      function () {
        var e,
          t,
          n,
          r,
          i,
          o,
          a = arguments[0] || {},
          s = 1,
          u = arguments.length,
          l = !1;
        for (
          'boolean' == typeof a && ((l = a), (a = arguments[s] || {}), s++),
            'object' == typeof a || g(a) || (a = {}),
            s === u && ((a = this), s--);
          s < u;
          s++
        )
          if (null != (e = arguments[s]))
            for (t in e)
              (n = a[t]),
                a !== (r = e[t]) &&
                  (l && r && (w.isPlainObject(r) || (i = Array.isArray(r)))
                    ? (i
                        ? ((i = !1), (o = n && Array.isArray(n) ? n : []))
                        : (o = n && w.isPlainObject(n) ? n : {}),
                      (a[t] = w.extend(l, o, r)))
                    : void 0 !== r && (a[t] = r));
        return a;
      }),
    w.extend({
      expando: 'jQuery' + ('3.3.1' + Math.random()).replace(/\D/g, ''),
      isReady: !0,
      error: function (e) {
        throw new Error(e);
      },
      noop: function () {},
      isPlainObject: function (e) {
        var t, n;
        return (
          !(!e || '[object Object]' !== c.call(e)) &&
          (!(t = i(e)) ||
            ('function' == typeof (n = f.call(t, 'constructor') && t.constructor) &&
              p.call(n) === d))
        );
      },
      isEmptyObject: function (e) {
        var t;
        for (t in e) return !1;
        return !0;
      },
      globalEval: function (e) {
        m(e);
      },
      each: function (e, t) {
        var n,
          r = 0;
        if (C(e)) {
          for (n = e.length; r < n; r++) if (!1 === t.call(e[r], r, e[r])) break;
        } else for (r in e) if (!1 === t.call(e[r], r, e[r])) break;
        return e;
      },
      trim: function (e) {
        return null == e ? '' : (e + '').replace(T, '');
      },
      makeArray: function (e, t) {
        var n = t || [];
        return (
          null != e && (C(Object(e)) ? w.merge(n, 'string' == typeof e ? [e] : e) : s.call(n, e)), n
        );
      },
      inArray: function (e, t, n) {
        return null == t ? -1 : u.call(t, e, n);
      },
      merge: function (e, t) {
        for (var n = +t.length, r = 0, i = e.length; r < n; r++) e[i++] = t[r];
        return (e.length = i), e;
      },
      grep: function (e, t, n) {
        for (var r, i = [], o = 0, a = e.length, s = !n; o < a; o++)
          (r = !t(e[o], o)) !== s && i.push(e[o]);
        return i;
      },
      map: function (e, t, n) {
        var r,
          i,
          o = 0,
          s = [];
        if (C(e)) for (r = e.length; o < r; o++) null != (i = t(e[o], o, n)) && s.push(i);
        else for (o in e) null != (i = t(e[o], o, n)) && s.push(i);
        return a.apply([], s);
      },
      guid: 1,
      support: h
    }),
    'function' == typeof Symbol && (w.fn[Symbol.iterator] = n[Symbol.iterator]),
    w.each(
      'Boolean Number String Function Array Date RegExp Object Error Symbol'.split(' '),
      function (e, t) {
        l['[object ' + t + ']'] = t.toLowerCase();
      }
    );
  function C(e) {
    var t = !!e && 'length' in e && e.length,
      n = x(e);
    return (
      !g(e) && !y(e) && ('array' === n || 0 === t || ('number' == typeof t && t > 0 && t - 1 in e))
    );
  }
  var E = (function (e) {
    var t,
      n,
      r,
      i,
      o,
      a,
      s,
      u,
      l,
      c,
      f,
      p,
      d,
      h,
      g,
      y,
      v,
      m,
      x,
      b = 'sizzle' + 1 * new Date(),
      w = e.document,
      T = 0,
      C = 0,
      E = ae(),
      k = ae(),
      S = ae(),
      D = function (e, t) {
        return e === t && (f = !0), 0;
      },
      N = {}.hasOwnProperty,
      A = [],
      j = A.pop,
      q = A.push,
      L = A.push,
      H = A.slice,
      O = function (e, t) {
        for (var n = 0, r = e.length; n < r; n++) if (e[n] === t) return n;
        return -1;
      },
      P =
        'checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped',
      M = '[\\x20\\t\\r\\n\\f]',
      R = '(?:\\\\.|[\\w-]|[^\0-\\xa0])+',
      I =
        '\\[' +
        M +
        '*(' +
        R +
        ')(?:' +
        M +
        '*([*^$|!~]?=)' +
        M +
        '*(?:\'((?:\\\\.|[^\\\\\'])*)\'|"((?:\\\\.|[^\\\\"])*)"|(' +
        R +
        '))|)' +
        M +
        '*\\]',
      W =
        ':(' +
        R +
        ')(?:\\(((\'((?:\\\\.|[^\\\\\'])*)\'|"((?:\\\\.|[^\\\\"])*)")|((?:\\\\.|[^\\\\()[\\]]|' +
        I +
        ')*)|.*)\\)|)',
      $ = new RegExp(M + '+', 'g'),
      B = new RegExp('^' + M + '+|((?:^|[^\\\\])(?:\\\\.)*)' + M + '+$', 'g'),
      F = new RegExp('^' + M + '*,' + M + '*'),
      _ = new RegExp('^' + M + '*([>+~]|' + M + ')' + M + '*'),
      z = new RegExp('=' + M + '*([^\\]\'"]*?)' + M + '*\\]', 'g'),
      X = new RegExp(W),
      U = new RegExp('^' + R + '$'),
      V = {
        ID: new RegExp('^#(' + R + ')'),
        CLASS: new RegExp('^\\.(' + R + ')'),
        TAG: new RegExp('^(' + R + '|[*])'),
        ATTR: new RegExp('^' + I),
        PSEUDO: new RegExp('^' + W),
        CHILD: new RegExp(
          '^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(' +
            M +
            '*(even|odd|(([+-]|)(\\d*)n|)' +
            M +
            '*(?:([+-]|)' +
            M +
            '*(\\d+)|))' +
            M +
            '*\\)|)',
          'i'
        ),
        bool: new RegExp('^(?:' + P + ')$', 'i'),
        needsContext: new RegExp(
          '^' +
            M +
            '*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(' +
            M +
            '*((?:-\\d)?\\d*)' +
            M +
            '*\\)|)(?=[^-]|$)',
          'i'
        )
      },
      G = /^(?:input|select|textarea|button)$/i,
      Y = /^h\d$/i,
      Q = /^[^{]+\{\s*\[native \w/,
      J = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
      K = /[+~]/,
      Z = new RegExp('\\\\([\\da-f]{1,6}' + M + '?|(' + M + ')|.)', 'ig'),
      ee = function (e, t, n) {
        var r = '0x' + t - 65536;
        return r !== r || n
          ? t
          : r < 0
          ? String.fromCharCode(r + 65536)
          : String.fromCharCode((r >> 10) | 55296, (1023 & r) | 56320);
      },
      te = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
      ne = function (e, t) {
        return t
          ? '\0' === e
            ? '\ufffd'
            : e.slice(0, -1) + '\\' + e.charCodeAt(e.length - 1).toString(16) + ' '
          : '\\' + e;
      },
      re = function () {
        p();
      },
      ie = me(
        function (e) {
          return !0 === e.disabled && ('form' in e || 'label' in e);
        },
        {dir: 'parentNode', next: 'legend'}
      );
    try {
      L.apply((A = H.call(w.childNodes)), w.childNodes), A[w.childNodes.length].nodeType;
    } catch (e) {
      L = {
        apply: A.length
          ? function (e, t) {
              q.apply(e, H.call(t));
            }
          : function (e, t) {
              var n = e.length,
                r = 0;
              while ((e[n++] = t[r++]));
              e.length = n - 1;
            }
      };
    }
    function oe(e, t, r, i) {
      var o,
        s,
        l,
        c,
        f,
        h,
        v,
        m = t && t.ownerDocument,
        T = t ? t.nodeType : 9;
      if (((r = r || []), 'string' != typeof e || !e || (1 !== T && 9 !== T && 11 !== T))) return r;
      if (!i && ((t ? t.ownerDocument || t : w) !== d && p(t), (t = t || d), g)) {
        if (11 !== T && (f = J.exec(e)))
          if ((o = f[1])) {
            if (9 === T) {
              if (!(l = t.getElementById(o))) return r;
              if (l.id === o) return r.push(l), r;
            } else if (m && (l = m.getElementById(o)) && x(t, l) && l.id === o) return r.push(l), r;
          } else {
            if (f[2]) return L.apply(r, t.getElementsByTagName(e)), r;
            if ((o = f[3]) && n.getElementsByClassName && t.getElementsByClassName)
              return L.apply(r, t.getElementsByClassName(o)), r;
          }
        if (n.qsa && !S[e + ' '] && (!y || !y.test(e))) {
          if (1 !== T) (m = t), (v = e);
          else if ('object' !== t.nodeName.toLowerCase()) {
            (c = t.getAttribute('id')) ? (c = c.replace(te, ne)) : t.setAttribute('id', (c = b)),
              (s = (h = a(e)).length);
            while (s--) h[s] = '#' + c + ' ' + ve(h[s]);
            (v = h.join(',')), (m = (K.test(e) && ge(t.parentNode)) || t);
          }
          if (v)
            try {
              return L.apply(r, m.querySelectorAll(v)), r;
            } catch (e) {
            } finally {
              c === b && t.removeAttribute('id');
            }
        }
      }
      return u(e.replace(B, '$1'), t, r, i);
    }
    function ae() {
      var e = [];
      function t(n, i) {
        return e.push(n + ' ') > r.cacheLength && delete t[e.shift()], (t[n + ' '] = i);
      }
      return t;
    }
    function se(e) {
      return (e[b] = !0), e;
    }
    function ue(e) {
      var t = d.createElement('fieldset');
      try {
        return !!e(t);
      } catch (e) {
        return !1;
      } finally {
        t.parentNode && t.parentNode.removeChild(t), (t = null);
      }
    }
    function le(e, t) {
      var n = e.split('|'),
        i = n.length;
      while (i--) r.attrHandle[n[i]] = t;
    }
    function ce(e, t) {
      var n = t && e,
        r = n && 1 === e.nodeType && 1 === t.nodeType && e.sourceIndex - t.sourceIndex;
      if (r) return r;
      if (n) while ((n = n.nextSibling)) if (n === t) return -1;
      return e ? 1 : -1;
    }
    function fe(e) {
      return function (t) {
        return 'input' === t.nodeName.toLowerCase() && t.type === e;
      };
    }
    function pe(e) {
      return function (t) {
        var n = t.nodeName.toLowerCase();
        return ('input' === n || 'button' === n) && t.type === e;
      };
    }
    function de(e) {
      return function (t) {
        return 'form' in t
          ? t.parentNode && !1 === t.disabled
            ? 'label' in t
              ? 'label' in t.parentNode
                ? t.parentNode.disabled === e
                : t.disabled === e
              : t.isDisabled === e || (t.isDisabled !== !e && ie(t) === e)
            : t.disabled === e
          : 'label' in t && t.disabled === e;
      };
    }
    function he(e) {
      return se(function (t) {
        return (
          (t = +t),
          se(function (n, r) {
            var i,
              o = e([], n.length, t),
              a = o.length;
            while (a--) n[(i = o[a])] && (n[i] = !(r[i] = n[i]));
          })
        );
      });
    }
    function ge(e) {
      return e && 'undefined' != typeof e.getElementsByTagName && e;
    }
    (n = oe.support = {}),
      (o = oe.isXML =
        function (e) {
          var t = e && (e.ownerDocument || e).documentElement;
          return !!t && 'HTML' !== t.nodeName;
        }),
      (p = oe.setDocument =
        function (e) {
          var t,
            i,
            a = e ? e.ownerDocument || e : w;
          return a !== d && 9 === a.nodeType && a.documentElement
            ? ((d = a),
              (h = d.documentElement),
              (g = !o(d)),
              w !== d &&
                (i = d.defaultView) &&
                i.top !== i &&
                (i.addEventListener
                  ? i.addEventListener('unload', re, !1)
                  : i.attachEvent && i.attachEvent('onunload', re)),
              (n.attributes = ue(function (e) {
                return (e.className = 'i'), !e.getAttribute('className');
              })),
              (n.getElementsByTagName = ue(function (e) {
                return e.appendChild(d.createComment('')), !e.getElementsByTagName('*').length;
              })),
              (n.getElementsByClassName = Q.test(d.getElementsByClassName)),
              (n.getById = ue(function (e) {
                return (
                  (h.appendChild(e).id = b), !d.getElementsByName || !d.getElementsByName(b).length
                );
              })),
              n.getById
                ? ((r.filter.ID = function (e) {
                    var t = e.replace(Z, ee);
                    return function (e) {
                      return e.getAttribute('id') === t;
                    };
                  }),
                  (r.find.ID = function (e, t) {
                    if ('undefined' != typeof t.getElementById && g) {
                      var n = t.getElementById(e);
                      return n ? [n] : [];
                    }
                  }))
                : ((r.filter.ID = function (e) {
                    var t = e.replace(Z, ee);
                    return function (e) {
                      var n = 'undefined' != typeof e.getAttributeNode && e.getAttributeNode('id');
                      return n && n.value === t;
                    };
                  }),
                  (r.find.ID = function (e, t) {
                    if ('undefined' != typeof t.getElementById && g) {
                      var n,
                        r,
                        i,
                        o = t.getElementById(e);
                      if (o) {
                        if ((n = o.getAttributeNode('id')) && n.value === e) return [o];
                        (i = t.getElementsByName(e)), (r = 0);
                        while ((o = i[r++]))
                          if ((n = o.getAttributeNode('id')) && n.value === e) return [o];
                      }
                      return [];
                    }
                  })),
              (r.find.TAG = n.getElementsByTagName
                ? function (e, t) {
                    return 'undefined' != typeof t.getElementsByTagName
                      ? t.getElementsByTagName(e)
                      : n.qsa
                      ? t.querySelectorAll(e)
                      : void 0;
                  }
                : function (e, t) {
                    var n,
                      r = [],
                      i = 0,
                      o = t.getElementsByTagName(e);
                    if ('*' === e) {
                      while ((n = o[i++])) 1 === n.nodeType && r.push(n);
                      return r;
                    }
                    return o;
                  }),
              (r.find.CLASS =
                n.getElementsByClassName &&
                function (e, t) {
                  if ('undefined' != typeof t.getElementsByClassName && g)
                    return t.getElementsByClassName(e);
                }),
              (v = []),
              (y = []),
              (n.qsa = Q.test(d.querySelectorAll)) &&
                (ue(function (e) {
                  (h.appendChild(e).innerHTML =
                    "<a id='" +
                    b +
                    "'></a><select id='" +
                    b +
                    "-\r\\' msallowcapture=''><option selected=''></option></select>"),
                    e.querySelectorAll("[msallowcapture^='']").length &&
                      y.push('[*^$]=' + M + '*(?:\'\'|"")'),
                    e.querySelectorAll('[selected]').length ||
                      y.push('\\[' + M + '*(?:value|' + P + ')'),
                    e.querySelectorAll('[id~=' + b + '-]').length || y.push('~='),
                    e.querySelectorAll(':checked').length || y.push(':checked'),
                    e.querySelectorAll('a#' + b + '+*').length || y.push('.#.+[+~]');
                }),
                ue(function (e) {
                  e.innerHTML =
                    "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
                  var t = d.createElement('input');
                  t.setAttribute('type', 'hidden'),
                    e.appendChild(t).setAttribute('name', 'D'),
                    e.querySelectorAll('[name=d]').length && y.push('name' + M + '*[*^$|!~]?='),
                    2 !== e.querySelectorAll(':enabled').length && y.push(':enabled', ':disabled'),
                    (h.appendChild(e).disabled = !0),
                    2 !== e.querySelectorAll(':disabled').length && y.push(':enabled', ':disabled'),
                    e.querySelectorAll('*,:x'),
                    y.push(',.*:');
                })),
              (n.matchesSelector = Q.test(
                (m =
                  h.matches ||
                  h.webkitMatchesSelector ||
                  h.mozMatchesSelector ||
                  h.oMatchesSelector ||
                  h.msMatchesSelector)
              )) &&
                ue(function (e) {
                  (n.disconnectedMatch = m.call(e, '*')), m.call(e, "[s!='']:x"), v.push('!=', W);
                }),
              (y = y.length && new RegExp(y.join('|'))),
              (v = v.length && new RegExp(v.join('|'))),
              (t = Q.test(h.compareDocumentPosition)),
              (x =
                t || Q.test(h.contains)
                  ? function (e, t) {
                      var n = 9 === e.nodeType ? e.documentElement : e,
                        r = t && t.parentNode;
                      return (
                        e === r ||
                        !(
                          !r ||
                          1 !== r.nodeType ||
                          !(n.contains
                            ? n.contains(r)
                            : e.compareDocumentPosition && 16 & e.compareDocumentPosition(r))
                        )
                      );
                    }
                  : function (e, t) {
                      if (t) while ((t = t.parentNode)) if (t === e) return !0;
                      return !1;
                    }),
              (D = t
                ? function (e, t) {
                    if (e === t) return (f = !0), 0;
                    var r = !e.compareDocumentPosition - !t.compareDocumentPosition;
                    return (
                      r ||
                      (1 &
                        (r =
                          (e.ownerDocument || e) === (t.ownerDocument || t)
                            ? e.compareDocumentPosition(t)
                            : 1) ||
                      (!n.sortDetached && t.compareDocumentPosition(e) === r)
                        ? e === d || (e.ownerDocument === w && x(w, e))
                          ? -1
                          : t === d || (t.ownerDocument === w && x(w, t))
                          ? 1
                          : c
                          ? O(c, e) - O(c, t)
                          : 0
                        : 4 & r
                        ? -1
                        : 1)
                    );
                  }
                : function (e, t) {
                    if (e === t) return (f = !0), 0;
                    var n,
                      r = 0,
                      i = e.parentNode,
                      o = t.parentNode,
                      a = [e],
                      s = [t];
                    if (!i || !o)
                      return e === d
                        ? -1
                        : t === d
                        ? 1
                        : i
                        ? -1
                        : o
                        ? 1
                        : c
                        ? O(c, e) - O(c, t)
                        : 0;
                    if (i === o) return ce(e, t);
                    n = e;
                    while ((n = n.parentNode)) a.unshift(n);
                    n = t;
                    while ((n = n.parentNode)) s.unshift(n);
                    while (a[r] === s[r]) r++;
                    return r ? ce(a[r], s[r]) : a[r] === w ? -1 : s[r] === w ? 1 : 0;
                  }),
              d)
            : d;
        }),
      (oe.matches = function (e, t) {
        return oe(e, null, null, t);
      }),
      (oe.matchesSelector = function (e, t) {
        if (
          ((e.ownerDocument || e) !== d && p(e),
          (t = t.replace(z, "='$1']")),
          n.matchesSelector && g && !S[t + ' '] && (!v || !v.test(t)) && (!y || !y.test(t)))
        )
          try {
            var r = m.call(e, t);
            if (r || n.disconnectedMatch || (e.document && 11 !== e.document.nodeType)) return r;
          } catch (e) {}
        return oe(t, d, null, [e]).length > 0;
      }),
      (oe.contains = function (e, t) {
        return (e.ownerDocument || e) !== d && p(e), x(e, t);
      }),
      (oe.attr = function (e, t) {
        (e.ownerDocument || e) !== d && p(e);
        var i = r.attrHandle[t.toLowerCase()],
          o = i && N.call(r.attrHandle, t.toLowerCase()) ? i(e, t, !g) : void 0;
        return void 0 !== o
          ? o
          : n.attributes || !g
          ? e.getAttribute(t)
          : (o = e.getAttributeNode(t)) && o.specified
          ? o.value
          : null;
      }),
      (oe.escape = function (e) {
        return (e + '').replace(te, ne);
      }),
      (oe.error = function (e) {
        throw new Error('Syntax error, unrecognized expression: ' + e);
      }),
      (oe.uniqueSort = function (e) {
        var t,
          r = [],
          i = 0,
          o = 0;
        if (((f = !n.detectDuplicates), (c = !n.sortStable && e.slice(0)), e.sort(D), f)) {
          while ((t = e[o++])) t === e[o] && (i = r.push(o));
          while (i--) e.splice(r[i], 1);
        }
        return (c = null), e;
      }),
      (i = oe.getText =
        function (e) {
          var t,
            n = '',
            r = 0,
            o = e.nodeType;
          if (o) {
            if (1 === o || 9 === o || 11 === o) {
              if ('string' == typeof e.textContent) return e.textContent;
              for (e = e.firstChild; e; e = e.nextSibling) n += i(e);
            } else if (3 === o || 4 === o) return e.nodeValue;
          } else while ((t = e[r++])) n += i(t);
          return n;
        }),
      ((r = oe.selectors =
        {
          cacheLength: 50,
          createPseudo: se,
          match: V,
          attrHandle: {},
          find: {},
          relative: {
            '>': {dir: 'parentNode', first: !0},
            ' ': {dir: 'parentNode'},
            '+': {dir: 'previousSibling', first: !0},
            '~': {dir: 'previousSibling'}
          },
          preFilter: {
            ATTR: function (e) {
              return (
                (e[1] = e[1].replace(Z, ee)),
                (e[3] = (e[3] || e[4] || e[5] || '').replace(Z, ee)),
                '~=' === e[2] && (e[3] = ' ' + e[3] + ' '),
                e.slice(0, 4)
              );
            },
            CHILD: function (e) {
              return (
                (e[1] = e[1].toLowerCase()),
                'nth' === e[1].slice(0, 3)
                  ? (e[3] || oe.error(e[0]),
                    (e[4] = +(e[4] ? e[5] + (e[6] || 1) : 2 * ('even' === e[3] || 'odd' === e[3]))),
                    (e[5] = +(e[7] + e[8] || 'odd' === e[3])))
                  : e[3] && oe.error(e[0]),
                e
              );
            },
            PSEUDO: function (e) {
              var t,
                n = !e[6] && e[2];
              return V.CHILD.test(e[0])
                ? null
                : (e[3]
                    ? (e[2] = e[4] || e[5] || '')
                    : n &&
                      X.test(n) &&
                      (t = a(n, !0)) &&
                      (t = n.indexOf(')', n.length - t) - n.length) &&
                      ((e[0] = e[0].slice(0, t)), (e[2] = n.slice(0, t))),
                  e.slice(0, 3));
            }
          },
          filter: {
            TAG: function (e) {
              var t = e.replace(Z, ee).toLowerCase();
              return '*' === e
                ? function () {
                    return !0;
                  }
                : function (e) {
                    return e.nodeName && e.nodeName.toLowerCase() === t;
                  };
            },
            CLASS: function (e) {
              var t = E[e + ' '];
              return (
                t ||
                ((t = new RegExp('(^|' + M + ')' + e + '(' + M + '|$)')) &&
                  E(e, function (e) {
                    return t.test(
                      ('string' == typeof e.className && e.className) ||
                        ('undefined' != typeof e.getAttribute && e.getAttribute('class')) ||
                        ''
                    );
                  }))
              );
            },
            ATTR: function (e, t, n) {
              return function (r) {
                var i = oe.attr(r, e);
                return null == i
                  ? '!=' === t
                  : !t ||
                      ((i += ''),
                      '=' === t
                        ? i === n
                        : '!=' === t
                        ? i !== n
                        : '^=' === t
                        ? n && 0 === i.indexOf(n)
                        : '*=' === t
                        ? n && i.indexOf(n) > -1
                        : '$=' === t
                        ? n && i.slice(-n.length) === n
                        : '~=' === t
                        ? (' ' + i.replace($, ' ') + ' ').indexOf(n) > -1
                        : '|=' === t && (i === n || i.slice(0, n.length + 1) === n + '-'));
              };
            },
            CHILD: function (e, t, n, r, i) {
              var o = 'nth' !== e.slice(0, 3),
                a = 'last' !== e.slice(-4),
                s = 'of-type' === t;
              return 1 === r && 0 === i
                ? function (e) {
                    return !!e.parentNode;
                  }
                : function (t, n, u) {
                    var l,
                      c,
                      f,
                      p,
                      d,
                      h,
                      g = o !== a ? 'nextSibling' : 'previousSibling',
                      y = t.parentNode,
                      v = s && t.nodeName.toLowerCase(),
                      m = !u && !s,
                      x = !1;
                    if (y) {
                      if (o) {
                        while (g) {
                          p = t;
                          while ((p = p[g]))
                            if (s ? p.nodeName.toLowerCase() === v : 1 === p.nodeType) return !1;
                          h = g = 'only' === e && !h && 'nextSibling';
                        }
                        return !0;
                      }
                      if (((h = [a ? y.firstChild : y.lastChild]), a && m)) {
                        (x =
                          (d =
                            (l =
                              (c =
                                (f = (p = y)[b] || (p[b] = {}))[p.uniqueID] ||
                                (f[p.uniqueID] = {}))[e] || [])[0] === T && l[1]) && l[2]),
                          (p = d && y.childNodes[d]);
                        while ((p = (++d && p && p[g]) || (x = d = 0) || h.pop()))
                          if (1 === p.nodeType && ++x && p === t) {
                            c[e] = [T, d, x];
                            break;
                          }
                      } else if (
                        (m &&
                          (x = d =
                            (l =
                              (c =
                                (f = (p = t)[b] || (p[b] = {}))[p.uniqueID] ||
                                (f[p.uniqueID] = {}))[e] || [])[0] === T && l[1]),
                        !1 === x)
                      )
                        while ((p = (++d && p && p[g]) || (x = d = 0) || h.pop()))
                          if (
                            (s ? p.nodeName.toLowerCase() === v : 1 === p.nodeType) &&
                            ++x &&
                            (m &&
                              ((c = (f = p[b] || (p[b] = {}))[p.uniqueID] || (f[p.uniqueID] = {}))[
                                e
                              ] = [T, x]),
                            p === t)
                          )
                            break;
                      return (x -= i) === r || (x % r == 0 && x / r >= 0);
                    }
                  };
            },
            PSEUDO: function (e, t) {
              var n,
                i =
                  r.pseudos[e] ||
                  r.setFilters[e.toLowerCase()] ||
                  oe.error('unsupported pseudo: ' + e);
              return i[b]
                ? i(t)
                : i.length > 1
                ? ((n = [e, e, '', t]),
                  r.setFilters.hasOwnProperty(e.toLowerCase())
                    ? se(function (e, n) {
                        var r,
                          o = i(e, t),
                          a = o.length;
                        while (a--) e[(r = O(e, o[a]))] = !(n[r] = o[a]);
                      })
                    : function (e) {
                        return i(e, 0, n);
                      })
                : i;
            }
          },
          pseudos: {
            not: se(function (e) {
              var t = [],
                n = [],
                r = s(e.replace(B, '$1'));
              return r[b]
                ? se(function (e, t, n, i) {
                    var o,
                      a = r(e, null, i, []),
                      s = e.length;
                    while (s--) (o = a[s]) && (e[s] = !(t[s] = o));
                  })
                : function (e, i, o) {
                    return (t[0] = e), r(t, null, o, n), (t[0] = null), !n.pop();
                  };
            }),
            has: se(function (e) {
              return function (t) {
                return oe(e, t).length > 0;
              };
            }),
            contains: se(function (e) {
              return (
                (e = e.replace(Z, ee)),
                function (t) {
                  return (t.textContent || t.innerText || i(t)).indexOf(e) > -1;
                }
              );
            }),
            lang: se(function (e) {
              return (
                U.test(e || '') || oe.error('unsupported lang: ' + e),
                (e = e.replace(Z, ee).toLowerCase()),
                function (t) {
                  var n;
                  do {
                    if ((n = g ? t.lang : t.getAttribute('xml:lang') || t.getAttribute('lang')))
                      return (n = n.toLowerCase()) === e || 0 === n.indexOf(e + '-');
                  } while ((t = t.parentNode) && 1 === t.nodeType);
                  return !1;
                }
              );
            }),
            target: function (t) {
              var n = e.location && e.location.hash;
              return n && n.slice(1) === t.id;
            },
            root: function (e) {
              return e === h;
            },
            focus: function (e) {
              return (
                e === d.activeElement &&
                (!d.hasFocus || d.hasFocus()) &&
                !!(e.type || e.href || ~e.tabIndex)
              );
            },
            enabled: de(!1),
            disabled: de(!0),
            checked: function (e) {
              var t = e.nodeName.toLowerCase();
              return ('input' === t && !!e.checked) || ('option' === t && !!e.selected);
            },
            selected: function (e) {
              return e.parentNode && e.parentNode.selectedIndex, !0 === e.selected;
            },
            empty: function (e) {
              for (e = e.firstChild; e; e = e.nextSibling) if (e.nodeType < 6) return !1;
              return !0;
            },
            parent: function (e) {
              return !r.pseudos.empty(e);
            },
            header: function (e) {
              return Y.test(e.nodeName);
            },
            input: function (e) {
              return G.test(e.nodeName);
            },
            button: function (e) {
              var t = e.nodeName.toLowerCase();
              return ('input' === t && 'button' === e.type) || 'button' === t;
            },
            text: function (e) {
              var t;
              return (
                'input' === e.nodeName.toLowerCase() &&
                'text' === e.type &&
                (null == (t = e.getAttribute('type')) || 'text' === t.toLowerCase())
              );
            },
            first: he(function () {
              return [0];
            }),
            last: he(function (e, t) {
              return [t - 1];
            }),
            eq: he(function (e, t, n) {
              return [n < 0 ? n + t : n];
            }),
            even: he(function (e, t) {
              for (var n = 0; n < t; n += 2) e.push(n);
              return e;
            }),
            odd: he(function (e, t) {
              for (var n = 1; n < t; n += 2) e.push(n);
              return e;
            }),
            lt: he(function (e, t, n) {
              for (var r = n < 0 ? n + t : n; --r >= 0; ) e.push(r);
              return e;
            }),
            gt: he(function (e, t, n) {
              for (var r = n < 0 ? n + t : n; ++r < t; ) e.push(r);
              return e;
            })
          }
        }).pseudos.nth = r.pseudos.eq);
    for (t in {radio: !0, checkbox: !0, file: !0, password: !0, image: !0}) r.pseudos[t] = fe(t);
    for (t in {submit: !0, reset: !0}) r.pseudos[t] = pe(t);
    function ye() {}
    (ye.prototype = r.filters = r.pseudos),
      (r.setFilters = new ye()),
      (a = oe.tokenize =
        function (e, t) {
          var n,
            i,
            o,
            a,
            s,
            u,
            l,
            c = k[e + ' '];
          if (c) return t ? 0 : c.slice(0);
          (s = e), (u = []), (l = r.preFilter);
          while (s) {
            (n && !(i = F.exec(s))) || (i && (s = s.slice(i[0].length) || s), u.push((o = []))),
              (n = !1),
              (i = _.exec(s)) &&
                ((n = i.shift()),
                o.push({value: n, type: i[0].replace(B, ' ')}),
                (s = s.slice(n.length)));
            for (a in r.filter)
              !(i = V[a].exec(s)) ||
                (l[a] && !(i = l[a](i))) ||
                ((n = i.shift()), o.push({value: n, type: a, matches: i}), (s = s.slice(n.length)));
            if (!n) break;
          }
          return t ? s.length : s ? oe.error(e) : k(e, u).slice(0);
        });
    function ve(e) {
      for (var t = 0, n = e.length, r = ''; t < n; t++) r += e[t].value;
      return r;
    }
    function me(e, t, n) {
      var r = t.dir,
        i = t.next,
        o = i || r,
        a = n && 'parentNode' === o,
        s = C++;
      return t.first
        ? function (t, n, i) {
            while ((t = t[r])) if (1 === t.nodeType || a) return e(t, n, i);
            return !1;
          }
        : function (t, n, u) {
            var l,
              c,
              f,
              p = [T, s];
            if (u) {
              while ((t = t[r])) if ((1 === t.nodeType || a) && e(t, n, u)) return !0;
            } else
              while ((t = t[r]))
                if (1 === t.nodeType || a)
                  if (
                    ((f = t[b] || (t[b] = {})),
                    (c = f[t.uniqueID] || (f[t.uniqueID] = {})),
                    i && i === t.nodeName.toLowerCase())
                  )
                    t = t[r] || t;
                  else {
                    if ((l = c[o]) && l[0] === T && l[1] === s) return (p[2] = l[2]);
                    if (((c[o] = p), (p[2] = e(t, n, u)))) return !0;
                  }
            return !1;
          };
    }
    function xe(e) {
      return e.length > 1
        ? function (t, n, r) {
            var i = e.length;
            while (i--) if (!e[i](t, n, r)) return !1;
            return !0;
          }
        : e[0];
    }
    function be(e, t, n) {
      for (var r = 0, i = t.length; r < i; r++) oe(e, t[r], n);
      return n;
    }
    function we(e, t, n, r, i) {
      for (var o, a = [], s = 0, u = e.length, l = null != t; s < u; s++)
        (o = e[s]) && ((n && !n(o, r, i)) || (a.push(o), l && t.push(s)));
      return a;
    }
    function Te(e, t, n, r, i, o) {
      return (
        r && !r[b] && (r = Te(r)),
        i && !i[b] && (i = Te(i, o)),
        se(function (o, a, s, u) {
          var l,
            c,
            f,
            p = [],
            d = [],
            h = a.length,
            g = o || be(t || '*', s.nodeType ? [s] : s, []),
            y = !e || (!o && t) ? g : we(g, p, e, s, u),
            v = n ? (i || (o ? e : h || r) ? [] : a) : y;
          if ((n && n(y, v, s, u), r)) {
            (l = we(v, d)), r(l, [], s, u), (c = l.length);
            while (c--) (f = l[c]) && (v[d[c]] = !(y[d[c]] = f));
          }
          if (o) {
            if (i || e) {
              if (i) {
                (l = []), (c = v.length);
                while (c--) (f = v[c]) && l.push((y[c] = f));
                i(null, (v = []), l, u);
              }
              c = v.length;
              while (c--) (f = v[c]) && (l = i ? O(o, f) : p[c]) > -1 && (o[l] = !(a[l] = f));
            }
          } else (v = we(v === a ? v.splice(h, v.length) : v)), i ? i(null, a, v, u) : L.apply(a, v);
        })
      );
    }
    function Ce(e) {
      for (
        var t,
          n,
          i,
          o = e.length,
          a = r.relative[e[0].type],
          s = a || r.relative[' '],
          u = a ? 1 : 0,
          c = me(
            function (e) {
              return e === t;
            },
            s,
            !0
          ),
          f = me(
            function (e) {
              return O(t, e) > -1;
            },
            s,
            !0
          ),
          p = [
            function (e, n, r) {
              var i = (!a && (r || n !== l)) || ((t = n).nodeType ? c(e, n, r) : f(e, n, r));
              return (t = null), i;
            }
          ];
        u < o;
        u++
      )
        if ((n = r.relative[e[u].type])) p = [me(xe(p), n)];
        else {
          if ((n = r.filter[e[u].type].apply(null, e[u].matches))[b]) {
            for (i = ++u; i < o; i++) if (r.relative[e[i].type]) break;
            return Te(
              u > 1 && xe(p),
              u > 1 &&
                ve(e.slice(0, u - 1).concat({value: ' ' === e[u - 2].type ? '*' : ''})).replace(
                  B,
                  '$1'
                ),
              n,
              u < i && Ce(e.slice(u, i)),
              i < o && Ce((e = e.slice(i))),
              i < o && ve(e)
            );
          }
          p.push(n);
        }
      return xe(p);
    }
    function Ee(e, t) {
      var n = t.length > 0,
        i = e.length > 0,
        o = function (o, a, s, u, c) {
          var f,
            h,
            y,
            v = 0,
            m = '0',
            x = o && [],
            b = [],
            w = l,
            C = o || (i && r.find.TAG('*', c)),
            E = (T += null == w ? 1 : Math.random() || 0.1),
            k = C.length;
          for (c && (l = a === d || a || c); m !== k && null != (f = C[m]); m++) {
            if (i && f) {
              (h = 0), a || f.ownerDocument === d || (p(f), (s = !g));
              while ((y = e[h++]))
                if (y(f, a || d, s)) {
                  u.push(f);
                  break;
                }
              c && (T = E);
            }
            n && ((f = !y && f) && v--, o && x.push(f));
          }
          if (((v += m), n && m !== v)) {
            h = 0;
            while ((y = t[h++])) y(x, b, a, s);
            if (o) {
              if (v > 0) while (m--) x[m] || b[m] || (b[m] = j.call(u));
              b = we(b);
            }
            L.apply(u, b), c && !o && b.length > 0 && v + t.length > 1 && oe.uniqueSort(u);
          }
          return c && ((T = E), (l = w)), x;
        };
      return n ? se(o) : o;
    }
    return (
      (s = oe.compile =
        function (e, t) {
          var n,
            r = [],
            i = [],
            o = S[e + ' '];
          if (!o) {
            t || (t = a(e)), (n = t.length);
            while (n--) (o = Ce(t[n]))[b] ? r.push(o) : i.push(o);
            (o = S(e, Ee(i, r))).selector = e;
          }
          return o;
        }),
      (u = oe.select =
        function (e, t, n, i) {
          var o,
            u,
            l,
            c,
            f,
            p = 'function' == typeof e && e,
            d = !i && a((e = p.selector || e));
          if (((n = n || []), 1 === d.length)) {
            if (
              (u = d[0] = d[0].slice(0)).length > 2 &&
              'ID' === (l = u[0]).type &&
              9 === t.nodeType &&
              g &&
              r.relative[u[1].type]
            ) {
              if (!(t = (r.find.ID(l.matches[0].replace(Z, ee), t) || [])[0])) return n;
              p && (t = t.parentNode), (e = e.slice(u.shift().value.length));
            }
            o = V.needsContext.test(e) ? 0 : u.length;
            while (o--) {
              if (((l = u[o]), r.relative[(c = l.type)])) break;
              if (
                (f = r.find[c]) &&
                (i = f(l.matches[0].replace(Z, ee), (K.test(u[0].type) && ge(t.parentNode)) || t))
              ) {
                if ((u.splice(o, 1), !(e = i.length && ve(u)))) return L.apply(n, i), n;
                break;
              }
            }
          }
          return (p || s(e, d))(i, t, !g, n, !t || (K.test(e) && ge(t.parentNode)) || t), n;
        }),
      (n.sortStable = b.split('').sort(D).join('') === b),
      (n.detectDuplicates = !!f),
      p(),
      (n.sortDetached = ue(function (e) {
        return 1 & e.compareDocumentPosition(d.createElement('fieldset'));
      })),
      ue(function (e) {
        return (e.innerHTML = "<a href='#'></a>"), '#' === e.firstChild.getAttribute('href');
      }) ||
        le('type|href|height|width', function (e, t, n) {
          if (!n) return e.getAttribute(t, 'type' === t.toLowerCase() ? 1 : 2);
        }),
      (n.attributes &&
        ue(function (e) {
          return (
            (e.innerHTML = '<input/>'),
            e.firstChild.setAttribute('value', ''),
            '' === e.firstChild.getAttribute('value')
          );
        })) ||
        le('value', function (e, t, n) {
          if (!n && 'input' === e.nodeName.toLowerCase()) return e.defaultValue;
        }),
      ue(function (e) {
        return null == e.getAttribute('disabled');
      }) ||
        le(P, function (e, t, n) {
          var r;
          if (!n)
            return !0 === e[t]
              ? t.toLowerCase()
              : (r = e.getAttributeNode(t)) && r.specified
              ? r.value
              : null;
        }),
      oe
    );
  })(e);
  (w.find = E),
    (w.expr = E.selectors),
    (w.expr[':'] = w.expr.pseudos),
    (w.uniqueSort = w.unique = E.uniqueSort),
    (w.text = E.getText),
    (w.isXMLDoc = E.isXML),
    (w.contains = E.contains),
    (w.escapeSelector = E.escape);
  var k = function (e, t, n) {
      var r = [],
        i = void 0 !== n;
      while ((e = e[t]) && 9 !== e.nodeType)
        if (1 === e.nodeType) {
          if (i && w(e).is(n)) break;
          r.push(e);
        }
      return r;
    },
    S = function (e, t) {
      for (var n = []; e; e = e.nextSibling) 1 === e.nodeType && e !== t && n.push(e);
      return n;
    },
    D = w.expr.match.needsContext;
  function N(e, t) {
    return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase();
  }
  var A = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
  function j(e, t, n) {
    return g(t)
      ? w.grep(e, function (e, r) {
          return !!t.call(e, r, e) !== n;
        })
      : t.nodeType
      ? w.grep(e, function (e) {
          return (e === t) !== n;
        })
      : 'string' != typeof t
      ? w.grep(e, function (e) {
          return u.call(t, e) > -1 !== n;
        })
      : w.filter(t, e, n);
  }
  (w.filter = function (e, t, n) {
    var r = t[0];
    return (
      n && (e = ':not(' + e + ')'),
      1 === t.length && 1 === r.nodeType
        ? w.find.matchesSelector(r, e)
          ? [r]
          : []
        : w.find.matches(
            e,
            w.grep(t, function (e) {
              return 1 === e.nodeType;
            })
          )
    );
  }),
    w.fn.extend({
      find: function (e) {
        var t,
          n,
          r = this.length,
          i = this;
        if ('string' != typeof e)
          return this.pushStack(
            w(e).filter(function () {
              for (t = 0; t < r; t++) if (w.contains(i[t], this)) return !0;
            })
          );
        for (n = this.pushStack([]), t = 0; t < r; t++) w.find(e, i[t], n);
        return r > 1 ? w.uniqueSort(n) : n;
      },
      filter: function (e) {
        return this.pushStack(j(this, e || [], !1));
      },
      not: function (e) {
        return this.pushStack(j(this, e || [], !0));
      },
      is: function (e) {
        return !!j(this, 'string' == typeof e && D.test(e) ? w(e) : e || [], !1).length;
      }
    });
  var q,
    L = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
  ((w.fn.init = function (e, t, n) {
    var i, o;
    if (!e) return this;
    if (((n = n || q), 'string' == typeof e)) {
      if (
        !(i =
          '<' === e[0] && '>' === e[e.length - 1] && e.length >= 3 ? [null, e, null] : L.exec(e)) ||
        (!i[1] && t)
      )
        return !t || t.jquery ? (t || n).find(e) : this.constructor(t).find(e);
      if (i[1]) {
        if (
          ((t = t instanceof w ? t[0] : t),
          w.merge(this, w.parseHTML(i[1], t && t.nodeType ? t.ownerDocument || t : r, !0)),
          A.test(i[1]) && w.isPlainObject(t))
        )
          for (i in t) g(this[i]) ? this[i](t[i]) : this.attr(i, t[i]);
        return this;
      }
      return (o = r.getElementById(i[2])) && ((this[0] = o), (this.length = 1)), this;
    }
    return e.nodeType
      ? ((this[0] = e), (this.length = 1), this)
      : g(e)
      ? void 0 !== n.ready
        ? n.ready(e)
        : e(w)
      : w.makeArray(e, this);
  }).prototype = w.fn),
    (q = w(r));
  var H = /^(?:parents|prev(?:Until|All))/,
    O = {children: !0, contents: !0, next: !0, prev: !0};
  w.fn.extend({
    has: function (e) {
      var t = w(e, this),
        n = t.length;
      return this.filter(function () {
        for (var e = 0; e < n; e++) if (w.contains(this, t[e])) return !0;
      });
    },
    closest: function (e, t) {
      var n,
        r = 0,
        i = this.length,
        o = [],
        a = 'string' != typeof e && w(e);
      if (!D.test(e))
        for (; r < i; r++)
          for (n = this[r]; n && n !== t; n = n.parentNode)
            if (
              n.nodeType < 11 &&
              (a ? a.index(n) > -1 : 1 === n.nodeType && w.find.matchesSelector(n, e))
            ) {
              o.push(n);
              break;
            }
      return this.pushStack(o.length > 1 ? w.uniqueSort(o) : o);
    },
    index: function (e) {
      return e
        ? 'string' == typeof e
          ? u.call(w(e), this[0])
          : u.call(this, e.jquery ? e[0] : e)
        : this[0] && this[0].parentNode
        ? this.first().prevAll().length
        : -1;
    },
    add: function (e, t) {
      return this.pushStack(w.uniqueSort(w.merge(this.get(), w(e, t))));
    },
    addBack: function (e) {
      return this.add(null == e ? this.prevObject : this.prevObject.filter(e));
    }
  });
  function P(e, t) {
    while ((e = e[t]) && 1 !== e.nodeType);
    return e;
  }
  w.each(
    {
      parent: function (e) {
        var t = e.parentNode;
        return t && 11 !== t.nodeType ? t : null;
      },
      parents: function (e) {
        return k(e, 'parentNode');
      },
      parentsUntil: function (e, t, n) {
        return k(e, 'parentNode', n);
      },
      next: function (e) {
        return P(e, 'nextSibling');
      },
      prev: function (e) {
        return P(e, 'previousSibling');
      },
      nextAll: function (e) {
        return k(e, 'nextSibling');
      },
      prevAll: function (e) {
        return k(e, 'previousSibling');
      },
      nextUntil: function (e, t, n) {
        return k(e, 'nextSibling', n);
      },
      prevUntil: function (e, t, n) {
        return k(e, 'previousSibling', n);
      },
      siblings: function (e) {
        return S((e.parentNode || {}).firstChild, e);
      },
      children: function (e) {
        return S(e.firstChild);
      },
      contents: function (e) {
        return N(e, 'iframe')
          ? e.contentDocument
          : (N(e, 'template') && (e = e.content || e), w.merge([], e.childNodes));
      }
    },
    function (e, t) {
      w.fn[e] = function (n, r) {
        var i = w.map(this, t, n);
        return (
          'Until' !== e.slice(-5) && (r = n),
          r && 'string' == typeof r && (i = w.filter(r, i)),
          this.length > 1 && (O[e] || w.uniqueSort(i), H.test(e) && i.reverse()),
          this.pushStack(i)
        );
      };
    }
  );
  var M = /[^\x20\t\r\n\f]+/g;
  function R(e) {
    var t = {};
    return (
      w.each(e.match(M) || [], function (e, n) {
        t[n] = !0;
      }),
      t
    );
  }
  w.Callbacks = function (e) {
    e = 'string' == typeof e ? R(e) : w.extend({}, e);
    var t,
      n,
      r,
      i,
      o = [],
      a = [],
      s = -1,
      u = function () {
        for (i = i || e.once, r = t = !0; a.length; s = -1) {
          n = a.shift();
          while (++s < o.length)
            !1 === o[s].apply(n[0], n[1]) && e.stopOnFalse && ((s = o.length), (n = !1));
        }
        e.memory || (n = !1), (t = !1), i && (o = n ? [] : '');
      },
      l = {
        add: function () {
          return (
            o &&
              (n && !t && ((s = o.length - 1), a.push(n)),
              (function t(n) {
                w.each(n, function (n, r) {
                  g(r)
                    ? (e.unique && l.has(r)) || o.push(r)
                    : r && r.length && 'string' !== x(r) && t(r);
                });
              })(arguments),
              n && !t && u()),
            this
          );
        },
        remove: function () {
          return (
            w.each(arguments, function (e, t) {
              var n;
              while ((n = w.inArray(t, o, n)) > -1) o.splice(n, 1), n <= s && s--;
            }),
            this
          );
        },
        has: function (e) {
          return e ? w.inArray(e, o) > -1 : o.length > 0;
        },
        empty: function () {
          return o && (o = []), this;
        },
        disable: function () {
          return (i = a = []), (o = n = ''), this;
        },
        disabled: function () {
          return !o;
        },
        lock: function () {
          return (i = a = []), n || t || (o = n = ''), this;
        },
        locked: function () {
          return !!i;
        },
        fireWith: function (e, n) {
          return i || ((n = [e, (n = n || []).slice ? n.slice() : n]), a.push(n), t || u()), this;
        },
        fire: function () {
          return l.fireWith(this, arguments), this;
        },
        fired: function () {
          return !!r;
        }
      };
    return l;
  };
  function I(e) {
    return e;
  }
  function W(e) {
    throw e;
  }
  function $(e, t, n, r) {
    var i;
    try {
      e && g((i = e.promise))
        ? i.call(e).done(t).fail(n)
        : e && g((i = e.then))
        ? i.call(e, t, n)
        : t.apply(void 0, [e].slice(r));
    } catch (e) {
      n.apply(void 0, [e]);
    }
  }
  w.extend({
    Deferred: function (t) {
      var n = [
          ['notify', 'progress', w.Callbacks('memory'), w.Callbacks('memory'), 2],
          [
            'resolve',
            'done',
            w.Callbacks('once memory'),
            w.Callbacks('once memory'),
            0,
            'resolved'
          ],
          ['reject', 'fail', w.Callbacks('once memory'), w.Callbacks('once memory'), 1, 'rejected']
        ],
        r = 'pending',
        i = {
          state: function () {
            return r;
          },
          always: function () {
            return o.done(arguments).fail(arguments), this;
          },
          catch: function (e) {
            return i.then(null, e);
          },
          pipe: function () {
            var e = arguments;
            return w
              .Deferred(function (t) {
                w.each(n, function (n, r) {
                  var i = g(e[r[4]]) && e[r[4]];
                  o[r[1]](function () {
                    var e = i && i.apply(this, arguments);
                    e && g(e.promise)
                      ? e.promise().progress(t.notify).done(t.resolve).fail(t.reject)
                      : t[r[0] + 'With'](this, i ? [e] : arguments);
                  });
                }),
                  (e = null);
              })
              .promise();
          },
          then: function (t, r, i) {
            var o = 0;
            function a(t, n, r, i) {
              return function () {
                var s = this,
                  u = arguments,
                  l = function () {
                    var e, l;
                    if (!(t < o)) {
                      if ((e = r.apply(s, u)) === n.promise())
                        throw new TypeError('Thenable self-resolution');
                      (l = e && ('object' == typeof e || 'function' == typeof e) && e.then),
                        g(l)
                          ? i
                            ? l.call(e, a(o, n, I, i), a(o, n, W, i))
                            : (o++,
                              l.call(e, a(o, n, I, i), a(o, n, W, i), a(o, n, I, n.notifyWith)))
                          : (r !== I && ((s = void 0), (u = [e])), (i || n.resolveWith)(s, u));
                    }
                  },
                  c = i
                    ? l
                    : function () {
                        try {
                          l();
                        } catch (e) {
                          w.Deferred.exceptionHook && w.Deferred.exceptionHook(e, c.stackTrace),
                            t + 1 >= o &&
                              (r !== W && ((s = void 0), (u = [e])), n.rejectWith(s, u));
                        }
                      };
                t
                  ? c()
                  : (w.Deferred.getStackHook && (c.stackTrace = w.Deferred.getStackHook()),
                    e.setTimeout(c));
              };
            }
            return w
              .Deferred(function (e) {
                n[0][3].add(a(0, e, g(i) ? i : I, e.notifyWith)),
                  n[1][3].add(a(0, e, g(t) ? t : I)),
                  n[2][3].add(a(0, e, g(r) ? r : W));
              })
              .promise();
          },
          promise: function (e) {
            return null != e ? w.extend(e, i) : i;
          }
        },
        o = {};
      return (
        w.each(n, function (e, t) {
          var a = t[2],
            s = t[5];
          (i[t[1]] = a.add),
            s &&
              a.add(
                function () {
                  r = s;
                },
                n[3 - e][2].disable,
                n[3 - e][3].disable,
                n[0][2].lock,
                n[0][3].lock
              ),
            a.add(t[3].fire),
            (o[t[0]] = function () {
              return o[t[0] + 'With'](this === o ? void 0 : this, arguments), this;
            }),
            (o[t[0] + 'With'] = a.fireWith);
        }),
        i.promise(o),
        t && t.call(o, o),
        o
      );
    },
    when: function (e) {
      var t = arguments.length,
        n = t,
        r = Array(n),
        i = o.call(arguments),
        a = w.Deferred(),
        s = function (e) {
          return function (n) {
            (r[e] = this),
              (i[e] = arguments.length > 1 ? o.call(arguments) : n),
              --t || a.resolveWith(r, i);
          };
        };
      if (
        t <= 1 &&
        ($(e, a.done(s(n)).resolve, a.reject, !t), 'pending' === a.state() || g(i[n] && i[n].then))
      )
        return a.then();
      while (n--) $(i[n], s(n), a.reject);
      return a.promise();
    }
  });
  var B = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
  (w.Deferred.exceptionHook = function (t, n) {
    e.console &&
      e.console.warn &&
      t &&
      B.test(t.name) &&
      e.console.warn('jQuery.Deferred exception: ' + t.message, t.stack, n);
  }),
    (w.readyException = function (t) {
      e.setTimeout(function () {
        throw t;
      });
    });
  var F = w.Deferred();
  (w.fn.ready = function (e) {
    return (
      F.then(e)['catch'](function (e) {
        w.readyException(e);
      }),
      this
    );
  }),
    w.extend({
      isReady: !1,
      readyWait: 1,
      ready: function (e) {
        (!0 === e ? --w.readyWait : w.isReady) ||
          ((w.isReady = !0), (!0 !== e && --w.readyWait > 0) || F.resolveWith(r, [w]));
      }
    }),
    (w.ready.then = F.then);
  function _() {
    r.removeEventListener('DOMContentLoaded', _), e.removeEventListener('load', _), w.ready();
  }
  'complete' === r.readyState || ('loading' !== r.readyState && !r.documentElement.doScroll)
    ? e.setTimeout(w.ready)
    : (r.addEventListener('DOMContentLoaded', _), e.addEventListener('load', _));
  var z = function (e, t, n, r, i, o, a) {
      var s = 0,
        u = e.length,
        l = null == n;
      if ('object' === x(n)) {
        i = !0;
        for (s in n) z(e, t, s, n[s], !0, o, a);
      } else if (
        void 0 !== r &&
        ((i = !0),
        g(r) || (a = !0),
        l &&
          (a
            ? (t.call(e, r), (t = null))
            : ((l = t),
              (t = function (e, t, n) {
                return l.call(w(e), n);
              }))),
        t)
      )
        for (; s < u; s++) t(e[s], n, a ? r : r.call(e[s], s, t(e[s], n)));
      return i ? e : l ? t.call(e) : u ? t(e[0], n) : o;
    },
    X = /^-ms-/,
    U = /-([a-z])/g;
  function V(e, t) {
    return t.toUpperCase();
  }
  function G(e) {
    return e.replace(X, 'ms-').replace(U, V);
  }
  var Y = function (e) {
    return 1 === e.nodeType || 9 === e.nodeType || !+e.nodeType;
  };
  function Q() {
    this.expando = w.expando + Q.uid++;
  }
  (Q.uid = 1),
    (Q.prototype = {
      cache: function (e) {
        var t = e[this.expando];
        return (
          t ||
            ((t = {}),
            Y(e) &&
              (e.nodeType
                ? (e[this.expando] = t)
                : Object.defineProperty(e, this.expando, {value: t, configurable: !0}))),
          t
        );
      },
      set: function (e, t, n) {
        var r,
          i = this.cache(e);
        if ('string' == typeof t) i[G(t)] = n;
        else for (r in t) i[G(r)] = t[r];
        return i;
      },
      get: function (e, t) {
        return void 0 === t ? this.cache(e) : e[this.expando] && e[this.expando][G(t)];
      },
      access: function (e, t, n) {
        return void 0 === t || (t && 'string' == typeof t && void 0 === n)
          ? this.get(e, t)
          : (this.set(e, t, n), void 0 !== n ? n : t);
      },
      remove: function (e, t) {
        var n,
          r = e[this.expando];
        if (void 0 !== r) {
          if (void 0 !== t) {
            n = (t = Array.isArray(t) ? t.map(G) : (t = G(t)) in r ? [t] : t.match(M) || []).length;
            while (n--) delete r[t[n]];
          }
          (void 0 === t || w.isEmptyObject(r)) &&
            (e.nodeType ? (e[this.expando] = void 0) : delete e[this.expando]);
        }
      },
      hasData: function (e) {
        var t = e[this.expando];
        return void 0 !== t && !w.isEmptyObject(t);
      }
    });
  var J = new Q(),
    K = new Q(),
    Z = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
    ee = /[A-Z]/g;
  function te(e) {
    return (
      'true' === e ||
      ('false' !== e && ('null' === e ? null : e === +e + '' ? +e : Z.test(e) ? JSON.parse(e) : e))
    );
  }
  function ne(e, t, n) {
    var r;
    if (void 0 === n && 1 === e.nodeType)
      if (
        ((r = 'data-' + t.replace(ee, '-$&').toLowerCase()),
        'string' == typeof (n = e.getAttribute(r)))
      ) {
        try {
          n = te(n);
        } catch (e) {}
        K.set(e, t, n);
      } else n = void 0;
    return n;
  }
  w.extend({
    hasData: function (e) {
      return K.hasData(e) || J.hasData(e);
    },
    data: function (e, t, n) {
      return K.access(e, t, n);
    },
    removeData: function (e, t) {
      K.remove(e, t);
    },
    _data: function (e, t, n) {
      return J.access(e, t, n);
    },
    _removeData: function (e, t) {
      J.remove(e, t);
    }
  }),
    w.fn.extend({
      data: function (e, t) {
        var n,
          r,
          i,
          o = this[0],
          a = o && o.attributes;
        if (void 0 === e) {
          if (this.length && ((i = K.get(o)), 1 === o.nodeType && !J.get(o, 'hasDataAttrs'))) {
            n = a.length;
            while (n--)
              a[n] &&
                0 === (r = a[n].name).indexOf('data-') &&
                ((r = G(r.slice(5))), ne(o, r, i[r]));
            J.set(o, 'hasDataAttrs', !0);
          }
          return i;
        }
        return 'object' == typeof e
          ? this.each(function () {
              K.set(this, e);
            })
          : z(
              this,
              function (t) {
                var n;
                if (o && void 0 === t) {
                  if (void 0 !== (n = K.get(o, e))) return n;
                  if (void 0 !== (n = ne(o, e))) return n;
                } else
                  this.each(function () {
                    K.set(this, e, t);
                  });
              },
              null,
              t,
              arguments.length > 1,
              null,
              !0
            );
      },
      removeData: function (e) {
        return this.each(function () {
          K.remove(this, e);
        });
      }
    }),
    w.extend({
      queue: function (e, t, n) {
        var r;
        if (e)
          return (
            (t = (t || 'fx') + 'queue'),
            (r = J.get(e, t)),
            n && (!r || Array.isArray(n) ? (r = J.access(e, t, w.makeArray(n))) : r.push(n)),
            r || []
          );
      },
      dequeue: function (e, t) {
        t = t || 'fx';
        var n = w.queue(e, t),
          r = n.length,
          i = n.shift(),
          o = w._queueHooks(e, t),
          a = function () {
            w.dequeue(e, t);
          };
        'inprogress' === i && ((i = n.shift()), r--),
          i && ('fx' === t && n.unshift('inprogress'), delete o.stop, i.call(e, a, o)),
          !r && o && o.empty.fire();
      },
      _queueHooks: function (e, t) {
        var n = t + 'queueHooks';
        return (
          J.get(e, n) ||
          J.access(e, n, {
            empty: w.Callbacks('once memory').add(function () {
              J.remove(e, [t + 'queue', n]);
            })
          })
        );
      }
    }),
    w.fn.extend({
      queue: function (e, t) {
        var n = 2;
        return (
          'string' != typeof e && ((t = e), (e = 'fx'), n--),
          arguments.length < n
            ? w.queue(this[0], e)
            : void 0 === t
            ? this
            : this.each(function () {
                var n = w.queue(this, e, t);
                w._queueHooks(this, e), 'fx' === e && 'inprogress' !== n[0] && w.dequeue(this, e);
              })
        );
      },
      dequeue: function (e) {
        return this.each(function () {
          w.dequeue(this, e);
        });
      },
      clearQueue: function (e) {
        return this.queue(e || 'fx', []);
      },
      promise: function (e, t) {
        var n,
          r = 1,
          i = w.Deferred(),
          o = this,
          a = this.length,
          s = function () {
            --r || i.resolveWith(o, [o]);
          };
        'string' != typeof e && ((t = e), (e = void 0)), (e = e || 'fx');
        while (a--) (n = J.get(o[a], e + 'queueHooks')) && n.empty && (r++, n.empty.add(s));
        return s(), i.promise(t);
      }
    });
  var re = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
    ie = new RegExp('^(?:([+-])=|)(' + re + ')([a-z%]*)$', 'i'),
    oe = ['Top', 'Right', 'Bottom', 'Left'],
    ae = function (e, t) {
      return (
        'none' === (e = t || e).style.display ||
        ('' === e.style.display && w.contains(e.ownerDocument, e) && 'none' === w.css(e, 'display'))
      );
    },
    se = function (e, t, n, r) {
      var i,
        o,
        a = {};
      for (o in t) (a[o] = e.style[o]), (e.style[o] = t[o]);
      i = n.apply(e, r || []);
      for (o in t) e.style[o] = a[o];
      return i;
    };
  function ue(e, t, n, r) {
    var i,
      o,
      a = 20,
      s = r
        ? function () {
            return r.cur();
          }
        : function () {
            return w.css(e, t, '');
          },
      u = s(),
      l = (n && n[3]) || (w.cssNumber[t] ? '' : 'px'),
      c = (w.cssNumber[t] || ('px' !== l && +u)) && ie.exec(w.css(e, t));
    if (c && c[3] !== l) {
      (u /= 2), (l = l || c[3]), (c = +u || 1);
      while (a--)
        w.style(e, t, c + l), (1 - o) * (1 - (o = s() / u || 0.5)) <= 0 && (a = 0), (c /= o);
      (c *= 2), w.style(e, t, c + l), (n = n || []);
    }
    return (
      n &&
        ((c = +c || +u || 0),
        (i = n[1] ? c + (n[1] + 1) * n[2] : +n[2]),
        r && ((r.unit = l), (r.start = c), (r.end = i))),
      i
    );
  }
  var le = {};
  function ce(e) {
    var t,
      n = e.ownerDocument,
      r = e.nodeName,
      i = le[r];
    return (
      i ||
      ((t = n.body.appendChild(n.createElement(r))),
      (i = w.css(t, 'display')),
      t.parentNode.removeChild(t),
      'none' === i && (i = 'block'),
      (le[r] = i),
      i)
    );
  }
  function fe(e, t) {
    for (var n, r, i = [], o = 0, a = e.length; o < a; o++)
      (r = e[o]).style &&
        ((n = r.style.display),
        t
          ? ('none' === n && ((i[o] = J.get(r, 'display') || null), i[o] || (r.style.display = '')),
            '' === r.style.display && ae(r) && (i[o] = ce(r)))
          : 'none' !== n && ((i[o] = 'none'), J.set(r, 'display', n)));
    for (o = 0; o < a; o++) null != i[o] && (e[o].style.display = i[o]);
    return e;
  }
  w.fn.extend({
    show: function () {
      return fe(this, !0);
    },
    hide: function () {
      return fe(this);
    },
    toggle: function (e) {
      return 'boolean' == typeof e
        ? e
          ? this.show()
          : this.hide()
        : this.each(function () {
            ae(this) ? w(this).show() : w(this).hide();
          });
    }
  });
  var pe = /^(?:checkbox|radio)$/i,
    de = /<([a-z][^\/\0>\x20\t\r\n\f]+)/i,
    he = /^$|^module$|\/(?:java|ecma)script/i,
    ge = {
      option: [1, "<select multiple='multiple'>", '</select>'],
      thead: [1, '<table>', '</table>'],
      col: [2, '<table><colgroup>', '</colgroup></table>'],
      tr: [2, '<table><tbody>', '</tbody></table>'],
      td: [3, '<table><tbody><tr>', '</tr></tbody></table>'],
      _default: [0, '', '']
    };
  (ge.optgroup = ge.option),
    (ge.tbody = ge.tfoot = ge.colgroup = ge.caption = ge.thead),
    (ge.th = ge.td);
  function ye(e, t) {
    var n;
    return (
      (n =
        'undefined' != typeof e.getElementsByTagName
          ? e.getElementsByTagName(t || '*')
          : 'undefined' != typeof e.querySelectorAll
          ? e.querySelectorAll(t || '*')
          : []),
      void 0 === t || (t && N(e, t)) ? w.merge([e], n) : n
    );
  }
  function ve(e, t) {
    for (var n = 0, r = e.length; n < r; n++)
      J.set(e[n], 'globalEval', !t || J.get(t[n], 'globalEval'));
  }
  var me = /<|&#?\w+;/;
  function xe(e, t, n, r, i) {
    for (
      var o, a, s, u, l, c, f = t.createDocumentFragment(), p = [], d = 0, h = e.length;
      d < h;
      d++
    )
      if ((o = e[d]) || 0 === o)
        if ('object' === x(o)) w.merge(p, o.nodeType ? [o] : o);
        else if (me.test(o)) {
          (a = a || f.appendChild(t.createElement('div'))),
            (s = (de.exec(o) || ['', ''])[1].toLowerCase()),
            (u = ge[s] || ge._default),
            (a.innerHTML = u[1] + w.htmlPrefilter(o) + u[2]),
            (c = u[0]);
          while (c--) a = a.lastChild;
          w.merge(p, a.childNodes), ((a = f.firstChild).textContent = '');
        } else p.push(t.createTextNode(o));
    (f.textContent = ''), (d = 0);
    while ((o = p[d++]))
      if (r && w.inArray(o, r) > -1) i && i.push(o);
      else if (
        ((l = w.contains(o.ownerDocument, o)), (a = ye(f.appendChild(o), 'script')), l && ve(a), n)
      ) {
        c = 0;
        while ((o = a[c++])) he.test(o.type || '') && n.push(o);
      }
    return f;
  }
  !(function () {
    var e = r.createDocumentFragment().appendChild(r.createElement('div')),
      t = r.createElement('input');
    t.setAttribute('type', 'radio'),
      t.setAttribute('checked', 'checked'),
      t.setAttribute('name', 't'),
      e.appendChild(t),
      (h.checkClone = e.cloneNode(!0).cloneNode(!0).lastChild.checked),
      (e.innerHTML = '<textarea>x</textarea>'),
      (h.noCloneChecked = !!e.cloneNode(!0).lastChild.defaultValue);
  })();
  var be = r.documentElement,
    we = /^key/,
    Te = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
    Ce = /^([^.]*)(?:\.(.+)|)/;
  function Ee() {
    return !0;
  }
  function ke() {
    return !1;
  }
  function Se() {
    try {
      return r.activeElement;
    } catch (e) {}
  }
  function De(e, t, n, r, i, o) {
    var a, s;
    if ('object' == typeof t) {
      'string' != typeof n && ((r = r || n), (n = void 0));
      for (s in t) De(e, s, n, r, t[s], o);
      return e;
    }
    if (
      (null == r && null == i
        ? ((i = n), (r = n = void 0))
        : null == i &&
          ('string' == typeof n ? ((i = r), (r = void 0)) : ((i = r), (r = n), (n = void 0))),
      !1 === i)
    )
      i = ke;
    else if (!i) return e;
    return (
      1 === o &&
        ((a = i),
        ((i = function (e) {
          return w().off(e), a.apply(this, arguments);
        }).guid = a.guid || (a.guid = w.guid++))),
      e.each(function () {
        w.event.add(this, t, i, r, n);
      })
    );
  }
  (w.event = {
    global: {},
    add: function (e, t, n, r, i) {
      var o,
        a,
        s,
        u,
        l,
        c,
        f,
        p,
        d,
        h,
        g,
        y = J.get(e);
      if (y) {
        n.handler && ((n = (o = n).handler), (i = o.selector)),
          i && w.find.matchesSelector(be, i),
          n.guid || (n.guid = w.guid++),
          (u = y.events) || (u = y.events = {}),
          (a = y.handle) ||
            (a = y.handle =
              function (t) {
                return 'undefined' != typeof w && w.event.triggered !== t.type
                  ? w.event.dispatch.apply(e, arguments)
                  : void 0;
              }),
          (l = (t = (t || '').match(M) || ['']).length);
        while (l--)
          (d = g = (s = Ce.exec(t[l]) || [])[1]),
            (h = (s[2] || '').split('.').sort()),
            d &&
              ((f = w.event.special[d] || {}),
              (d = (i ? f.delegateType : f.bindType) || d),
              (f = w.event.special[d] || {}),
              (c = w.extend(
                {
                  type: d,
                  origType: g,
                  data: r,
                  handler: n,
                  guid: n.guid,
                  selector: i,
                  needsContext: i && w.expr.match.needsContext.test(i),
                  namespace: h.join('.')
                },
                o
              )),
              (p = u[d]) ||
                (((p = u[d] = []).delegateCount = 0),
                (f.setup && !1 !== f.setup.call(e, r, h, a)) ||
                  (e.addEventListener && e.addEventListener(d, a))),
              f.add && (f.add.call(e, c), c.handler.guid || (c.handler.guid = n.guid)),
              i ? p.splice(p.delegateCount++, 0, c) : p.push(c),
              (w.event.global[d] = !0));
      }
    },
    remove: function (e, t, n, r, i) {
      var o,
        a,
        s,
        u,
        l,
        c,
        f,
        p,
        d,
        h,
        g,
        y = J.hasData(e) && J.get(e);
      if (y && (u = y.events)) {
        l = (t = (t || '').match(M) || ['']).length;
        while (l--)
          if (
            ((s = Ce.exec(t[l]) || []), (d = g = s[1]), (h = (s[2] || '').split('.').sort()), d)
          ) {
            (f = w.event.special[d] || {}),
              (p = u[(d = (r ? f.delegateType : f.bindType) || d)] || []),
              (s = s[2] && new RegExp('(^|\\.)' + h.join('\\.(?:.*\\.|)') + '(\\.|$)')),
              (a = o = p.length);
            while (o--)
              (c = p[o]),
                (!i && g !== c.origType) ||
                  (n && n.guid !== c.guid) ||
                  (s && !s.test(c.namespace)) ||
                  (r && r !== c.selector && ('**' !== r || !c.selector)) ||
                  (p.splice(o, 1),
                  c.selector && p.delegateCount--,
                  f.remove && f.remove.call(e, c));
            a &&
              !p.length &&
              ((f.teardown && !1 !== f.teardown.call(e, h, y.handle)) ||
                w.removeEvent(e, d, y.handle),
              delete u[d]);
          } else for (d in u) w.event.remove(e, d + t[l], n, r, !0);
        w.isEmptyObject(u) && J.remove(e, 'handle events');
      }
    },
    dispatch: function (e) {
      var t = w.event.fix(e),
        n,
        r,
        i,
        o,
        a,
        s,
        u = new Array(arguments.length),
        l = (J.get(this, 'events') || {})[t.type] || [],
        c = w.event.special[t.type] || {};
      for (u[0] = t, n = 1; n < arguments.length; n++) u[n] = arguments[n];
      if (((t.delegateTarget = this), !c.preDispatch || !1 !== c.preDispatch.call(this, t))) {
        (s = w.event.handlers.call(this, t, l)), (n = 0);
        while ((o = s[n++]) && !t.isPropagationStopped()) {
          (t.currentTarget = o.elem), (r = 0);
          while ((a = o.handlers[r++]) && !t.isImmediatePropagationStopped())
            (t.rnamespace && !t.rnamespace.test(a.namespace)) ||
              ((t.handleObj = a),
              (t.data = a.data),
              void 0 !==
                (i = ((w.event.special[a.origType] || {}).handle || a.handler).apply(o.elem, u)) &&
                !1 === (t.result = i) &&
                (t.preventDefault(), t.stopPropagation()));
        }
        return c.postDispatch && c.postDispatch.call(this, t), t.result;
      }
    },
    handlers: function (e, t) {
      var n,
        r,
        i,
        o,
        a,
        s = [],
        u = t.delegateCount,
        l = e.target;
      if (u && l.nodeType && !('click' === e.type && e.button >= 1))
        for (; l !== this; l = l.parentNode || this)
          if (1 === l.nodeType && ('click' !== e.type || !0 !== l.disabled)) {
            for (o = [], a = {}, n = 0; n < u; n++)
              void 0 === a[(i = (r = t[n]).selector + ' ')] &&
                (a[i] = r.needsContext
                  ? w(i, this).index(l) > -1
                  : w.find(i, this, null, [l]).length),
                a[i] && o.push(r);
            o.length && s.push({elem: l, handlers: o});
          }
      return (l = this), u < t.length && s.push({elem: l, handlers: t.slice(u)}), s;
    },
    addProp: function (e, t) {
      Object.defineProperty(w.Event.prototype, e, {
        enumerable: !0,
        configurable: !0,
        get: g(t)
          ? function () {
              if (this.originalEvent) return t(this.originalEvent);
            }
          : function () {
              if (this.originalEvent) return this.originalEvent[e];
            },
        set: function (t) {
          Object.defineProperty(this, e, {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: t
          });
        }
      });
    },
    fix: function (e) {
      return e[w.expando] ? e : new w.Event(e);
    },
    special: {
      load: {noBubble: !0},
      focus: {
        trigger: function () {
          if (this !== Se() && this.focus) return this.focus(), !1;
        },
        delegateType: 'focusin'
      },
      blur: {
        trigger: function () {
          if (this === Se() && this.blur) return this.blur(), !1;
        },
        delegateType: 'focusout'
      },
      click: {
        trigger: function () {
          if ('checkbox' === this.type && this.click && N(this, 'input')) return this.click(), !1;
        },
        _default: function (e) {
          return N(e.target, 'a');
        }
      },
      beforeunload: {
        postDispatch: function (e) {
          void 0 !== e.result && e.originalEvent && (e.originalEvent.returnValue = e.result);
        }
      }
    }
  }),
    (w.removeEvent = function (e, t, n) {
      e.removeEventListener && e.removeEventListener(t, n);
    }),
    (w.Event = function (e, t) {
      if (!(this instanceof w.Event)) return new w.Event(e, t);
      e && e.type
        ? ((this.originalEvent = e),
          (this.type = e.type),
          (this.isDefaultPrevented =
            e.defaultPrevented || (void 0 === e.defaultPrevented && !1 === e.returnValue)
              ? Ee
              : ke),
          (this.target = e.target && 3 === e.target.nodeType ? e.target.parentNode : e.target),
          (this.currentTarget = e.currentTarget),
          (this.relatedTarget = e.relatedTarget))
        : (this.type = e),
        t && w.extend(this, t),
        (this.timeStamp = (e && e.timeStamp) || Date.now()),
        (this[w.expando] = !0);
    }),
    (w.Event.prototype = {
      constructor: w.Event,
      isDefaultPrevented: ke,
      isPropagationStopped: ke,
      isImmediatePropagationStopped: ke,
      isSimulated: !1,
      preventDefault: function () {
        var e = this.originalEvent;
        (this.isDefaultPrevented = Ee), e && !this.isSimulated && e.preventDefault();
      },
      stopPropagation: function () {
        var e = this.originalEvent;
        (this.isPropagationStopped = Ee), e && !this.isSimulated && e.stopPropagation();
      },
      stopImmediatePropagation: function () {
        var e = this.originalEvent;
        (this.isImmediatePropagationStopped = Ee),
          e && !this.isSimulated && e.stopImmediatePropagation(),
          this.stopPropagation();
      }
    }),
    w.each(
      {
        altKey: !0,
        bubbles: !0,
        cancelable: !0,
        changedTouches: !0,
        ctrlKey: !0,
        detail: !0,
        eventPhase: !0,
        metaKey: !0,
        pageX: !0,
        pageY: !0,
        shiftKey: !0,
        view: !0,
        char: !0,
        charCode: !0,
        key: !0,
        keyCode: !0,
        button: !0,
        buttons: !0,
        clientX: !0,
        clientY: !0,
        offsetX: !0,
        offsetY: !0,
        pointerId: !0,
        pointerType: !0,
        screenX: !0,
        screenY: !0,
        targetTouches: !0,
        toElement: !0,
        touches: !0,
        which: function (e) {
          var t = e.button;
          return null == e.which && we.test(e.type)
            ? null != e.charCode
              ? e.charCode
              : e.keyCode
            : !e.which && void 0 !== t && Te.test(e.type)
            ? 1 & t
              ? 1
              : 2 & t
              ? 3
              : 4 & t
              ? 2
              : 0
            : e.which;
        }
      },
      w.event.addProp
    ),
    w.each(
      {
        mouseenter: 'mouseover',
        mouseleave: 'mouseout',
        pointerenter: 'pointerover',
        pointerleave: 'pointerout'
      },
      function (e, t) {
        w.event.special[e] = {
          delegateType: t,
          bindType: t,
          handle: function (e) {
            var n,
              r = this,
              i = e.relatedTarget,
              o = e.handleObj;
            return (
              (i && (i === r || w.contains(r, i))) ||
                ((e.type = o.origType), (n = o.handler.apply(this, arguments)), (e.type = t)),
              n
            );
          }
        };
      }
    ),
    w.fn.extend({
      on: function (e, t, n, r) {
        return De(this, e, t, n, r);
      },
      one: function (e, t, n, r) {
        return De(this, e, t, n, r, 1);
      },
      off: function (e, t, n) {
        var r, i;
        if (e && e.preventDefault && e.handleObj)
          return (
            (r = e.handleObj),
            w(e.delegateTarget).off(
              r.namespace ? r.origType + '.' + r.namespace : r.origType,
              r.selector,
              r.handler
            ),
            this
          );
        if ('object' == typeof e) {
          for (i in e) this.off(i, t, e[i]);
          return this;
        }
        return (
          (!1 !== t && 'function' != typeof t) || ((n = t), (t = void 0)),
          !1 === n && (n = ke),
          this.each(function () {
            w.event.remove(this, e, n, t);
          })
        );
      }
    });
  var Ne =
      /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,
    Ae = /<script|<style|<link/i,
    je = /checked\s*(?:[^=]|=\s*.checked.)/i,
    qe = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
  function Le(e, t) {
    return N(e, 'table') && N(11 !== t.nodeType ? t : t.firstChild, 'tr')
      ? w(e).children('tbody')[0] || e
      : e;
  }
  function He(e) {
    return (e.type = (null !== e.getAttribute('type')) + '/' + e.type), e;
  }
  function Oe(e) {
    return (
      'true/' === (e.type || '').slice(0, 5)
        ? (e.type = e.type.slice(5))
        : e.removeAttribute('type'),
      e
    );
  }
  function Pe(e, t) {
    var n, r, i, o, a, s, u, l;
    if (1 === t.nodeType) {
      if (J.hasData(e) && ((o = J.access(e)), (a = J.set(t, o)), (l = o.events))) {
        delete a.handle, (a.events = {});
        for (i in l) for (n = 0, r = l[i].length; n < r; n++) w.event.add(t, i, l[i][n]);
      }
      K.hasData(e) && ((s = K.access(e)), (u = w.extend({}, s)), K.set(t, u));
    }
  }
  function Me(e, t) {
    var n = t.nodeName.toLowerCase();
    'input' === n && pe.test(e.type)
      ? (t.checked = e.checked)
      : ('input' !== n && 'textarea' !== n) || (t.defaultValue = e.defaultValue);
  }
  function Re(e, t, n, r) {
    t = a.apply([], t);
    var i,
      o,
      s,
      u,
      l,
      c,
      f = 0,
      p = e.length,
      d = p - 1,
      y = t[0],
      v = g(y);
    if (v || (p > 1 && 'string' == typeof y && !h.checkClone && je.test(y)))
      return e.each(function (i) {
        var o = e.eq(i);
        v && (t[0] = y.call(this, i, o.html())), Re(o, t, n, r);
      });
    if (
      p &&
      ((i = xe(t, e[0].ownerDocument, !1, e, r)),
      (o = i.firstChild),
      1 === i.childNodes.length && (i = o),
      o || r)
    ) {
      for (u = (s = w.map(ye(i, 'script'), He)).length; f < p; f++)
        (l = i),
          f !== d && ((l = w.clone(l, !0, !0)), u && w.merge(s, ye(l, 'script'))),
          n.call(e[f], l, f);
      if (u)
        for (c = s[s.length - 1].ownerDocument, w.map(s, Oe), f = 0; f < u; f++)
          (l = s[f]),
            he.test(l.type || '') &&
              !J.access(l, 'globalEval') &&
              w.contains(c, l) &&
              (l.src && 'module' !== (l.type || '').toLowerCase()
                ? w._evalUrl && w._evalUrl(l.src)
                : m(l.textContent.replace(qe, ''), c, l));
    }
    return e;
  }
  function Ie(e, t, n) {
    for (var r, i = t ? w.filter(t, e) : e, o = 0; null != (r = i[o]); o++)
      n || 1 !== r.nodeType || w.cleanData(ye(r)),
        r.parentNode &&
          (n && w.contains(r.ownerDocument, r) && ve(ye(r, 'script')), r.parentNode.removeChild(r));
    return e;
  }
  w.extend({
    htmlPrefilter: function (e) {
      return e.replace(Ne, '<$1></$2>');
    },
    clone: function (e, t, n) {
      var r,
        i,
        o,
        a,
        s = e.cloneNode(!0),
        u = w.contains(e.ownerDocument, e);
      if (!(h.noCloneChecked || (1 !== e.nodeType && 11 !== e.nodeType) || w.isXMLDoc(e)))
        for (a = ye(s), r = 0, i = (o = ye(e)).length; r < i; r++) Me(o[r], a[r]);
      if (t)
        if (n) for (o = o || ye(e), a = a || ye(s), r = 0, i = o.length; r < i; r++) Pe(o[r], a[r]);
        else Pe(e, s);
      return (a = ye(s, 'script')).length > 0 && ve(a, !u && ye(e, 'script')), s;
    },
    cleanData: function (e) {
      for (var t, n, r, i = w.event.special, o = 0; void 0 !== (n = e[o]); o++)
        if (Y(n)) {
          if ((t = n[J.expando])) {
            if (t.events)
              for (r in t.events) i[r] ? w.event.remove(n, r) : w.removeEvent(n, r, t.handle);
            n[J.expando] = void 0;
          }
          n[K.expando] && (n[K.expando] = void 0);
        }
    }
  }),
    w.fn.extend({
      detach: function (e) {
        return Ie(this, e, !0);
      },
      remove: function (e) {
        return Ie(this, e);
      },
      text: function (e) {
        return z(
          this,
          function (e) {
            return void 0 === e
              ? w.text(this)
              : this.empty().each(function () {
                  (1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType) ||
                    (this.textContent = e);
                });
          },
          null,
          e,
          arguments.length
        );
      },
      append: function () {
        return Re(this, arguments, function (e) {
          (1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType) ||
            Le(this, e).appendChild(e);
        });
      },
      prepend: function () {
        return Re(this, arguments, function (e) {
          if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
            var t = Le(this, e);
            t.insertBefore(e, t.firstChild);
          }
        });
      },
      before: function () {
        return Re(this, arguments, function (e) {
          this.parentNode && this.parentNode.insertBefore(e, this);
        });
      },
      after: function () {
        return Re(this, arguments, function (e) {
          this.parentNode && this.parentNode.insertBefore(e, this.nextSibling);
        });
      },
      empty: function () {
        for (var e, t = 0; null != (e = this[t]); t++)
          1 === e.nodeType && (w.cleanData(ye(e, !1)), (e.textContent = ''));
        return this;
      },
      clone: function (e, t) {
        return (
          (e = null != e && e),
          (t = null == t ? e : t),
          this.map(function () {
            return w.clone(this, e, t);
          })
        );
      },
      html: function (e) {
        return z(
          this,
          function (e) {
            var t = this[0] || {},
              n = 0,
              r = this.length;
            if (void 0 === e && 1 === t.nodeType) return t.innerHTML;
            if (
              'string' == typeof e &&
              !Ae.test(e) &&
              !ge[(de.exec(e) || ['', ''])[1].toLowerCase()]
            ) {
              e = w.htmlPrefilter(e);
              try {
                for (; n < r; n++)
                  1 === (t = this[n] || {}).nodeType && (w.cleanData(ye(t, !1)), (t.innerHTML = e));
                t = 0;
              } catch (e) {}
            }
            t && this.empty().append(e);
          },
          null,
          e,
          arguments.length
        );
      },
      replaceWith: function () {
        var e = [];
        return Re(
          this,
          arguments,
          function (t) {
            var n = this.parentNode;
            w.inArray(this, e) < 0 && (w.cleanData(ye(this)), n && n.replaceChild(t, this));
          },
          e
        );
      }
    }),
    w.each(
      {
        appendTo: 'append',
        prependTo: 'prepend',
        insertBefore: 'before',
        insertAfter: 'after',
        replaceAll: 'replaceWith'
      },
      function (e, t) {
        w.fn[e] = function (e) {
          for (var n, r = [], i = w(e), o = i.length - 1, a = 0; a <= o; a++)
            (n = a === o ? this : this.clone(!0)), w(i[a])[t](n), s.apply(r, n.get());
          return this.pushStack(r);
        };
      }
    );
  var We = new RegExp('^(' + re + ')(?!px)[a-z%]+$', 'i'),
    $e = function (t) {
      var n = t.ownerDocument.defaultView;
      return (n && n.opener) || (n = e), n.getComputedStyle(t);
    },
    Be = new RegExp(oe.join('|'), 'i');
  !(function () {
    function t() {
      if (c) {
        (l.style.cssText =
          'position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0'),
          (c.style.cssText =
            'position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%'),
          be.appendChild(l).appendChild(c);
        var t = e.getComputedStyle(c);
        (i = '1%' !== t.top),
          (u = 12 === n(t.marginLeft)),
          (c.style.right = '60%'),
          (s = 36 === n(t.right)),
          (o = 36 === n(t.width)),
          (c.style.position = 'absolute'),
          (a = 36 === c.offsetWidth || 'absolute'),
          be.removeChild(l),
          (c = null);
      }
    }
    function n(e) {
      return Math.round(parseFloat(e));
    }
    var i,
      o,
      a,
      s,
      u,
      l = r.createElement('div'),
      c = r.createElement('div');
    c.style &&
      ((c.style.backgroundClip = 'content-box'),
      (c.cloneNode(!0).style.backgroundClip = ''),
      (h.clearCloneStyle = 'content-box' === c.style.backgroundClip),
      w.extend(h, {
        boxSizingReliable: function () {
          return t(), o;
        },
        pixelBoxStyles: function () {
          return t(), s;
        },
        pixelPosition: function () {
          return t(), i;
        },
        reliableMarginLeft: function () {
          return t(), u;
        },
        scrollboxSize: function () {
          return t(), a;
        }
      }));
  })();
  function Fe(e, t, n) {
    var r,
      i,
      o,
      a,
      s = e.style;
    return (
      (n = n || $e(e)) &&
        ('' !== (a = n.getPropertyValue(t) || n[t]) ||
          w.contains(e.ownerDocument, e) ||
          (a = w.style(e, t)),
        !h.pixelBoxStyles() &&
          We.test(a) &&
          Be.test(t) &&
          ((r = s.width),
          (i = s.minWidth),
          (o = s.maxWidth),
          (s.minWidth = s.maxWidth = s.width = a),
          (a = n.width),
          (s.width = r),
          (s.minWidth = i),
          (s.maxWidth = o))),
      void 0 !== a ? a + '' : a
    );
  }
  function _e(e, t) {
    return {
      get: function () {
        if (!e()) return (this.get = t).apply(this, arguments);
        delete this.get;
      }
    };
  }
  var ze = /^(none|table(?!-c[ea]).+)/,
    Xe = /^--/,
    Ue = {position: 'absolute', visibility: 'hidden', display: 'block'},
    Ve = {letterSpacing: '0', fontWeight: '400'},
    Ge = ['Webkit', 'Moz', 'ms'],
    Ye = r.createElement('div').style;
  function Qe(e) {
    if (e in Ye) return e;
    var t = e[0].toUpperCase() + e.slice(1),
      n = Ge.length;
    while (n--) if ((e = Ge[n] + t) in Ye) return e;
  }
  function Je(e) {
    var t = w.cssProps[e];
    return t || (t = w.cssProps[e] = Qe(e) || e), t;
  }
  function Ke(e, t, n) {
    var r = ie.exec(t);
    return r ? Math.max(0, r[2] - (n || 0)) + (r[3] || 'px') : t;
  }
  function Ze(e, t, n, r, i, o) {
    var a = 'width' === t ? 1 : 0,
      s = 0,
      u = 0;
    if (n === (r ? 'border' : 'content')) return 0;
    for (; a < 4; a += 2)
      'margin' === n && (u += w.css(e, n + oe[a], !0, i)),
        r
          ? ('content' === n && (u -= w.css(e, 'padding' + oe[a], !0, i)),
            'margin' !== n && (u -= w.css(e, 'border' + oe[a] + 'Width', !0, i)))
          : ((u += w.css(e, 'padding' + oe[a], !0, i)),
            'padding' !== n
              ? (u += w.css(e, 'border' + oe[a] + 'Width', !0, i))
              : (s += w.css(e, 'border' + oe[a] + 'Width', !0, i)));
    return (
      !r &&
        o >= 0 &&
        (u += Math.max(
          0,
          Math.ceil(e['offset' + t[0].toUpperCase() + t.slice(1)] - o - u - s - 0.5)
        )),
      u
    );
  }
  function et(e, t, n) {
    var r = $e(e),
      i = Fe(e, t, r),
      o = 'border-box' === w.css(e, 'boxSizing', !1, r),
      a = o;
    if (We.test(i)) {
      if (!n) return i;
      i = 'auto';
    }
    return (
      (a = a && (h.boxSizingReliable() || i === e.style[t])),
      ('auto' === i || (!parseFloat(i) && 'inline' === w.css(e, 'display', !1, r))) &&
        ((i = e['offset' + t[0].toUpperCase() + t.slice(1)]), (a = !0)),
      (i = parseFloat(i) || 0) + Ze(e, t, n || (o ? 'border' : 'content'), a, r, i) + 'px'
    );
  }
  w.extend({
    cssHooks: {
      opacity: {
        get: function (e, t) {
          if (t) {
            var n = Fe(e, 'opacity');
            return '' === n ? '1' : n;
          }
        }
      }
    },
    cssNumber: {
      animationIterationCount: !0,
      columnCount: !0,
      fillOpacity: !0,
      flexGrow: !0,
      flexShrink: !0,
      fontWeight: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0
    },
    cssProps: {},
    style: function (e, t, n, r) {
      if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
        var i,
          o,
          a,
          s = G(t),
          u = Xe.test(t),
          l = e.style;
        if ((u || (t = Je(s)), (a = w.cssHooks[t] || w.cssHooks[s]), void 0 === n))
          return a && 'get' in a && void 0 !== (i = a.get(e, !1, r)) ? i : l[t];
        'string' == (o = typeof n) &&
          (i = ie.exec(n)) &&
          i[1] &&
          ((n = ue(e, t, i)), (o = 'number')),
          null != n &&
            n === n &&
            ('number' === o && (n += (i && i[3]) || (w.cssNumber[s] ? '' : 'px')),
            h.clearCloneStyle || '' !== n || 0 !== t.indexOf('background') || (l[t] = 'inherit'),
            (a && 'set' in a && void 0 === (n = a.set(e, n, r))) ||
              (u ? l.setProperty(t, n) : (l[t] = n)));
      }
    },
    css: function (e, t, n, r) {
      var i,
        o,
        a,
        s = G(t);
      return (
        Xe.test(t) || (t = Je(s)),
        (a = w.cssHooks[t] || w.cssHooks[s]) && 'get' in a && (i = a.get(e, !0, n)),
        void 0 === i && (i = Fe(e, t, r)),
        'normal' === i && t in Ve && (i = Ve[t]),
        '' === n || n ? ((o = parseFloat(i)), !0 === n || isFinite(o) ? o || 0 : i) : i
      );
    }
  }),
    w.each(['height', 'width'], function (e, t) {
      w.cssHooks[t] = {
        get: function (e, n, r) {
          if (n)
            return !ze.test(w.css(e, 'display')) ||
              (e.getClientRects().length && e.getBoundingClientRect().width)
              ? et(e, t, r)
              : se(e, Ue, function () {
                  return et(e, t, r);
                });
        },
        set: function (e, n, r) {
          var i,
            o = $e(e),
            a = 'border-box' === w.css(e, 'boxSizing', !1, o),
            s = r && Ze(e, t, r, a, o);
          return (
            a &&
              h.scrollboxSize() === o.position &&
              (s -= Math.ceil(
                e['offset' + t[0].toUpperCase() + t.slice(1)] -
                  parseFloat(o[t]) -
                  Ze(e, t, 'border', !1, o) -
                  0.5
              )),
            s &&
              (i = ie.exec(n)) &&
              'px' !== (i[3] || 'px') &&
              ((e.style[t] = n), (n = w.css(e, t))),
            Ke(e, n, s)
          );
        }
      };
    }),
    (w.cssHooks.marginLeft = _e(h.reliableMarginLeft, function (e, t) {
      if (t)
        return (
          (parseFloat(Fe(e, 'marginLeft')) ||
            e.getBoundingClientRect().left -
              se(e, {marginLeft: 0}, function () {
                return e.getBoundingClientRect().left;
              })) + 'px'
        );
    })),
    w.each({margin: '', padding: '', border: 'Width'}, function (e, t) {
      (w.cssHooks[e + t] = {
        expand: function (n) {
          for (var r = 0, i = {}, o = 'string' == typeof n ? n.split(' ') : [n]; r < 4; r++)
            i[e + oe[r] + t] = o[r] || o[r - 2] || o[0];
          return i;
        }
      }),
        'margin' !== e && (w.cssHooks[e + t].set = Ke);
    }),
    w.fn.extend({
      css: function (e, t) {
        return z(
          this,
          function (e, t, n) {
            var r,
              i,
              o = {},
              a = 0;
            if (Array.isArray(t)) {
              for (r = $e(e), i = t.length; a < i; a++) o[t[a]] = w.css(e, t[a], !1, r);
              return o;
            }
            return void 0 !== n ? w.style(e, t, n) : w.css(e, t);
          },
          e,
          t,
          arguments.length > 1
        );
      }
    });
  function tt(e, t, n, r, i) {
    return new tt.prototype.init(e, t, n, r, i);
  }
  (w.Tween = tt),
    (tt.prototype = {
      constructor: tt,
      init: function (e, t, n, r, i, o) {
        (this.elem = e),
          (this.prop = n),
          (this.easing = i || w.easing._default),
          (this.options = t),
          (this.start = this.now = this.cur()),
          (this.end = r),
          (this.unit = o || (w.cssNumber[n] ? '' : 'px'));
      },
      cur: function () {
        var e = tt.propHooks[this.prop];
        return e && e.get ? e.get(this) : tt.propHooks._default.get(this);
      },
      run: function (e) {
        var t,
          n = tt.propHooks[this.prop];
        return (
          this.options.duration
            ? (this.pos = t =
                w.easing[this.easing](e, this.options.duration * e, 0, 1, this.options.duration))
            : (this.pos = t = e),
          (this.now = (this.end - this.start) * t + this.start),
          this.options.step && this.options.step.call(this.elem, this.now, this),
          n && n.set ? n.set(this) : tt.propHooks._default.set(this),
          this
        );
      }
    }),
    (tt.prototype.init.prototype = tt.prototype),
    (tt.propHooks = {
      _default: {
        get: function (e) {
          var t;
          return 1 !== e.elem.nodeType || (null != e.elem[e.prop] && null == e.elem.style[e.prop])
            ? e.elem[e.prop]
            : (t = w.css(e.elem, e.prop, '')) && 'auto' !== t
            ? t
            : 0;
        },
        set: function (e) {
          w.fx.step[e.prop]
            ? w.fx.step[e.prop](e)
            : 1 !== e.elem.nodeType ||
              (null == e.elem.style[w.cssProps[e.prop]] && !w.cssHooks[e.prop])
            ? (e.elem[e.prop] = e.now)
            : w.style(e.elem, e.prop, e.now + e.unit);
        }
      }
    }),
    (tt.propHooks.scrollTop = tt.propHooks.scrollLeft =
      {
        set: function (e) {
          e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now);
        }
      }),
    (w.easing = {
      linear: function (e) {
        return e;
      },
      swing: function (e) {
        return 0.5 - Math.cos(e * Math.PI) / 2;
      },
      _default: 'swing'
    }),
    (w.fx = tt.prototype.init),
    (w.fx.step = {});
  var nt,
    rt,
    it = /^(?:toggle|show|hide)$/,
    ot = /queueHooks$/;
  function at() {
    rt &&
      (!1 === r.hidden && e.requestAnimationFrame
        ? e.requestAnimationFrame(at)
        : e.setTimeout(at, w.fx.interval),
      w.fx.tick());
  }
  function st() {
    return (
      e.setTimeout(function () {
        nt = void 0;
      }),
      (nt = Date.now())
    );
  }
  function ut(e, t) {
    var n,
      r = 0,
      i = {height: e};
    for (t = t ? 1 : 0; r < 4; r += 2 - t) i['margin' + (n = oe[r])] = i['padding' + n] = e;
    return t && (i.opacity = i.width = e), i;
  }
  function lt(e, t, n) {
    for (
      var r, i = (pt.tweeners[t] || []).concat(pt.tweeners['*']), o = 0, a = i.length;
      o < a;
      o++
    )
      if ((r = i[o].call(n, t, e))) return r;
  }
  function ct(e, t, n) {
    var r,
      i,
      o,
      a,
      s,
      u,
      l,
      c,
      f = 'width' in t || 'height' in t,
      p = this,
      d = {},
      h = e.style,
      g = e.nodeType && ae(e),
      y = J.get(e, 'fxshow');
    n.queue ||
      (null == (a = w._queueHooks(e, 'fx')).unqueued &&
        ((a.unqueued = 0),
        (s = a.empty.fire),
        (a.empty.fire = function () {
          a.unqueued || s();
        })),
      a.unqueued++,
      p.always(function () {
        p.always(function () {
          a.unqueued--, w.queue(e, 'fx').length || a.empty.fire();
        });
      }));
    for (r in t)
      if (((i = t[r]), it.test(i))) {
        if ((delete t[r], (o = o || 'toggle' === i), i === (g ? 'hide' : 'show'))) {
          if ('show' !== i || !y || void 0 === y[r]) continue;
          g = !0;
        }
        d[r] = (y && y[r]) || w.style(e, r);
      }
    if ((u = !w.isEmptyObject(t)) || !w.isEmptyObject(d)) {
      f &&
        1 === e.nodeType &&
        ((n.overflow = [h.overflow, h.overflowX, h.overflowY]),
        null == (l = y && y.display) && (l = J.get(e, 'display')),
        'none' === (c = w.css(e, 'display')) &&
          (l
            ? (c = l)
            : (fe([e], !0), (l = e.style.display || l), (c = w.css(e, 'display')), fe([e]))),
        ('inline' === c || ('inline-block' === c && null != l)) &&
          'none' === w.css(e, 'float') &&
          (u ||
            (p.done(function () {
              h.display = l;
            }),
            null == l && ((c = h.display), (l = 'none' === c ? '' : c))),
          (h.display = 'inline-block'))),
        n.overflow &&
          ((h.overflow = 'hidden'),
          p.always(function () {
            (h.overflow = n.overflow[0]),
              (h.overflowX = n.overflow[1]),
              (h.overflowY = n.overflow[2]);
          })),
        (u = !1);
      for (r in d)
        u ||
          (y ? 'hidden' in y && (g = y.hidden) : (y = J.access(e, 'fxshow', {display: l})),
          o && (y.hidden = !g),
          g && fe([e], !0),
          p.done(function () {
            g || fe([e]), J.remove(e, 'fxshow');
            for (r in d) w.style(e, r, d[r]);
          })),
          (u = lt(g ? y[r] : 0, r, p)),
          r in y || ((y[r] = u.start), g && ((u.end = u.start), (u.start = 0)));
    }
  }
  function ft(e, t) {
    var n, r, i, o, a;
    for (n in e)
      if (
        ((r = G(n)),
        (i = t[r]),
        (o = e[n]),
        Array.isArray(o) && ((i = o[1]), (o = e[n] = o[0])),
        n !== r && ((e[r] = o), delete e[n]),
        (a = w.cssHooks[r]) && 'expand' in a)
      ) {
        (o = a.expand(o)), delete e[r];
        for (n in o) n in e || ((e[n] = o[n]), (t[n] = i));
      } else t[r] = i;
  }
  function pt(e, t, n) {
    var r,
      i,
      o = 0,
      a = pt.prefilters.length,
      s = w.Deferred().always(function () {
        delete u.elem;
      }),
      u = function () {
        if (i) return !1;
        for (
          var t = nt || st(),
            n = Math.max(0, l.startTime + l.duration - t),
            r = 1 - (n / l.duration || 0),
            o = 0,
            a = l.tweens.length;
          o < a;
          o++
        )
          l.tweens[o].run(r);
        return (
          s.notifyWith(e, [l, r, n]),
          r < 1 && a ? n : (a || s.notifyWith(e, [l, 1, 0]), s.resolveWith(e, [l]), !1)
        );
      },
      l = s.promise({
        elem: e,
        props: w.extend({}, t),
        opts: w.extend(!0, {specialEasing: {}, easing: w.easing._default}, n),
        originalProperties: t,
        originalOptions: n,
        startTime: nt || st(),
        duration: n.duration,
        tweens: [],
        createTween: function (t, n) {
          var r = w.Tween(e, l.opts, t, n, l.opts.specialEasing[t] || l.opts.easing);
          return l.tweens.push(r), r;
        },
        stop: function (t) {
          var n = 0,
            r = t ? l.tweens.length : 0;
          if (i) return this;
          for (i = !0; n < r; n++) l.tweens[n].run(1);
          return (
            t ? (s.notifyWith(e, [l, 1, 0]), s.resolveWith(e, [l, t])) : s.rejectWith(e, [l, t]),
            this
          );
        }
      }),
      c = l.props;
    for (ft(c, l.opts.specialEasing); o < a; o++)
      if ((r = pt.prefilters[o].call(l, e, c, l.opts)))
        return g(r.stop) && (w._queueHooks(l.elem, l.opts.queue).stop = r.stop.bind(r)), r;
    return (
      w.map(c, lt, l),
      g(l.opts.start) && l.opts.start.call(e, l),
      l
        .progress(l.opts.progress)
        .done(l.opts.done, l.opts.complete)
        .fail(l.opts.fail)
        .always(l.opts.always),
      w.fx.timer(w.extend(u, {elem: e, anim: l, queue: l.opts.queue})),
      l
    );
  }
  (w.Animation = w.extend(pt, {
    tweeners: {
      '*': [
        function (e, t) {
          var n = this.createTween(e, t);
          return ue(n.elem, e, ie.exec(t), n), n;
        }
      ]
    },
    tweener: function (e, t) {
      g(e) ? ((t = e), (e = ['*'])) : (e = e.match(M));
      for (var n, r = 0, i = e.length; r < i; r++)
        (n = e[r]), (pt.tweeners[n] = pt.tweeners[n] || []), pt.tweeners[n].unshift(t);
    },
    prefilters: [ct],
    prefilter: function (e, t) {
      t ? pt.prefilters.unshift(e) : pt.prefilters.push(e);
    }
  })),
    (w.speed = function (e, t, n) {
      var r =
        e && 'object' == typeof e
          ? w.extend({}, e)
          : {
              complete: n || (!n && t) || (g(e) && e),
              duration: e,
              easing: (n && t) || (t && !g(t) && t)
            };
      return (
        w.fx.off
          ? (r.duration = 0)
          : 'number' != typeof r.duration &&
            (r.duration in w.fx.speeds
              ? (r.duration = w.fx.speeds[r.duration])
              : (r.duration = w.fx.speeds._default)),
        (null != r.queue && !0 !== r.queue) || (r.queue = 'fx'),
        (r.old = r.complete),
        (r.complete = function () {
          g(r.old) && r.old.call(this), r.queue && w.dequeue(this, r.queue);
        }),
        r
      );
    }),
    w.fn.extend({
      fadeTo: function (e, t, n, r) {
        return this.filter(ae).css('opacity', 0).show().end().animate({opacity: t}, e, n, r);
      },
      animate: function (e, t, n, r) {
        var i = w.isEmptyObject(e),
          o = w.speed(t, n, r),
          a = function () {
            var t = pt(this, w.extend({}, e), o);
            (i || J.get(this, 'finish')) && t.stop(!0);
          };
        return (a.finish = a), i || !1 === o.queue ? this.each(a) : this.queue(o.queue, a);
      },
      stop: function (e, t, n) {
        var r = function (e) {
          var t = e.stop;
          delete e.stop, t(n);
        };
        return (
          'string' != typeof e && ((n = t), (t = e), (e = void 0)),
          t && !1 !== e && this.queue(e || 'fx', []),
          this.each(function () {
            var t = !0,
              i = null != e && e + 'queueHooks',
              o = w.timers,
              a = J.get(this);
            if (i) a[i] && a[i].stop && r(a[i]);
            else for (i in a) a[i] && a[i].stop && ot.test(i) && r(a[i]);
            for (i = o.length; i--; )
              o[i].elem !== this ||
                (null != e && o[i].queue !== e) ||
                (o[i].anim.stop(n), (t = !1), o.splice(i, 1));
            (!t && n) || w.dequeue(this, e);
          })
        );
      },
      finish: function (e) {
        return (
          !1 !== e && (e = e || 'fx'),
          this.each(function () {
            var t,
              n = J.get(this),
              r = n[e + 'queue'],
              i = n[e + 'queueHooks'],
              o = w.timers,
              a = r ? r.length : 0;
            for (
              n.finish = !0,
                w.queue(this, e, []),
                i && i.stop && i.stop.call(this, !0),
                t = o.length;
              t--;

            )
              o[t].elem === this && o[t].queue === e && (o[t].anim.stop(!0), o.splice(t, 1));
            for (t = 0; t < a; t++) r[t] && r[t].finish && r[t].finish.call(this);
            delete n.finish;
          })
        );
      }
    }),
    w.each(['toggle', 'show', 'hide'], function (e, t) {
      var n = w.fn[t];
      w.fn[t] = function (e, r, i) {
        return null == e || 'boolean' == typeof e
          ? n.apply(this, arguments)
          : this.animate(ut(t, !0), e, r, i);
      };
    }),
    w.each(
      {
        slideDown: ut('show'),
        slideUp: ut('hide'),
        slideToggle: ut('toggle'),
        fadeIn: {opacity: 'show'},
        fadeOut: {opacity: 'hide'},
        fadeToggle: {opacity: 'toggle'}
      },
      function (e, t) {
        w.fn[e] = function (e, n, r) {
          return this.animate(t, e, n, r);
        };
      }
    ),
    (w.timers = []),
    (w.fx.tick = function () {
      var e,
        t = 0,
        n = w.timers;
      for (nt = Date.now(); t < n.length; t++) (e = n[t])() || n[t] !== e || n.splice(t--, 1);
      n.length || w.fx.stop(), (nt = void 0);
    }),
    (w.fx.timer = function (e) {
      w.timers.push(e), w.fx.start();
    }),
    (w.fx.interval = 13),
    (w.fx.start = function () {
      rt || ((rt = !0), at());
    }),
    (w.fx.stop = function () {
      rt = null;
    }),
    (w.fx.speeds = {slow: 600, fast: 200, _default: 400}),
    (w.fn.delay = function (t, n) {
      return (
        (t = w.fx ? w.fx.speeds[t] || t : t),
        (n = n || 'fx'),
        this.queue(n, function (n, r) {
          var i = e.setTimeout(n, t);
          r.stop = function () {
            e.clearTimeout(i);
          };
        })
      );
    }),
    (function () {
      var e = r.createElement('input'),
        t = r.createElement('select').appendChild(r.createElement('option'));
      (e.type = 'checkbox'),
        (h.checkOn = '' !== e.value),
        (h.optSelected = t.selected),
        ((e = r.createElement('input')).value = 't'),
        (e.type = 'radio'),
        (h.radioValue = 't' === e.value);
    })();
  var dt,
    ht = w.expr.attrHandle;
  w.fn.extend({
    attr: function (e, t) {
      return z(this, w.attr, e, t, arguments.length > 1);
    },
    removeAttr: function (e) {
      return this.each(function () {
        w.removeAttr(this, e);
      });
    }
  }),
    w.extend({
      attr: function (e, t, n) {
        var r,
          i,
          o = e.nodeType;
        if (3 !== o && 8 !== o && 2 !== o)
          return 'undefined' == typeof e.getAttribute
            ? w.prop(e, t, n)
            : ((1 === o && w.isXMLDoc(e)) ||
                (i = w.attrHooks[t.toLowerCase()] || (w.expr.match.bool.test(t) ? dt : void 0)),
              void 0 !== n
                ? null === n
                  ? void w.removeAttr(e, t)
                  : i && 'set' in i && void 0 !== (r = i.set(e, n, t))
                  ? r
                  : (e.setAttribute(t, n + ''), n)
                : i && 'get' in i && null !== (r = i.get(e, t))
                ? r
                : null == (r = w.find.attr(e, t))
                ? void 0
                : r);
      },
      attrHooks: {
        type: {
          set: function (e, t) {
            if (!h.radioValue && 'radio' === t && N(e, 'input')) {
              var n = e.value;
              return e.setAttribute('type', t), n && (e.value = n), t;
            }
          }
        }
      },
      removeAttr: function (e, t) {
        var n,
          r = 0,
          i = t && t.match(M);
        if (i && 1 === e.nodeType) while ((n = i[r++])) e.removeAttribute(n);
      }
    }),
    (dt = {
      set: function (e, t, n) {
        return !1 === t ? w.removeAttr(e, n) : e.setAttribute(n, n), n;
      }
    }),
    w.each(w.expr.match.bool.source.match(/\w+/g), function (e, t) {
      var n = ht[t] || w.find.attr;
      ht[t] = function (e, t, r) {
        var i,
          o,
          a = t.toLowerCase();
        return r || ((o = ht[a]), (ht[a] = i), (i = null != n(e, t, r) ? a : null), (ht[a] = o)), i;
      };
    });
  var gt = /^(?:input|select|textarea|button)$/i,
    yt = /^(?:a|area)$/i;
  w.fn.extend({
    prop: function (e, t) {
      return z(this, w.prop, e, t, arguments.length > 1);
    },
    removeProp: function (e) {
      return this.each(function () {
        delete this[w.propFix[e] || e];
      });
    }
  }),
    w.extend({
      prop: function (e, t, n) {
        var r,
          i,
          o = e.nodeType;
        if (3 !== o && 8 !== o && 2 !== o)
          return (
            (1 === o && w.isXMLDoc(e)) || ((t = w.propFix[t] || t), (i = w.propHooks[t])),
            void 0 !== n
              ? i && 'set' in i && void 0 !== (r = i.set(e, n, t))
                ? r
                : (e[t] = n)
              : i && 'get' in i && null !== (r = i.get(e, t))
              ? r
              : e[t]
          );
      },
      propHooks: {
        tabIndex: {
          get: function (e) {
            var t = w.find.attr(e, 'tabindex');
            return t
              ? parseInt(t, 10)
              : gt.test(e.nodeName) || (yt.test(e.nodeName) && e.href)
              ? 0
              : -1;
          }
        }
      },
      propFix: {for: 'htmlFor', class: 'className'}
    }),
    h.optSelected ||
      (w.propHooks.selected = {
        get: function (e) {
          var t = e.parentNode;
          return t && t.parentNode && t.parentNode.selectedIndex, null;
        },
        set: function (e) {
          var t = e.parentNode;
          t && (t.selectedIndex, t.parentNode && t.parentNode.selectedIndex);
        }
      }),
    w.each(
      [
        'tabIndex',
        'readOnly',
        'maxLength',
        'cellSpacing',
        'cellPadding',
        'rowSpan',
        'colSpan',
        'useMap',
        'frameBorder',
        'contentEditable'
      ],
      function () {
        w.propFix[this.toLowerCase()] = this;
      }
    );
  function vt(e) {
    return (e.match(M) || []).join(' ');
  }
  function mt(e) {
    return (e.getAttribute && e.getAttribute('class')) || '';
  }
  function xt(e) {
    return Array.isArray(e) ? e : 'string' == typeof e ? e.match(M) || [] : [];
  }
  w.fn.extend({
    addClass: function (e) {
      var t,
        n,
        r,
        i,
        o,
        a,
        s,
        u = 0;
      if (g(e))
        return this.each(function (t) {
          w(this).addClass(e.call(this, t, mt(this)));
        });
      if ((t = xt(e)).length)
        while ((n = this[u++]))
          if (((i = mt(n)), (r = 1 === n.nodeType && ' ' + vt(i) + ' '))) {
            a = 0;
            while ((o = t[a++])) r.indexOf(' ' + o + ' ') < 0 && (r += o + ' ');
            i !== (s = vt(r)) && n.setAttribute('class', s);
          }
      return this;
    },
    removeClass: function (e) {
      var t,
        n,
        r,
        i,
        o,
        a,
        s,
        u = 0;
      if (g(e))
        return this.each(function (t) {
          w(this).removeClass(e.call(this, t, mt(this)));
        });
      if (!arguments.length) return this.attr('class', '');
      if ((t = xt(e)).length)
        while ((n = this[u++]))
          if (((i = mt(n)), (r = 1 === n.nodeType && ' ' + vt(i) + ' '))) {
            a = 0;
            while ((o = t[a++]))
              while (r.indexOf(' ' + o + ' ') > -1) r = r.replace(' ' + o + ' ', ' ');
            i !== (s = vt(r)) && n.setAttribute('class', s);
          }
      return this;
    },
    toggleClass: function (e, t) {
      var n = typeof e,
        r = 'string' === n || Array.isArray(e);
      return 'boolean' == typeof t && r
        ? t
          ? this.addClass(e)
          : this.removeClass(e)
        : g(e)
        ? this.each(function (n) {
            w(this).toggleClass(e.call(this, n, mt(this), t), t);
          })
        : this.each(function () {
            var t, i, o, a;
            if (r) {
              (i = 0), (o = w(this)), (a = xt(e));
              while ((t = a[i++])) o.hasClass(t) ? o.removeClass(t) : o.addClass(t);
            } else (void 0 !== e && 'boolean' !== n) || ((t = mt(this)) && J.set(this, '__className__', t), this.setAttribute && this.setAttribute('class', t || !1 === e ? '' : J.get(this, '__className__') || ''));
          });
    },
    hasClass: function (e) {
      var t,
        n,
        r = 0;
      t = ' ' + e + ' ';
      while ((n = this[r++]))
        if (1 === n.nodeType && (' ' + vt(mt(n)) + ' ').indexOf(t) > -1) return !0;
      return !1;
    }
  });
  var bt = /\r/g;
  w.fn.extend({
    val: function (e) {
      var t,
        n,
        r,
        i = this[0];
      {
        if (arguments.length)
          return (
            (r = g(e)),
            this.each(function (n) {
              var i;
              1 === this.nodeType &&
                (null == (i = r ? e.call(this, n, w(this).val()) : e)
                  ? (i = '')
                  : 'number' == typeof i
                  ? (i += '')
                  : Array.isArray(i) &&
                    (i = w.map(i, function (e) {
                      return null == e ? '' : e + '';
                    })),
                ((t = w.valHooks[this.type] || w.valHooks[this.nodeName.toLowerCase()]) &&
                  'set' in t &&
                  void 0 !== t.set(this, i, 'value')) ||
                  (this.value = i));
            })
          );
        if (i)
          return (t = w.valHooks[i.type] || w.valHooks[i.nodeName.toLowerCase()]) &&
            'get' in t &&
            void 0 !== (n = t.get(i, 'value'))
            ? n
            : 'string' == typeof (n = i.value)
            ? n.replace(bt, '')
            : null == n
            ? ''
            : n;
      }
    }
  }),
    w.extend({
      valHooks: {
        option: {
          get: function (e) {
            var t = w.find.attr(e, 'value');
            return null != t ? t : vt(w.text(e));
          }
        },
        select: {
          get: function (e) {
            var t,
              n,
              r,
              i = e.options,
              o = e.selectedIndex,
              a = 'select-one' === e.type,
              s = a ? null : [],
              u = a ? o + 1 : i.length;
            for (r = o < 0 ? u : a ? o : 0; r < u; r++)
              if (
                ((n = i[r]).selected || r === o) &&
                !n.disabled &&
                (!n.parentNode.disabled || !N(n.parentNode, 'optgroup'))
              ) {
                if (((t = w(n).val()), a)) return t;
                s.push(t);
              }
            return s;
          },
          set: function (e, t) {
            var n,
              r,
              i = e.options,
              o = w.makeArray(t),
              a = i.length;
            while (a--)
              ((r = i[a]).selected = w.inArray(w.valHooks.option.get(r), o) > -1) && (n = !0);
            return n || (e.selectedIndex = -1), o;
          }
        }
      }
    }),
    w.each(['radio', 'checkbox'], function () {
      (w.valHooks[this] = {
        set: function (e, t) {
          if (Array.isArray(t)) return (e.checked = w.inArray(w(e).val(), t) > -1);
        }
      }),
        h.checkOn ||
          (w.valHooks[this].get = function (e) {
            return null === e.getAttribute('value') ? 'on' : e.value;
          });
    }),
    (h.focusin = 'onfocusin' in e);
  var wt = /^(?:focusinfocus|focusoutblur)$/,
    Tt = function (e) {
      e.stopPropagation();
    };
  w.extend(w.event, {
    trigger: function (t, n, i, o) {
      var a,
        s,
        u,
        l,
        c,
        p,
        d,
        h,
        v = [i || r],
        m = f.call(t, 'type') ? t.type : t,
        x = f.call(t, 'namespace') ? t.namespace.split('.') : [];
      if (
        ((s = h = u = i = i || r),
        3 !== i.nodeType &&
          8 !== i.nodeType &&
          !wt.test(m + w.event.triggered) &&
          (m.indexOf('.') > -1 && ((m = (x = m.split('.')).shift()), x.sort()),
          (c = m.indexOf(':') < 0 && 'on' + m),
          (t = t[w.expando] ? t : new w.Event(m, 'object' == typeof t && t)),
          (t.isTrigger = o ? 2 : 3),
          (t.namespace = x.join('.')),
          (t.rnamespace = t.namespace
            ? new RegExp('(^|\\.)' + x.join('\\.(?:.*\\.|)') + '(\\.|$)')
            : null),
          (t.result = void 0),
          t.target || (t.target = i),
          (n = null == n ? [t] : w.makeArray(n, [t])),
          (d = w.event.special[m] || {}),
          o || !d.trigger || !1 !== d.trigger.apply(i, n)))
      ) {
        if (!o && !d.noBubble && !y(i)) {
          for (l = d.delegateType || m, wt.test(l + m) || (s = s.parentNode); s; s = s.parentNode)
            v.push(s), (u = s);
          u === (i.ownerDocument || r) && v.push(u.defaultView || u.parentWindow || e);
        }
        a = 0;
        while ((s = v[a++]) && !t.isPropagationStopped())
          (h = s),
            (t.type = a > 1 ? l : d.bindType || m),
            (p = (J.get(s, 'events') || {})[t.type] && J.get(s, 'handle')) && p.apply(s, n),
            (p = c && s[c]) &&
              p.apply &&
              Y(s) &&
              ((t.result = p.apply(s, n)), !1 === t.result && t.preventDefault());
        return (
          (t.type = m),
          o ||
            t.isDefaultPrevented() ||
            (d._default && !1 !== d._default.apply(v.pop(), n)) ||
            !Y(i) ||
            (c &&
              g(i[m]) &&
              !y(i) &&
              ((u = i[c]) && (i[c] = null),
              (w.event.triggered = m),
              t.isPropagationStopped() && h.addEventListener(m, Tt),
              i[m](),
              t.isPropagationStopped() && h.removeEventListener(m, Tt),
              (w.event.triggered = void 0),
              u && (i[c] = u))),
          t.result
        );
      }
    },
    simulate: function (e, t, n) {
      var r = w.extend(new w.Event(), n, {type: e, isSimulated: !0});
      w.event.trigger(r, null, t);
    }
  }),
    w.fn.extend({
      trigger: function (e, t) {
        return this.each(function () {
          w.event.trigger(e, t, this);
        });
      },
      triggerHandler: function (e, t) {
        var n = this[0];
        if (n) return w.event.trigger(e, t, n, !0);
      }
    }),
    h.focusin ||
      w.each({focus: 'focusin', blur: 'focusout'}, function (e, t) {
        var n = function (e) {
          w.event.simulate(t, e.target, w.event.fix(e));
        };
        w.event.special[t] = {
          setup: function () {
            var r = this.ownerDocument || this,
              i = J.access(r, t);
            i || r.addEventListener(e, n, !0), J.access(r, t, (i || 0) + 1);
          },
          teardown: function () {
            var r = this.ownerDocument || this,
              i = J.access(r, t) - 1;
            i ? J.access(r, t, i) : (r.removeEventListener(e, n, !0), J.remove(r, t));
          }
        };
      });
  var Ct = e.location,
    Et = Date.now(),
    kt = /\?/;
  w.parseXML = function (t) {
    var n;
    if (!t || 'string' != typeof t) return null;
    try {
      n = new e.DOMParser().parseFromString(t, 'text/xml');
    } catch (e) {
      n = void 0;
    }
    return (n && !n.getElementsByTagName('parsererror').length) || w.error('Invalid XML: ' + t), n;
  };
  var St = /\[\]$/,
    Dt = /\r?\n/g,
    Nt = /^(?:submit|button|image|reset|file)$/i,
    At = /^(?:input|select|textarea|keygen)/i;
  function jt(e, t, n, r) {
    var i;
    if (Array.isArray(t))
      w.each(t, function (t, i) {
        n || St.test(e)
          ? r(e, i)
          : jt(e + '[' + ('object' == typeof i && null != i ? t : '') + ']', i, n, r);
      });
    else if (n || 'object' !== x(t)) r(e, t);
    else for (i in t) jt(e + '[' + i + ']', t[i], n, r);
  }
  (w.param = function (e, t) {
    var n,
      r = [],
      i = function (e, t) {
        var n = g(t) ? t() : t;
        r[r.length] = encodeURIComponent(e) + '=' + encodeURIComponent(null == n ? '' : n);
      };
    if (Array.isArray(e) || (e.jquery && !w.isPlainObject(e)))
      w.each(e, function () {
        i(this.name, this.value);
      });
    else for (n in e) jt(n, e[n], t, i);
    return r.join('&');
  }),
    w.fn.extend({
      serialize: function () {
        return w.param(this.serializeArray());
      },
      serializeArray: function () {
        return this.map(function () {
          var e = w.prop(this, 'elements');
          return e ? w.makeArray(e) : this;
        })
          .filter(function () {
            var e = this.type;
            return (
              this.name &&
              !w(this).is(':disabled') &&
              At.test(this.nodeName) &&
              !Nt.test(e) &&
              (this.checked || !pe.test(e))
            );
          })
          .map(function (e, t) {
            var n = w(this).val();
            return null == n
              ? null
              : Array.isArray(n)
              ? w.map(n, function (e) {
                  return {name: t.name, value: e.replace(Dt, '\r\n')};
                })
              : {name: t.name, value: n.replace(Dt, '\r\n')};
          })
          .get();
      }
    });
  var qt = /%20/g,
    Lt = /#.*$/,
    Ht = /([?&])_=[^&]*/,
    Ot = /^(.*?):[ \t]*([^\r\n]*)$/gm,
    Pt = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
    Mt = /^(?:GET|HEAD)$/,
    Rt = /^\/\//,
    It = {},
    Wt = {},
    $t = '*/'.concat('*'),
    Bt = r.createElement('a');
  Bt.href = Ct.href;
  function Ft(e) {
    return function (t, n) {
      'string' != typeof t && ((n = t), (t = '*'));
      var r,
        i = 0,
        o = t.toLowerCase().match(M) || [];
      if (g(n))
        while ((r = o[i++]))
          '+' === r[0]
            ? ((r = r.slice(1) || '*'), (e[r] = e[r] || []).unshift(n))
            : (e[r] = e[r] || []).push(n);
    };
  }
  function _t(e, t, n, r) {
    var i = {},
      o = e === Wt;
    function a(s) {
      var u;
      return (
        (i[s] = !0),
        w.each(e[s] || [], function (e, s) {
          var l = s(t, n, r);
          return 'string' != typeof l || o || i[l]
            ? o
              ? !(u = l)
              : void 0
            : (t.dataTypes.unshift(l), a(l), !1);
        }),
        u
      );
    }
    return a(t.dataTypes[0]) || (!i['*'] && a('*'));
  }
  function zt(e, t) {
    var n,
      r,
      i = w.ajaxSettings.flatOptions || {};
    for (n in t) void 0 !== t[n] && ((i[n] ? e : r || (r = {}))[n] = t[n]);
    return r && w.extend(!0, e, r), e;
  }
  function Xt(e, t, n) {
    var r,
      i,
      o,
      a,
      s = e.contents,
      u = e.dataTypes;
    while ('*' === u[0])
      u.shift(), void 0 === r && (r = e.mimeType || t.getResponseHeader('Content-Type'));
    if (r)
      for (i in s)
        if (s[i] && s[i].test(r)) {
          u.unshift(i);
          break;
        }
    if (u[0] in n) o = u[0];
    else {
      for (i in n) {
        if (!u[0] || e.converters[i + ' ' + u[0]]) {
          o = i;
          break;
        }
        a || (a = i);
      }
      o = o || a;
    }
    if (o) return o !== u[0] && u.unshift(o), n[o];
  }
  function Ut(e, t, n, r) {
    var i,
      o,
      a,
      s,
      u,
      l = {},
      c = e.dataTypes.slice();
    if (c[1]) for (a in e.converters) l[a.toLowerCase()] = e.converters[a];
    o = c.shift();
    while (o)
      if (
        (e.responseFields[o] && (n[e.responseFields[o]] = t),
        !u && r && e.dataFilter && (t = e.dataFilter(t, e.dataType)),
        (u = o),
        (o = c.shift()))
      )
        if ('*' === o) o = u;
        else if ('*' !== u && u !== o) {
          if (!(a = l[u + ' ' + o] || l['* ' + o]))
            for (i in l)
              if ((s = i.split(' '))[1] === o && (a = l[u + ' ' + s[0]] || l['* ' + s[0]])) {
                !0 === a ? (a = l[i]) : !0 !== l[i] && ((o = s[0]), c.unshift(s[1]));
                break;
              }
          if (!0 !== a)
            if (a && e['throws']) t = a(t);
            else
              try {
                t = a(t);
              } catch (e) {
                return {
                  state: 'parsererror',
                  error: a ? e : 'No conversion from ' + u + ' to ' + o
                };
              }
        }
    return {state: 'success', data: t};
  }
  w.extend({
    active: 0,
    lastModified: {},
    etag: {},
    ajaxSettings: {
      url: Ct.href,
      type: 'GET',
      isLocal: Pt.test(Ct.protocol),
      global: !0,
      processData: !0,
      async: !0,
      contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
      accepts: {
        '*': $t,
        text: 'text/plain',
        html: 'text/html',
        xml: 'application/xml, text/xml',
        json: 'application/json, text/javascript'
      },
      contents: {xml: /\bxml\b/, html: /\bhtml/, json: /\bjson\b/},
      responseFields: {xml: 'responseXML', text: 'responseText', json: 'responseJSON'},
      converters: {
        '* text': String,
        'text html': !0,
        'text json': JSON.parse,
        'text xml': w.parseXML
      },
      flatOptions: {url: !0, context: !0}
    },
    ajaxSetup: function (e, t) {
      return t ? zt(zt(e, w.ajaxSettings), t) : zt(w.ajaxSettings, e);
    },
    ajaxPrefilter: Ft(It),
    ajaxTransport: Ft(Wt),
    ajax: function (t, n) {
      'object' == typeof t && ((n = t), (t = void 0)), (n = n || {});
      var i,
        o,
        a,
        s,
        u,
        l,
        c,
        f,
        p,
        d,
        h = w.ajaxSetup({}, n),
        g = h.context || h,
        y = h.context && (g.nodeType || g.jquery) ? w(g) : w.event,
        v = w.Deferred(),
        m = w.Callbacks('once memory'),
        x = h.statusCode || {},
        b = {},
        T = {},
        C = 'canceled',
        E = {
          readyState: 0,
          getResponseHeader: function (e) {
            var t;
            if (c) {
              if (!s) {
                s = {};
                while ((t = Ot.exec(a))) s[t[1].toLowerCase()] = t[2];
              }
              t = s[e.toLowerCase()];
            }
            return null == t ? null : t;
          },
          getAllResponseHeaders: function () {
            return c ? a : null;
          },
          setRequestHeader: function (e, t) {
            return (
              null == c && ((e = T[e.toLowerCase()] = T[e.toLowerCase()] || e), (b[e] = t)), this
            );
          },
          overrideMimeType: function (e) {
            return null == c && (h.mimeType = e), this;
          },
          statusCode: function (e) {
            var t;
            if (e)
              if (c) E.always(e[E.status]);
              else for (t in e) x[t] = [x[t], e[t]];
            return this;
          },
          abort: function (e) {
            var t = e || C;
            return i && i.abort(t), k(0, t), this;
          }
        };
      if (
        (v.promise(E),
        (h.url = ((t || h.url || Ct.href) + '').replace(Rt, Ct.protocol + '//')),
        (h.type = n.method || n.type || h.method || h.type),
        (h.dataTypes = (h.dataType || '*').toLowerCase().match(M) || ['']),
        null == h.crossDomain)
      ) {
        l = r.createElement('a');
        try {
          (l.href = h.url),
            (l.href = l.href),
            (h.crossDomain = Bt.protocol + '//' + Bt.host != l.protocol + '//' + l.host);
        } catch (e) {
          h.crossDomain = !0;
        }
      }
      if (
        (h.data &&
          h.processData &&
          'string' != typeof h.data &&
          (h.data = w.param(h.data, h.traditional)),
        _t(It, h, n, E),
        c)
      )
        return E;
      (f = w.event && h.global) && 0 == w.active++ && w.event.trigger('ajaxStart'),
        (h.type = h.type.toUpperCase()),
        (h.hasContent = !Mt.test(h.type)),
        (o = h.url.replace(Lt, '')),
        h.hasContent
          ? h.data &&
            h.processData &&
            0 === (h.contentType || '').indexOf('application/x-www-form-urlencoded') &&
            (h.data = h.data.replace(qt, '+'))
          : ((d = h.url.slice(o.length)),
            h.data &&
              (h.processData || 'string' == typeof h.data) &&
              ((o += (kt.test(o) ? '&' : '?') + h.data), delete h.data),
            !1 === h.cache &&
              ((o = o.replace(Ht, '$1')), (d = (kt.test(o) ? '&' : '?') + '_=' + Et++ + d)),
            (h.url = o + d)),
        h.ifModified &&
          (w.lastModified[o] && E.setRequestHeader('If-Modified-Since', w.lastModified[o]),
          w.etag[o] && E.setRequestHeader('If-None-Match', w.etag[o])),
        ((h.data && h.hasContent && !1 !== h.contentType) || n.contentType) &&
          E.setRequestHeader('Content-Type', h.contentType),
        E.setRequestHeader(
          'Accept',
          h.dataTypes[0] && h.accepts[h.dataTypes[0]]
            ? h.accepts[h.dataTypes[0]] + ('*' !== h.dataTypes[0] ? ', ' + $t + '; q=0.01' : '')
            : h.accepts['*']
        );
      for (p in h.headers) E.setRequestHeader(p, h.headers[p]);
      if (h.beforeSend && (!1 === h.beforeSend.call(g, E, h) || c)) return E.abort();
      if (
        ((C = 'abort'),
        m.add(h.complete),
        E.done(h.success),
        E.fail(h.error),
        (i = _t(Wt, h, n, E)))
      ) {
        if (((E.readyState = 1), f && y.trigger('ajaxSend', [E, h]), c)) return E;
        h.async &&
          h.timeout > 0 &&
          (u = e.setTimeout(function () {
            E.abort('timeout');
          }, h.timeout));
        try {
          (c = !1), i.send(b, k);
        } catch (e) {
          if (c) throw e;
          k(-1, e);
        }
      } else k(-1, 'No Transport');
      function k(t, n, r, s) {
        var l,
          p,
          d,
          b,
          T,
          C = n;
        c ||
          ((c = !0),
          u && e.clearTimeout(u),
          (i = void 0),
          (a = s || ''),
          (E.readyState = t > 0 ? 4 : 0),
          (l = (t >= 200 && t < 300) || 304 === t),
          r && (b = Xt(h, E, r)),
          (b = Ut(h, b, E, l)),
          l
            ? (h.ifModified &&
                ((T = E.getResponseHeader('Last-Modified')) && (w.lastModified[o] = T),
                (T = E.getResponseHeader('etag')) && (w.etag[o] = T)),
              204 === t || 'HEAD' === h.type
                ? (C = 'nocontent')
                : 304 === t
                ? (C = 'notmodified')
                : ((C = b.state), (p = b.data), (l = !(d = b.error))))
            : ((d = C), (!t && C) || ((C = 'error'), t < 0 && (t = 0))),
          (E.status = t),
          (E.statusText = (n || C) + ''),
          l ? v.resolveWith(g, [p, C, E]) : v.rejectWith(g, [E, C, d]),
          E.statusCode(x),
          (x = void 0),
          f && y.trigger(l ? 'ajaxSuccess' : 'ajaxError', [E, h, l ? p : d]),
          m.fireWith(g, [E, C]),
          f && (y.trigger('ajaxComplete', [E, h]), --w.active || w.event.trigger('ajaxStop')));
      }
      return E;
    },
    getJSON: function (e, t, n) {
      return w.get(e, t, n, 'json');
    },
    getScript: function (e, t) {
      return w.get(e, void 0, t, 'script');
    }
  }),
    w.each(['get', 'post'], function (e, t) {
      w[t] = function (e, n, r, i) {
        return (
          g(n) && ((i = i || r), (r = n), (n = void 0)),
          w.ajax(
            w.extend({url: e, type: t, dataType: i, data: n, success: r}, w.isPlainObject(e) && e)
          )
        );
      };
    }),
    (w._evalUrl = function (e) {
      return w.ajax({
        url: e,
        type: 'GET',
        dataType: 'script',
        cache: !0,
        async: !1,
        global: !1,
        throws: !0
      });
    }),
    w.fn.extend({
      wrapAll: function (e) {
        var t;
        return (
          this[0] &&
            (g(e) && (e = e.call(this[0])),
            (t = w(e, this[0].ownerDocument).eq(0).clone(!0)),
            this[0].parentNode && t.insertBefore(this[0]),
            t
              .map(function () {
                var e = this;
                while (e.firstElementChild) e = e.firstElementChild;
                return e;
              })
              .append(this)),
          this
        );
      },
      wrapInner: function (e) {
        return g(e)
          ? this.each(function (t) {
              w(this).wrapInner(e.call(this, t));
            })
          : this.each(function () {
              var t = w(this),
                n = t.contents();
              n.length ? n.wrapAll(e) : t.append(e);
            });
      },
      wrap: function (e) {
        var t = g(e);
        return this.each(function (n) {
          w(this).wrapAll(t ? e.call(this, n) : e);
        });
      },
      unwrap: function (e) {
        return (
          this.parent(e)
            .not('body')
            .each(function () {
              w(this).replaceWith(this.childNodes);
            }),
          this
        );
      }
    }),
    (w.expr.pseudos.hidden = function (e) {
      return !w.expr.pseudos.visible(e);
    }),
    (w.expr.pseudos.visible = function (e) {
      return !!(e.offsetWidth || e.offsetHeight || e.getClientRects().length);
    }),
    (w.ajaxSettings.xhr = function () {
      try {
        return new e.XMLHttpRequest();
      } catch (e) {}
    });
  var Vt = {0: 200, 1223: 204},
    Gt = w.ajaxSettings.xhr();
  (h.cors = !!Gt && 'withCredentials' in Gt),
    (h.ajax = Gt = !!Gt),
    w.ajaxTransport(function (t) {
      var n, r;
      if (h.cors || (Gt && !t.crossDomain))
        return {
          send: function (i, o) {
            var a,
              s = t.xhr();
            if ((s.open(t.type, t.url, t.async, t.username, t.password), t.xhrFields))
              for (a in t.xhrFields) s[a] = t.xhrFields[a];
            t.mimeType && s.overrideMimeType && s.overrideMimeType(t.mimeType),
              t.crossDomain || i['X-Requested-With'] || (i['X-Requested-With'] = 'XMLHttpRequest');
            for (a in i) s.setRequestHeader(a, i[a]);
            (n = function (e) {
              return function () {
                n &&
                  ((n =
                    r =
                    s.onload =
                    s.onerror =
                    s.onabort =
                    s.ontimeout =
                    s.onreadystatechange =
                      null),
                  'abort' === e
                    ? s.abort()
                    : 'error' === e
                    ? 'number' != typeof s.status
                      ? o(0, 'error')
                      : o(s.status, s.statusText)
                    : o(
                        Vt[s.status] || s.status,
                        s.statusText,
                        'text' !== (s.responseType || 'text') || 'string' != typeof s.responseText
                          ? {binary: s.response}
                          : {text: s.responseText},
                        s.getAllResponseHeaders()
                      ));
              };
            }),
              (s.onload = n()),
              (r = s.onerror = s.ontimeout = n('error')),
              void 0 !== s.onabort
                ? (s.onabort = r)
                : (s.onreadystatechange = function () {
                    4 === s.readyState &&
                      e.setTimeout(function () {
                        n && r();
                      });
                  }),
              (n = n('abort'));
            try {
              s.send((t.hasContent && t.data) || null);
            } catch (e) {
              if (n) throw e;
            }
          },
          abort: function () {
            n && n();
          }
        };
    }),
    w.ajaxPrefilter(function (e) {
      e.crossDomain && (e.contents.script = !1);
    }),
    w.ajaxSetup({
      accepts: {
        script:
          'text/javascript, application/javascript, application/ecmascript, application/x-ecmascript'
      },
      contents: {script: /\b(?:java|ecma)script\b/},
      converters: {
        'text script': function (e) {
          return w.globalEval(e), e;
        }
      }
    }),
    w.ajaxPrefilter('script', function (e) {
      void 0 === e.cache && (e.cache = !1), e.crossDomain && (e.type = 'GET');
    }),
    w.ajaxTransport('script', function (e) {
      if (e.crossDomain) {
        var t, n;
        return {
          send: function (i, o) {
            (t = w('<script>')
              .prop({charset: e.scriptCharset, src: e.url})
              .on(
                'load error',
                (n = function (e) {
                  t.remove(), (n = null), e && o('error' === e.type ? 404 : 200, e.type);
                })
              )),
              r.head.appendChild(t[0]);
          },
          abort: function () {
            n && n();
          }
        };
      }
    });
  var Yt = [],
    Qt = /(=)\?(?=&|$)|\?\?/;
  w.ajaxSetup({
    jsonp: 'callback',
    jsonpCallback: function () {
      var e = Yt.pop() || w.expando + '_' + Et++;
      return (this[e] = !0), e;
    }
  }),
    w.ajaxPrefilter('json jsonp', function (t, n, r) {
      var i,
        o,
        a,
        s =
          !1 !== t.jsonp &&
          (Qt.test(t.url)
            ? 'url'
            : 'string' == typeof t.data &&
              0 === (t.contentType || '').indexOf('application/x-www-form-urlencoded') &&
              Qt.test(t.data) &&
              'data');
      if (s || 'jsonp' === t.dataTypes[0])
        return (
          (i = t.jsonpCallback = g(t.jsonpCallback) ? t.jsonpCallback() : t.jsonpCallback),
          s
            ? (t[s] = t[s].replace(Qt, '$1' + i))
            : !1 !== t.jsonp && (t.url += (kt.test(t.url) ? '&' : '?') + t.jsonp + '=' + i),
          (t.converters['script json'] = function () {
            return a || w.error(i + ' was not called'), a[0];
          }),
          (t.dataTypes[0] = 'json'),
          (o = e[i]),
          (e[i] = function () {
            a = arguments;
          }),
          r.always(function () {
            void 0 === o ? w(e).removeProp(i) : (e[i] = o),
              t[i] && ((t.jsonpCallback = n.jsonpCallback), Yt.push(i)),
              a && g(o) && o(a[0]),
              (a = o = void 0);
          }),
          'script'
        );
    }),
    (h.createHTMLDocument = (function () {
      var e = r.implementation.createHTMLDocument('').body;
      return (e.innerHTML = '<form></form><form></form>'), 2 === e.childNodes.length;
    })()),
    (w.parseHTML = function (e, t, n) {
      if ('string' != typeof e) return [];
      'boolean' == typeof t && ((n = t), (t = !1));
      var i, o, a;
      return (
        t ||
          (h.createHTMLDocument
            ? (((i = (t = r.implementation.createHTMLDocument('')).createElement('base')).href =
                r.location.href),
              t.head.appendChild(i))
            : (t = r)),
        (o = A.exec(e)),
        (a = !n && []),
        o
          ? [t.createElement(o[1])]
          : ((o = xe([e], t, a)), a && a.length && w(a).remove(), w.merge([], o.childNodes))
      );
    }),
    (w.fn.load = function (e, t, n) {
      var r,
        i,
        o,
        a = this,
        s = e.indexOf(' ');
      return (
        s > -1 && ((r = vt(e.slice(s))), (e = e.slice(0, s))),
        g(t) ? ((n = t), (t = void 0)) : t && 'object' == typeof t && (i = 'POST'),
        a.length > 0 &&
          w
            .ajax({url: e, type: i || 'GET', dataType: 'html', data: t})
            .done(function (e) {
              (o = arguments), a.html(r ? w('<div>').append(w.parseHTML(e)).find(r) : e);
            })
            .always(
              n &&
                function (e, t) {
                  a.each(function () {
                    n.apply(this, o || [e.responseText, t, e]);
                  });
                }
            ),
        this
      );
    }),
    w.each(
      ['ajaxStart', 'ajaxStop', 'ajaxComplete', 'ajaxError', 'ajaxSuccess', 'ajaxSend'],
      function (e, t) {
        w.fn[t] = function (e) {
          return this.on(t, e);
        };
      }
    ),
    (w.expr.pseudos.animated = function (e) {
      return w.grep(w.timers, function (t) {
        return e === t.elem;
      }).length;
    }),
    (w.offset = {
      setOffset: function (e, t, n) {
        var r,
          i,
          o,
          a,
          s,
          u,
          l,
          c = w.css(e, 'position'),
          f = w(e),
          p = {};
        'static' === c && (e.style.position = 'relative'),
          (s = f.offset()),
          (o = w.css(e, 'top')),
          (u = w.css(e, 'left')),
          (l = ('absolute' === c || 'fixed' === c) && (o + u).indexOf('auto') > -1)
            ? ((a = (r = f.position()).top), (i = r.left))
            : ((a = parseFloat(o) || 0), (i = parseFloat(u) || 0)),
          g(t) && (t = t.call(e, n, w.extend({}, s))),
          null != t.top && (p.top = t.top - s.top + a),
          null != t.left && (p.left = t.left - s.left + i),
          'using' in t ? t.using.call(e, p) : f.css(p);
      }
    }),
    w.fn.extend({
      offset: function (e) {
        if (arguments.length)
          return void 0 === e
            ? this
            : this.each(function (t) {
                w.offset.setOffset(this, e, t);
              });
        var t,
          n,
          r = this[0];
        if (r)
          return r.getClientRects().length
            ? ((t = r.getBoundingClientRect()),
              (n = r.ownerDocument.defaultView),
              {top: t.top + n.pageYOffset, left: t.left + n.pageXOffset})
            : {top: 0, left: 0};
      },
      position: function () {
        if (this[0]) {
          var e,
            t,
            n,
            r = this[0],
            i = {top: 0, left: 0};
          if ('fixed' === w.css(r, 'position')) t = r.getBoundingClientRect();
          else {
            (t = this.offset()), (n = r.ownerDocument), (e = r.offsetParent || n.documentElement);
            while (
              e &&
              (e === n.body || e === n.documentElement) &&
              'static' === w.css(e, 'position')
            )
              e = e.parentNode;
            e &&
              e !== r &&
              1 === e.nodeType &&
              (((i = w(e).offset()).top += w.css(e, 'borderTopWidth', !0)),
              (i.left += w.css(e, 'borderLeftWidth', !0)));
          }
          return {
            top: t.top - i.top - w.css(r, 'marginTop', !0),
            left: t.left - i.left - w.css(r, 'marginLeft', !0)
          };
        }
      },
      offsetParent: function () {
        return this.map(function () {
          var e = this.offsetParent;
          while (e && 'static' === w.css(e, 'position')) e = e.offsetParent;
          return e || be;
        });
      }
    }),
    w.each({scrollLeft: 'pageXOffset', scrollTop: 'pageYOffset'}, function (e, t) {
      var n = 'pageYOffset' === t;
      w.fn[e] = function (r) {
        return z(
          this,
          function (e, r, i) {
            var o;
            if ((y(e) ? (o = e) : 9 === e.nodeType && (o = e.defaultView), void 0 === i))
              return o ? o[t] : e[r];
            o ? o.scrollTo(n ? o.pageXOffset : i, n ? i : o.pageYOffset) : (e[r] = i);
          },
          e,
          r,
          arguments.length
        );
      };
    }),
    w.each(['top', 'left'], function (e, t) {
      w.cssHooks[t] = _e(h.pixelPosition, function (e, n) {
        if (n) return (n = Fe(e, t)), We.test(n) ? w(e).position()[t] + 'px' : n;
      });
    }),
    w.each({Height: 'height', Width: 'width'}, function (e, t) {
      w.each({padding: 'inner' + e, content: t, '': 'outer' + e}, function (n, r) {
        w.fn[r] = function (i, o) {
          var a = arguments.length && (n || 'boolean' != typeof i),
            s = n || (!0 === i || !0 === o ? 'margin' : 'border');
          return z(
            this,
            function (t, n, i) {
              var o;
              return y(t)
                ? 0 === r.indexOf('outer')
                  ? t['inner' + e]
                  : t.document.documentElement['client' + e]
                : 9 === t.nodeType
                ? ((o = t.documentElement),
                  Math.max(
                    t.body['scroll' + e],
                    o['scroll' + e],
                    t.body['offset' + e],
                    o['offset' + e],
                    o['client' + e]
                  ))
                : void 0 === i
                ? w.css(t, n, s)
                : w.style(t, n, i, s);
            },
            t,
            a ? i : void 0,
            a
          );
        };
      });
    }),
    w.each(
      'blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu'.split(
        ' '
      ),
      function (e, t) {
        w.fn[t] = function (e, n) {
          return arguments.length > 0 ? this.on(t, null, e, n) : this.trigger(t);
        };
      }
    ),
    w.fn.extend({
      hover: function (e, t) {
        return this.mouseenter(e).mouseleave(t || e);
      }
    }),
    w.fn.extend({
      bind: function (e, t, n) {
        return this.on(e, null, t, n);
      },
      unbind: function (e, t) {
        return this.off(e, null, t);
      },
      delegate: function (e, t, n, r) {
        return this.on(t, e, n, r);
      },
      undelegate: function (e, t, n) {
        return 1 === arguments.length ? this.off(e, '**') : this.off(t, e || '**', n);
      }
    }),
    (w.proxy = function (e, t) {
      var n, r, i;
      if (('string' == typeof t && ((n = e[t]), (t = e), (e = n)), g(e)))
        return (
          (r = o.call(arguments, 2)),
          (i = function () {
            return e.apply(t || this, r.concat(o.call(arguments)));
          }),
          (i.guid = e.guid = e.guid || w.guid++),
          i
        );
    }),
    (w.holdReady = function (e) {
      e ? w.readyWait++ : w.ready(!0);
    }),
    (w.isArray = Array.isArray),
    (w.parseJSON = JSON.parse),
    (w.nodeName = N),
    (w.isFunction = g),
    (w.isWindow = y),
    (w.camelCase = G),
    (w.type = x),
    (w.now = Date.now),
    (w.isNumeric = function (e) {
      var t = w.type(e);
      return ('number' === t || 'string' === t) && !isNaN(e - parseFloat(e));
    }),
    'function' == typeof define &&
      define.amd &&
      define('jquery', [], function () {
        return w;
      });
  var Jt = e.jQuery,
    Kt = e.$;
  return (
    (w.noConflict = function (t) {
      return e.$ === w && (e.$ = Kt), t && e.jQuery === w && (e.jQuery = Jt), w;
    }),
    t || (e.jQuery = e.$ = w),
    w
  );
});

/*!
 * metismenu - v2.7.9
 * A jQuery menu plugin
 * https://github.com/onokumus/metismenu#readme
 *
 * Made by Osman Nuri Okumus <onokumus@gmail.com> (https://github.com/onokumus)
 * Under MIT License
 */
!(function (n, e) {
  'object' == typeof exports && 'undefined' != typeof module
    ? (module.exports = e(require('jquery')))
    : 'function' == typeof define && define.amd
    ? define(['jquery'], e)
    : (n.metisMenu = e(n.jQuery));
})(this, function (n) {
  'use strict';
  function a(s) {
    for (var n = 1; n < arguments.length; n++) {
      var a = null != arguments[n] ? arguments[n] : {},
        e = Object.keys(a);
      'function' == typeof Object.getOwnPropertySymbols &&
        (e = e.concat(
          Object.getOwnPropertySymbols(a).filter(function (n) {
            return Object.getOwnPropertyDescriptor(a, n).enumerable;
          })
        )),
        e.forEach(function (n) {
          var e, i, t;
          (e = s),
            (t = a[(i = n)]),
            i in e
              ? Object.defineProperty(e, i, {
                  value: t,
                  enumerable: !0,
                  configurable: !0,
                  writable: !0
                })
              : (e[i] = t);
        });
    }
    return s;
  }
  var o,
    e,
    r,
    i,
    t,
    l,
    c,
    s,
    g = (function (t) {
      var e = 'transitionend',
        s = {
          TRANSITION_END: 'mmTransitionEnd',
          triggerTransitionEnd: function (n) {
            t(n).trigger(e);
          },
          supportsTransitionEnd: function () {
            return Boolean(e);
          }
        };
      function n(n) {
        var e = this,
          i = !1;
        return (
          t(this).one(s.TRANSITION_END, function () {
            i = !0;
          }),
          setTimeout(function () {
            i || s.triggerTransitionEnd(e);
          }, n),
          this
        );
      }
      return (
        (t.fn.mmEmulateTransitionEnd = n),
        (t.event.special[s.TRANSITION_END] = {
          bindType: e,
          delegateType: e,
          handle: function (n) {
            if (t(n.target).is(this)) return n.handleObj.handler.apply(this, arguments);
          }
        }),
        s
      );
    })((n = n && n.hasOwnProperty('default') ? n.default : n));
  return (
    (i = '.' + (r = e = 'metisMenu')),
    (t = (o = n).fn[e]),
    (l = {
      toggle: !0,
      preventDefault: !0,
      activeClass: 'active',
      collapseClass: 'collapse',
      collapseInClass: 'in',
      collapsingClass: 'collapsing',
      triggerElement: 'a',
      parentTrigger: 'li',
      subMenu: 'ul'
    }),
    (c = {
      SHOW: 'show' + i,
      SHOWN: 'shown' + i,
      HIDE: 'hide' + i,
      HIDDEN: 'hidden' + i,
      CLICK_DATA_API: 'click' + i + '.data-api'
    }),
    (s = (function () {
      function s(n, e) {
        (this.element = n), (this.config = a({}, l, e)), (this.transitioning = null), this.init();
      }
      var n = s.prototype;
      return (
        (n.init = function () {
          var a = this,
            r = this.config;
          o(this.element)
            .find(r.parentTrigger + '.' + r.activeClass)
            .has(r.subMenu)
            .children(r.subMenu)
            .addClass(r.collapseClass + ' ' + r.collapseInClass),
            o(this.element)
              .find(r.parentTrigger)
              .not('.' + r.activeClass)
              .has(r.subMenu)
              .children(r.subMenu)
              .addClass(r.collapseClass),
            o(this.element)
              .find(r.parentTrigger)
              .has(r.subMenu)
              .children(r.triggerElement)
              .on(c.CLICK_DATA_API, function (n) {
                var e = o(this),
                  i = e.parent(r.parentTrigger),
                  t = i.siblings(r.parentTrigger).children(r.triggerElement),
                  s = i.children(r.subMenu);
                r.preventDefault && n.preventDefault(),
                  'true' !== e.attr('aria-disabled') &&
                    (i.hasClass(r.activeClass)
                      ? (e.attr('aria-expanded', !1), a.hide(s))
                      : (a.show(s),
                        e.attr('aria-expanded', !0),
                        r.toggle && t.attr('aria-expanded', !1)),
                    r.onTransitionStart && r.onTransitionStart(n));
              });
        }),
        (n.show = function (n) {
          var e = this;
          if (!this.transitioning && !o(n).hasClass(this.config.collapsingClass)) {
            var i = o(n),
              t = o.Event(c.SHOW);
            if ((i.trigger(t), !t.isDefaultPrevented())) {
              i.parent(this.config.parentTrigger).addClass(this.config.activeClass),
                this.config.toggle &&
                  this.hide(
                    i
                      .parent(this.config.parentTrigger)
                      .siblings()
                      .children(this.config.subMenu + '.' + this.config.collapseInClass)
                  ),
                i
                  .removeClass(this.config.collapseClass)
                  .addClass(this.config.collapsingClass)
                  .height(0),
                this.setTransitioning(!0);
              i.height(n[0].scrollHeight)
                .one(g.TRANSITION_END, function () {
                  e.config &&
                    e.element &&
                    (i
                      .removeClass(e.config.collapsingClass)
                      .addClass(e.config.collapseClass + ' ' + e.config.collapseInClass)
                      .height(''),
                    e.setTransitioning(!1),
                    i.trigger(c.SHOWN));
                })
                .mmEmulateTransitionEnd(350);
            }
          }
        }),
        (n.hide = function (n) {
          var e = this;
          if (!this.transitioning && o(n).hasClass(this.config.collapseInClass)) {
            var i = o(n),
              t = o.Event(c.HIDE);
            if ((i.trigger(t), !t.isDefaultPrevented())) {
              i.parent(this.config.parentTrigger).removeClass(this.config.activeClass),
                i.height(i.height())[0].offsetHeight,
                i
                  .addClass(this.config.collapsingClass)
                  .removeClass(this.config.collapseClass)
                  .removeClass(this.config.collapseInClass),
                this.setTransitioning(!0);
              var s = function () {
                e.config &&
                  e.element &&
                  (e.transitioning && e.config.onTransitionEnd && e.config.onTransitionEnd(),
                  e.setTransitioning(!1),
                  i.trigger(c.HIDDEN),
                  i.removeClass(e.config.collapsingClass).addClass(e.config.collapseClass));
              };
              0 === i.height() || 'none' === i.css('display')
                ? s()
                : i.height(0).one(g.TRANSITION_END, s).mmEmulateTransitionEnd(350);
            }
          }
        }),
        (n.setTransitioning = function (n) {
          this.transitioning = n;
        }),
        (n.dispose = function () {
          o.removeData(this.element, r),
            o(this.element)
              .find(this.config.parentTrigger)
              .has(this.config.subMenu)
              .children(this.config.triggerElement)
              .off('click'),
            (this.transitioning = null),
            (this.config = null),
            (this.element = null);
        }),
        (s.jQueryInterface = function (t) {
          return this.each(function () {
            var n = o(this),
              e = n.data(r),
              i = a({}, l, n.data(), 'object' == typeof t && t ? t : {});
            if (
              (!e && /dispose/.test(t) && this.dispose(),
              e || ((e = new s(this, i)), n.data(r, e)),
              'string' == typeof t)
            ) {
              if (void 0 === e[t]) throw new Error('No method named "' + t + '"');
              e[t]();
            }
          });
        }),
        s
      );
    })()),
    (o.fn[e] = s.jQueryInterface),
    (o.fn[e].Constructor = s),
    (o.fn[e].noConflict = function () {
      return (o.fn[e] = t), s.jQueryInterface;
    }),
    s
  );
});
//# sourceMappingURL=metisMenu.min.js.map

/*! jQuery v3.3.1 | (c) JS Foundation and other contributors | jquery.org/license */
!(function (e, t) {
  'use strict';
  'object' == typeof module && 'object' == typeof module.exports
    ? (module.exports = e.document
        ? t(e, !0)
        : function (e) {
            if (!e.document) throw new Error('jQuery requires a window with a document');
            return t(e);
          })
    : t(e);
})('undefined' != typeof window ? window : this, function (e, t) {
  'use strict';
  var n = [],
    r = e.document,
    i = Object.getPrototypeOf,
    o = n.slice,
    a = n.concat,
    s = n.push,
    u = n.indexOf,
    l = {},
    c = l.toString,
    f = l.hasOwnProperty,
    p = f.toString,
    d = p.call(Object),
    h = {},
    g = function e(t) {
      return 'function' == typeof t && 'number' != typeof t.nodeType;
    },
    y = function e(t) {
      return null != t && t === t.window;
    },
    v = {type: !0, src: !0, noModule: !0};
  function m(e, t, n) {
    var i,
      o = (t = t || r).createElement('script');
    if (((o.text = e), n)) for (i in v) n[i] && (o[i] = n[i]);
    t.head.appendChild(o).parentNode.removeChild(o);
  }
  function x(e) {
    return null == e
      ? e + ''
      : 'object' == typeof e || 'function' == typeof e
      ? l[c.call(e)] || 'object'
      : typeof e;
  }
  var b = '3.3.1',
    w = function (e, t) {
      return new w.fn.init(e, t);
    },
    T = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
  (w.fn = w.prototype =
    {
      jquery: '3.3.1',
      constructor: w,
      length: 0,
      toArray: function () {
        return o.call(this);
      },
      get: function (e) {
        return null == e ? o.call(this) : e < 0 ? this[e + this.length] : this[e];
      },
      pushStack: function (e) {
        var t = w.merge(this.constructor(), e);
        return (t.prevObject = this), t;
      },
      each: function (e) {
        return w.each(this, e);
      },
      map: function (e) {
        return this.pushStack(
          w.map(this, function (t, n) {
            return e.call(t, n, t);
          })
        );
      },
      slice: function () {
        return this.pushStack(o.apply(this, arguments));
      },
      first: function () {
        return this.eq(0);
      },
      last: function () {
        return this.eq(-1);
      },
      eq: function (e) {
        var t = this.length,
          n = +e + (e < 0 ? t : 0);
        return this.pushStack(n >= 0 && n < t ? [this[n]] : []);
      },
      end: function () {
        return this.prevObject || this.constructor();
      },
      push: s,
      sort: n.sort,
      splice: n.splice
    }),
    (w.extend = w.fn.extend =
      function () {
        var e,
          t,
          n,
          r,
          i,
          o,
          a = arguments[0] || {},
          s = 1,
          u = arguments.length,
          l = !1;
        for (
          'boolean' == typeof a && ((l = a), (a = arguments[s] || {}), s++),
            'object' == typeof a || g(a) || (a = {}),
            s === u && ((a = this), s--);
          s < u;
          s++
        )
          if (null != (e = arguments[s]))
            for (t in e)
              (n = a[t]),
                a !== (r = e[t]) &&
                  (l && r && (w.isPlainObject(r) || (i = Array.isArray(r)))
                    ? (i
                        ? ((i = !1), (o = n && Array.isArray(n) ? n : []))
                        : (o = n && w.isPlainObject(n) ? n : {}),
                      (a[t] = w.extend(l, o, r)))
                    : void 0 !== r && (a[t] = r));
        return a;
      }),
    w.extend({
      expando: 'jQuery' + ('3.3.1' + Math.random()).replace(/\D/g, ''),
      isReady: !0,
      error: function (e) {
        throw new Error(e);
      },
      noop: function () {},
      isPlainObject: function (e) {
        var t, n;
        return (
          !(!e || '[object Object]' !== c.call(e)) &&
          (!(t = i(e)) ||
            ('function' == typeof (n = f.call(t, 'constructor') && t.constructor) &&
              p.call(n) === d))
        );
      },
      isEmptyObject: function (e) {
        var t;
        for (t in e) return !1;
        return !0;
      },
      globalEval: function (e) {
        m(e);
      },
      each: function (e, t) {
        var n,
          r = 0;
        if (C(e)) {
          for (n = e.length; r < n; r++) if (!1 === t.call(e[r], r, e[r])) break;
        } else for (r in e) if (!1 === t.call(e[r], r, e[r])) break;
        return e;
      },
      trim: function (e) {
        return null == e ? '' : (e + '').replace(T, '');
      },
      makeArray: function (e, t) {
        var n = t || [];
        return (
          null != e && (C(Object(e)) ? w.merge(n, 'string' == typeof e ? [e] : e) : s.call(n, e)), n
        );
      },
      inArray: function (e, t, n) {
        return null == t ? -1 : u.call(t, e, n);
      },
      merge: function (e, t) {
        for (var n = +t.length, r = 0, i = e.length; r < n; r++) e[i++] = t[r];
        return (e.length = i), e;
      },
      grep: function (e, t, n) {
        for (var r, i = [], o = 0, a = e.length, s = !n; o < a; o++)
          (r = !t(e[o], o)) !== s && i.push(e[o]);
        return i;
      },
      map: function (e, t, n) {
        var r,
          i,
          o = 0,
          s = [];
        if (C(e)) for (r = e.length; o < r; o++) null != (i = t(e[o], o, n)) && s.push(i);
        else for (o in e) null != (i = t(e[o], o, n)) && s.push(i);
        return a.apply([], s);
      },
      guid: 1,
      support: h
    }),
    'function' == typeof Symbol && (w.fn[Symbol.iterator] = n[Symbol.iterator]),
    w.each(
      'Boolean Number String Function Array Date RegExp Object Error Symbol'.split(' '),
      function (e, t) {
        l['[object ' + t + ']'] = t.toLowerCase();
      }
    );
  function C(e) {
    var t = !!e && 'length' in e && e.length,
      n = x(e);
    return (
      !g(e) && !y(e) && ('array' === n || 0 === t || ('number' == typeof t && t > 0 && t - 1 in e))
    );
  }
  var E = (function (e) {
    var t,
      n,
      r,
      i,
      o,
      a,
      s,
      u,
      l,
      c,
      f,
      p,
      d,
      h,
      g,
      y,
      v,
      m,
      x,
      b = 'sizzle' + 1 * new Date(),
      w = e.document,
      T = 0,
      C = 0,
      E = ae(),
      k = ae(),
      S = ae(),
      D = function (e, t) {
        return e === t && (f = !0), 0;
      },
      N = {}.hasOwnProperty,
      A = [],
      j = A.pop,
      q = A.push,
      L = A.push,
      H = A.slice,
      O = function (e, t) {
        for (var n = 0, r = e.length; n < r; n++) if (e[n] === t) return n;
        return -1;
      },
      P =
        'checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped',
      M = '[\\x20\\t\\r\\n\\f]',
      R = '(?:\\\\.|[\\w-]|[^\0-\\xa0])+',
      I =
        '\\[' +
        M +
        '*(' +
        R +
        ')(?:' +
        M +
        '*([*^$|!~]?=)' +
        M +
        '*(?:\'((?:\\\\.|[^\\\\\'])*)\'|"((?:\\\\.|[^\\\\"])*)"|(' +
        R +
        '))|)' +
        M +
        '*\\]',
      W =
        ':(' +
        R +
        ')(?:\\(((\'((?:\\\\.|[^\\\\\'])*)\'|"((?:\\\\.|[^\\\\"])*)")|((?:\\\\.|[^\\\\()[\\]]|' +
        I +
        ')*)|.*)\\)|)',
      $ = new RegExp(M + '+', 'g'),
      B = new RegExp('^' + M + '+|((?:^|[^\\\\])(?:\\\\.)*)' + M + '+$', 'g'),
      F = new RegExp('^' + M + '*,' + M + '*'),
      _ = new RegExp('^' + M + '*([>+~]|' + M + ')' + M + '*'),
      z = new RegExp('=' + M + '*([^\\]\'"]*?)' + M + '*\\]', 'g'),
      X = new RegExp(W),
      U = new RegExp('^' + R + '$'),
      V = {
        ID: new RegExp('^#(' + R + ')'),
        CLASS: new RegExp('^\\.(' + R + ')'),
        TAG: new RegExp('^(' + R + '|[*])'),
        ATTR: new RegExp('^' + I),
        PSEUDO: new RegExp('^' + W),
        CHILD: new RegExp(
          '^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(' +
            M +
            '*(even|odd|(([+-]|)(\\d*)n|)' +
            M +
            '*(?:([+-]|)' +
            M +
            '*(\\d+)|))' +
            M +
            '*\\)|)',
          'i'
        ),
        bool: new RegExp('^(?:' + P + ')$', 'i'),
        needsContext: new RegExp(
          '^' +
            M +
            '*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(' +
            M +
            '*((?:-\\d)?\\d*)' +
            M +
            '*\\)|)(?=[^-]|$)',
          'i'
        )
      },
      G = /^(?:input|select|textarea|button)$/i,
      Y = /^h\d$/i,
      Q = /^[^{]+\{\s*\[native \w/,
      J = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
      K = /[+~]/,
      Z = new RegExp('\\\\([\\da-f]{1,6}' + M + '?|(' + M + ')|.)', 'ig'),
      ee = function (e, t, n) {
        var r = '0x' + t - 65536;
        return r !== r || n
          ? t
          : r < 0
          ? String.fromCharCode(r + 65536)
          : String.fromCharCode((r >> 10) | 55296, (1023 & r) | 56320);
      },
      te = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
      ne = function (e, t) {
        return t
          ? '\0' === e
            ? '\ufffd'
            : e.slice(0, -1) + '\\' + e.charCodeAt(e.length - 1).toString(16) + ' '
          : '\\' + e;
      },
      re = function () {
        p();
      },
      ie = me(
        function (e) {
          return !0 === e.disabled && ('form' in e || 'label' in e);
        },
        {dir: 'parentNode', next: 'legend'}
      );
    try {
      L.apply((A = H.call(w.childNodes)), w.childNodes), A[w.childNodes.length].nodeType;
    } catch (e) {
      L = {
        apply: A.length
          ? function (e, t) {
              q.apply(e, H.call(t));
            }
          : function (e, t) {
              var n = e.length,
                r = 0;
              while ((e[n++] = t[r++]));
              e.length = n - 1;
            }
      };
    }
    function oe(e, t, r, i) {
      var o,
        s,
        l,
        c,
        f,
        h,
        v,
        m = t && t.ownerDocument,
        T = t ? t.nodeType : 9;
      if (((r = r || []), 'string' != typeof e || !e || (1 !== T && 9 !== T && 11 !== T))) return r;
      if (!i && ((t ? t.ownerDocument || t : w) !== d && p(t), (t = t || d), g)) {
        if (11 !== T && (f = J.exec(e)))
          if ((o = f[1])) {
            if (9 === T) {
              if (!(l = t.getElementById(o))) return r;
              if (l.id === o) return r.push(l), r;
            } else if (m && (l = m.getElementById(o)) && x(t, l) && l.id === o) return r.push(l), r;
          } else {
            if (f[2]) return L.apply(r, t.getElementsByTagName(e)), r;
            if ((o = f[3]) && n.getElementsByClassName && t.getElementsByClassName)
              return L.apply(r, t.getElementsByClassName(o)), r;
          }
        if (n.qsa && !S[e + ' '] && (!y || !y.test(e))) {
          if (1 !== T) (m = t), (v = e);
          else if ('object' !== t.nodeName.toLowerCase()) {
            (c = t.getAttribute('id')) ? (c = c.replace(te, ne)) : t.setAttribute('id', (c = b)),
              (s = (h = a(e)).length);
            while (s--) h[s] = '#' + c + ' ' + ve(h[s]);
            (v = h.join(',')), (m = (K.test(e) && ge(t.parentNode)) || t);
          }
          if (v)
            try {
              return L.apply(r, m.querySelectorAll(v)), r;
            } catch (e) {
            } finally {
              c === b && t.removeAttribute('id');
            }
        }
      }
      return u(e.replace(B, '$1'), t, r, i);
    }
    function ae() {
      var e = [];
      function t(n, i) {
        return e.push(n + ' ') > r.cacheLength && delete t[e.shift()], (t[n + ' '] = i);
      }
      return t;
    }
    function se(e) {
      return (e[b] = !0), e;
    }
    function ue(e) {
      var t = d.createElement('fieldset');
      try {
        return !!e(t);
      } catch (e) {
        return !1;
      } finally {
        t.parentNode && t.parentNode.removeChild(t), (t = null);
      }
    }
    function le(e, t) {
      var n = e.split('|'),
        i = n.length;
      while (i--) r.attrHandle[n[i]] = t;
    }
    function ce(e, t) {
      var n = t && e,
        r = n && 1 === e.nodeType && 1 === t.nodeType && e.sourceIndex - t.sourceIndex;
      if (r) return r;
      if (n) while ((n = n.nextSibling)) if (n === t) return -1;
      return e ? 1 : -1;
    }
    function fe(e) {
      return function (t) {
        return 'input' === t.nodeName.toLowerCase() && t.type === e;
      };
    }
    function pe(e) {
      return function (t) {
        var n = t.nodeName.toLowerCase();
        return ('input' === n || 'button' === n) && t.type === e;
      };
    }
    function de(e) {
      return function (t) {
        return 'form' in t
          ? t.parentNode && !1 === t.disabled
            ? 'label' in t
              ? 'label' in t.parentNode
                ? t.parentNode.disabled === e
                : t.disabled === e
              : t.isDisabled === e || (t.isDisabled !== !e && ie(t) === e)
            : t.disabled === e
          : 'label' in t && t.disabled === e;
      };
    }
    function he(e) {
      return se(function (t) {
        return (
          (t = +t),
          se(function (n, r) {
            var i,
              o = e([], n.length, t),
              a = o.length;
            while (a--) n[(i = o[a])] && (n[i] = !(r[i] = n[i]));
          })
        );
      });
    }
    function ge(e) {
      return e && 'undefined' != typeof e.getElementsByTagName && e;
    }
    (n = oe.support = {}),
      (o = oe.isXML =
        function (e) {
          var t = e && (e.ownerDocument || e).documentElement;
          return !!t && 'HTML' !== t.nodeName;
        }),
      (p = oe.setDocument =
        function (e) {
          var t,
            i,
            a = e ? e.ownerDocument || e : w;
          return a !== d && 9 === a.nodeType && a.documentElement
            ? ((d = a),
              (h = d.documentElement),
              (g = !o(d)),
              w !== d &&
                (i = d.defaultView) &&
                i.top !== i &&
                (i.addEventListener
                  ? i.addEventListener('unload', re, !1)
                  : i.attachEvent && i.attachEvent('onunload', re)),
              (n.attributes = ue(function (e) {
                return (e.className = 'i'), !e.getAttribute('className');
              })),
              (n.getElementsByTagName = ue(function (e) {
                return e.appendChild(d.createComment('')), !e.getElementsByTagName('*').length;
              })),
              (n.getElementsByClassName = Q.test(d.getElementsByClassName)),
              (n.getById = ue(function (e) {
                return (
                  (h.appendChild(e).id = b), !d.getElementsByName || !d.getElementsByName(b).length
                );
              })),
              n.getById
                ? ((r.filter.ID = function (e) {
                    var t = e.replace(Z, ee);
                    return function (e) {
                      return e.getAttribute('id') === t;
                    };
                  }),
                  (r.find.ID = function (e, t) {
                    if ('undefined' != typeof t.getElementById && g) {
                      var n = t.getElementById(e);
                      return n ? [n] : [];
                    }
                  }))
                : ((r.filter.ID = function (e) {
                    var t = e.replace(Z, ee);
                    return function (e) {
                      var n = 'undefined' != typeof e.getAttributeNode && e.getAttributeNode('id');
                      return n && n.value === t;
                    };
                  }),
                  (r.find.ID = function (e, t) {
                    if ('undefined' != typeof t.getElementById && g) {
                      var n,
                        r,
                        i,
                        o = t.getElementById(e);
                      if (o) {
                        if ((n = o.getAttributeNode('id')) && n.value === e) return [o];
                        (i = t.getElementsByName(e)), (r = 0);
                        while ((o = i[r++]))
                          if ((n = o.getAttributeNode('id')) && n.value === e) return [o];
                      }
                      return [];
                    }
                  })),
              (r.find.TAG = n.getElementsByTagName
                ? function (e, t) {
                    return 'undefined' != typeof t.getElementsByTagName
                      ? t.getElementsByTagName(e)
                      : n.qsa
                      ? t.querySelectorAll(e)
                      : void 0;
                  }
                : function (e, t) {
                    var n,
                      r = [],
                      i = 0,
                      o = t.getElementsByTagName(e);
                    if ('*' === e) {
                      while ((n = o[i++])) 1 === n.nodeType && r.push(n);
                      return r;
                    }
                    return o;
                  }),
              (r.find.CLASS =
                n.getElementsByClassName &&
                function (e, t) {
                  if ('undefined' != typeof t.getElementsByClassName && g)
                    return t.getElementsByClassName(e);
                }),
              (v = []),
              (y = []),
              (n.qsa = Q.test(d.querySelectorAll)) &&
                (ue(function (e) {
                  (h.appendChild(e).innerHTML =
                    "<a id='" +
                    b +
                    "'></a><select id='" +
                    b +
                    "-\r\\' msallowcapture=''><option selected=''></option></select>"),
                    e.querySelectorAll("[msallowcapture^='']").length &&
                      y.push('[*^$]=' + M + '*(?:\'\'|"")'),
                    e.querySelectorAll('[selected]').length ||
                      y.push('\\[' + M + '*(?:value|' + P + ')'),
                    e.querySelectorAll('[id~=' + b + '-]').length || y.push('~='),
                    e.querySelectorAll(':checked').length || y.push(':checked'),
                    e.querySelectorAll('a#' + b + '+*').length || y.push('.#.+[+~]');
                }),
                ue(function (e) {
                  e.innerHTML =
                    "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
                  var t = d.createElement('input');
                  t.setAttribute('type', 'hidden'),
                    e.appendChild(t).setAttribute('name', 'D'),
                    e.querySelectorAll('[name=d]').length && y.push('name' + M + '*[*^$|!~]?='),
                    2 !== e.querySelectorAll(':enabled').length && y.push(':enabled', ':disabled'),
                    (h.appendChild(e).disabled = !0),
                    2 !== e.querySelectorAll(':disabled').length && y.push(':enabled', ':disabled'),
                    e.querySelectorAll('*,:x'),
                    y.push(',.*:');
                })),
              (n.matchesSelector = Q.test(
                (m =
                  h.matches ||
                  h.webkitMatchesSelector ||
                  h.mozMatchesSelector ||
                  h.oMatchesSelector ||
                  h.msMatchesSelector)
              )) &&
                ue(function (e) {
                  (n.disconnectedMatch = m.call(e, '*')), m.call(e, "[s!='']:x"), v.push('!=', W);
                }),
              (y = y.length && new RegExp(y.join('|'))),
              (v = v.length && new RegExp(v.join('|'))),
              (t = Q.test(h.compareDocumentPosition)),
              (x =
                t || Q.test(h.contains)
                  ? function (e, t) {
                      var n = 9 === e.nodeType ? e.documentElement : e,
                        r = t && t.parentNode;
                      return (
                        e === r ||
                        !(
                          !r ||
                          1 !== r.nodeType ||
                          !(n.contains
                            ? n.contains(r)
                            : e.compareDocumentPosition && 16 & e.compareDocumentPosition(r))
                        )
                      );
                    }
                  : function (e, t) {
                      if (t) while ((t = t.parentNode)) if (t === e) return !0;
                      return !1;
                    }),
              (D = t
                ? function (e, t) {
                    if (e === t) return (f = !0), 0;
                    var r = !e.compareDocumentPosition - !t.compareDocumentPosition;
                    return (
                      r ||
                      (1 &
                        (r =
                          (e.ownerDocument || e) === (t.ownerDocument || t)
                            ? e.compareDocumentPosition(t)
                            : 1) ||
                      (!n.sortDetached && t.compareDocumentPosition(e) === r)
                        ? e === d || (e.ownerDocument === w && x(w, e))
                          ? -1
                          : t === d || (t.ownerDocument === w && x(w, t))
                          ? 1
                          : c
                          ? O(c, e) - O(c, t)
                          : 0
                        : 4 & r
                        ? -1
                        : 1)
                    );
                  }
                : function (e, t) {
                    if (e === t) return (f = !0), 0;
                    var n,
                      r = 0,
                      i = e.parentNode,
                      o = t.parentNode,
                      a = [e],
                      s = [t];
                    if (!i || !o)
                      return e === d
                        ? -1
                        : t === d
                        ? 1
                        : i
                        ? -1
                        : o
                        ? 1
                        : c
                        ? O(c, e) - O(c, t)
                        : 0;
                    if (i === o) return ce(e, t);
                    n = e;
                    while ((n = n.parentNode)) a.unshift(n);
                    n = t;
                    while ((n = n.parentNode)) s.unshift(n);
                    while (a[r] === s[r]) r++;
                    return r ? ce(a[r], s[r]) : a[r] === w ? -1 : s[r] === w ? 1 : 0;
                  }),
              d)
            : d;
        }),
      (oe.matches = function (e, t) {
        return oe(e, null, null, t);
      }),
      (oe.matchesSelector = function (e, t) {
        if (
          ((e.ownerDocument || e) !== d && p(e),
          (t = t.replace(z, "='$1']")),
          n.matchesSelector && g && !S[t + ' '] && (!v || !v.test(t)) && (!y || !y.test(t)))
        )
          try {
            var r = m.call(e, t);
            if (r || n.disconnectedMatch || (e.document && 11 !== e.document.nodeType)) return r;
          } catch (e) {}
        return oe(t, d, null, [e]).length > 0;
      }),
      (oe.contains = function (e, t) {
        return (e.ownerDocument || e) !== d && p(e), x(e, t);
      }),
      (oe.attr = function (e, t) {
        (e.ownerDocument || e) !== d && p(e);
        var i = r.attrHandle[t.toLowerCase()],
          o = i && N.call(r.attrHandle, t.toLowerCase()) ? i(e, t, !g) : void 0;
        return void 0 !== o
          ? o
          : n.attributes || !g
          ? e.getAttribute(t)
          : (o = e.getAttributeNode(t)) && o.specified
          ? o.value
          : null;
      }),
      (oe.escape = function (e) {
        return (e + '').replace(te, ne);
      }),
      (oe.error = function (e) {
        throw new Error('Syntax error, unrecognized expression: ' + e);
      }),
      (oe.uniqueSort = function (e) {
        var t,
          r = [],
          i = 0,
          o = 0;
        if (((f = !n.detectDuplicates), (c = !n.sortStable && e.slice(0)), e.sort(D), f)) {
          while ((t = e[o++])) t === e[o] && (i = r.push(o));
          while (i--) e.splice(r[i], 1);
        }
        return (c = null), e;
      }),
      (i = oe.getText =
        function (e) {
          var t,
            n = '',
            r = 0,
            o = e.nodeType;
          if (o) {
            if (1 === o || 9 === o || 11 === o) {
              if ('string' == typeof e.textContent) return e.textContent;
              for (e = e.firstChild; e; e = e.nextSibling) n += i(e);
            } else if (3 === o || 4 === o) return e.nodeValue;
          } else while ((t = e[r++])) n += i(t);
          return n;
        }),
      ((r = oe.selectors =
        {
          cacheLength: 50,
          createPseudo: se,
          match: V,
          attrHandle: {},
          find: {},
          relative: {
            '>': {dir: 'parentNode', first: !0},
            ' ': {dir: 'parentNode'},
            '+': {dir: 'previousSibling', first: !0},
            '~': {dir: 'previousSibling'}
          },
          preFilter: {
            ATTR: function (e) {
              return (
                (e[1] = e[1].replace(Z, ee)),
                (e[3] = (e[3] || e[4] || e[5] || '').replace(Z, ee)),
                '~=' === e[2] && (e[3] = ' ' + e[3] + ' '),
                e.slice(0, 4)
              );
            },
            CHILD: function (e) {
              return (
                (e[1] = e[1].toLowerCase()),
                'nth' === e[1].slice(0, 3)
                  ? (e[3] || oe.error(e[0]),
                    (e[4] = +(e[4] ? e[5] + (e[6] || 1) : 2 * ('even' === e[3] || 'odd' === e[3]))),
                    (e[5] = +(e[7] + e[8] || 'odd' === e[3])))
                  : e[3] && oe.error(e[0]),
                e
              );
            },
            PSEUDO: function (e) {
              var t,
                n = !e[6] && e[2];
              return V.CHILD.test(e[0])
                ? null
                : (e[3]
                    ? (e[2] = e[4] || e[5] || '')
                    : n &&
                      X.test(n) &&
                      (t = a(n, !0)) &&
                      (t = n.indexOf(')', n.length - t) - n.length) &&
                      ((e[0] = e[0].slice(0, t)), (e[2] = n.slice(0, t))),
                  e.slice(0, 3));
            }
          },
          filter: {
            TAG: function (e) {
              var t = e.replace(Z, ee).toLowerCase();
              return '*' === e
                ? function () {
                    return !0;
                  }
                : function (e) {
                    return e.nodeName && e.nodeName.toLowerCase() === t;
                  };
            },
            CLASS: function (e) {
              var t = E[e + ' '];
              return (
                t ||
                ((t = new RegExp('(^|' + M + ')' + e + '(' + M + '|$)')) &&
                  E(e, function (e) {
                    return t.test(
                      ('string' == typeof e.className && e.className) ||
                        ('undefined' != typeof e.getAttribute && e.getAttribute('class')) ||
                        ''
                    );
                  }))
              );
            },
            ATTR: function (e, t, n) {
              return function (r) {
                var i = oe.attr(r, e);
                return null == i
                  ? '!=' === t
                  : !t ||
                      ((i += ''),
                      '=' === t
                        ? i === n
                        : '!=' === t
                        ? i !== n
                        : '^=' === t
                        ? n && 0 === i.indexOf(n)
                        : '*=' === t
                        ? n && i.indexOf(n) > -1
                        : '$=' === t
                        ? n && i.slice(-n.length) === n
                        : '~=' === t
                        ? (' ' + i.replace($, ' ') + ' ').indexOf(n) > -1
                        : '|=' === t && (i === n || i.slice(0, n.length + 1) === n + '-'));
              };
            },
            CHILD: function (e, t, n, r, i) {
              var o = 'nth' !== e.slice(0, 3),
                a = 'last' !== e.slice(-4),
                s = 'of-type' === t;
              return 1 === r && 0 === i
                ? function (e) {
                    return !!e.parentNode;
                  }
                : function (t, n, u) {
                    var l,
                      c,
                      f,
                      p,
                      d,
                      h,
                      g = o !== a ? 'nextSibling' : 'previousSibling',
                      y = t.parentNode,
                      v = s && t.nodeName.toLowerCase(),
                      m = !u && !s,
                      x = !1;
                    if (y) {
                      if (o) {
                        while (g) {
                          p = t;
                          while ((p = p[g]))
                            if (s ? p.nodeName.toLowerCase() === v : 1 === p.nodeType) return !1;
                          h = g = 'only' === e && !h && 'nextSibling';
                        }
                        return !0;
                      }
                      if (((h = [a ? y.firstChild : y.lastChild]), a && m)) {
                        (x =
                          (d =
                            (l =
                              (c =
                                (f = (p = y)[b] || (p[b] = {}))[p.uniqueID] ||
                                (f[p.uniqueID] = {}))[e] || [])[0] === T && l[1]) && l[2]),
                          (p = d && y.childNodes[d]);
                        while ((p = (++d && p && p[g]) || (x = d = 0) || h.pop()))
                          if (1 === p.nodeType && ++x && p === t) {
                            c[e] = [T, d, x];
                            break;
                          }
                      } else if (
                        (m &&
                          (x = d =
                            (l =
                              (c =
                                (f = (p = t)[b] || (p[b] = {}))[p.uniqueID] ||
                                (f[p.uniqueID] = {}))[e] || [])[0] === T && l[1]),
                        !1 === x)
                      )
                        while ((p = (++d && p && p[g]) || (x = d = 0) || h.pop()))
                          if (
                            (s ? p.nodeName.toLowerCase() === v : 1 === p.nodeType) &&
                            ++x &&
                            (m &&
                              ((c = (f = p[b] || (p[b] = {}))[p.uniqueID] || (f[p.uniqueID] = {}))[
                                e
                              ] = [T, x]),
                            p === t)
                          )
                            break;
                      return (x -= i) === r || (x % r == 0 && x / r >= 0);
                    }
                  };
            },
            PSEUDO: function (e, t) {
              var n,
                i =
                  r.pseudos[e] ||
                  r.setFilters[e.toLowerCase()] ||
                  oe.error('unsupported pseudo: ' + e);
              return i[b]
                ? i(t)
                : i.length > 1
                ? ((n = [e, e, '', t]),
                  r.setFilters.hasOwnProperty(e.toLowerCase())
                    ? se(function (e, n) {
                        var r,
                          o = i(e, t),
                          a = o.length;
                        while (a--) e[(r = O(e, o[a]))] = !(n[r] = o[a]);
                      })
                    : function (e) {
                        return i(e, 0, n);
                      })
                : i;
            }
          },
          pseudos: {
            not: se(function (e) {
              var t = [],
                n = [],
                r = s(e.replace(B, '$1'));
              return r[b]
                ? se(function (e, t, n, i) {
                    var o,
                      a = r(e, null, i, []),
                      s = e.length;
                    while (s--) (o = a[s]) && (e[s] = !(t[s] = o));
                  })
                : function (e, i, o) {
                    return (t[0] = e), r(t, null, o, n), (t[0] = null), !n.pop();
                  };
            }),
            has: se(function (e) {
              return function (t) {
                return oe(e, t).length > 0;
              };
            }),
            contains: se(function (e) {
              return (
                (e = e.replace(Z, ee)),
                function (t) {
                  return (t.textContent || t.innerText || i(t)).indexOf(e) > -1;
                }
              );
            }),
            lang: se(function (e) {
              return (
                U.test(e || '') || oe.error('unsupported lang: ' + e),
                (e = e.replace(Z, ee).toLowerCase()),
                function (t) {
                  var n;
                  do {
                    if ((n = g ? t.lang : t.getAttribute('xml:lang') || t.getAttribute('lang')))
                      return (n = n.toLowerCase()) === e || 0 === n.indexOf(e + '-');
                  } while ((t = t.parentNode) && 1 === t.nodeType);
                  return !1;
                }
              );
            }),
            target: function (t) {
              var n = e.location && e.location.hash;
              return n && n.slice(1) === t.id;
            },
            root: function (e) {
              return e === h;
            },
            focus: function (e) {
              return (
                e === d.activeElement &&
                (!d.hasFocus || d.hasFocus()) &&
                !!(e.type || e.href || ~e.tabIndex)
              );
            },
            enabled: de(!1),
            disabled: de(!0),
            checked: function (e) {
              var t = e.nodeName.toLowerCase();
              return ('input' === t && !!e.checked) || ('option' === t && !!e.selected);
            },
            selected: function (e) {
              return e.parentNode && e.parentNode.selectedIndex, !0 === e.selected;
            },
            empty: function (e) {
              for (e = e.firstChild; e; e = e.nextSibling) if (e.nodeType < 6) return !1;
              return !0;
            },
            parent: function (e) {
              return !r.pseudos.empty(e);
            },
            header: function (e) {
              return Y.test(e.nodeName);
            },
            input: function (e) {
              return G.test(e.nodeName);
            },
            button: function (e) {
              var t = e.nodeName.toLowerCase();
              return ('input' === t && 'button' === e.type) || 'button' === t;
            },
            text: function (e) {
              var t;
              return (
                'input' === e.nodeName.toLowerCase() &&
                'text' === e.type &&
                (null == (t = e.getAttribute('type')) || 'text' === t.toLowerCase())
              );
            },
            first: he(function () {
              return [0];
            }),
            last: he(function (e, t) {
              return [t - 1];
            }),
            eq: he(function (e, t, n) {
              return [n < 0 ? n + t : n];
            }),
            even: he(function (e, t) {
              for (var n = 0; n < t; n += 2) e.push(n);
              return e;
            }),
            odd: he(function (e, t) {
              for (var n = 1; n < t; n += 2) e.push(n);
              return e;
            }),
            lt: he(function (e, t, n) {
              for (var r = n < 0 ? n + t : n; --r >= 0; ) e.push(r);
              return e;
            }),
            gt: he(function (e, t, n) {
              for (var r = n < 0 ? n + t : n; ++r < t; ) e.push(r);
              return e;
            })
          }
        }).pseudos.nth = r.pseudos.eq);
    for (t in {radio: !0, checkbox: !0, file: !0, password: !0, image: !0}) r.pseudos[t] = fe(t);
    for (t in {submit: !0, reset: !0}) r.pseudos[t] = pe(t);
    function ye() {}
    (ye.prototype = r.filters = r.pseudos),
      (r.setFilters = new ye()),
      (a = oe.tokenize =
        function (e, t) {
          var n,
            i,
            o,
            a,
            s,
            u,
            l,
            c = k[e + ' '];
          if (c) return t ? 0 : c.slice(0);
          (s = e), (u = []), (l = r.preFilter);
          while (s) {
            (n && !(i = F.exec(s))) || (i && (s = s.slice(i[0].length) || s), u.push((o = []))),
              (n = !1),
              (i = _.exec(s)) &&
                ((n = i.shift()),
                o.push({value: n, type: i[0].replace(B, ' ')}),
                (s = s.slice(n.length)));
            for (a in r.filter)
              !(i = V[a].exec(s)) ||
                (l[a] && !(i = l[a](i))) ||
                ((n = i.shift()), o.push({value: n, type: a, matches: i}), (s = s.slice(n.length)));
            if (!n) break;
          }
          return t ? s.length : s ? oe.error(e) : k(e, u).slice(0);
        });
    function ve(e) {
      for (var t = 0, n = e.length, r = ''; t < n; t++) r += e[t].value;
      return r;
    }
    function me(e, t, n) {
      var r = t.dir,
        i = t.next,
        o = i || r,
        a = n && 'parentNode' === o,
        s = C++;
      return t.first
        ? function (t, n, i) {
            while ((t = t[r])) if (1 === t.nodeType || a) return e(t, n, i);
            return !1;
          }
        : function (t, n, u) {
            var l,
              c,
              f,
              p = [T, s];
            if (u) {
              while ((t = t[r])) if ((1 === t.nodeType || a) && e(t, n, u)) return !0;
            } else
              while ((t = t[r]))
                if (1 === t.nodeType || a)
                  if (
                    ((f = t[b] || (t[b] = {})),
                    (c = f[t.uniqueID] || (f[t.uniqueID] = {})),
                    i && i === t.nodeName.toLowerCase())
                  )
                    t = t[r] || t;
                  else {
                    if ((l = c[o]) && l[0] === T && l[1] === s) return (p[2] = l[2]);
                    if (((c[o] = p), (p[2] = e(t, n, u)))) return !0;
                  }
            return !1;
          };
    }
    function xe(e) {
      return e.length > 1
        ? function (t, n, r) {
            var i = e.length;
            while (i--) if (!e[i](t, n, r)) return !1;
            return !0;
          }
        : e[0];
    }
    function be(e, t, n) {
      for (var r = 0, i = t.length; r < i; r++) oe(e, t[r], n);
      return n;
    }
    function we(e, t, n, r, i) {
      for (var o, a = [], s = 0, u = e.length, l = null != t; s < u; s++)
        (o = e[s]) && ((n && !n(o, r, i)) || (a.push(o), l && t.push(s)));
      return a;
    }
    function Te(e, t, n, r, i, o) {
      return (
        r && !r[b] && (r = Te(r)),
        i && !i[b] && (i = Te(i, o)),
        se(function (o, a, s, u) {
          var l,
            c,
            f,
            p = [],
            d = [],
            h = a.length,
            g = o || be(t || '*', s.nodeType ? [s] : s, []),
            y = !e || (!o && t) ? g : we(g, p, e, s, u),
            v = n ? (i || (o ? e : h || r) ? [] : a) : y;
          if ((n && n(y, v, s, u), r)) {
            (l = we(v, d)), r(l, [], s, u), (c = l.length);
            while (c--) (f = l[c]) && (v[d[c]] = !(y[d[c]] = f));
          }
          if (o) {
            if (i || e) {
              if (i) {
                (l = []), (c = v.length);
                while (c--) (f = v[c]) && l.push((y[c] = f));
                i(null, (v = []), l, u);
              }
              c = v.length;
              while (c--) (f = v[c]) && (l = i ? O(o, f) : p[c]) > -1 && (o[l] = !(a[l] = f));
            }
          } else (v = we(v === a ? v.splice(h, v.length) : v)), i ? i(null, a, v, u) : L.apply(a, v);
        })
      );
    }
    function Ce(e) {
      for (
        var t,
          n,
          i,
          o = e.length,
          a = r.relative[e[0].type],
          s = a || r.relative[' '],
          u = a ? 1 : 0,
          c = me(
            function (e) {
              return e === t;
            },
            s,
            !0
          ),
          f = me(
            function (e) {
              return O(t, e) > -1;
            },
            s,
            !0
          ),
          p = [
            function (e, n, r) {
              var i = (!a && (r || n !== l)) || ((t = n).nodeType ? c(e, n, r) : f(e, n, r));
              return (t = null), i;
            }
          ];
        u < o;
        u++
      )
        if ((n = r.relative[e[u].type])) p = [me(xe(p), n)];
        else {
          if ((n = r.filter[e[u].type].apply(null, e[u].matches))[b]) {
            for (i = ++u; i < o; i++) if (r.relative[e[i].type]) break;
            return Te(
              u > 1 && xe(p),
              u > 1 &&
                ve(e.slice(0, u - 1).concat({value: ' ' === e[u - 2].type ? '*' : ''})).replace(
                  B,
                  '$1'
                ),
              n,
              u < i && Ce(e.slice(u, i)),
              i < o && Ce((e = e.slice(i))),
              i < o && ve(e)
            );
          }
          p.push(n);
        }
      return xe(p);
    }
    function Ee(e, t) {
      var n = t.length > 0,
        i = e.length > 0,
        o = function (o, a, s, u, c) {
          var f,
            h,
            y,
            v = 0,
            m = '0',
            x = o && [],
            b = [],
            w = l,
            C = o || (i && r.find.TAG('*', c)),
            E = (T += null == w ? 1 : Math.random() || 0.1),
            k = C.length;
          for (c && (l = a === d || a || c); m !== k && null != (f = C[m]); m++) {
            if (i && f) {
              (h = 0), a || f.ownerDocument === d || (p(f), (s = !g));
              while ((y = e[h++]))
                if (y(f, a || d, s)) {
                  u.push(f);
                  break;
                }
              c && (T = E);
            }
            n && ((f = !y && f) && v--, o && x.push(f));
          }
          if (((v += m), n && m !== v)) {
            h = 0;
            while ((y = t[h++])) y(x, b, a, s);
            if (o) {
              if (v > 0) while (m--) x[m] || b[m] || (b[m] = j.call(u));
              b = we(b);
            }
            L.apply(u, b), c && !o && b.length > 0 && v + t.length > 1 && oe.uniqueSort(u);
          }
          return c && ((T = E), (l = w)), x;
        };
      return n ? se(o) : o;
    }
    return (
      (s = oe.compile =
        function (e, t) {
          var n,
            r = [],
            i = [],
            o = S[e + ' '];
          if (!o) {
            t || (t = a(e)), (n = t.length);
            while (n--) (o = Ce(t[n]))[b] ? r.push(o) : i.push(o);
            (o = S(e, Ee(i, r))).selector = e;
          }
          return o;
        }),
      (u = oe.select =
        function (e, t, n, i) {
          var o,
            u,
            l,
            c,
            f,
            p = 'function' == typeof e && e,
            d = !i && a((e = p.selector || e));
          if (((n = n || []), 1 === d.length)) {
            if (
              (u = d[0] = d[0].slice(0)).length > 2 &&
              'ID' === (l = u[0]).type &&
              9 === t.nodeType &&
              g &&
              r.relative[u[1].type]
            ) {
              if (!(t = (r.find.ID(l.matches[0].replace(Z, ee), t) || [])[0])) return n;
              p && (t = t.parentNode), (e = e.slice(u.shift().value.length));
            }
            o = V.needsContext.test(e) ? 0 : u.length;
            while (o--) {
              if (((l = u[o]), r.relative[(c = l.type)])) break;
              if (
                (f = r.find[c]) &&
                (i = f(l.matches[0].replace(Z, ee), (K.test(u[0].type) && ge(t.parentNode)) || t))
              ) {
                if ((u.splice(o, 1), !(e = i.length && ve(u)))) return L.apply(n, i), n;
                break;
              }
            }
          }
          return (p || s(e, d))(i, t, !g, n, !t || (K.test(e) && ge(t.parentNode)) || t), n;
        }),
      (n.sortStable = b.split('').sort(D).join('') === b),
      (n.detectDuplicates = !!f),
      p(),
      (n.sortDetached = ue(function (e) {
        return 1 & e.compareDocumentPosition(d.createElement('fieldset'));
      })),
      ue(function (e) {
        return (e.innerHTML = "<a href='#'></a>"), '#' === e.firstChild.getAttribute('href');
      }) ||
        le('type|href|height|width', function (e, t, n) {
          if (!n) return e.getAttribute(t, 'type' === t.toLowerCase() ? 1 : 2);
        }),
      (n.attributes &&
        ue(function (e) {
          return (
            (e.innerHTML = '<input/>'),
            e.firstChild.setAttribute('value', ''),
            '' === e.firstChild.getAttribute('value')
          );
        })) ||
        le('value', function (e, t, n) {
          if (!n && 'input' === e.nodeName.toLowerCase()) return e.defaultValue;
        }),
      ue(function (e) {
        return null == e.getAttribute('disabled');
      }) ||
        le(P, function (e, t, n) {
          var r;
          if (!n)
            return !0 === e[t]
              ? t.toLowerCase()
              : (r = e.getAttributeNode(t)) && r.specified
              ? r.value
              : null;
        }),
      oe
    );
  })(e);
  (w.find = E),
    (w.expr = E.selectors),
    (w.expr[':'] = w.expr.pseudos),
    (w.uniqueSort = w.unique = E.uniqueSort),
    (w.text = E.getText),
    (w.isXMLDoc = E.isXML),
    (w.contains = E.contains),
    (w.escapeSelector = E.escape);
  var k = function (e, t, n) {
      var r = [],
        i = void 0 !== n;
      while ((e = e[t]) && 9 !== e.nodeType)
        if (1 === e.nodeType) {
          if (i && w(e).is(n)) break;
          r.push(e);
        }
      return r;
    },
    S = function (e, t) {
      for (var n = []; e; e = e.nextSibling) 1 === e.nodeType && e !== t && n.push(e);
      return n;
    },
    D = w.expr.match.needsContext;
  function N(e, t) {
    return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase();
  }
  var A = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
  function j(e, t, n) {
    return g(t)
      ? w.grep(e, function (e, r) {
          return !!t.call(e, r, e) !== n;
        })
      : t.nodeType
      ? w.grep(e, function (e) {
          return (e === t) !== n;
        })
      : 'string' != typeof t
      ? w.grep(e, function (e) {
          return u.call(t, e) > -1 !== n;
        })
      : w.filter(t, e, n);
  }
  (w.filter = function (e, t, n) {
    var r = t[0];
    return (
      n && (e = ':not(' + e + ')'),
      1 === t.length && 1 === r.nodeType
        ? w.find.matchesSelector(r, e)
          ? [r]
          : []
        : w.find.matches(
            e,
            w.grep(t, function (e) {
              return 1 === e.nodeType;
            })
          )
    );
  }),
    w.fn.extend({
      find: function (e) {
        var t,
          n,
          r = this.length,
          i = this;
        if ('string' != typeof e)
          return this.pushStack(
            w(e).filter(function () {
              for (t = 0; t < r; t++) if (w.contains(i[t], this)) return !0;
            })
          );
        for (n = this.pushStack([]), t = 0; t < r; t++) w.find(e, i[t], n);
        return r > 1 ? w.uniqueSort(n) : n;
      },
      filter: function (e) {
        return this.pushStack(j(this, e || [], !1));
      },
      not: function (e) {
        return this.pushStack(j(this, e || [], !0));
      },
      is: function (e) {
        return !!j(this, 'string' == typeof e && D.test(e) ? w(e) : e || [], !1).length;
      }
    });
  var q,
    L = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
  ((w.fn.init = function (e, t, n) {
    var i, o;
    if (!e) return this;
    if (((n = n || q), 'string' == typeof e)) {
      if (
        !(i =
          '<' === e[0] && '>' === e[e.length - 1] && e.length >= 3 ? [null, e, null] : L.exec(e)) ||
        (!i[1] && t)
      )
        return !t || t.jquery ? (t || n).find(e) : this.constructor(t).find(e);
      if (i[1]) {
        if (
          ((t = t instanceof w ? t[0] : t),
          w.merge(this, w.parseHTML(i[1], t && t.nodeType ? t.ownerDocument || t : r, !0)),
          A.test(i[1]) && w.isPlainObject(t))
        )
          for (i in t) g(this[i]) ? this[i](t[i]) : this.attr(i, t[i]);
        return this;
      }
      return (o = r.getElementById(i[2])) && ((this[0] = o), (this.length = 1)), this;
    }
    return e.nodeType
      ? ((this[0] = e), (this.length = 1), this)
      : g(e)
      ? void 0 !== n.ready
        ? n.ready(e)
        : e(w)
      : w.makeArray(e, this);
  }).prototype = w.fn),
    (q = w(r));
  var H = /^(?:parents|prev(?:Until|All))/,
    O = {children: !0, contents: !0, next: !0, prev: !0};
  w.fn.extend({
    has: function (e) {
      var t = w(e, this),
        n = t.length;
      return this.filter(function () {
        for (var e = 0; e < n; e++) if (w.contains(this, t[e])) return !0;
      });
    },
    closest: function (e, t) {
      var n,
        r = 0,
        i = this.length,
        o = [],
        a = 'string' != typeof e && w(e);
      if (!D.test(e))
        for (; r < i; r++)
          for (n = this[r]; n && n !== t; n = n.parentNode)
            if (
              n.nodeType < 11 &&
              (a ? a.index(n) > -1 : 1 === n.nodeType && w.find.matchesSelector(n, e))
            ) {
              o.push(n);
              break;
            }
      return this.pushStack(o.length > 1 ? w.uniqueSort(o) : o);
    },
    index: function (e) {
      return e
        ? 'string' == typeof e
          ? u.call(w(e), this[0])
          : u.call(this, e.jquery ? e[0] : e)
        : this[0] && this[0].parentNode
        ? this.first().prevAll().length
        : -1;
    },
    add: function (e, t) {
      return this.pushStack(w.uniqueSort(w.merge(this.get(), w(e, t))));
    },
    addBack: function (e) {
      return this.add(null == e ? this.prevObject : this.prevObject.filter(e));
    }
  });
  function P(e, t) {
    while ((e = e[t]) && 1 !== e.nodeType);
    return e;
  }
  w.each(
    {
      parent: function (e) {
        var t = e.parentNode;
        return t && 11 !== t.nodeType ? t : null;
      },
      parents: function (e) {
        return k(e, 'parentNode');
      },
      parentsUntil: function (e, t, n) {
        return k(e, 'parentNode', n);
      },
      next: function (e) {
        return P(e, 'nextSibling');
      },
      prev: function (e) {
        return P(e, 'previousSibling');
      },
      nextAll: function (e) {
        return k(e, 'nextSibling');
      },
      prevAll: function (e) {
        return k(e, 'previousSibling');
      },
      nextUntil: function (e, t, n) {
        return k(e, 'nextSibling', n);
      },
      prevUntil: function (e, t, n) {
        return k(e, 'previousSibling', n);
      },
      siblings: function (e) {
        return S((e.parentNode || {}).firstChild, e);
      },
      children: function (e) {
        return S(e.firstChild);
      },
      contents: function (e) {
        return N(e, 'iframe')
          ? e.contentDocument
          : (N(e, 'template') && (e = e.content || e), w.merge([], e.childNodes));
      }
    },
    function (e, t) {
      w.fn[e] = function (n, r) {
        var i = w.map(this, t, n);
        return (
          'Until' !== e.slice(-5) && (r = n),
          r && 'string' == typeof r && (i = w.filter(r, i)),
          this.length > 1 && (O[e] || w.uniqueSort(i), H.test(e) && i.reverse()),
          this.pushStack(i)
        );
      };
    }
  );
  var M = /[^\x20\t\r\n\f]+/g;
  function R(e) {
    var t = {};
    return (
      w.each(e.match(M) || [], function (e, n) {
        t[n] = !0;
      }),
      t
    );
  }
  w.Callbacks = function (e) {
    e = 'string' == typeof e ? R(e) : w.extend({}, e);
    var t,
      n,
      r,
      i,
      o = [],
      a = [],
      s = -1,
      u = function () {
        for (i = i || e.once, r = t = !0; a.length; s = -1) {
          n = a.shift();
          while (++s < o.length)
            !1 === o[s].apply(n[0], n[1]) && e.stopOnFalse && ((s = o.length), (n = !1));
        }
        e.memory || (n = !1), (t = !1), i && (o = n ? [] : '');
      },
      l = {
        add: function () {
          return (
            o &&
              (n && !t && ((s = o.length - 1), a.push(n)),
              (function t(n) {
                w.each(n, function (n, r) {
                  g(r)
                    ? (e.unique && l.has(r)) || o.push(r)
                    : r && r.length && 'string' !== x(r) && t(r);
                });
              })(arguments),
              n && !t && u()),
            this
          );
        },
        remove: function () {
          return (
            w.each(arguments, function (e, t) {
              var n;
              while ((n = w.inArray(t, o, n)) > -1) o.splice(n, 1), n <= s && s--;
            }),
            this
          );
        },
        has: function (e) {
          return e ? w.inArray(e, o) > -1 : o.length > 0;
        },
        empty: function () {
          return o && (o = []), this;
        },
        disable: function () {
          return (i = a = []), (o = n = ''), this;
        },
        disabled: function () {
          return !o;
        },
        lock: function () {
          return (i = a = []), n || t || (o = n = ''), this;
        },
        locked: function () {
          return !!i;
        },
        fireWith: function (e, n) {
          return i || ((n = [e, (n = n || []).slice ? n.slice() : n]), a.push(n), t || u()), this;
        },
        fire: function () {
          return l.fireWith(this, arguments), this;
        },
        fired: function () {
          return !!r;
        }
      };
    return l;
  };
  function I(e) {
    return e;
  }
  function W(e) {
    throw e;
  }
  function $(e, t, n, r) {
    var i;
    try {
      e && g((i = e.promise))
        ? i.call(e).done(t).fail(n)
        : e && g((i = e.then))
        ? i.call(e, t, n)
        : t.apply(void 0, [e].slice(r));
    } catch (e) {
      n.apply(void 0, [e]);
    }
  }
  w.extend({
    Deferred: function (t) {
      var n = [
          ['notify', 'progress', w.Callbacks('memory'), w.Callbacks('memory'), 2],
          [
            'resolve',
            'done',
            w.Callbacks('once memory'),
            w.Callbacks('once memory'),
            0,
            'resolved'
          ],
          ['reject', 'fail', w.Callbacks('once memory'), w.Callbacks('once memory'), 1, 'rejected']
        ],
        r = 'pending',
        i = {
          state: function () {
            return r;
          },
          always: function () {
            return o.done(arguments).fail(arguments), this;
          },
          catch: function (e) {
            return i.then(null, e);
          },
          pipe: function () {
            var e = arguments;
            return w
              .Deferred(function (t) {
                w.each(n, function (n, r) {
                  var i = g(e[r[4]]) && e[r[4]];
                  o[r[1]](function () {
                    var e = i && i.apply(this, arguments);
                    e && g(e.promise)
                      ? e.promise().progress(t.notify).done(t.resolve).fail(t.reject)
                      : t[r[0] + 'With'](this, i ? [e] : arguments);
                  });
                }),
                  (e = null);
              })
              .promise();
          },
          then: function (t, r, i) {
            var o = 0;
            function a(t, n, r, i) {
              return function () {
                var s = this,
                  u = arguments,
                  l = function () {
                    var e, l;
                    if (!(t < o)) {
                      if ((e = r.apply(s, u)) === n.promise())
                        throw new TypeError('Thenable self-resolution');
                      (l = e && ('object' == typeof e || 'function' == typeof e) && e.then),
                        g(l)
                          ? i
                            ? l.call(e, a(o, n, I, i), a(o, n, W, i))
                            : (o++,
                              l.call(e, a(o, n, I, i), a(o, n, W, i), a(o, n, I, n.notifyWith)))
                          : (r !== I && ((s = void 0), (u = [e])), (i || n.resolveWith)(s, u));
                    }
                  },
                  c = i
                    ? l
                    : function () {
                        try {
                          l();
                        } catch (e) {
                          w.Deferred.exceptionHook && w.Deferred.exceptionHook(e, c.stackTrace),
                            t + 1 >= o &&
                              (r !== W && ((s = void 0), (u = [e])), n.rejectWith(s, u));
                        }
                      };
                t
                  ? c()
                  : (w.Deferred.getStackHook && (c.stackTrace = w.Deferred.getStackHook()),
                    e.setTimeout(c));
              };
            }
            return w
              .Deferred(function (e) {
                n[0][3].add(a(0, e, g(i) ? i : I, e.notifyWith)),
                  n[1][3].add(a(0, e, g(t) ? t : I)),
                  n[2][3].add(a(0, e, g(r) ? r : W));
              })
              .promise();
          },
          promise: function (e) {
            return null != e ? w.extend(e, i) : i;
          }
        },
        o = {};
      return (
        w.each(n, function (e, t) {
          var a = t[2],
            s = t[5];
          (i[t[1]] = a.add),
            s &&
              a.add(
                function () {
                  r = s;
                },
                n[3 - e][2].disable,
                n[3 - e][3].disable,
                n[0][2].lock,
                n[0][3].lock
              ),
            a.add(t[3].fire),
            (o[t[0]] = function () {
              return o[t[0] + 'With'](this === o ? void 0 : this, arguments), this;
            }),
            (o[t[0] + 'With'] = a.fireWith);
        }),
        i.promise(o),
        t && t.call(o, o),
        o
      );
    },
    when: function (e) {
      var t = arguments.length,
        n = t,
        r = Array(n),
        i = o.call(arguments),
        a = w.Deferred(),
        s = function (e) {
          return function (n) {
            (r[e] = this),
              (i[e] = arguments.length > 1 ? o.call(arguments) : n),
              --t || a.resolveWith(r, i);
          };
        };
      if (
        t <= 1 &&
        ($(e, a.done(s(n)).resolve, a.reject, !t), 'pending' === a.state() || g(i[n] && i[n].then))
      )
        return a.then();
      while (n--) $(i[n], s(n), a.reject);
      return a.promise();
    }
  });
  var B = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
  (w.Deferred.exceptionHook = function (t, n) {
    e.console &&
      e.console.warn &&
      t &&
      B.test(t.name) &&
      e.console.warn('jQuery.Deferred exception: ' + t.message, t.stack, n);
  }),
    (w.readyException = function (t) {
      e.setTimeout(function () {
        throw t;
      });
    });
  var F = w.Deferred();
  (w.fn.ready = function (e) {
    return (
      F.then(e)['catch'](function (e) {
        w.readyException(e);
      }),
      this
    );
  }),
    w.extend({
      isReady: !1,
      readyWait: 1,
      ready: function (e) {
        (!0 === e ? --w.readyWait : w.isReady) ||
          ((w.isReady = !0), (!0 !== e && --w.readyWait > 0) || F.resolveWith(r, [w]));
      }
    }),
    (w.ready.then = F.then);
  function _() {
    r.removeEventListener('DOMContentLoaded', _), e.removeEventListener('load', _), w.ready();
  }
  'complete' === r.readyState || ('loading' !== r.readyState && !r.documentElement.doScroll)
    ? e.setTimeout(w.ready)
    : (r.addEventListener('DOMContentLoaded', _), e.addEventListener('load', _));
  var z = function (e, t, n, r, i, o, a) {
      var s = 0,
        u = e.length,
        l = null == n;
      if ('object' === x(n)) {
        i = !0;
        for (s in n) z(e, t, s, n[s], !0, o, a);
      } else if (
        void 0 !== r &&
        ((i = !0),
        g(r) || (a = !0),
        l &&
          (a
            ? (t.call(e, r), (t = null))
            : ((l = t),
              (t = function (e, t, n) {
                return l.call(w(e), n);
              }))),
        t)
      )
        for (; s < u; s++) t(e[s], n, a ? r : r.call(e[s], s, t(e[s], n)));
      return i ? e : l ? t.call(e) : u ? t(e[0], n) : o;
    },
    X = /^-ms-/,
    U = /-([a-z])/g;
  function V(e, t) {
    return t.toUpperCase();
  }
  function G(e) {
    return e.replace(X, 'ms-').replace(U, V);
  }
  var Y = function (e) {
    return 1 === e.nodeType || 9 === e.nodeType || !+e.nodeType;
  };
  function Q() {
    this.expando = w.expando + Q.uid++;
  }
  (Q.uid = 1),
    (Q.prototype = {
      cache: function (e) {
        var t = e[this.expando];
        return (
          t ||
            ((t = {}),
            Y(e) &&
              (e.nodeType
                ? (e[this.expando] = t)
                : Object.defineProperty(e, this.expando, {value: t, configurable: !0}))),
          t
        );
      },
      set: function (e, t, n) {
        var r,
          i = this.cache(e);
        if ('string' == typeof t) i[G(t)] = n;
        else for (r in t) i[G(r)] = t[r];
        return i;
      },
      get: function (e, t) {
        return void 0 === t ? this.cache(e) : e[this.expando] && e[this.expando][G(t)];
      },
      access: function (e, t, n) {
        return void 0 === t || (t && 'string' == typeof t && void 0 === n)
          ? this.get(e, t)
          : (this.set(e, t, n), void 0 !== n ? n : t);
      },
      remove: function (e, t) {
        var n,
          r = e[this.expando];
        if (void 0 !== r) {
          if (void 0 !== t) {
            n = (t = Array.isArray(t) ? t.map(G) : (t = G(t)) in r ? [t] : t.match(M) || []).length;
            while (n--) delete r[t[n]];
          }
          (void 0 === t || w.isEmptyObject(r)) &&
            (e.nodeType ? (e[this.expando] = void 0) : delete e[this.expando]);
        }
      },
      hasData: function (e) {
        var t = e[this.expando];
        return void 0 !== t && !w.isEmptyObject(t);
      }
    });
  var J = new Q(),
    K = new Q(),
    Z = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
    ee = /[A-Z]/g;
  function te(e) {
    return (
      'true' === e ||
      ('false' !== e && ('null' === e ? null : e === +e + '' ? +e : Z.test(e) ? JSON.parse(e) : e))
    );
  }
  function ne(e, t, n) {
    var r;
    if (void 0 === n && 1 === e.nodeType)
      if (
        ((r = 'data-' + t.replace(ee, '-$&').toLowerCase()),
        'string' == typeof (n = e.getAttribute(r)))
      ) {
        try {
          n = te(n);
        } catch (e) {}
        K.set(e, t, n);
      } else n = void 0;
    return n;
  }
  w.extend({
    hasData: function (e) {
      return K.hasData(e) || J.hasData(e);
    },
    data: function (e, t, n) {
      return K.access(e, t, n);
    },
    removeData: function (e, t) {
      K.remove(e, t);
    },
    _data: function (e, t, n) {
      return J.access(e, t, n);
    },
    _removeData: function (e, t) {
      J.remove(e, t);
    }
  }),
    w.fn.extend({
      data: function (e, t) {
        var n,
          r,
          i,
          o = this[0],
          a = o && o.attributes;
        if (void 0 === e) {
          if (this.length && ((i = K.get(o)), 1 === o.nodeType && !J.get(o, 'hasDataAttrs'))) {
            n = a.length;
            while (n--)
              a[n] &&
                0 === (r = a[n].name).indexOf('data-') &&
                ((r = G(r.slice(5))), ne(o, r, i[r]));
            J.set(o, 'hasDataAttrs', !0);
          }
          return i;
        }
        return 'object' == typeof e
          ? this.each(function () {
              K.set(this, e);
            })
          : z(
              this,
              function (t) {
                var n;
                if (o && void 0 === t) {
                  if (void 0 !== (n = K.get(o, e))) return n;
                  if (void 0 !== (n = ne(o, e))) return n;
                } else
                  this.each(function () {
                    K.set(this, e, t);
                  });
              },
              null,
              t,
              arguments.length > 1,
              null,
              !0
            );
      },
      removeData: function (e) {
        return this.each(function () {
          K.remove(this, e);
        });
      }
    }),
    w.extend({
      queue: function (e, t, n) {
        var r;
        if (e)
          return (
            (t = (t || 'fx') + 'queue'),
            (r = J.get(e, t)),
            n && (!r || Array.isArray(n) ? (r = J.access(e, t, w.makeArray(n))) : r.push(n)),
            r || []
          );
      },
      dequeue: function (e, t) {
        t = t || 'fx';
        var n = w.queue(e, t),
          r = n.length,
          i = n.shift(),
          o = w._queueHooks(e, t),
          a = function () {
            w.dequeue(e, t);
          };
        'inprogress' === i && ((i = n.shift()), r--),
          i && ('fx' === t && n.unshift('inprogress'), delete o.stop, i.call(e, a, o)),
          !r && o && o.empty.fire();
      },
      _queueHooks: function (e, t) {
        var n = t + 'queueHooks';
        return (
          J.get(e, n) ||
          J.access(e, n, {
            empty: w.Callbacks('once memory').add(function () {
              J.remove(e, [t + 'queue', n]);
            })
          })
        );
      }
    }),
    w.fn.extend({
      queue: function (e, t) {
        var n = 2;
        return (
          'string' != typeof e && ((t = e), (e = 'fx'), n--),
          arguments.length < n
            ? w.queue(this[0], e)
            : void 0 === t
            ? this
            : this.each(function () {
                var n = w.queue(this, e, t);
                w._queueHooks(this, e), 'fx' === e && 'inprogress' !== n[0] && w.dequeue(this, e);
              })
        );
      },
      dequeue: function (e) {
        return this.each(function () {
          w.dequeue(this, e);
        });
      },
      clearQueue: function (e) {
        return this.queue(e || 'fx', []);
      },
      promise: function (e, t) {
        var n,
          r = 1,
          i = w.Deferred(),
          o = this,
          a = this.length,
          s = function () {
            --r || i.resolveWith(o, [o]);
          };
        'string' != typeof e && ((t = e), (e = void 0)), (e = e || 'fx');
        while (a--) (n = J.get(o[a], e + 'queueHooks')) && n.empty && (r++, n.empty.add(s));
        return s(), i.promise(t);
      }
    });
  var re = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
    ie = new RegExp('^(?:([+-])=|)(' + re + ')([a-z%]*)$', 'i'),
    oe = ['Top', 'Right', 'Bottom', 'Left'],
    ae = function (e, t) {
      return (
        'none' === (e = t || e).style.display ||
        ('' === e.style.display && w.contains(e.ownerDocument, e) && 'none' === w.css(e, 'display'))
      );
    },
    se = function (e, t, n, r) {
      var i,
        o,
        a = {};
      for (o in t) (a[o] = e.style[o]), (e.style[o] = t[o]);
      i = n.apply(e, r || []);
      for (o in t) e.style[o] = a[o];
      return i;
    };
  function ue(e, t, n, r) {
    var i,
      o,
      a = 20,
      s = r
        ? function () {
            return r.cur();
          }
        : function () {
            return w.css(e, t, '');
          },
      u = s(),
      l = (n && n[3]) || (w.cssNumber[t] ? '' : 'px'),
      c = (w.cssNumber[t] || ('px' !== l && +u)) && ie.exec(w.css(e, t));
    if (c && c[3] !== l) {
      (u /= 2), (l = l || c[3]), (c = +u || 1);
      while (a--)
        w.style(e, t, c + l), (1 - o) * (1 - (o = s() / u || 0.5)) <= 0 && (a = 0), (c /= o);
      (c *= 2), w.style(e, t, c + l), (n = n || []);
    }
    return (
      n &&
        ((c = +c || +u || 0),
        (i = n[1] ? c + (n[1] + 1) * n[2] : +n[2]),
        r && ((r.unit = l), (r.start = c), (r.end = i))),
      i
    );
  }
  var le = {};
  function ce(e) {
    var t,
      n = e.ownerDocument,
      r = e.nodeName,
      i = le[r];
    return (
      i ||
      ((t = n.body.appendChild(n.createElement(r))),
      (i = w.css(t, 'display')),
      t.parentNode.removeChild(t),
      'none' === i && (i = 'block'),
      (le[r] = i),
      i)
    );
  }
  function fe(e, t) {
    for (var n, r, i = [], o = 0, a = e.length; o < a; o++)
      (r = e[o]).style &&
        ((n = r.style.display),
        t
          ? ('none' === n && ((i[o] = J.get(r, 'display') || null), i[o] || (r.style.display = '')),
            '' === r.style.display && ae(r) && (i[o] = ce(r)))
          : 'none' !== n && ((i[o] = 'none'), J.set(r, 'display', n)));
    for (o = 0; o < a; o++) null != i[o] && (e[o].style.display = i[o]);
    return e;
  }
  w.fn.extend({
    show: function () {
      return fe(this, !0);
    },
    hide: function () {
      return fe(this);
    },
    toggle: function (e) {
      return 'boolean' == typeof e
        ? e
          ? this.show()
          : this.hide()
        : this.each(function () {
            ae(this) ? w(this).show() : w(this).hide();
          });
    }
  });
  var pe = /^(?:checkbox|radio)$/i,
    de = /<([a-z][^\/\0>\x20\t\r\n\f]+)/i,
    he = /^$|^module$|\/(?:java|ecma)script/i,
    ge = {
      option: [1, "<select multiple='multiple'>", '</select>'],
      thead: [1, '<table>', '</table>'],
      col: [2, '<table><colgroup>', '</colgroup></table>'],
      tr: [2, '<table><tbody>', '</tbody></table>'],
      td: [3, '<table><tbody><tr>', '</tr></tbody></table>'],
      _default: [0, '', '']
    };
  (ge.optgroup = ge.option),
    (ge.tbody = ge.tfoot = ge.colgroup = ge.caption = ge.thead),
    (ge.th = ge.td);
  function ye(e, t) {
    var n;
    return (
      (n =
        'undefined' != typeof e.getElementsByTagName
          ? e.getElementsByTagName(t || '*')
          : 'undefined' != typeof e.querySelectorAll
          ? e.querySelectorAll(t || '*')
          : []),
      void 0 === t || (t && N(e, t)) ? w.merge([e], n) : n
    );
  }
  function ve(e, t) {
    for (var n = 0, r = e.length; n < r; n++)
      J.set(e[n], 'globalEval', !t || J.get(t[n], 'globalEval'));
  }
  var me = /<|&#?\w+;/;
  function xe(e, t, n, r, i) {
    for (
      var o, a, s, u, l, c, f = t.createDocumentFragment(), p = [], d = 0, h = e.length;
      d < h;
      d++
    )
      if ((o = e[d]) || 0 === o)
        if ('object' === x(o)) w.merge(p, o.nodeType ? [o] : o);
        else if (me.test(o)) {
          (a = a || f.appendChild(t.createElement('div'))),
            (s = (de.exec(o) || ['', ''])[1].toLowerCase()),
            (u = ge[s] || ge._default),
            (a.innerHTML = u[1] + w.htmlPrefilter(o) + u[2]),
            (c = u[0]);
          while (c--) a = a.lastChild;
          w.merge(p, a.childNodes), ((a = f.firstChild).textContent = '');
        } else p.push(t.createTextNode(o));
    (f.textContent = ''), (d = 0);
    while ((o = p[d++]))
      if (r && w.inArray(o, r) > -1) i && i.push(o);
      else if (
        ((l = w.contains(o.ownerDocument, o)), (a = ye(f.appendChild(o), 'script')), l && ve(a), n)
      ) {
        c = 0;
        while ((o = a[c++])) he.test(o.type || '') && n.push(o);
      }
    return f;
  }
  !(function () {
    var e = r.createDocumentFragment().appendChild(r.createElement('div')),
      t = r.createElement('input');
    t.setAttribute('type', 'radio'),
      t.setAttribute('checked', 'checked'),
      t.setAttribute('name', 't'),
      e.appendChild(t),
      (h.checkClone = e.cloneNode(!0).cloneNode(!0).lastChild.checked),
      (e.innerHTML = '<textarea>x</textarea>'),
      (h.noCloneChecked = !!e.cloneNode(!0).lastChild.defaultValue);
  })();
  var be = r.documentElement,
    we = /^key/,
    Te = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
    Ce = /^([^.]*)(?:\.(.+)|)/;
  function Ee() {
    return !0;
  }
  function ke() {
    return !1;
  }
  function Se() {
    try {
      return r.activeElement;
    } catch (e) {}
  }
  function De(e, t, n, r, i, o) {
    var a, s;
    if ('object' == typeof t) {
      'string' != typeof n && ((r = r || n), (n = void 0));
      for (s in t) De(e, s, n, r, t[s], o);
      return e;
    }
    if (
      (null == r && null == i
        ? ((i = n), (r = n = void 0))
        : null == i &&
          ('string' == typeof n ? ((i = r), (r = void 0)) : ((i = r), (r = n), (n = void 0))),
      !1 === i)
    )
      i = ke;
    else if (!i) return e;
    return (
      1 === o &&
        ((a = i),
        ((i = function (e) {
          return w().off(e), a.apply(this, arguments);
        }).guid = a.guid || (a.guid = w.guid++))),
      e.each(function () {
        w.event.add(this, t, i, r, n);
      })
    );
  }
  (w.event = {
    global: {},
    add: function (e, t, n, r, i) {
      var o,
        a,
        s,
        u,
        l,
        c,
        f,
        p,
        d,
        h,
        g,
        y = J.get(e);
      if (y) {
        n.handler && ((n = (o = n).handler), (i = o.selector)),
          i && w.find.matchesSelector(be, i),
          n.guid || (n.guid = w.guid++),
          (u = y.events) || (u = y.events = {}),
          (a = y.handle) ||
            (a = y.handle =
              function (t) {
                return 'undefined' != typeof w && w.event.triggered !== t.type
                  ? w.event.dispatch.apply(e, arguments)
                  : void 0;
              }),
          (l = (t = (t || '').match(M) || ['']).length);
        while (l--)
          (d = g = (s = Ce.exec(t[l]) || [])[1]),
            (h = (s[2] || '').split('.').sort()),
            d &&
              ((f = w.event.special[d] || {}),
              (d = (i ? f.delegateType : f.bindType) || d),
              (f = w.event.special[d] || {}),
              (c = w.extend(
                {
                  type: d,
                  origType: g,
                  data: r,
                  handler: n,
                  guid: n.guid,
                  selector: i,
                  needsContext: i && w.expr.match.needsContext.test(i),
                  namespace: h.join('.')
                },
                o
              )),
              (p = u[d]) ||
                (((p = u[d] = []).delegateCount = 0),
                (f.setup && !1 !== f.setup.call(e, r, h, a)) ||
                  (e.addEventListener && e.addEventListener(d, a))),
              f.add && (f.add.call(e, c), c.handler.guid || (c.handler.guid = n.guid)),
              i ? p.splice(p.delegateCount++, 0, c) : p.push(c),
              (w.event.global[d] = !0));
      }
    },
    remove: function (e, t, n, r, i) {
      var o,
        a,
        s,
        u,
        l,
        c,
        f,
        p,
        d,
        h,
        g,
        y = J.hasData(e) && J.get(e);
      if (y && (u = y.events)) {
        l = (t = (t || '').match(M) || ['']).length;
        while (l--)
          if (
            ((s = Ce.exec(t[l]) || []), (d = g = s[1]), (h = (s[2] || '').split('.').sort()), d)
          ) {
            (f = w.event.special[d] || {}),
              (p = u[(d = (r ? f.delegateType : f.bindType) || d)] || []),
              (s = s[2] && new RegExp('(^|\\.)' + h.join('\\.(?:.*\\.|)') + '(\\.|$)')),
              (a = o = p.length);
            while (o--)
              (c = p[o]),
                (!i && g !== c.origType) ||
                  (n && n.guid !== c.guid) ||
                  (s && !s.test(c.namespace)) ||
                  (r && r !== c.selector && ('**' !== r || !c.selector)) ||
                  (p.splice(o, 1),
                  c.selector && p.delegateCount--,
                  f.remove && f.remove.call(e, c));
            a &&
              !p.length &&
              ((f.teardown && !1 !== f.teardown.call(e, h, y.handle)) ||
                w.removeEvent(e, d, y.handle),
              delete u[d]);
          } else for (d in u) w.event.remove(e, d + t[l], n, r, !0);
        w.isEmptyObject(u) && J.remove(e, 'handle events');
      }
    },
    dispatch: function (e) {
      var t = w.event.fix(e),
        n,
        r,
        i,
        o,
        a,
        s,
        u = new Array(arguments.length),
        l = (J.get(this, 'events') || {})[t.type] || [],
        c = w.event.special[t.type] || {};
      for (u[0] = t, n = 1; n < arguments.length; n++) u[n] = arguments[n];
      if (((t.delegateTarget = this), !c.preDispatch || !1 !== c.preDispatch.call(this, t))) {
        (s = w.event.handlers.call(this, t, l)), (n = 0);
        while ((o = s[n++]) && !t.isPropagationStopped()) {
          (t.currentTarget = o.elem), (r = 0);
          while ((a = o.handlers[r++]) && !t.isImmediatePropagationStopped())
            (t.rnamespace && !t.rnamespace.test(a.namespace)) ||
              ((t.handleObj = a),
              (t.data = a.data),
              void 0 !==
                (i = ((w.event.special[a.origType] || {}).handle || a.handler).apply(o.elem, u)) &&
                !1 === (t.result = i) &&
                (t.preventDefault(), t.stopPropagation()));
        }
        return c.postDispatch && c.postDispatch.call(this, t), t.result;
      }
    },
    handlers: function (e, t) {
      var n,
        r,
        i,
        o,
        a,
        s = [],
        u = t.delegateCount,
        l = e.target;
      if (u && l.nodeType && !('click' === e.type && e.button >= 1))
        for (; l !== this; l = l.parentNode || this)
          if (1 === l.nodeType && ('click' !== e.type || !0 !== l.disabled)) {
            for (o = [], a = {}, n = 0; n < u; n++)
              void 0 === a[(i = (r = t[n]).selector + ' ')] &&
                (a[i] = r.needsContext
                  ? w(i, this).index(l) > -1
                  : w.find(i, this, null, [l]).length),
                a[i] && o.push(r);
            o.length && s.push({elem: l, handlers: o});
          }
      return (l = this), u < t.length && s.push({elem: l, handlers: t.slice(u)}), s;
    },
    addProp: function (e, t) {
      Object.defineProperty(w.Event.prototype, e, {
        enumerable: !0,
        configurable: !0,
        get: g(t)
          ? function () {
              if (this.originalEvent) return t(this.originalEvent);
            }
          : function () {
              if (this.originalEvent) return this.originalEvent[e];
            },
        set: function (t) {
          Object.defineProperty(this, e, {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: t
          });
        }
      });
    },
    fix: function (e) {
      return e[w.expando] ? e : new w.Event(e);
    },
    special: {
      load: {noBubble: !0},
      focus: {
        trigger: function () {
          if (this !== Se() && this.focus) return this.focus(), !1;
        },
        delegateType: 'focusin'
      },
      blur: {
        trigger: function () {
          if (this === Se() && this.blur) return this.blur(), !1;
        },
        delegateType: 'focusout'
      },
      click: {
        trigger: function () {
          if ('checkbox' === this.type && this.click && N(this, 'input')) return this.click(), !1;
        },
        _default: function (e) {
          return N(e.target, 'a');
        }
      },
      beforeunload: {
        postDispatch: function (e) {
          void 0 !== e.result && e.originalEvent && (e.originalEvent.returnValue = e.result);
        }
      }
    }
  }),
    (w.removeEvent = function (e, t, n) {
      e.removeEventListener && e.removeEventListener(t, n);
    }),
    (w.Event = function (e, t) {
      if (!(this instanceof w.Event)) return new w.Event(e, t);
      e && e.type
        ? ((this.originalEvent = e),
          (this.type = e.type),
          (this.isDefaultPrevented =
            e.defaultPrevented || (void 0 === e.defaultPrevented && !1 === e.returnValue)
              ? Ee
              : ke),
          (this.target = e.target && 3 === e.target.nodeType ? e.target.parentNode : e.target),
          (this.currentTarget = e.currentTarget),
          (this.relatedTarget = e.relatedTarget))
        : (this.type = e),
        t && w.extend(this, t),
        (this.timeStamp = (e && e.timeStamp) || Date.now()),
        (this[w.expando] = !0);
    }),
    (w.Event.prototype = {
      constructor: w.Event,
      isDefaultPrevented: ke,
      isPropagationStopped: ke,
      isImmediatePropagationStopped: ke,
      isSimulated: !1,
      preventDefault: function () {
        var e = this.originalEvent;
        (this.isDefaultPrevented = Ee), e && !this.isSimulated && e.preventDefault();
      },
      stopPropagation: function () {
        var e = this.originalEvent;
        (this.isPropagationStopped = Ee), e && !this.isSimulated && e.stopPropagation();
      },
      stopImmediatePropagation: function () {
        var e = this.originalEvent;
        (this.isImmediatePropagationStopped = Ee),
          e && !this.isSimulated && e.stopImmediatePropagation(),
          this.stopPropagation();
      }
    }),
    w.each(
      {
        altKey: !0,
        bubbles: !0,
        cancelable: !0,
        changedTouches: !0,
        ctrlKey: !0,
        detail: !0,
        eventPhase: !0,
        metaKey: !0,
        pageX: !0,
        pageY: !0,
        shiftKey: !0,
        view: !0,
        char: !0,
        charCode: !0,
        key: !0,
        keyCode: !0,
        button: !0,
        buttons: !0,
        clientX: !0,
        clientY: !0,
        offsetX: !0,
        offsetY: !0,
        pointerId: !0,
        pointerType: !0,
        screenX: !0,
        screenY: !0,
        targetTouches: !0,
        toElement: !0,
        touches: !0,
        which: function (e) {
          var t = e.button;
          return null == e.which && we.test(e.type)
            ? null != e.charCode
              ? e.charCode
              : e.keyCode
            : !e.which && void 0 !== t && Te.test(e.type)
            ? 1 & t
              ? 1
              : 2 & t
              ? 3
              : 4 & t
              ? 2
              : 0
            : e.which;
        }
      },
      w.event.addProp
    ),
    w.each(
      {
        mouseenter: 'mouseover',
        mouseleave: 'mouseout',
        pointerenter: 'pointerover',
        pointerleave: 'pointerout'
      },
      function (e, t) {
        w.event.special[e] = {
          delegateType: t,
          bindType: t,
          handle: function (e) {
            var n,
              r = this,
              i = e.relatedTarget,
              o = e.handleObj;
            return (
              (i && (i === r || w.contains(r, i))) ||
                ((e.type = o.origType), (n = o.handler.apply(this, arguments)), (e.type = t)),
              n
            );
          }
        };
      }
    ),
    w.fn.extend({
      on: function (e, t, n, r) {
        return De(this, e, t, n, r);
      },
      one: function (e, t, n, r) {
        return De(this, e, t, n, r, 1);
      },
      off: function (e, t, n) {
        var r, i;
        if (e && e.preventDefault && e.handleObj)
          return (
            (r = e.handleObj),
            w(e.delegateTarget).off(
              r.namespace ? r.origType + '.' + r.namespace : r.origType,
              r.selector,
              r.handler
            ),
            this
          );
        if ('object' == typeof e) {
          for (i in e) this.off(i, t, e[i]);
          return this;
        }
        return (
          (!1 !== t && 'function' != typeof t) || ((n = t), (t = void 0)),
          !1 === n && (n = ke),
          this.each(function () {
            w.event.remove(this, e, n, t);
          })
        );
      }
    });
  var Ne =
      /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,
    Ae = /<script|<style|<link/i,
    je = /checked\s*(?:[^=]|=\s*.checked.)/i,
    qe = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
  function Le(e, t) {
    return N(e, 'table') && N(11 !== t.nodeType ? t : t.firstChild, 'tr')
      ? w(e).children('tbody')[0] || e
      : e;
  }
  function He(e) {
    return (e.type = (null !== e.getAttribute('type')) + '/' + e.type), e;
  }
  function Oe(e) {
    return (
      'true/' === (e.type || '').slice(0, 5)
        ? (e.type = e.type.slice(5))
        : e.removeAttribute('type'),
      e
    );
  }
  function Pe(e, t) {
    var n, r, i, o, a, s, u, l;
    if (1 === t.nodeType) {
      if (J.hasData(e) && ((o = J.access(e)), (a = J.set(t, o)), (l = o.events))) {
        delete a.handle, (a.events = {});
        for (i in l) for (n = 0, r = l[i].length; n < r; n++) w.event.add(t, i, l[i][n]);
      }
      K.hasData(e) && ((s = K.access(e)), (u = w.extend({}, s)), K.set(t, u));
    }
  }
  function Me(e, t) {
    var n = t.nodeName.toLowerCase();
    'input' === n && pe.test(e.type)
      ? (t.checked = e.checked)
      : ('input' !== n && 'textarea' !== n) || (t.defaultValue = e.defaultValue);
  }
  function Re(e, t, n, r) {
    t = a.apply([], t);
    var i,
      o,
      s,
      u,
      l,
      c,
      f = 0,
      p = e.length,
      d = p - 1,
      y = t[0],
      v = g(y);
    if (v || (p > 1 && 'string' == typeof y && !h.checkClone && je.test(y)))
      return e.each(function (i) {
        var o = e.eq(i);
        v && (t[0] = y.call(this, i, o.html())), Re(o, t, n, r);
      });
    if (
      p &&
      ((i = xe(t, e[0].ownerDocument, !1, e, r)),
      (o = i.firstChild),
      1 === i.childNodes.length && (i = o),
      o || r)
    ) {
      for (u = (s = w.map(ye(i, 'script'), He)).length; f < p; f++)
        (l = i),
          f !== d && ((l = w.clone(l, !0, !0)), u && w.merge(s, ye(l, 'script'))),
          n.call(e[f], l, f);
      if (u)
        for (c = s[s.length - 1].ownerDocument, w.map(s, Oe), f = 0; f < u; f++)
          (l = s[f]),
            he.test(l.type || '') &&
              !J.access(l, 'globalEval') &&
              w.contains(c, l) &&
              (l.src && 'module' !== (l.type || '').toLowerCase()
                ? w._evalUrl && w._evalUrl(l.src)
                : m(l.textContent.replace(qe, ''), c, l));
    }
    return e;
  }
  function Ie(e, t, n) {
    for (var r, i = t ? w.filter(t, e) : e, o = 0; null != (r = i[o]); o++)
      n || 1 !== r.nodeType || w.cleanData(ye(r)),
        r.parentNode &&
          (n && w.contains(r.ownerDocument, r) && ve(ye(r, 'script')), r.parentNode.removeChild(r));
    return e;
  }
  w.extend({
    htmlPrefilter: function (e) {
      return e.replace(Ne, '<$1></$2>');
    },
    clone: function (e, t, n) {
      var r,
        i,
        o,
        a,
        s = e.cloneNode(!0),
        u = w.contains(e.ownerDocument, e);
      if (!(h.noCloneChecked || (1 !== e.nodeType && 11 !== e.nodeType) || w.isXMLDoc(e)))
        for (a = ye(s), r = 0, i = (o = ye(e)).length; r < i; r++) Me(o[r], a[r]);
      if (t)
        if (n) for (o = o || ye(e), a = a || ye(s), r = 0, i = o.length; r < i; r++) Pe(o[r], a[r]);
        else Pe(e, s);
      return (a = ye(s, 'script')).length > 0 && ve(a, !u && ye(e, 'script')), s;
    },
    cleanData: function (e) {
      for (var t, n, r, i = w.event.special, o = 0; void 0 !== (n = e[o]); o++)
        if (Y(n)) {
          if ((t = n[J.expando])) {
            if (t.events)
              for (r in t.events) i[r] ? w.event.remove(n, r) : w.removeEvent(n, r, t.handle);
            n[J.expando] = void 0;
          }
          n[K.expando] && (n[K.expando] = void 0);
        }
    }
  }),
    w.fn.extend({
      detach: function (e) {
        return Ie(this, e, !0);
      },
      remove: function (e) {
        return Ie(this, e);
      },
      text: function (e) {
        return z(
          this,
          function (e) {
            return void 0 === e
              ? w.text(this)
              : this.empty().each(function () {
                  (1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType) ||
                    (this.textContent = e);
                });
          },
          null,
          e,
          arguments.length
        );
      },
      append: function () {
        return Re(this, arguments, function (e) {
          (1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType) ||
            Le(this, e).appendChild(e);
        });
      },
      prepend: function () {
        return Re(this, arguments, function (e) {
          if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
            var t = Le(this, e);
            t.insertBefore(e, t.firstChild);
          }
        });
      },
      before: function () {
        return Re(this, arguments, function (e) {
          this.parentNode && this.parentNode.insertBefore(e, this);
        });
      },
      after: function () {
        return Re(this, arguments, function (e) {
          this.parentNode && this.parentNode.insertBefore(e, this.nextSibling);
        });
      },
      empty: function () {
        for (var e, t = 0; null != (e = this[t]); t++)
          1 === e.nodeType && (w.cleanData(ye(e, !1)), (e.textContent = ''));
        return this;
      },
      clone: function (e, t) {
        return (
          (e = null != e && e),
          (t = null == t ? e : t),
          this.map(function () {
            return w.clone(this, e, t);
          })
        );
      },
      html: function (e) {
        return z(
          this,
          function (e) {
            var t = this[0] || {},
              n = 0,
              r = this.length;
            if (void 0 === e && 1 === t.nodeType) return t.innerHTML;
            if (
              'string' == typeof e &&
              !Ae.test(e) &&
              !ge[(de.exec(e) || ['', ''])[1].toLowerCase()]
            ) {
              e = w.htmlPrefilter(e);
              try {
                for (; n < r; n++)
                  1 === (t = this[n] || {}).nodeType && (w.cleanData(ye(t, !1)), (t.innerHTML = e));
                t = 0;
              } catch (e) {}
            }
            t && this.empty().append(e);
          },
          null,
          e,
          arguments.length
        );
      },
      replaceWith: function () {
        var e = [];
        return Re(
          this,
          arguments,
          function (t) {
            var n = this.parentNode;
            w.inArray(this, e) < 0 && (w.cleanData(ye(this)), n && n.replaceChild(t, this));
          },
          e
        );
      }
    }),
    w.each(
      {
        appendTo: 'append',
        prependTo: 'prepend',
        insertBefore: 'before',
        insertAfter: 'after',
        replaceAll: 'replaceWith'
      },
      function (e, t) {
        w.fn[e] = function (e) {
          for (var n, r = [], i = w(e), o = i.length - 1, a = 0; a <= o; a++)
            (n = a === o ? this : this.clone(!0)), w(i[a])[t](n), s.apply(r, n.get());
          return this.pushStack(r);
        };
      }
    );
  var We = new RegExp('^(' + re + ')(?!px)[a-z%]+$', 'i'),
    $e = function (t) {
      var n = t.ownerDocument.defaultView;
      return (n && n.opener) || (n = e), n.getComputedStyle(t);
    },
    Be = new RegExp(oe.join('|'), 'i');
  !(function () {
    function t() {
      if (c) {
        (l.style.cssText =
          'position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0'),
          (c.style.cssText =
            'position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%'),
          be.appendChild(l).appendChild(c);
        var t = e.getComputedStyle(c);
        (i = '1%' !== t.top),
          (u = 12 === n(t.marginLeft)),
          (c.style.right = '60%'),
          (s = 36 === n(t.right)),
          (o = 36 === n(t.width)),
          (c.style.position = 'absolute'),
          (a = 36 === c.offsetWidth || 'absolute'),
          be.removeChild(l),
          (c = null);
      }
    }
    function n(e) {
      return Math.round(parseFloat(e));
    }
    var i,
      o,
      a,
      s,
      u,
      l = r.createElement('div'),
      c = r.createElement('div');
    c.style &&
      ((c.style.backgroundClip = 'content-box'),
      (c.cloneNode(!0).style.backgroundClip = ''),
      (h.clearCloneStyle = 'content-box' === c.style.backgroundClip),
      w.extend(h, {
        boxSizingReliable: function () {
          return t(), o;
        },
        pixelBoxStyles: function () {
          return t(), s;
        },
        pixelPosition: function () {
          return t(), i;
        },
        reliableMarginLeft: function () {
          return t(), u;
        },
        scrollboxSize: function () {
          return t(), a;
        }
      }));
  })();
  function Fe(e, t, n) {
    var r,
      i,
      o,
      a,
      s = e.style;
    return (
      (n = n || $e(e)) &&
        ('' !== (a = n.getPropertyValue(t) || n[t]) ||
          w.contains(e.ownerDocument, e) ||
          (a = w.style(e, t)),
        !h.pixelBoxStyles() &&
          We.test(a) &&
          Be.test(t) &&
          ((r = s.width),
          (i = s.minWidth),
          (o = s.maxWidth),
          (s.minWidth = s.maxWidth = s.width = a),
          (a = n.width),
          (s.width = r),
          (s.minWidth = i),
          (s.maxWidth = o))),
      void 0 !== a ? a + '' : a
    );
  }
  function _e(e, t) {
    return {
      get: function () {
        if (!e()) return (this.get = t).apply(this, arguments);
        delete this.get;
      }
    };
  }
  var ze = /^(none|table(?!-c[ea]).+)/,
    Xe = /^--/,
    Ue = {position: 'absolute', visibility: 'hidden', display: 'block'},
    Ve = {letterSpacing: '0', fontWeight: '400'},
    Ge = ['Webkit', 'Moz', 'ms'],
    Ye = r.createElement('div').style;
  function Qe(e) {
    if (e in Ye) return e;
    var t = e[0].toUpperCase() + e.slice(1),
      n = Ge.length;
    while (n--) if ((e = Ge[n] + t) in Ye) return e;
  }
  function Je(e) {
    var t = w.cssProps[e];
    return t || (t = w.cssProps[e] = Qe(e) || e), t;
  }
  function Ke(e, t, n) {
    var r = ie.exec(t);
    return r ? Math.max(0, r[2] - (n || 0)) + (r[3] || 'px') : t;
  }
  function Ze(e, t, n, r, i, o) {
    var a = 'width' === t ? 1 : 0,
      s = 0,
      u = 0;
    if (n === (r ? 'border' : 'content')) return 0;
    for (; a < 4; a += 2)
      'margin' === n && (u += w.css(e, n + oe[a], !0, i)),
        r
          ? ('content' === n && (u -= w.css(e, 'padding' + oe[a], !0, i)),
            'margin' !== n && (u -= w.css(e, 'border' + oe[a] + 'Width', !0, i)))
          : ((u += w.css(e, 'padding' + oe[a], !0, i)),
            'padding' !== n
              ? (u += w.css(e, 'border' + oe[a] + 'Width', !0, i))
              : (s += w.css(e, 'border' + oe[a] + 'Width', !0, i)));
    return (
      !r &&
        o >= 0 &&
        (u += Math.max(
          0,
          Math.ceil(e['offset' + t[0].toUpperCase() + t.slice(1)] - o - u - s - 0.5)
        )),
      u
    );
  }
  function et(e, t, n) {
    var r = $e(e),
      i = Fe(e, t, r),
      o = 'border-box' === w.css(e, 'boxSizing', !1, r),
      a = o;
    if (We.test(i)) {
      if (!n) return i;
      i = 'auto';
    }
    return (
      (a = a && (h.boxSizingReliable() || i === e.style[t])),
      ('auto' === i || (!parseFloat(i) && 'inline' === w.css(e, 'display', !1, r))) &&
        ((i = e['offset' + t[0].toUpperCase() + t.slice(1)]), (a = !0)),
      (i = parseFloat(i) || 0) + Ze(e, t, n || (o ? 'border' : 'content'), a, r, i) + 'px'
    );
  }
  w.extend({
    cssHooks: {
      opacity: {
        get: function (e, t) {
          if (t) {
            var n = Fe(e, 'opacity');
            return '' === n ? '1' : n;
          }
        }
      }
    },
    cssNumber: {
      animationIterationCount: !0,
      columnCount: !0,
      fillOpacity: !0,
      flexGrow: !0,
      flexShrink: !0,
      fontWeight: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0
    },
    cssProps: {},
    style: function (e, t, n, r) {
      if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
        var i,
          o,
          a,
          s = G(t),
          u = Xe.test(t),
          l = e.style;
        if ((u || (t = Je(s)), (a = w.cssHooks[t] || w.cssHooks[s]), void 0 === n))
          return a && 'get' in a && void 0 !== (i = a.get(e, !1, r)) ? i : l[t];
        'string' == (o = typeof n) &&
          (i = ie.exec(n)) &&
          i[1] &&
          ((n = ue(e, t, i)), (o = 'number')),
          null != n &&
            n === n &&
            ('number' === o && (n += (i && i[3]) || (w.cssNumber[s] ? '' : 'px')),
            h.clearCloneStyle || '' !== n || 0 !== t.indexOf('background') || (l[t] = 'inherit'),
            (a && 'set' in a && void 0 === (n = a.set(e, n, r))) ||
              (u ? l.setProperty(t, n) : (l[t] = n)));
      }
    },
    css: function (e, t, n, r) {
      var i,
        o,
        a,
        s = G(t);
      return (
        Xe.test(t) || (t = Je(s)),
        (a = w.cssHooks[t] || w.cssHooks[s]) && 'get' in a && (i = a.get(e, !0, n)),
        void 0 === i && (i = Fe(e, t, r)),
        'normal' === i && t in Ve && (i = Ve[t]),
        '' === n || n ? ((o = parseFloat(i)), !0 === n || isFinite(o) ? o || 0 : i) : i
      );
    }
  }),
    w.each(['height', 'width'], function (e, t) {
      w.cssHooks[t] = {
        get: function (e, n, r) {
          if (n)
            return !ze.test(w.css(e, 'display')) ||
              (e.getClientRects().length && e.getBoundingClientRect().width)
              ? et(e, t, r)
              : se(e, Ue, function () {
                  return et(e, t, r);
                });
        },
        set: function (e, n, r) {
          var i,
            o = $e(e),
            a = 'border-box' === w.css(e, 'boxSizing', !1, o),
            s = r && Ze(e, t, r, a, o);
          return (
            a &&
              h.scrollboxSize() === o.position &&
              (s -= Math.ceil(
                e['offset' + t[0].toUpperCase() + t.slice(1)] -
                  parseFloat(o[t]) -
                  Ze(e, t, 'border', !1, o) -
                  0.5
              )),
            s &&
              (i = ie.exec(n)) &&
              'px' !== (i[3] || 'px') &&
              ((e.style[t] = n), (n = w.css(e, t))),
            Ke(e, n, s)
          );
        }
      };
    }),
    (w.cssHooks.marginLeft = _e(h.reliableMarginLeft, function (e, t) {
      if (t)
        return (
          (parseFloat(Fe(e, 'marginLeft')) ||
            e.getBoundingClientRect().left -
              se(e, {marginLeft: 0}, function () {
                return e.getBoundingClientRect().left;
              })) + 'px'
        );
    })),
    w.each({margin: '', padding: '', border: 'Width'}, function (e, t) {
      (w.cssHooks[e + t] = {
        expand: function (n) {
          for (var r = 0, i = {}, o = 'string' == typeof n ? n.split(' ') : [n]; r < 4; r++)
            i[e + oe[r] + t] = o[r] || o[r - 2] || o[0];
          return i;
        }
      }),
        'margin' !== e && (w.cssHooks[e + t].set = Ke);
    }),
    w.fn.extend({
      css: function (e, t) {
        return z(
          this,
          function (e, t, n) {
            var r,
              i,
              o = {},
              a = 0;
            if (Array.isArray(t)) {
              for (r = $e(e), i = t.length; a < i; a++) o[t[a]] = w.css(e, t[a], !1, r);
              return o;
            }
            return void 0 !== n ? w.style(e, t, n) : w.css(e, t);
          },
          e,
          t,
          arguments.length > 1
        );
      }
    });
  function tt(e, t, n, r, i) {
    return new tt.prototype.init(e, t, n, r, i);
  }
  (w.Tween = tt),
    (tt.prototype = {
      constructor: tt,
      init: function (e, t, n, r, i, o) {
        (this.elem = e),
          (this.prop = n),
          (this.easing = i || w.easing._default),
          (this.options = t),
          (this.start = this.now = this.cur()),
          (this.end = r),
          (this.unit = o || (w.cssNumber[n] ? '' : 'px'));
      },
      cur: function () {
        var e = tt.propHooks[this.prop];
        return e && e.get ? e.get(this) : tt.propHooks._default.get(this);
      },
      run: function (e) {
        var t,
          n = tt.propHooks[this.prop];
        return (
          this.options.duration
            ? (this.pos = t =
                w.easing[this.easing](e, this.options.duration * e, 0, 1, this.options.duration))
            : (this.pos = t = e),
          (this.now = (this.end - this.start) * t + this.start),
          this.options.step && this.options.step.call(this.elem, this.now, this),
          n && n.set ? n.set(this) : tt.propHooks._default.set(this),
          this
        );
      }
    }),
    (tt.prototype.init.prototype = tt.prototype),
    (tt.propHooks = {
      _default: {
        get: function (e) {
          var t;
          return 1 !== e.elem.nodeType || (null != e.elem[e.prop] && null == e.elem.style[e.prop])
            ? e.elem[e.prop]
            : (t = w.css(e.elem, e.prop, '')) && 'auto' !== t
            ? t
            : 0;
        },
        set: function (e) {
          w.fx.step[e.prop]
            ? w.fx.step[e.prop](e)
            : 1 !== e.elem.nodeType ||
              (null == e.elem.style[w.cssProps[e.prop]] && !w.cssHooks[e.prop])
            ? (e.elem[e.prop] = e.now)
            : w.style(e.elem, e.prop, e.now + e.unit);
        }
      }
    }),
    (tt.propHooks.scrollTop = tt.propHooks.scrollLeft =
      {
        set: function (e) {
          e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now);
        }
      }),
    (w.easing = {
      linear: function (e) {
        return e;
      },
      swing: function (e) {
        return 0.5 - Math.cos(e * Math.PI) / 2;
      },
      _default: 'swing'
    }),
    (w.fx = tt.prototype.init),
    (w.fx.step = {});
  var nt,
    rt,
    it = /^(?:toggle|show|hide)$/,
    ot = /queueHooks$/;
  function at() {
    rt &&
      (!1 === r.hidden && e.requestAnimationFrame
        ? e.requestAnimationFrame(at)
        : e.setTimeout(at, w.fx.interval),
      w.fx.tick());
  }
  function st() {
    return (
      e.setTimeout(function () {
        nt = void 0;
      }),
      (nt = Date.now())
    );
  }
  function ut(e, t) {
    var n,
      r = 0,
      i = {height: e};
    for (t = t ? 1 : 0; r < 4; r += 2 - t) i['margin' + (n = oe[r])] = i['padding' + n] = e;
    return t && (i.opacity = i.width = e), i;
  }
  function lt(e, t, n) {
    for (
      var r, i = (pt.tweeners[t] || []).concat(pt.tweeners['*']), o = 0, a = i.length;
      o < a;
      o++
    )
      if ((r = i[o].call(n, t, e))) return r;
  }
  function ct(e, t, n) {
    var r,
      i,
      o,
      a,
      s,
      u,
      l,
      c,
      f = 'width' in t || 'height' in t,
      p = this,
      d = {},
      h = e.style,
      g = e.nodeType && ae(e),
      y = J.get(e, 'fxshow');
    n.queue ||
      (null == (a = w._queueHooks(e, 'fx')).unqueued &&
        ((a.unqueued = 0),
        (s = a.empty.fire),
        (a.empty.fire = function () {
          a.unqueued || s();
        })),
      a.unqueued++,
      p.always(function () {
        p.always(function () {
          a.unqueued--, w.queue(e, 'fx').length || a.empty.fire();
        });
      }));
    for (r in t)
      if (((i = t[r]), it.test(i))) {
        if ((delete t[r], (o = o || 'toggle' === i), i === (g ? 'hide' : 'show'))) {
          if ('show' !== i || !y || void 0 === y[r]) continue;
          g = !0;
        }
        d[r] = (y && y[r]) || w.style(e, r);
      }
    if ((u = !w.isEmptyObject(t)) || !w.isEmptyObject(d)) {
      f &&
        1 === e.nodeType &&
        ((n.overflow = [h.overflow, h.overflowX, h.overflowY]),
        null == (l = y && y.display) && (l = J.get(e, 'display')),
        'none' === (c = w.css(e, 'display')) &&
          (l
            ? (c = l)
            : (fe([e], !0), (l = e.style.display || l), (c = w.css(e, 'display')), fe([e]))),
        ('inline' === c || ('inline-block' === c && null != l)) &&
          'none' === w.css(e, 'float') &&
          (u ||
            (p.done(function () {
              h.display = l;
            }),
            null == l && ((c = h.display), (l = 'none' === c ? '' : c))),
          (h.display = 'inline-block'))),
        n.overflow &&
          ((h.overflow = 'hidden'),
          p.always(function () {
            (h.overflow = n.overflow[0]),
              (h.overflowX = n.overflow[1]),
              (h.overflowY = n.overflow[2]);
          })),
        (u = !1);
      for (r in d)
        u ||
          (y ? 'hidden' in y && (g = y.hidden) : (y = J.access(e, 'fxshow', {display: l})),
          o && (y.hidden = !g),
          g && fe([e], !0),
          p.done(function () {
            g || fe([e]), J.remove(e, 'fxshow');
            for (r in d) w.style(e, r, d[r]);
          })),
          (u = lt(g ? y[r] : 0, r, p)),
          r in y || ((y[r] = u.start), g && ((u.end = u.start), (u.start = 0)));
    }
  }
  function ft(e, t) {
    var n, r, i, o, a;
    for (n in e)
      if (
        ((r = G(n)),
        (i = t[r]),
        (o = e[n]),
        Array.isArray(o) && ((i = o[1]), (o = e[n] = o[0])),
        n !== r && ((e[r] = o), delete e[n]),
        (a = w.cssHooks[r]) && 'expand' in a)
      ) {
        (o = a.expand(o)), delete e[r];
        for (n in o) n in e || ((e[n] = o[n]), (t[n] = i));
      } else t[r] = i;
  }
  function pt(e, t, n) {
    var r,
      i,
      o = 0,
      a = pt.prefilters.length,
      s = w.Deferred().always(function () {
        delete u.elem;
      }),
      u = function () {
        if (i) return !1;
        for (
          var t = nt || st(),
            n = Math.max(0, l.startTime + l.duration - t),
            r = 1 - (n / l.duration || 0),
            o = 0,
            a = l.tweens.length;
          o < a;
          o++
        )
          l.tweens[o].run(r);
        return (
          s.notifyWith(e, [l, r, n]),
          r < 1 && a ? n : (a || s.notifyWith(e, [l, 1, 0]), s.resolveWith(e, [l]), !1)
        );
      },
      l = s.promise({
        elem: e,
        props: w.extend({}, t),
        opts: w.extend(!0, {specialEasing: {}, easing: w.easing._default}, n),
        originalProperties: t,
        originalOptions: n,
        startTime: nt || st(),
        duration: n.duration,
        tweens: [],
        createTween: function (t, n) {
          var r = w.Tween(e, l.opts, t, n, l.opts.specialEasing[t] || l.opts.easing);
          return l.tweens.push(r), r;
        },
        stop: function (t) {
          var n = 0,
            r = t ? l.tweens.length : 0;
          if (i) return this;
          for (i = !0; n < r; n++) l.tweens[n].run(1);
          return (
            t ? (s.notifyWith(e, [l, 1, 0]), s.resolveWith(e, [l, t])) : s.rejectWith(e, [l, t]),
            this
          );
        }
      }),
      c = l.props;
    for (ft(c, l.opts.specialEasing); o < a; o++)
      if ((r = pt.prefilters[o].call(l, e, c, l.opts)))
        return g(r.stop) && (w._queueHooks(l.elem, l.opts.queue).stop = r.stop.bind(r)), r;
    return (
      w.map(c, lt, l),
      g(l.opts.start) && l.opts.start.call(e, l),
      l
        .progress(l.opts.progress)
        .done(l.opts.done, l.opts.complete)
        .fail(l.opts.fail)
        .always(l.opts.always),
      w.fx.timer(w.extend(u, {elem: e, anim: l, queue: l.opts.queue})),
      l
    );
  }
  (w.Animation = w.extend(pt, {
    tweeners: {
      '*': [
        function (e, t) {
          var n = this.createTween(e, t);
          return ue(n.elem, e, ie.exec(t), n), n;
        }
      ]
    },
    tweener: function (e, t) {
      g(e) ? ((t = e), (e = ['*'])) : (e = e.match(M));
      for (var n, r = 0, i = e.length; r < i; r++)
        (n = e[r]), (pt.tweeners[n] = pt.tweeners[n] || []), pt.tweeners[n].unshift(t);
    },
    prefilters: [ct],
    prefilter: function (e, t) {
      t ? pt.prefilters.unshift(e) : pt.prefilters.push(e);
    }
  })),
    (w.speed = function (e, t, n) {
      var r =
        e && 'object' == typeof e
          ? w.extend({}, e)
          : {
              complete: n || (!n && t) || (g(e) && e),
              duration: e,
              easing: (n && t) || (t && !g(t) && t)
            };
      return (
        w.fx.off
          ? (r.duration = 0)
          : 'number' != typeof r.duration &&
            (r.duration in w.fx.speeds
              ? (r.duration = w.fx.speeds[r.duration])
              : (r.duration = w.fx.speeds._default)),
        (null != r.queue && !0 !== r.queue) || (r.queue = 'fx'),
        (r.old = r.complete),
        (r.complete = function () {
          g(r.old) && r.old.call(this), r.queue && w.dequeue(this, r.queue);
        }),
        r
      );
    }),
    w.fn.extend({
      fadeTo: function (e, t, n, r) {
        return this.filter(ae).css('opacity', 0).show().end().animate({opacity: t}, e, n, r);
      },
      animate: function (e, t, n, r) {
        var i = w.isEmptyObject(e),
          o = w.speed(t, n, r),
          a = function () {
            var t = pt(this, w.extend({}, e), o);
            (i || J.get(this, 'finish')) && t.stop(!0);
          };
        return (a.finish = a), i || !1 === o.queue ? this.each(a) : this.queue(o.queue, a);
      },
      stop: function (e, t, n) {
        var r = function (e) {
          var t = e.stop;
          delete e.stop, t(n);
        };
        return (
          'string' != typeof e && ((n = t), (t = e), (e = void 0)),
          t && !1 !== e && this.queue(e || 'fx', []),
          this.each(function () {
            var t = !0,
              i = null != e && e + 'queueHooks',
              o = w.timers,
              a = J.get(this);
            if (i) a[i] && a[i].stop && r(a[i]);
            else for (i in a) a[i] && a[i].stop && ot.test(i) && r(a[i]);
            for (i = o.length; i--; )
              o[i].elem !== this ||
                (null != e && o[i].queue !== e) ||
                (o[i].anim.stop(n), (t = !1), o.splice(i, 1));
            (!t && n) || w.dequeue(this, e);
          })
        );
      },
      finish: function (e) {
        return (
          !1 !== e && (e = e || 'fx'),
          this.each(function () {
            var t,
              n = J.get(this),
              r = n[e + 'queue'],
              i = n[e + 'queueHooks'],
              o = w.timers,
              a = r ? r.length : 0;
            for (
              n.finish = !0,
                w.queue(this, e, []),
                i && i.stop && i.stop.call(this, !0),
                t = o.length;
              t--;

            )
              o[t].elem === this && o[t].queue === e && (o[t].anim.stop(!0), o.splice(t, 1));
            for (t = 0; t < a; t++) r[t] && r[t].finish && r[t].finish.call(this);
            delete n.finish;
          })
        );
      }
    }),
    w.each(['toggle', 'show', 'hide'], function (e, t) {
      var n = w.fn[t];
      w.fn[t] = function (e, r, i) {
        return null == e || 'boolean' == typeof e
          ? n.apply(this, arguments)
          : this.animate(ut(t, !0), e, r, i);
      };
    }),
    w.each(
      {
        slideDown: ut('show'),
        slideUp: ut('hide'),
        slideToggle: ut('toggle'),
        fadeIn: {opacity: 'show'},
        fadeOut: {opacity: 'hide'},
        fadeToggle: {opacity: 'toggle'}
      },
      function (e, t) {
        w.fn[e] = function (e, n, r) {
          return this.animate(t, e, n, r);
        };
      }
    ),
    (w.timers = []),
    (w.fx.tick = function () {
      var e,
        t = 0,
        n = w.timers;
      for (nt = Date.now(); t < n.length; t++) (e = n[t])() || n[t] !== e || n.splice(t--, 1);
      n.length || w.fx.stop(), (nt = void 0);
    }),
    (w.fx.timer = function (e) {
      w.timers.push(e), w.fx.start();
    }),
    (w.fx.interval = 13),
    (w.fx.start = function () {
      rt || ((rt = !0), at());
    }),
    (w.fx.stop = function () {
      rt = null;
    }),
    (w.fx.speeds = {slow: 600, fast: 200, _default: 400}),
    (w.fn.delay = function (t, n) {
      return (
        (t = w.fx ? w.fx.speeds[t] || t : t),
        (n = n || 'fx'),
        this.queue(n, function (n, r) {
          var i = e.setTimeout(n, t);
          r.stop = function () {
            e.clearTimeout(i);
          };
        })
      );
    }),
    (function () {
      var e = r.createElement('input'),
        t = r.createElement('select').appendChild(r.createElement('option'));
      (e.type = 'checkbox'),
        (h.checkOn = '' !== e.value),
        (h.optSelected = t.selected),
        ((e = r.createElement('input')).value = 't'),
        (e.type = 'radio'),
        (h.radioValue = 't' === e.value);
    })();
  var dt,
    ht = w.expr.attrHandle;
  w.fn.extend({
    attr: function (e, t) {
      return z(this, w.attr, e, t, arguments.length > 1);
    },
    removeAttr: function (e) {
      return this.each(function () {
        w.removeAttr(this, e);
      });
    }
  }),
    w.extend({
      attr: function (e, t, n) {
        var r,
          i,
          o = e.nodeType;
        if (3 !== o && 8 !== o && 2 !== o)
          return 'undefined' == typeof e.getAttribute
            ? w.prop(e, t, n)
            : ((1 === o && w.isXMLDoc(e)) ||
                (i = w.attrHooks[t.toLowerCase()] || (w.expr.match.bool.test(t) ? dt : void 0)),
              void 0 !== n
                ? null === n
                  ? void w.removeAttr(e, t)
                  : i && 'set' in i && void 0 !== (r = i.set(e, n, t))
                  ? r
                  : (e.setAttribute(t, n + ''), n)
                : i && 'get' in i && null !== (r = i.get(e, t))
                ? r
                : null == (r = w.find.attr(e, t))
                ? void 0
                : r);
      },
      attrHooks: {
        type: {
          set: function (e, t) {
            if (!h.radioValue && 'radio' === t && N(e, 'input')) {
              var n = e.value;
              return e.setAttribute('type', t), n && (e.value = n), t;
            }
          }
        }
      },
      removeAttr: function (e, t) {
        var n,
          r = 0,
          i = t && t.match(M);
        if (i && 1 === e.nodeType) while ((n = i[r++])) e.removeAttribute(n);
      }
    }),
    (dt = {
      set: function (e, t, n) {
        return !1 === t ? w.removeAttr(e, n) : e.setAttribute(n, n), n;
      }
    }),
    w.each(w.expr.match.bool.source.match(/\w+/g), function (e, t) {
      var n = ht[t] || w.find.attr;
      ht[t] = function (e, t, r) {
        var i,
          o,
          a = t.toLowerCase();
        return r || ((o = ht[a]), (ht[a] = i), (i = null != n(e, t, r) ? a : null), (ht[a] = o)), i;
      };
    });
  var gt = /^(?:input|select|textarea|button)$/i,
    yt = /^(?:a|area)$/i;
  w.fn.extend({
    prop: function (e, t) {
      return z(this, w.prop, e, t, arguments.length > 1);
    },
    removeProp: function (e) {
      return this.each(function () {
        delete this[w.propFix[e] || e];
      });
    }
  }),
    w.extend({
      prop: function (e, t, n) {
        var r,
          i,
          o = e.nodeType;
        if (3 !== o && 8 !== o && 2 !== o)
          return (
            (1 === o && w.isXMLDoc(e)) || ((t = w.propFix[t] || t), (i = w.propHooks[t])),
            void 0 !== n
              ? i && 'set' in i && void 0 !== (r = i.set(e, n, t))
                ? r
                : (e[t] = n)
              : i && 'get' in i && null !== (r = i.get(e, t))
              ? r
              : e[t]
          );
      },
      propHooks: {
        tabIndex: {
          get: function (e) {
            var t = w.find.attr(e, 'tabindex');
            return t
              ? parseInt(t, 10)
              : gt.test(e.nodeName) || (yt.test(e.nodeName) && e.href)
              ? 0
              : -1;
          }
        }
      },
      propFix: {for: 'htmlFor', class: 'className'}
    }),
    h.optSelected ||
      (w.propHooks.selected = {
        get: function (e) {
          var t = e.parentNode;
          return t && t.parentNode && t.parentNode.selectedIndex, null;
        },
        set: function (e) {
          var t = e.parentNode;
          t && (t.selectedIndex, t.parentNode && t.parentNode.selectedIndex);
        }
      }),
    w.each(
      [
        'tabIndex',
        'readOnly',
        'maxLength',
        'cellSpacing',
        'cellPadding',
        'rowSpan',
        'colSpan',
        'useMap',
        'frameBorder',
        'contentEditable'
      ],
      function () {
        w.propFix[this.toLowerCase()] = this;
      }
    );
  function vt(e) {
    return (e.match(M) || []).join(' ');
  }
  function mt(e) {
    return (e.getAttribute && e.getAttribute('class')) || '';
  }
  function xt(e) {
    return Array.isArray(e) ? e : 'string' == typeof e ? e.match(M) || [] : [];
  }
  w.fn.extend({
    addClass: function (e) {
      var t,
        n,
        r,
        i,
        o,
        a,
        s,
        u = 0;
      if (g(e))
        return this.each(function (t) {
          w(this).addClass(e.call(this, t, mt(this)));
        });
      if ((t = xt(e)).length)
        while ((n = this[u++]))
          if (((i = mt(n)), (r = 1 === n.nodeType && ' ' + vt(i) + ' '))) {
            a = 0;
            while ((o = t[a++])) r.indexOf(' ' + o + ' ') < 0 && (r += o + ' ');
            i !== (s = vt(r)) && n.setAttribute('class', s);
          }
      return this;
    },
    removeClass: function (e) {
      var t,
        n,
        r,
        i,
        o,
        a,
        s,
        u = 0;
      if (g(e))
        return this.each(function (t) {
          w(this).removeClass(e.call(this, t, mt(this)));
        });
      if (!arguments.length) return this.attr('class', '');
      if ((t = xt(e)).length)
        while ((n = this[u++]))
          if (((i = mt(n)), (r = 1 === n.nodeType && ' ' + vt(i) + ' '))) {
            a = 0;
            while ((o = t[a++]))
              while (r.indexOf(' ' + o + ' ') > -1) r = r.replace(' ' + o + ' ', ' ');
            i !== (s = vt(r)) && n.setAttribute('class', s);
          }
      return this;
    },
    toggleClass: function (e, t) {
      var n = typeof e,
        r = 'string' === n || Array.isArray(e);
      return 'boolean' == typeof t && r
        ? t
          ? this.addClass(e)
          : this.removeClass(e)
        : g(e)
        ? this.each(function (n) {
            w(this).toggleClass(e.call(this, n, mt(this), t), t);
          })
        : this.each(function () {
            var t, i, o, a;
            if (r) {
              (i = 0), (o = w(this)), (a = xt(e));
              while ((t = a[i++])) o.hasClass(t) ? o.removeClass(t) : o.addClass(t);
            } else (void 0 !== e && 'boolean' !== n) || ((t = mt(this)) && J.set(this, '__className__', t), this.setAttribute && this.setAttribute('class', t || !1 === e ? '' : J.get(this, '__className__') || ''));
          });
    },
    hasClass: function (e) {
      var t,
        n,
        r = 0;
      t = ' ' + e + ' ';
      while ((n = this[r++]))
        if (1 === n.nodeType && (' ' + vt(mt(n)) + ' ').indexOf(t) > -1) return !0;
      return !1;
    }
  });
  var bt = /\r/g;
  w.fn.extend({
    val: function (e) {
      var t,
        n,
        r,
        i = this[0];
      {
        if (arguments.length)
          return (
            (r = g(e)),
            this.each(function (n) {
              var i;
              1 === this.nodeType &&
                (null == (i = r ? e.call(this, n, w(this).val()) : e)
                  ? (i = '')
                  : 'number' == typeof i
                  ? (i += '')
                  : Array.isArray(i) &&
                    (i = w.map(i, function (e) {
                      return null == e ? '' : e + '';
                    })),
                ((t = w.valHooks[this.type] || w.valHooks[this.nodeName.toLowerCase()]) &&
                  'set' in t &&
                  void 0 !== t.set(this, i, 'value')) ||
                  (this.value = i));
            })
          );
        if (i)
          return (t = w.valHooks[i.type] || w.valHooks[i.nodeName.toLowerCase()]) &&
            'get' in t &&
            void 0 !== (n = t.get(i, 'value'))
            ? n
            : 'string' == typeof (n = i.value)
            ? n.replace(bt, '')
            : null == n
            ? ''
            : n;
      }
    }
  }),
    w.extend({
      valHooks: {
        option: {
          get: function (e) {
            var t = w.find.attr(e, 'value');
            return null != t ? t : vt(w.text(e));
          }
        },
        select: {
          get: function (e) {
            var t,
              n,
              r,
              i = e.options,
              o = e.selectedIndex,
              a = 'select-one' === e.type,
              s = a ? null : [],
              u = a ? o + 1 : i.length;
            for (r = o < 0 ? u : a ? o : 0; r < u; r++)
              if (
                ((n = i[r]).selected || r === o) &&
                !n.disabled &&
                (!n.parentNode.disabled || !N(n.parentNode, 'optgroup'))
              ) {
                if (((t = w(n).val()), a)) return t;
                s.push(t);
              }
            return s;
          },
          set: function (e, t) {
            var n,
              r,
              i = e.options,
              o = w.makeArray(t),
              a = i.length;
            while (a--)
              ((r = i[a]).selected = w.inArray(w.valHooks.option.get(r), o) > -1) && (n = !0);
            return n || (e.selectedIndex = -1), o;
          }
        }
      }
    }),
    w.each(['radio', 'checkbox'], function () {
      (w.valHooks[this] = {
        set: function (e, t) {
          if (Array.isArray(t)) return (e.checked = w.inArray(w(e).val(), t) > -1);
        }
      }),
        h.checkOn ||
          (w.valHooks[this].get = function (e) {
            return null === e.getAttribute('value') ? 'on' : e.value;
          });
    }),
    (h.focusin = 'onfocusin' in e);
  var wt = /^(?:focusinfocus|focusoutblur)$/,
    Tt = function (e) {
      e.stopPropagation();
    };
  w.extend(w.event, {
    trigger: function (t, n, i, o) {
      var a,
        s,
        u,
        l,
        c,
        p,
        d,
        h,
        v = [i || r],
        m = f.call(t, 'type') ? t.type : t,
        x = f.call(t, 'namespace') ? t.namespace.split('.') : [];
      if (
        ((s = h = u = i = i || r),
        3 !== i.nodeType &&
          8 !== i.nodeType &&
          !wt.test(m + w.event.triggered) &&
          (m.indexOf('.') > -1 && ((m = (x = m.split('.')).shift()), x.sort()),
          (c = m.indexOf(':') < 0 && 'on' + m),
          (t = t[w.expando] ? t : new w.Event(m, 'object' == typeof t && t)),
          (t.isTrigger = o ? 2 : 3),
          (t.namespace = x.join('.')),
          (t.rnamespace = t.namespace
            ? new RegExp('(^|\\.)' + x.join('\\.(?:.*\\.|)') + '(\\.|$)')
            : null),
          (t.result = void 0),
          t.target || (t.target = i),
          (n = null == n ? [t] : w.makeArray(n, [t])),
          (d = w.event.special[m] || {}),
          o || !d.trigger || !1 !== d.trigger.apply(i, n)))
      ) {
        if (!o && !d.noBubble && !y(i)) {
          for (l = d.delegateType || m, wt.test(l + m) || (s = s.parentNode); s; s = s.parentNode)
            v.push(s), (u = s);
          u === (i.ownerDocument || r) && v.push(u.defaultView || u.parentWindow || e);
        }
        a = 0;
        while ((s = v[a++]) && !t.isPropagationStopped())
          (h = s),
            (t.type = a > 1 ? l : d.bindType || m),
            (p = (J.get(s, 'events') || {})[t.type] && J.get(s, 'handle')) && p.apply(s, n),
            (p = c && s[c]) &&
              p.apply &&
              Y(s) &&
              ((t.result = p.apply(s, n)), !1 === t.result && t.preventDefault());
        return (
          (t.type = m),
          o ||
            t.isDefaultPrevented() ||
            (d._default && !1 !== d._default.apply(v.pop(), n)) ||
            !Y(i) ||
            (c &&
              g(i[m]) &&
              !y(i) &&
              ((u = i[c]) && (i[c] = null),
              (w.event.triggered = m),
              t.isPropagationStopped() && h.addEventListener(m, Tt),
              i[m](),
              t.isPropagationStopped() && h.removeEventListener(m, Tt),
              (w.event.triggered = void 0),
              u && (i[c] = u))),
          t.result
        );
      }
    },
    simulate: function (e, t, n) {
      var r = w.extend(new w.Event(), n, {type: e, isSimulated: !0});
      w.event.trigger(r, null, t);
    }
  }),
    w.fn.extend({
      trigger: function (e, t) {
        return this.each(function () {
          w.event.trigger(e, t, this);
        });
      },
      triggerHandler: function (e, t) {
        var n = this[0];
        if (n) return w.event.trigger(e, t, n, !0);
      }
    }),
    h.focusin ||
      w.each({focus: 'focusin', blur: 'focusout'}, function (e, t) {
        var n = function (e) {
          w.event.simulate(t, e.target, w.event.fix(e));
        };
        w.event.special[t] = {
          setup: function () {
            var r = this.ownerDocument || this,
              i = J.access(r, t);
            i || r.addEventListener(e, n, !0), J.access(r, t, (i || 0) + 1);
          },
          teardown: function () {
            var r = this.ownerDocument || this,
              i = J.access(r, t) - 1;
            i ? J.access(r, t, i) : (r.removeEventListener(e, n, !0), J.remove(r, t));
          }
        };
      });
  var Ct = e.location,
    Et = Date.now(),
    kt = /\?/;
  w.parseXML = function (t) {
    var n;
    if (!t || 'string' != typeof t) return null;
    try {
      n = new e.DOMParser().parseFromString(t, 'text/xml');
    } catch (e) {
      n = void 0;
    }
    return (n && !n.getElementsByTagName('parsererror').length) || w.error('Invalid XML: ' + t), n;
  };
  var St = /\[\]$/,
    Dt = /\r?\n/g,
    Nt = /^(?:submit|button|image|reset|file)$/i,
    At = /^(?:input|select|textarea|keygen)/i;
  function jt(e, t, n, r) {
    var i;
    if (Array.isArray(t))
      w.each(t, function (t, i) {
        n || St.test(e)
          ? r(e, i)
          : jt(e + '[' + ('object' == typeof i && null != i ? t : '') + ']', i, n, r);
      });
    else if (n || 'object' !== x(t)) r(e, t);
    else for (i in t) jt(e + '[' + i + ']', t[i], n, r);
  }
  (w.param = function (e, t) {
    var n,
      r = [],
      i = function (e, t) {
        var n = g(t) ? t() : t;
        r[r.length] = encodeURIComponent(e) + '=' + encodeURIComponent(null == n ? '' : n);
      };
    if (Array.isArray(e) || (e.jquery && !w.isPlainObject(e)))
      w.each(e, function () {
        i(this.name, this.value);
      });
    else for (n in e) jt(n, e[n], t, i);
    return r.join('&');
  }),
    w.fn.extend({
      serialize: function () {
        return w.param(this.serializeArray());
      },
      serializeArray: function () {
        return this.map(function () {
          var e = w.prop(this, 'elements');
          return e ? w.makeArray(e) : this;
        })
          .filter(function () {
            var e = this.type;
            return (
              this.name &&
              !w(this).is(':disabled') &&
              At.test(this.nodeName) &&
              !Nt.test(e) &&
              (this.checked || !pe.test(e))
            );
          })
          .map(function (e, t) {
            var n = w(this).val();
            return null == n
              ? null
              : Array.isArray(n)
              ? w.map(n, function (e) {
                  return {name: t.name, value: e.replace(Dt, '\r\n')};
                })
              : {name: t.name, value: n.replace(Dt, '\r\n')};
          })
          .get();
      }
    });
  var qt = /%20/g,
    Lt = /#.*$/,
    Ht = /([?&])_=[^&]*/,
    Ot = /^(.*?):[ \t]*([^\r\n]*)$/gm,
    Pt = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
    Mt = /^(?:GET|HEAD)$/,
    Rt = /^\/\//,
    It = {},
    Wt = {},
    $t = '*/'.concat('*'),
    Bt = r.createElement('a');
  Bt.href = Ct.href;
  function Ft(e) {
    return function (t, n) {
      'string' != typeof t && ((n = t), (t = '*'));
      var r,
        i = 0,
        o = t.toLowerCase().match(M) || [];
      if (g(n))
        while ((r = o[i++]))
          '+' === r[0]
            ? ((r = r.slice(1) || '*'), (e[r] = e[r] || []).unshift(n))
            : (e[r] = e[r] || []).push(n);
    };
  }
  function _t(e, t, n, r) {
    var i = {},
      o = e === Wt;
    function a(s) {
      var u;
      return (
        (i[s] = !0),
        w.each(e[s] || [], function (e, s) {
          var l = s(t, n, r);
          return 'string' != typeof l || o || i[l]
            ? o
              ? !(u = l)
              : void 0
            : (t.dataTypes.unshift(l), a(l), !1);
        }),
        u
      );
    }
    return a(t.dataTypes[0]) || (!i['*'] && a('*'));
  }
  function zt(e, t) {
    var n,
      r,
      i = w.ajaxSettings.flatOptions || {};
    for (n in t) void 0 !== t[n] && ((i[n] ? e : r || (r = {}))[n] = t[n]);
    return r && w.extend(!0, e, r), e;
  }
  function Xt(e, t, n) {
    var r,
      i,
      o,
      a,
      s = e.contents,
      u = e.dataTypes;
    while ('*' === u[0])
      u.shift(), void 0 === r && (r = e.mimeType || t.getResponseHeader('Content-Type'));
    if (r)
      for (i in s)
        if (s[i] && s[i].test(r)) {
          u.unshift(i);
          break;
        }
    if (u[0] in n) o = u[0];
    else {
      for (i in n) {
        if (!u[0] || e.converters[i + ' ' + u[0]]) {
          o = i;
          break;
        }
        a || (a = i);
      }
      o = o || a;
    }
    if (o) return o !== u[0] && u.unshift(o), n[o];
  }
  function Ut(e, t, n, r) {
    var i,
      o,
      a,
      s,
      u,
      l = {},
      c = e.dataTypes.slice();
    if (c[1]) for (a in e.converters) l[a.toLowerCase()] = e.converters[a];
    o = c.shift();
    while (o)
      if (
        (e.responseFields[o] && (n[e.responseFields[o]] = t),
        !u && r && e.dataFilter && (t = e.dataFilter(t, e.dataType)),
        (u = o),
        (o = c.shift()))
      )
        if ('*' === o) o = u;
        else if ('*' !== u && u !== o) {
          if (!(a = l[u + ' ' + o] || l['* ' + o]))
            for (i in l)
              if ((s = i.split(' '))[1] === o && (a = l[u + ' ' + s[0]] || l['* ' + s[0]])) {
                !0 === a ? (a = l[i]) : !0 !== l[i] && ((o = s[0]), c.unshift(s[1]));
                break;
              }
          if (!0 !== a)
            if (a && e['throws']) t = a(t);
            else
              try {
                t = a(t);
              } catch (e) {
                return {
                  state: 'parsererror',
                  error: a ? e : 'No conversion from ' + u + ' to ' + o
                };
              }
        }
    return {state: 'success', data: t};
  }
  w.extend({
    active: 0,
    lastModified: {},
    etag: {},
    ajaxSettings: {
      url: Ct.href,
      type: 'GET',
      isLocal: Pt.test(Ct.protocol),
      global: !0,
      processData: !0,
      async: !0,
      contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
      accepts: {
        '*': $t,
        text: 'text/plain',
        html: 'text/html',
        xml: 'application/xml, text/xml',
        json: 'application/json, text/javascript'
      },
      contents: {xml: /\bxml\b/, html: /\bhtml/, json: /\bjson\b/},
      responseFields: {xml: 'responseXML', text: 'responseText', json: 'responseJSON'},
      converters: {
        '* text': String,
        'text html': !0,
        'text json': JSON.parse,
        'text xml': w.parseXML
      },
      flatOptions: {url: !0, context: !0}
    },
    ajaxSetup: function (e, t) {
      return t ? zt(zt(e, w.ajaxSettings), t) : zt(w.ajaxSettings, e);
    },
    ajaxPrefilter: Ft(It),
    ajaxTransport: Ft(Wt),
    ajax: function (t, n) {
      'object' == typeof t && ((n = t), (t = void 0)), (n = n || {});
      var i,
        o,
        a,
        s,
        u,
        l,
        c,
        f,
        p,
        d,
        h = w.ajaxSetup({}, n),
        g = h.context || h,
        y = h.context && (g.nodeType || g.jquery) ? w(g) : w.event,
        v = w.Deferred(),
        m = w.Callbacks('once memory'),
        x = h.statusCode || {},
        b = {},
        T = {},
        C = 'canceled',
        E = {
          readyState: 0,
          getResponseHeader: function (e) {
            var t;
            if (c) {
              if (!s) {
                s = {};
                while ((t = Ot.exec(a))) s[t[1].toLowerCase()] = t[2];
              }
              t = s[e.toLowerCase()];
            }
            return null == t ? null : t;
          },
          getAllResponseHeaders: function () {
            return c ? a : null;
          },
          setRequestHeader: function (e, t) {
            return (
              null == c && ((e = T[e.toLowerCase()] = T[e.toLowerCase()] || e), (b[e] = t)), this
            );
          },
          overrideMimeType: function (e) {
            return null == c && (h.mimeType = e), this;
          },
          statusCode: function (e) {
            var t;
            if (e)
              if (c) E.always(e[E.status]);
              else for (t in e) x[t] = [x[t], e[t]];
            return this;
          },
          abort: function (e) {
            var t = e || C;
            return i && i.abort(t), k(0, t), this;
          }
        };
      if (
        (v.promise(E),
        (h.url = ((t || h.url || Ct.href) + '').replace(Rt, Ct.protocol + '//')),
        (h.type = n.method || n.type || h.method || h.type),
        (h.dataTypes = (h.dataType || '*').toLowerCase().match(M) || ['']),
        null == h.crossDomain)
      ) {
        l = r.createElement('a');
        try {
          (l.href = h.url),
            (l.href = l.href),
            (h.crossDomain = Bt.protocol + '//' + Bt.host != l.protocol + '//' + l.host);
        } catch (e) {
          h.crossDomain = !0;
        }
      }
      if (
        (h.data &&
          h.processData &&
          'string' != typeof h.data &&
          (h.data = w.param(h.data, h.traditional)),
        _t(It, h, n, E),
        c)
      )
        return E;
      (f = w.event && h.global) && 0 == w.active++ && w.event.trigger('ajaxStart'),
        (h.type = h.type.toUpperCase()),
        (h.hasContent = !Mt.test(h.type)),
        (o = h.url.replace(Lt, '')),
        h.hasContent
          ? h.data &&
            h.processData &&
            0 === (h.contentType || '').indexOf('application/x-www-form-urlencoded') &&
            (h.data = h.data.replace(qt, '+'))
          : ((d = h.url.slice(o.length)),
            h.data &&
              (h.processData || 'string' == typeof h.data) &&
              ((o += (kt.test(o) ? '&' : '?') + h.data), delete h.data),
            !1 === h.cache &&
              ((o = o.replace(Ht, '$1')), (d = (kt.test(o) ? '&' : '?') + '_=' + Et++ + d)),
            (h.url = o + d)),
        h.ifModified &&
          (w.lastModified[o] && E.setRequestHeader('If-Modified-Since', w.lastModified[o]),
          w.etag[o] && E.setRequestHeader('If-None-Match', w.etag[o])),
        ((h.data && h.hasContent && !1 !== h.contentType) || n.contentType) &&
          E.setRequestHeader('Content-Type', h.contentType),
        E.setRequestHeader(
          'Accept',
          h.dataTypes[0] && h.accepts[h.dataTypes[0]]
            ? h.accepts[h.dataTypes[0]] + ('*' !== h.dataTypes[0] ? ', ' + $t + '; q=0.01' : '')
            : h.accepts['*']
        );
      for (p in h.headers) E.setRequestHeader(p, h.headers[p]);
      if (h.beforeSend && (!1 === h.beforeSend.call(g, E, h) || c)) return E.abort();
      if (
        ((C = 'abort'),
        m.add(h.complete),
        E.done(h.success),
        E.fail(h.error),
        (i = _t(Wt, h, n, E)))
      ) {
        if (((E.readyState = 1), f && y.trigger('ajaxSend', [E, h]), c)) return E;
        h.async &&
          h.timeout > 0 &&
          (u = e.setTimeout(function () {
            E.abort('timeout');
          }, h.timeout));
        try {
          (c = !1), i.send(b, k);
        } catch (e) {
          if (c) throw e;
          k(-1, e);
        }
      } else k(-1, 'No Transport');
      function k(t, n, r, s) {
        var l,
          p,
          d,
          b,
          T,
          C = n;
        c ||
          ((c = !0),
          u && e.clearTimeout(u),
          (i = void 0),
          (a = s || ''),
          (E.readyState = t > 0 ? 4 : 0),
          (l = (t >= 200 && t < 300) || 304 === t),
          r && (b = Xt(h, E, r)),
          (b = Ut(h, b, E, l)),
          l
            ? (h.ifModified &&
                ((T = E.getResponseHeader('Last-Modified')) && (w.lastModified[o] = T),
                (T = E.getResponseHeader('etag')) && (w.etag[o] = T)),
              204 === t || 'HEAD' === h.type
                ? (C = 'nocontent')
                : 304 === t
                ? (C = 'notmodified')
                : ((C = b.state), (p = b.data), (l = !(d = b.error))))
            : ((d = C), (!t && C) || ((C = 'error'), t < 0 && (t = 0))),
          (E.status = t),
          (E.statusText = (n || C) + ''),
          l ? v.resolveWith(g, [p, C, E]) : v.rejectWith(g, [E, C, d]),
          E.statusCode(x),
          (x = void 0),
          f && y.trigger(l ? 'ajaxSuccess' : 'ajaxError', [E, h, l ? p : d]),
          m.fireWith(g, [E, C]),
          f && (y.trigger('ajaxComplete', [E, h]), --w.active || w.event.trigger('ajaxStop')));
      }
      return E;
    },
    getJSON: function (e, t, n) {
      return w.get(e, t, n, 'json');
    },
    getScript: function (e, t) {
      return w.get(e, void 0, t, 'script');
    }
  }),
    w.each(['get', 'post'], function (e, t) {
      w[t] = function (e, n, r, i) {
        return (
          g(n) && ((i = i || r), (r = n), (n = void 0)),
          w.ajax(
            w.extend({url: e, type: t, dataType: i, data: n, success: r}, w.isPlainObject(e) && e)
          )
        );
      };
    }),
    (w._evalUrl = function (e) {
      return w.ajax({
        url: e,
        type: 'GET',
        dataType: 'script',
        cache: !0,
        async: !1,
        global: !1,
        throws: !0
      });
    }),
    w.fn.extend({
      wrapAll: function (e) {
        var t;
        return (
          this[0] &&
            (g(e) && (e = e.call(this[0])),
            (t = w(e, this[0].ownerDocument).eq(0).clone(!0)),
            this[0].parentNode && t.insertBefore(this[0]),
            t
              .map(function () {
                var e = this;
                while (e.firstElementChild) e = e.firstElementChild;
                return e;
              })
              .append(this)),
          this
        );
      },
      wrapInner: function (e) {
        return g(e)
          ? this.each(function (t) {
              w(this).wrapInner(e.call(this, t));
            })
          : this.each(function () {
              var t = w(this),
                n = t.contents();
              n.length ? n.wrapAll(e) : t.append(e);
            });
      },
      wrap: function (e) {
        var t = g(e);
        return this.each(function (n) {
          w(this).wrapAll(t ? e.call(this, n) : e);
        });
      },
      unwrap: function (e) {
        return (
          this.parent(e)
            .not('body')
            .each(function () {
              w(this).replaceWith(this.childNodes);
            }),
          this
        );
      }
    }),
    (w.expr.pseudos.hidden = function (e) {
      return !w.expr.pseudos.visible(e);
    }),
    (w.expr.pseudos.visible = function (e) {
      return !!(e.offsetWidth || e.offsetHeight || e.getClientRects().length);
    }),
    (w.ajaxSettings.xhr = function () {
      try {
        return new e.XMLHttpRequest();
      } catch (e) {}
    });
  var Vt = {0: 200, 1223: 204},
    Gt = w.ajaxSettings.xhr();
  (h.cors = !!Gt && 'withCredentials' in Gt),
    (h.ajax = Gt = !!Gt),
    w.ajaxTransport(function (t) {
      var n, r;
      if (h.cors || (Gt && !t.crossDomain))
        return {
          send: function (i, o) {
            var a,
              s = t.xhr();
            if ((s.open(t.type, t.url, t.async, t.username, t.password), t.xhrFields))
              for (a in t.xhrFields) s[a] = t.xhrFields[a];
            t.mimeType && s.overrideMimeType && s.overrideMimeType(t.mimeType),
              t.crossDomain || i['X-Requested-With'] || (i['X-Requested-With'] = 'XMLHttpRequest');
            for (a in i) s.setRequestHeader(a, i[a]);
            (n = function (e) {
              return function () {
                n &&
                  ((n =
                    r =
                    s.onload =
                    s.onerror =
                    s.onabort =
                    s.ontimeout =
                    s.onreadystatechange =
                      null),
                  'abort' === e
                    ? s.abort()
                    : 'error' === e
                    ? 'number' != typeof s.status
                      ? o(0, 'error')
                      : o(s.status, s.statusText)
                    : o(
                        Vt[s.status] || s.status,
                        s.statusText,
                        'text' !== (s.responseType || 'text') || 'string' != typeof s.responseText
                          ? {binary: s.response}
                          : {text: s.responseText},
                        s.getAllResponseHeaders()
                      ));
              };
            }),
              (s.onload = n()),
              (r = s.onerror = s.ontimeout = n('error')),
              void 0 !== s.onabort
                ? (s.onabort = r)
                : (s.onreadystatechange = function () {
                    4 === s.readyState &&
                      e.setTimeout(function () {
                        n && r();
                      });
                  }),
              (n = n('abort'));
            try {
              s.send((t.hasContent && t.data) || null);
            } catch (e) {
              if (n) throw e;
            }
          },
          abort: function () {
            n && n();
          }
        };
    }),
    w.ajaxPrefilter(function (e) {
      e.crossDomain && (e.contents.script = !1);
    }),
    w.ajaxSetup({
      accepts: {
        script:
          'text/javascript, application/javascript, application/ecmascript, application/x-ecmascript'
      },
      contents: {script: /\b(?:java|ecma)script\b/},
      converters: {
        'text script': function (e) {
          return w.globalEval(e), e;
        }
      }
    }),
    w.ajaxPrefilter('script', function (e) {
      void 0 === e.cache && (e.cache = !1), e.crossDomain && (e.type = 'GET');
    }),
    w.ajaxTransport('script', function (e) {
      if (e.crossDomain) {
        var t, n;
        return {
          send: function (i, o) {
            (t = w('<script>')
              .prop({charset: e.scriptCharset, src: e.url})
              .on(
                'load error',
                (n = function (e) {
                  t.remove(), (n = null), e && o('error' === e.type ? 404 : 200, e.type);
                })
              )),
              r.head.appendChild(t[0]);
          },
          abort: function () {
            n && n();
          }
        };
      }
    });
  var Yt = [],
    Qt = /(=)\?(?=&|$)|\?\?/;
  w.ajaxSetup({
    jsonp: 'callback',
    jsonpCallback: function () {
      var e = Yt.pop() || w.expando + '_' + Et++;
      return (this[e] = !0), e;
    }
  }),
    w.ajaxPrefilter('json jsonp', function (t, n, r) {
      var i,
        o,
        a,
        s =
          !1 !== t.jsonp &&
          (Qt.test(t.url)
            ? 'url'
            : 'string' == typeof t.data &&
              0 === (t.contentType || '').indexOf('application/x-www-form-urlencoded') &&
              Qt.test(t.data) &&
              'data');
      if (s || 'jsonp' === t.dataTypes[0])
        return (
          (i = t.jsonpCallback = g(t.jsonpCallback) ? t.jsonpCallback() : t.jsonpCallback),
          s
            ? (t[s] = t[s].replace(Qt, '$1' + i))
            : !1 !== t.jsonp && (t.url += (kt.test(t.url) ? '&' : '?') + t.jsonp + '=' + i),
          (t.converters['script json'] = function () {
            return a || w.error(i + ' was not called'), a[0];
          }),
          (t.dataTypes[0] = 'json'),
          (o = e[i]),
          (e[i] = function () {
            a = arguments;
          }),
          r.always(function () {
            void 0 === o ? w(e).removeProp(i) : (e[i] = o),
              t[i] && ((t.jsonpCallback = n.jsonpCallback), Yt.push(i)),
              a && g(o) && o(a[0]),
              (a = o = void 0);
          }),
          'script'
        );
    }),
    (h.createHTMLDocument = (function () {
      var e = r.implementation.createHTMLDocument('').body;
      return (e.innerHTML = '<form></form><form></form>'), 2 === e.childNodes.length;
    })()),
    (w.parseHTML = function (e, t, n) {
      if ('string' != typeof e) return [];
      'boolean' == typeof t && ((n = t), (t = !1));
      var i, o, a;
      return (
        t ||
          (h.createHTMLDocument
            ? (((i = (t = r.implementation.createHTMLDocument('')).createElement('base')).href =
                r.location.href),
              t.head.appendChild(i))
            : (t = r)),
        (o = A.exec(e)),
        (a = !n && []),
        o
          ? [t.createElement(o[1])]
          : ((o = xe([e], t, a)), a && a.length && w(a).remove(), w.merge([], o.childNodes))
      );
    }),
    (w.fn.load = function (e, t, n) {
      var r,
        i,
        o,
        a = this,
        s = e.indexOf(' ');
      return (
        s > -1 && ((r = vt(e.slice(s))), (e = e.slice(0, s))),
        g(t) ? ((n = t), (t = void 0)) : t && 'object' == typeof t && (i = 'POST'),
        a.length > 0 &&
          w
            .ajax({url: e, type: i || 'GET', dataType: 'html', data: t})
            .done(function (e) {
              (o = arguments), a.html(r ? w('<div>').append(w.parseHTML(e)).find(r) : e);
            })
            .always(
              n &&
                function (e, t) {
                  a.each(function () {
                    n.apply(this, o || [e.responseText, t, e]);
                  });
                }
            ),
        this
      );
    }),
    w.each(
      ['ajaxStart', 'ajaxStop', 'ajaxComplete', 'ajaxError', 'ajaxSuccess', 'ajaxSend'],
      function (e, t) {
        w.fn[t] = function (e) {
          return this.on(t, e);
        };
      }
    ),
    (w.expr.pseudos.animated = function (e) {
      return w.grep(w.timers, function (t) {
        return e === t.elem;
      }).length;
    }),
    (w.offset = {
      setOffset: function (e, t, n) {
        var r,
          i,
          o,
          a,
          s,
          u,
          l,
          c = w.css(e, 'position'),
          f = w(e),
          p = {};
        'static' === c && (e.style.position = 'relative'),
          (s = f.offset()),
          (o = w.css(e, 'top')),
          (u = w.css(e, 'left')),
          (l = ('absolute' === c || 'fixed' === c) && (o + u).indexOf('auto') > -1)
            ? ((a = (r = f.position()).top), (i = r.left))
            : ((a = parseFloat(o) || 0), (i = parseFloat(u) || 0)),
          g(t) && (t = t.call(e, n, w.extend({}, s))),
          null != t.top && (p.top = t.top - s.top + a),
          null != t.left && (p.left = t.left - s.left + i),
          'using' in t ? t.using.call(e, p) : f.css(p);
      }
    }),
    w.fn.extend({
      offset: function (e) {
        if (arguments.length)
          return void 0 === e
            ? this
            : this.each(function (t) {
                w.offset.setOffset(this, e, t);
              });
        var t,
          n,
          r = this[0];
        if (r)
          return r.getClientRects().length
            ? ((t = r.getBoundingClientRect()),
              (n = r.ownerDocument.defaultView),
              {top: t.top + n.pageYOffset, left: t.left + n.pageXOffset})
            : {top: 0, left: 0};
      },
      position: function () {
        if (this[0]) {
          var e,
            t,
            n,
            r = this[0],
            i = {top: 0, left: 0};
          if ('fixed' === w.css(r, 'position')) t = r.getBoundingClientRect();
          else {
            (t = this.offset()), (n = r.ownerDocument), (e = r.offsetParent || n.documentElement);
            while (
              e &&
              (e === n.body || e === n.documentElement) &&
              'static' === w.css(e, 'position')
            )
              e = e.parentNode;
            e &&
              e !== r &&
              1 === e.nodeType &&
              (((i = w(e).offset()).top += w.css(e, 'borderTopWidth', !0)),
              (i.left += w.css(e, 'borderLeftWidth', !0)));
          }
          return {
            top: t.top - i.top - w.css(r, 'marginTop', !0),
            left: t.left - i.left - w.css(r, 'marginLeft', !0)
          };
        }
      },
      offsetParent: function () {
        return this.map(function () {
          var e = this.offsetParent;
          while (e && 'static' === w.css(e, 'position')) e = e.offsetParent;
          return e || be;
        });
      }
    }),
    w.each({scrollLeft: 'pageXOffset', scrollTop: 'pageYOffset'}, function (e, t) {
      var n = 'pageYOffset' === t;
      w.fn[e] = function (r) {
        return z(
          this,
          function (e, r, i) {
            var o;
            if ((y(e) ? (o = e) : 9 === e.nodeType && (o = e.defaultView), void 0 === i))
              return o ? o[t] : e[r];
            o ? o.scrollTo(n ? o.pageXOffset : i, n ? i : o.pageYOffset) : (e[r] = i);
          },
          e,
          r,
          arguments.length
        );
      };
    }),
    w.each(['top', 'left'], function (e, t) {
      w.cssHooks[t] = _e(h.pixelPosition, function (e, n) {
        if (n) return (n = Fe(e, t)), We.test(n) ? w(e).position()[t] + 'px' : n;
      });
    }),
    w.each({Height: 'height', Width: 'width'}, function (e, t) {
      w.each({padding: 'inner' + e, content: t, '': 'outer' + e}, function (n, r) {
        w.fn[r] = function (i, o) {
          var a = arguments.length && (n || 'boolean' != typeof i),
            s = n || (!0 === i || !0 === o ? 'margin' : 'border');
          return z(
            this,
            function (t, n, i) {
              var o;
              return y(t)
                ? 0 === r.indexOf('outer')
                  ? t['inner' + e]
                  : t.document.documentElement['client' + e]
                : 9 === t.nodeType
                ? ((o = t.documentElement),
                  Math.max(
                    t.body['scroll' + e],
                    o['scroll' + e],
                    t.body['offset' + e],
                    o['offset' + e],
                    o['client' + e]
                  ))
                : void 0 === i
                ? w.css(t, n, s)
                : w.style(t, n, i, s);
            },
            t,
            a ? i : void 0,
            a
          );
        };
      });
    }),
    w.each(
      'blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu'.split(
        ' '
      ),
      function (e, t) {
        w.fn[t] = function (e, n) {
          return arguments.length > 0 ? this.on(t, null, e, n) : this.trigger(t);
        };
      }
    ),
    w.fn.extend({
      hover: function (e, t) {
        return this.mouseenter(e).mouseleave(t || e);
      }
    }),
    w.fn.extend({
      bind: function (e, t, n) {
        return this.on(e, null, t, n);
      },
      unbind: function (e, t) {
        return this.off(e, null, t);
      },
      delegate: function (e, t, n, r) {
        return this.on(t, e, n, r);
      },
      undelegate: function (e, t, n) {
        return 1 === arguments.length ? this.off(e, '**') : this.off(t, e || '**', n);
      }
    }),
    (w.proxy = function (e, t) {
      var n, r, i;
      if (('string' == typeof t && ((n = e[t]), (t = e), (e = n)), g(e)))
        return (
          (r = o.call(arguments, 2)),
          (i = function () {
            return e.apply(t || this, r.concat(o.call(arguments)));
          }),
          (i.guid = e.guid = e.guid || w.guid++),
          i
        );
    }),
    (w.holdReady = function (e) {
      e ? w.readyWait++ : w.ready(!0);
    }),
    (w.isArray = Array.isArray),
    (w.parseJSON = JSON.parse),
    (w.nodeName = N),
    (w.isFunction = g),
    (w.isWindow = y),
    (w.camelCase = G),
    (w.type = x),
    (w.now = Date.now),
    (w.isNumeric = function (e) {
      var t = w.type(e);
      return ('number' === t || 'string' === t) && !isNaN(e - parseFloat(e));
    }),
    'function' == typeof define &&
      define.amd &&
      define('jquery', [], function () {
        return w;
      });
  var Jt = e.jQuery,
    Kt = e.$;
  return (
    (w.noConflict = function (t) {
      return e.$ === w && (e.$ = Kt), t && e.jQuery === w && (e.jQuery = Jt), w;
    }),
    t || (e.jQuery = e.$ = w),
    w
  );
});

/*!
 * Bootstrap v4.1.3 (https://getbootstrap.com/)
 * Copyright 2011-2018 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 */
!(function (e, t) {
  'object' == typeof exports && 'undefined' != typeof module
    ? t(exports, require('jquery'))
    : 'function' == typeof define && define.amd
    ? define(['exports', 'jquery'], t)
    : t((e.bootstrap = {}), e.jQuery);
})(this, function (e, t) {
  'use strict';
  function i(e, t) {
    for (var n = 0; n < t.length; n++) {
      var i = t[n];
      (i.enumerable = i.enumerable || !1),
        (i.configurable = !0),
        'value' in i && (i.writable = !0),
        Object.defineProperty(e, i.key, i);
    }
  }
  function s(e, t, n) {
    return t && i(e.prototype, t), n && i(e, n), e;
  }
  function l(r) {
    for (var e = 1; e < arguments.length; e++) {
      var o = null != arguments[e] ? arguments[e] : {},
        t = Object.keys(o);
      'function' == typeof Object.getOwnPropertySymbols &&
        (t = t.concat(
          Object.getOwnPropertySymbols(o).filter(function (e) {
            return Object.getOwnPropertyDescriptor(o, e).enumerable;
          })
        )),
        t.forEach(function (e) {
          var t, n, i;
          (t = r),
            (i = o[(n = e)]),
            n in t
              ? Object.defineProperty(t, n, {
                  value: i,
                  enumerable: !0,
                  configurable: !0,
                  writable: !0
                })
              : (t[n] = i);
        });
    }
    return r;
  }
  for (
    var r,
      n,
      o,
      a,
      c,
      u,
      f,
      h,
      d,
      p,
      m,
      g,
      _,
      v,
      y,
      E,
      b,
      w,
      C,
      T,
      S,
      D,
      A,
      I,
      O,
      N,
      k,
      x,
      P,
      L,
      j,
      H,
      M,
      F,
      W,
      R,
      U,
      B,
      q,
      K,
      Q,
      Y,
      V,
      z,
      G,
      J,
      Z,
      X,
      $,
      ee,
      te,
      ne,
      ie,
      re,
      oe,
      se,
      ae,
      le,
      ce,
      ue,
      fe,
      he,
      de,
      pe,
      me,
      ge,
      _e,
      ve,
      ye,
      Ee,
      be,
      we = (function (i) {
        var t = 'transitionend';
        function e(e) {
          var t = this,
            n = !1;
          return (
            i(this).one(l.TRANSITION_END, function () {
              n = !0;
            }),
            setTimeout(function () {
              n || l.triggerTransitionEnd(t);
            }, e),
            this
          );
        }
        var l = {
          TRANSITION_END: 'bsTransitionEnd',
          getUID: function (e) {
            for (; (e += ~~(1e6 * Math.random())), document.getElementById(e); );
            return e;
          },
          getSelectorFromElement: function (e) {
            var t = e.getAttribute('data-target');
            (t && '#' !== t) || (t = e.getAttribute('href') || '');
            try {
              return document.querySelector(t) ? t : null;
            } catch (e) {
              return null;
            }
          },
          getTransitionDurationFromElement: function (e) {
            if (!e) return 0;
            var t = i(e).css('transition-duration');
            return parseFloat(t) ? ((t = t.split(',')[0]), 1e3 * parseFloat(t)) : 0;
          },
          reflow: function (e) {
            return e.offsetHeight;
          },
          triggerTransitionEnd: function (e) {
            i(e).trigger(t);
          },
          supportsTransitionEnd: function () {
            return Boolean(t);
          },
          isElement: function (e) {
            return (e[0] || e).nodeType;
          },
          typeCheckConfig: function (e, t, n) {
            for (var i in n)
              if (Object.prototype.hasOwnProperty.call(n, i)) {
                var r = n[i],
                  o = t[i],
                  s =
                    o && l.isElement(o)
                      ? 'element'
                      : ((a = o),
                        {}.toString
                          .call(a)
                          .match(/\s([a-z]+)/i)[1]
                          .toLowerCase());
                if (!new RegExp(r).test(s))
                  throw new Error(
                    e.toUpperCase() +
                      ': Option "' +
                      i +
                      '" provided type "' +
                      s +
                      '" but expected type "' +
                      r +
                      '".'
                  );
              }
            var a;
          }
        };
        return (
          (i.fn.emulateTransitionEnd = e),
          (i.event.special[l.TRANSITION_END] = {
            bindType: t,
            delegateType: t,
            handle: function (e) {
              if (i(e.target).is(this)) return e.handleObj.handler.apply(this, arguments);
            }
          }),
          l
        );
      })((t = t && t.hasOwnProperty('default') ? t.default : t)),
      Ce =
        ((n = 'alert'),
        (a = '.' + (o = 'bs.alert')),
        (c = (r = t).fn[n]),
        (u = {CLOSE: 'close' + a, CLOSED: 'closed' + a, CLICK_DATA_API: 'click' + a + '.data-api'}),
        (f = 'alert'),
        (h = 'fade'),
        (d = 'show'),
        (p = (function () {
          function i(e) {
            this._element = e;
          }
          var e = i.prototype;
          return (
            (e.close = function (e) {
              var t = this._element;
              e && (t = this._getRootElement(e)),
                this._triggerCloseEvent(t).isDefaultPrevented() || this._removeElement(t);
            }),
            (e.dispose = function () {
              r.removeData(this._element, o), (this._element = null);
            }),
            (e._getRootElement = function (e) {
              var t = we.getSelectorFromElement(e),
                n = !1;
              return t && (n = document.querySelector(t)), n || (n = r(e).closest('.' + f)[0]), n;
            }),
            (e._triggerCloseEvent = function (e) {
              var t = r.Event(u.CLOSE);
              return r(e).trigger(t), t;
            }),
            (e._removeElement = function (t) {
              var n = this;
              if ((r(t).removeClass(d), r(t).hasClass(h))) {
                var e = we.getTransitionDurationFromElement(t);
                r(t)
                  .one(we.TRANSITION_END, function (e) {
                    return n._destroyElement(t, e);
                  })
                  .emulateTransitionEnd(e);
              } else this._destroyElement(t);
            }),
            (e._destroyElement = function (e) {
              r(e).detach().trigger(u.CLOSED).remove();
            }),
            (i._jQueryInterface = function (n) {
              return this.each(function () {
                var e = r(this),
                  t = e.data(o);
                t || ((t = new i(this)), e.data(o, t)), 'close' === n && t[n](this);
              });
            }),
            (i._handleDismiss = function (t) {
              return function (e) {
                e && e.preventDefault(), t.close(this);
              };
            }),
            s(i, null, [
              {
                key: 'VERSION',
                get: function () {
                  return '4.1.3';
                }
              }
            ]),
            i
          );
        })()),
        r(document).on(u.CLICK_DATA_API, '[data-dismiss="alert"]', p._handleDismiss(new p())),
        (r.fn[n] = p._jQueryInterface),
        (r.fn[n].Constructor = p),
        (r.fn[n].noConflict = function () {
          return (r.fn[n] = c), p._jQueryInterface;
        }),
        p),
      Te =
        ((g = 'button'),
        (v = '.' + (_ = 'bs.button')),
        (y = '.data-api'),
        (E = (m = t).fn[g]),
        (b = 'active'),
        (w = 'btn'),
        (T = '[data-toggle^="button"]'),
        (S = '[data-toggle="buttons"]'),
        (D = 'input'),
        (A = '.active'),
        (I = '.btn'),
        (O = {
          CLICK_DATA_API: 'click' + v + y,
          FOCUS_BLUR_DATA_API: (C = 'focus') + v + y + ' blur' + v + y
        }),
        (N = (function () {
          function n(e) {
            this._element = e;
          }
          var e = n.prototype;
          return (
            (e.toggle = function () {
              var e = !0,
                t = !0,
                n = m(this._element).closest(S)[0];
              if (n) {
                var i = this._element.querySelector(D);
                if (i) {
                  if ('radio' === i.type)
                    if (i.checked && this._element.classList.contains(b)) e = !1;
                    else {
                      var r = n.querySelector(A);
                      r && m(r).removeClass(b);
                    }
                  if (e) {
                    if (
                      i.hasAttribute('disabled') ||
                      n.hasAttribute('disabled') ||
                      i.classList.contains('disabled') ||
                      n.classList.contains('disabled')
                    )
                      return;
                    (i.checked = !this._element.classList.contains(b)), m(i).trigger('change');
                  }
                  i.focus(), (t = !1);
                }
              }
              t && this._element.setAttribute('aria-pressed', !this._element.classList.contains(b)),
                e && m(this._element).toggleClass(b);
            }),
            (e.dispose = function () {
              m.removeData(this._element, _), (this._element = null);
            }),
            (n._jQueryInterface = function (t) {
              return this.each(function () {
                var e = m(this).data(_);
                e || ((e = new n(this)), m(this).data(_, e)), 'toggle' === t && e[t]();
              });
            }),
            s(n, null, [
              {
                key: 'VERSION',
                get: function () {
                  return '4.1.3';
                }
              }
            ]),
            n
          );
        })()),
        m(document)
          .on(O.CLICK_DATA_API, T, function (e) {
            e.preventDefault();
            var t = e.target;
            m(t).hasClass(w) || (t = m(t).closest(I)), N._jQueryInterface.call(m(t), 'toggle');
          })
          .on(O.FOCUS_BLUR_DATA_API, T, function (e) {
            var t = m(e.target).closest(I)[0];
            m(t).toggleClass(C, /^focus(in)?$/.test(e.type));
          }),
        (m.fn[g] = N._jQueryInterface),
        (m.fn[g].Constructor = N),
        (m.fn[g].noConflict = function () {
          return (m.fn[g] = E), N._jQueryInterface;
        }),
        N),
      Se =
        ((x = 'carousel'),
        (L = '.' + (P = 'bs.carousel')),
        (j = '.data-api'),
        (H = (k = t).fn[x]),
        (M = {interval: 5e3, keyboard: !0, slide: !1, pause: 'hover', wrap: !0}),
        (F = {
          interval: '(number|boolean)',
          keyboard: 'boolean',
          slide: '(boolean|string)',
          pause: '(string|boolean)',
          wrap: 'boolean'
        }),
        (W = 'next'),
        (R = 'prev'),
        (U = 'left'),
        (B = 'right'),
        (q = {
          SLIDE: 'slide' + L,
          SLID: 'slid' + L,
          KEYDOWN: 'keydown' + L,
          MOUSEENTER: 'mouseenter' + L,
          MOUSELEAVE: 'mouseleave' + L,
          TOUCHEND: 'touchend' + L,
          LOAD_DATA_API: 'load' + L + j,
          CLICK_DATA_API: 'click' + L + j
        }),
        (K = 'carousel'),
        (Q = 'active'),
        (Y = 'slide'),
        (V = 'carousel-item-right'),
        (z = 'carousel-item-left'),
        (G = 'carousel-item-next'),
        (J = 'carousel-item-prev'),
        (Z = '.active'),
        (X = '.active.carousel-item'),
        ($ = '.carousel-item'),
        (ee = '.carousel-item-next, .carousel-item-prev'),
        (te = '.carousel-indicators'),
        (ne = '[data-slide], [data-slide-to]'),
        (ie = '[data-ride="carousel"]'),
        (re = (function () {
          function o(e, t) {
            (this._items = null),
              (this._interval = null),
              (this._activeElement = null),
              (this._isPaused = !1),
              (this._isSliding = !1),
              (this.touchTimeout = null),
              (this._config = this._getConfig(t)),
              (this._element = k(e)[0]),
              (this._indicatorsElement = this._element.querySelector(te)),
              this._addEventListeners();
          }
          var e = o.prototype;
          return (
            (e.next = function () {
              this._isSliding || this._slide(W);
            }),
            (e.nextWhenVisible = function () {
              !document.hidden &&
                k(this._element).is(':visible') &&
                'hidden' !== k(this._element).css('visibility') &&
                this.next();
            }),
            (e.prev = function () {
              this._isSliding || this._slide(R);
            }),
            (e.pause = function (e) {
              e || (this._isPaused = !0),
                this._element.querySelector(ee) &&
                  (we.triggerTransitionEnd(this._element), this.cycle(!0)),
                clearInterval(this._interval),
                (this._interval = null);
            }),
            (e.cycle = function (e) {
              e || (this._isPaused = !1),
                this._interval && (clearInterval(this._interval), (this._interval = null)),
                this._config.interval &&
                  !this._isPaused &&
                  (this._interval = setInterval(
                    (document.visibilityState ? this.nextWhenVisible : this.next).bind(this),
                    this._config.interval
                  ));
            }),
            (e.to = function (e) {
              var t = this;
              this._activeElement = this._element.querySelector(X);
              var n = this._getItemIndex(this._activeElement);
              if (!(e > this._items.length - 1 || e < 0))
                if (this._isSliding)
                  k(this._element).one(q.SLID, function () {
                    return t.to(e);
                  });
                else {
                  if (n === e) return this.pause(), void this.cycle();
                  var i = n < e ? W : R;
                  this._slide(i, this._items[e]);
                }
            }),
            (e.dispose = function () {
              k(this._element).off(L),
                k.removeData(this._element, P),
                (this._items = null),
                (this._config = null),
                (this._element = null),
                (this._interval = null),
                (this._isPaused = null),
                (this._isSliding = null),
                (this._activeElement = null),
                (this._indicatorsElement = null);
            }),
            (e._getConfig = function (e) {
              return (e = l({}, M, e)), we.typeCheckConfig(x, e, F), e;
            }),
            (e._addEventListeners = function () {
              var t = this;
              this._config.keyboard &&
                k(this._element).on(q.KEYDOWN, function (e) {
                  return t._keydown(e);
                }),
                'hover' === this._config.pause &&
                  (k(this._element)
                    .on(q.MOUSEENTER, function (e) {
                      return t.pause(e);
                    })
                    .on(q.MOUSELEAVE, function (e) {
                      return t.cycle(e);
                    }),
                  ('ontouchstart' in document.documentElement) &&
                    k(this._element).on(q.TOUCHEND, function () {
                      t.pause(),
                        t.touchTimeout && clearTimeout(t.touchTimeout),
                        (t.touchTimeout = setTimeout(function (e) {
                          return t.cycle(e);
                        }, 500 + t._config.interval));
                    }));
            }),
            (e._keydown = function (e) {
              if (!/input|textarea/i.test(e.target.tagName))
                switch (e.which) {
                  case 37:
                    e.preventDefault(), this.prev();
                    break;
                  case 39:
                    e.preventDefault(), this.next();
                }
            }),
            (e._getItemIndex = function (e) {
              return (
                (this._items =
                  e && e.parentNode ? [].slice.call(e.parentNode.querySelectorAll($)) : []),
                this._items.indexOf(e)
              );
            }),
            (e._getItemByDirection = function (e, t) {
              var n = e === W,
                i = e === R,
                r = this._getItemIndex(t),
                o = this._items.length - 1;
              if (((i && 0 === r) || (n && r === o)) && !this._config.wrap) return t;
              var s = (r + (e === R ? -1 : 1)) % this._items.length;
              return -1 === s ? this._items[this._items.length - 1] : this._items[s];
            }),
            (e._triggerSlideEvent = function (e, t) {
              var n = this._getItemIndex(e),
                i = this._getItemIndex(this._element.querySelector(X)),
                r = k.Event(q.SLIDE, {relatedTarget: e, direction: t, from: i, to: n});
              return k(this._element).trigger(r), r;
            }),
            (e._setActiveIndicatorElement = function (e) {
              if (this._indicatorsElement) {
                var t = [].slice.call(this._indicatorsElement.querySelectorAll(Z));
                k(t).removeClass(Q);
                var n = this._indicatorsElement.children[this._getItemIndex(e)];
                n && k(n).addClass(Q);
              }
            }),
            (e._slide = function (e, t) {
              var n,
                i,
                r,
                o = this,
                s = this._element.querySelector(X),
                a = this._getItemIndex(s),
                l = t || (s && this._getItemByDirection(e, s)),
                c = this._getItemIndex(l),
                u = Boolean(this._interval);
              if (
                (e === W ? ((n = z), (i = G), (r = U)) : ((n = V), (i = J), (r = B)),
                l && k(l).hasClass(Q))
              )
                this._isSliding = !1;
              else if (!this._triggerSlideEvent(l, r).isDefaultPrevented() && s && l) {
                (this._isSliding = !0), u && this.pause(), this._setActiveIndicatorElement(l);
                var f = k.Event(q.SLID, {relatedTarget: l, direction: r, from: a, to: c});
                if (k(this._element).hasClass(Y)) {
                  k(l).addClass(i), we.reflow(l), k(s).addClass(n), k(l).addClass(n);
                  var h = we.getTransitionDurationFromElement(s);
                  k(s)
                    .one(we.TRANSITION_END, function () {
                      k(l)
                        .removeClass(n + ' ' + i)
                        .addClass(Q),
                        k(s).removeClass(Q + ' ' + i + ' ' + n),
                        (o._isSliding = !1),
                        setTimeout(function () {
                          return k(o._element).trigger(f);
                        }, 0);
                    })
                    .emulateTransitionEnd(h);
                } else
                  k(s).removeClass(Q),
                    k(l).addClass(Q),
                    (this._isSliding = !1),
                    k(this._element).trigger(f);
                u && this.cycle();
              }
            }),
            (o._jQueryInterface = function (i) {
              return this.each(function () {
                var e = k(this).data(P),
                  t = l({}, M, k(this).data());
                'object' == typeof i && (t = l({}, t, i));
                var n = 'string' == typeof i ? i : t.slide;
                if ((e || ((e = new o(this, t)), k(this).data(P, e)), 'number' == typeof i))
                  e.to(i);
                else if ('string' == typeof n) {
                  if ('undefined' == typeof e[n])
                    throw new TypeError('No method named "' + n + '"');
                  e[n]();
                } else t.interval && (e.pause(), e.cycle());
              });
            }),
            (o._dataApiClickHandler = function (e) {
              var t = we.getSelectorFromElement(this);
              if (t) {
                var n = k(t)[0];
                if (n && k(n).hasClass(K)) {
                  var i = l({}, k(n).data(), k(this).data()),
                    r = this.getAttribute('data-slide-to');
                  r && (i.interval = !1),
                    o._jQueryInterface.call(k(n), i),
                    r && k(n).data(P).to(r),
                    e.preventDefault();
                }
              }
            }),
            s(o, null, [
              {
                key: 'VERSION',
                get: function () {
                  return '4.1.3';
                }
              },
              {
                key: 'Default',
                get: function () {
                  return M;
                }
              }
            ]),
            o
          );
        })()),
        k(document).on(q.CLICK_DATA_API, ne, re._dataApiClickHandler),
        k(window).on(q.LOAD_DATA_API, function () {
          for (
            var e = [].slice.call(document.querySelectorAll(ie)), t = 0, n = e.length;
            t < n;
            t++
          ) {
            var i = k(e[t]);
            re._jQueryInterface.call(i, i.data());
          }
        }),
        (k.fn[x] = re._jQueryInterface),
        (k.fn[x].Constructor = re),
        (k.fn[x].noConflict = function () {
          return (k.fn[x] = H), re._jQueryInterface;
        }),
        re),
      De =
        ((se = 'collapse'),
        (le = '.' + (ae = 'bs.collapse')),
        (ce = (oe = t).fn[se]),
        (ue = {toggle: !0, parent: ''}),
        (fe = {toggle: 'boolean', parent: '(string|element)'}),
        (he = {
          SHOW: 'show' + le,
          SHOWN: 'shown' + le,
          HIDE: 'hide' + le,
          HIDDEN: 'hidden' + le,
          CLICK_DATA_API: 'click' + le + '.data-api'
        }),
        (de = 'show'),
        (pe = 'collapse'),
        (me = 'collapsing'),
        (ge = 'collapsed'),
        (_e = 'width'),
        (ve = 'height'),
        (ye = '.show, .collapsing'),
        (Ee = '[data-toggle="collapse"]'),
        (be = (function () {
          function a(t, e) {
            (this._isTransitioning = !1),
              (this._element = t),
              (this._config = this._getConfig(e)),
              (this._triggerArray = oe.makeArray(
                document.querySelectorAll(
                  '[data-toggle="collapse"][href="#' +
                    t.id +
                    '"],[data-toggle="collapse"][data-target="#' +
                    t.id +
                    '"]'
                )
              ));
            for (
              var n = [].slice.call(document.querySelectorAll(Ee)), i = 0, r = n.length;
              i < r;
              i++
            ) {
              var o = n[i],
                s = we.getSelectorFromElement(o),
                a = [].slice.call(document.querySelectorAll(s)).filter(function (e) {
                  return e === t;
                });
              null !== s && 0 < a.length && ((this._selector = s), this._triggerArray.push(o));
            }
            (this._parent = this._config.parent ? this._getParent() : null),
              this._config.parent ||
                this._addAriaAndCollapsedClass(this._element, this._triggerArray),
              this._config.toggle && this.toggle();
          }
          var e = a.prototype;
          return (
            (e.toggle = function () {
              oe(this._element).hasClass(de) ? this.hide() : this.show();
            }),
            (e.show = function () {
              var e,
                t,
                n = this;
              if (
                !this._isTransitioning &&
                !oe(this._element).hasClass(de) &&
                (this._parent &&
                  0 ===
                    (e = [].slice.call(this._parent.querySelectorAll(ye)).filter(function (e) {
                      return e.getAttribute('data-parent') === n._config.parent;
                    })).length &&
                  (e = null),
                !(e && (t = oe(e).not(this._selector).data(ae)) && t._isTransitioning))
              ) {
                var i = oe.Event(he.SHOW);
                if ((oe(this._element).trigger(i), !i.isDefaultPrevented())) {
                  e &&
                    (a._jQueryInterface.call(oe(e).not(this._selector), 'hide'),
                    t || oe(e).data(ae, null));
                  var r = this._getDimension();
                  oe(this._element).removeClass(pe).addClass(me),
                    (this._element.style[r] = 0),
                    this._triggerArray.length &&
                      oe(this._triggerArray).removeClass(ge).attr('aria-expanded', !0),
                    this.setTransitioning(!0);
                  var o = 'scroll' + (r[0].toUpperCase() + r.slice(1)),
                    s = we.getTransitionDurationFromElement(this._element);
                  oe(this._element)
                    .one(we.TRANSITION_END, function () {
                      oe(n._element).removeClass(me).addClass(pe).addClass(de),
                        (n._element.style[r] = ''),
                        n.setTransitioning(!1),
                        oe(n._element).trigger(he.SHOWN);
                    })
                    .emulateTransitionEnd(s),
                    (this._element.style[r] = this._element[o] + 'px');
                }
              }
            }),
            (e.hide = function () {
              var e = this;
              if (!this._isTransitioning && oe(this._element).hasClass(de)) {
                var t = oe.Event(he.HIDE);
                if ((oe(this._element).trigger(t), !t.isDefaultPrevented())) {
                  var n = this._getDimension();
                  (this._element.style[n] = this._element.getBoundingClientRect()[n] + 'px'),
                    we.reflow(this._element),
                    oe(this._element).addClass(me).removeClass(pe).removeClass(de);
                  var i = this._triggerArray.length;
                  if (0 < i)
                    for (var r = 0; r < i; r++) {
                      var o = this._triggerArray[r],
                        s = we.getSelectorFromElement(o);
                      if (null !== s)
                        oe([].slice.call(document.querySelectorAll(s))).hasClass(de) ||
                          oe(o).addClass(ge).attr('aria-expanded', !1);
                    }
                  this.setTransitioning(!0);
                  this._element.style[n] = '';
                  var a = we.getTransitionDurationFromElement(this._element);
                  oe(this._element)
                    .one(we.TRANSITION_END, function () {
                      e.setTransitioning(!1),
                        oe(e._element).removeClass(me).addClass(pe).trigger(he.HIDDEN);
                    })
                    .emulateTransitionEnd(a);
                }
              }
            }),
            (e.setTransitioning = function (e) {
              this._isTransitioning = e;
            }),
            (e.dispose = function () {
              oe.removeData(this._element, ae),
                (this._config = null),
                (this._parent = null),
                (this._element = null),
                (this._triggerArray = null),
                (this._isTransitioning = null);
            }),
            (e._getConfig = function (e) {
              return (
                ((e = l({}, ue, e)).toggle = Boolean(e.toggle)), we.typeCheckConfig(se, e, fe), e
              );
            }),
            (e._getDimension = function () {
              return oe(this._element).hasClass(_e) ? _e : ve;
            }),
            (e._getParent = function () {
              var n = this,
                e = null;
              we.isElement(this._config.parent)
                ? ((e = this._config.parent),
                  'undefined' != typeof this._config.parent.jquery && (e = this._config.parent[0]))
                : (e = document.querySelector(this._config.parent));
              var t = '[data-toggle="collapse"][data-parent="' + this._config.parent + '"]',
                i = [].slice.call(e.querySelectorAll(t));
              return (
                oe(i).each(function (e, t) {
                  n._addAriaAndCollapsedClass(a._getTargetFromElement(t), [t]);
                }),
                e
              );
            }),
            (e._addAriaAndCollapsedClass = function (e, t) {
              if (e) {
                var n = oe(e).hasClass(de);
                t.length && oe(t).toggleClass(ge, !n).attr('aria-expanded', n);
              }
            }),
            (a._getTargetFromElement = function (e) {
              var t = we.getSelectorFromElement(e);
              return t ? document.querySelector(t) : null;
            }),
            (a._jQueryInterface = function (i) {
              return this.each(function () {
                var e = oe(this),
                  t = e.data(ae),
                  n = l({}, ue, e.data(), 'object' == typeof i && i ? i : {});
                if (
                  (!t && n.toggle && /show|hide/.test(i) && (n.toggle = !1),
                  t || ((t = new a(this, n)), e.data(ae, t)),
                  'string' == typeof i)
                ) {
                  if ('undefined' == typeof t[i])
                    throw new TypeError('No method named "' + i + '"');
                  t[i]();
                }
              });
            }),
            s(a, null, [
              {
                key: 'VERSION',
                get: function () {
                  return '4.1.3';
                }
              },
              {
                key: 'Default',
                get: function () {
                  return ue;
                }
              }
            ]),
            a
          );
        })()),
        oe(document).on(he.CLICK_DATA_API, Ee, function (e) {
          'A' === e.currentTarget.tagName && e.preventDefault();
          var n = oe(this),
            t = we.getSelectorFromElement(this),
            i = [].slice.call(document.querySelectorAll(t));
          oe(i).each(function () {
            var e = oe(this),
              t = e.data(ae) ? 'toggle' : n.data();
            be._jQueryInterface.call(e, t);
          });
        }),
        (oe.fn[se] = be._jQueryInterface),
        (oe.fn[se].Constructor = be),
        (oe.fn[se].noConflict = function () {
          return (oe.fn[se] = ce), be._jQueryInterface;
        }),
        be),
      Ae = 'undefined' != typeof window && 'undefined' != typeof document,
      Ie = ['Edge', 'Trident', 'Firefox'],
      Oe = 0,
      Ne = 0;
    Ne < Ie.length;
    Ne += 1
  )
    if (Ae && 0 <= navigator.userAgent.indexOf(Ie[Ne])) {
      Oe = 1;
      break;
    }
  var ke =
    Ae && window.Promise
      ? function (e) {
          var t = !1;
          return function () {
            t ||
              ((t = !0),
              window.Promise.resolve().then(function () {
                (t = !1), e();
              }));
          };
        }
      : function (e) {
          var t = !1;
          return function () {
            t ||
              ((t = !0),
              setTimeout(function () {
                (t = !1), e();
              }, Oe));
          };
        };
  function xe(e) {
    return e && '[object Function]' === {}.toString.call(e);
  }
  function Pe(e, t) {
    if (1 !== e.nodeType) return [];
    var n = getComputedStyle(e, null);
    return t ? n[t] : n;
  }
  function Le(e) {
    return 'HTML' === e.nodeName ? e : e.parentNode || e.host;
  }
  function je(e) {
    if (!e) return document.body;
    switch (e.nodeName) {
      case 'HTML':
      case 'BODY':
        return e.ownerDocument.body;
      case '#document':
        return e.body;
    }
    var t = Pe(e),
      n = t.overflow,
      i = t.overflowX,
      r = t.overflowY;
    return /(auto|scroll|overlay)/.test(n + r + i) ? e : je(Le(e));
  }
  var He = Ae && !(!window.MSInputMethodContext || !document.documentMode),
    Me = Ae && /MSIE 10/.test(navigator.userAgent);
  function Fe(e) {
    return 11 === e ? He : 10 === e ? Me : He || Me;
  }
  function We(e) {
    if (!e) return document.documentElement;
    for (
      var t = Fe(10) ? document.body : null, n = e.offsetParent;
      n === t && e.nextElementSibling;

    )
      n = (e = e.nextElementSibling).offsetParent;
    var i = n && n.nodeName;
    return i && 'BODY' !== i && 'HTML' !== i
      ? -1 !== ['TD', 'TABLE'].indexOf(n.nodeName) && 'static' === Pe(n, 'position')
        ? We(n)
        : n
      : e
      ? e.ownerDocument.documentElement
      : document.documentElement;
  }
  function Re(e) {
    return null !== e.parentNode ? Re(e.parentNode) : e;
  }
  function Ue(e, t) {
    if (!(e && e.nodeType && t && t.nodeType)) return document.documentElement;
    var n = e.compareDocumentPosition(t) & Node.DOCUMENT_POSITION_FOLLOWING,
      i = n ? e : t,
      r = n ? t : e,
      o = document.createRange();
    o.setStart(i, 0), o.setEnd(r, 0);
    var s,
      a,
      l = o.commonAncestorContainer;
    if ((e !== l && t !== l) || i.contains(r))
      return 'BODY' === (a = (s = l).nodeName) || ('HTML' !== a && We(s.firstElementChild) !== s)
        ? We(l)
        : l;
    var c = Re(e);
    return c.host ? Ue(c.host, t) : Ue(e, Re(t).host);
  }
  function Be(e) {
    var t =
        'top' === (1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : 'top')
          ? 'scrollTop'
          : 'scrollLeft',
      n = e.nodeName;
    if ('BODY' === n || 'HTML' === n) {
      var i = e.ownerDocument.documentElement;
      return (e.ownerDocument.scrollingElement || i)[t];
    }
    return e[t];
  }
  function qe(e, t) {
    var n = 'x' === t ? 'Left' : 'Top',
      i = 'Left' === n ? 'Right' : 'Bottom';
    return parseFloat(e['border' + n + 'Width'], 10) + parseFloat(e['border' + i + 'Width'], 10);
  }
  function Ke(e, t, n, i) {
    return Math.max(
      t['offset' + e],
      t['scroll' + e],
      n['client' + e],
      n['offset' + e],
      n['scroll' + e],
      Fe(10)
        ? n['offset' + e] +
            i['margin' + ('Height' === e ? 'Top' : 'Left')] +
            i['margin' + ('Height' === e ? 'Bottom' : 'Right')]
        : 0
    );
  }
  function Qe() {
    var e = document.body,
      t = document.documentElement,
      n = Fe(10) && getComputedStyle(t);
    return {height: Ke('Height', e, t, n), width: Ke('Width', e, t, n)};
  }
  var Ye = (function () {
      function i(e, t) {
        for (var n = 0; n < t.length; n++) {
          var i = t[n];
          (i.enumerable = i.enumerable || !1),
            (i.configurable = !0),
            'value' in i && (i.writable = !0),
            Object.defineProperty(e, i.key, i);
        }
      }
      return function (e, t, n) {
        return t && i(e.prototype, t), n && i(e, n), e;
      };
    })(),
    Ve = function (e, t, n) {
      return (
        t in e
          ? Object.defineProperty(e, t, {value: n, enumerable: !0, configurable: !0, writable: !0})
          : (e[t] = n),
        e
      );
    },
    ze =
      Object.assign ||
      function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];
          for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
        }
        return e;
      };
  function Ge(e) {
    return ze({}, e, {right: e.left + e.width, bottom: e.top + e.height});
  }
  function Je(e) {
    var t = {};
    try {
      if (Fe(10)) {
        t = e.getBoundingClientRect();
        var n = Be(e, 'top'),
          i = Be(e, 'left');
        (t.top += n), (t.left += i), (t.bottom += n), (t.right += i);
      } else t = e.getBoundingClientRect();
    } catch (e) {}
    var r = {left: t.left, top: t.top, width: t.right - t.left, height: t.bottom - t.top},
      o = 'HTML' === e.nodeName ? Qe() : {},
      s = o.width || e.clientWidth || r.right - r.left,
      a = o.height || e.clientHeight || r.bottom - r.top,
      l = e.offsetWidth - s,
      c = e.offsetHeight - a;
    if (l || c) {
      var u = Pe(e);
      (l -= qe(u, 'x')), (c -= qe(u, 'y')), (r.width -= l), (r.height -= c);
    }
    return Ge(r);
  }
  function Ze(e, t) {
    var n = 2 < arguments.length && void 0 !== arguments[2] && arguments[2],
      i = Fe(10),
      r = 'HTML' === t.nodeName,
      o = Je(e),
      s = Je(t),
      a = je(e),
      l = Pe(t),
      c = parseFloat(l.borderTopWidth, 10),
      u = parseFloat(l.borderLeftWidth, 10);
    n && 'HTML' === t.nodeName && ((s.top = Math.max(s.top, 0)), (s.left = Math.max(s.left, 0)));
    var f = Ge({
      top: o.top - s.top - c,
      left: o.left - s.left - u,
      width: o.width,
      height: o.height
    });
    if (((f.marginTop = 0), (f.marginLeft = 0), !i && r)) {
      var h = parseFloat(l.marginTop, 10),
        d = parseFloat(l.marginLeft, 10);
      (f.top -= c - h),
        (f.bottom -= c - h),
        (f.left -= u - d),
        (f.right -= u - d),
        (f.marginTop = h),
        (f.marginLeft = d);
    }
    return (
      (i && !n ? t.contains(a) : t === a && 'BODY' !== a.nodeName) &&
        (f = (function (e, t) {
          var n = 2 < arguments.length && void 0 !== arguments[2] && arguments[2],
            i = Be(t, 'top'),
            r = Be(t, 'left'),
            o = n ? -1 : 1;
          return (e.top += i * o), (e.bottom += i * o), (e.left += r * o), (e.right += r * o), e;
        })(f, t)),
      f
    );
  }
  function Xe(e) {
    if (!e || !e.parentElement || Fe()) return document.documentElement;
    for (var t = e.parentElement; t && 'none' === Pe(t, 'transform'); ) t = t.parentElement;
    return t || document.documentElement;
  }
  function $e(e, t, n, i) {
    var r = 4 < arguments.length && void 0 !== arguments[4] && arguments[4],
      o = {top: 0, left: 0},
      s = r ? Xe(e) : Ue(e, t);
    if ('viewport' === i)
      o = (function (e) {
        var t = 1 < arguments.length && void 0 !== arguments[1] && arguments[1],
          n = e.ownerDocument.documentElement,
          i = Ze(e, n),
          r = Math.max(n.clientWidth, window.innerWidth || 0),
          o = Math.max(n.clientHeight, window.innerHeight || 0),
          s = t ? 0 : Be(n),
          a = t ? 0 : Be(n, 'left');
        return Ge({
          top: s - i.top + i.marginTop,
          left: a - i.left + i.marginLeft,
          width: r,
          height: o
        });
      })(s, r);
    else {
      var a = void 0;
      'scrollParent' === i
        ? 'BODY' === (a = je(Le(t))).nodeName && (a = e.ownerDocument.documentElement)
        : (a = 'window' === i ? e.ownerDocument.documentElement : i);
      var l = Ze(a, s, r);
      if (
        'HTML' !== a.nodeName ||
        (function e(t) {
          var n = t.nodeName;
          return 'BODY' !== n && 'HTML' !== n && ('fixed' === Pe(t, 'position') || e(Le(t)));
        })(s)
      )
        o = l;
      else {
        var c = Qe(),
          u = c.height,
          f = c.width;
        (o.top += l.top - l.marginTop),
          (o.bottom = u + l.top),
          (o.left += l.left - l.marginLeft),
          (o.right = f + l.left);
      }
    }
    return (o.left += n), (o.top += n), (o.right -= n), (o.bottom -= n), o;
  }
  function et(e, t, i, n, r) {
    var o = 5 < arguments.length && void 0 !== arguments[5] ? arguments[5] : 0;
    if (-1 === e.indexOf('auto')) return e;
    var s = $e(i, n, o, r),
      a = {
        top: {width: s.width, height: t.top - s.top},
        right: {width: s.right - t.right, height: s.height},
        bottom: {width: s.width, height: s.bottom - t.bottom},
        left: {width: t.left - s.left, height: s.height}
      },
      l = Object.keys(a)
        .map(function (e) {
          return ze({key: e}, a[e], {area: ((t = a[e]), t.width * t.height)});
          var t;
        })
        .sort(function (e, t) {
          return t.area - e.area;
        }),
      c = l.filter(function (e) {
        var t = e.width,
          n = e.height;
        return t >= i.clientWidth && n >= i.clientHeight;
      }),
      u = 0 < c.length ? c[0].key : l[0].key,
      f = e.split('-')[1];
    return u + (f ? '-' + f : '');
  }
  function tt(e, t, n) {
    var i = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return Ze(n, i ? Xe(t) : Ue(t, n), i);
  }
  function nt(e) {
    var t = getComputedStyle(e),
      n = parseFloat(t.marginTop) + parseFloat(t.marginBottom),
      i = parseFloat(t.marginLeft) + parseFloat(t.marginRight);
    return {width: e.offsetWidth + i, height: e.offsetHeight + n};
  }
  function it(e) {
    var t = {left: 'right', right: 'left', bottom: 'top', top: 'bottom'};
    return e.replace(/left|right|bottom|top/g, function (e) {
      return t[e];
    });
  }
  function rt(e, t, n) {
    n = n.split('-')[0];
    var i = nt(e),
      r = {width: i.width, height: i.height},
      o = -1 !== ['right', 'left'].indexOf(n),
      s = o ? 'top' : 'left',
      a = o ? 'left' : 'top',
      l = o ? 'height' : 'width',
      c = o ? 'width' : 'height';
    return (r[s] = t[s] + t[l] / 2 - i[l] / 2), (r[a] = n === a ? t[a] - i[c] : t[it(a)]), r;
  }
  function ot(e, t) {
    return Array.prototype.find ? e.find(t) : e.filter(t)[0];
  }
  function st(e, n, t) {
    return (
      (void 0 === t
        ? e
        : e.slice(
            0,
            (function (e, t, n) {
              if (Array.prototype.findIndex)
                return e.findIndex(function (e) {
                  return e[t] === n;
                });
              var i = ot(e, function (e) {
                return e[t] === n;
              });
              return e.indexOf(i);
            })(e, 'name', t)
          )
      ).forEach(function (e) {
        e.function && console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
        var t = e.function || e.fn;
        e.enabled &&
          xe(t) &&
          ((n.offsets.popper = Ge(n.offsets.popper)),
          (n.offsets.reference = Ge(n.offsets.reference)),
          (n = t(n, e)));
      }),
      n
    );
  }
  function at(e, n) {
    return e.some(function (e) {
      var t = e.name;
      return e.enabled && t === n;
    });
  }
  function lt(e) {
    for (
      var t = [!1, 'ms', 'Webkit', 'Moz', 'O'], n = e.charAt(0).toUpperCase() + e.slice(1), i = 0;
      i < t.length;
      i++
    ) {
      var r = t[i],
        o = r ? '' + r + n : e;
      if ('undefined' != typeof document.body.style[o]) return o;
    }
    return null;
  }
  function ct(e) {
    var t = e.ownerDocument;
    return t ? t.defaultView : window;
  }
  function ut(e, t, n, i) {
    (n.updateBound = i), ct(e).addEventListener('resize', n.updateBound, {passive: !0});
    var r = je(e);
    return (
      (function e(t, n, i, r) {
        var o = 'BODY' === t.nodeName,
          s = o ? t.ownerDocument.defaultView : t;
        s.addEventListener(n, i, {passive: !0}), o || e(je(s.parentNode), n, i, r), r.push(s);
      })(r, 'scroll', n.updateBound, n.scrollParents),
      (n.scrollElement = r),
      (n.eventsEnabled = !0),
      n
    );
  }
  function ft() {
    var e, t;
    this.state.eventsEnabled &&
      (cancelAnimationFrame(this.scheduleUpdate),
      (this.state =
        ((e = this.reference),
        (t = this.state),
        ct(e).removeEventListener('resize', t.updateBound),
        t.scrollParents.forEach(function (e) {
          e.removeEventListener('scroll', t.updateBound);
        }),
        (t.updateBound = null),
        (t.scrollParents = []),
        (t.scrollElement = null),
        (t.eventsEnabled = !1),
        t)));
  }
  function ht(e) {
    return '' !== e && !isNaN(parseFloat(e)) && isFinite(e);
  }
  function dt(n, i) {
    Object.keys(i).forEach(function (e) {
      var t = '';
      -1 !== ['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(e) &&
        ht(i[e]) &&
        (t = 'px'),
        (n.style[e] = i[e] + t);
    });
  }
  function pt(e, t, n) {
    var i = ot(e, function (e) {
        return e.name === t;
      }),
      r =
        !!i &&
        e.some(function (e) {
          return e.name === n && e.enabled && e.order < i.order;
        });
    if (!r) {
      var o = '`' + t + '`',
        s = '`' + n + '`';
      console.warn(
        s +
          ' modifier is required by ' +
          o +
          ' modifier in order to work, be sure to include it before ' +
          o +
          '!'
      );
    }
    return r;
  }
  var mt = [
      'auto-start',
      'auto',
      'auto-end',
      'top-start',
      'top',
      'top-end',
      'right-start',
      'right',
      'right-end',
      'bottom-end',
      'bottom',
      'bottom-start',
      'left-end',
      'left',
      'left-start'
    ],
    gt = mt.slice(3);
  function _t(e) {
    var t = 1 < arguments.length && void 0 !== arguments[1] && arguments[1],
      n = gt.indexOf(e),
      i = gt.slice(n + 1).concat(gt.slice(0, n));
    return t ? i.reverse() : i;
  }
  var vt = 'flip',
    yt = 'clockwise',
    Et = 'counterclockwise';
  function bt(e, r, o, t) {
    var s = [0, 0],
      a = -1 !== ['right', 'left'].indexOf(t),
      n = e.split(/(\+|\-)/).map(function (e) {
        return e.trim();
      }),
      i = n.indexOf(
        ot(n, function (e) {
          return -1 !== e.search(/,|\s/);
        })
      );
    n[i] &&
      -1 === n[i].indexOf(',') &&
      console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
    var l = /\s*,\s*|\s+/,
      c =
        -1 !== i
          ? [n.slice(0, i).concat([n[i].split(l)[0]]), [n[i].split(l)[1]].concat(n.slice(i + 1))]
          : [n];
    return (
      (c = c.map(function (e, t) {
        var n = (1 === t ? !a : a) ? 'height' : 'width',
          i = !1;
        return e
          .reduce(function (e, t) {
            return '' === e[e.length - 1] && -1 !== ['+', '-'].indexOf(t)
              ? ((e[e.length - 1] = t), (i = !0), e)
              : i
              ? ((e[e.length - 1] += t), (i = !1), e)
              : e.concat(t);
          }, [])
          .map(function (e) {
            return (function (e, t, n, i) {
              var r = e.match(/((?:\-|\+)?\d*\.?\d*)(.*)/),
                o = +r[1],
                s = r[2];
              if (!o) return e;
              if (0 === s.indexOf('%')) {
                var a = void 0;
                switch (s) {
                  case '%p':
                    a = n;
                    break;
                  case '%':
                  case '%r':
                  default:
                    a = i;
                }
                return (Ge(a)[t] / 100) * o;
              }
              if ('vh' === s || 'vw' === s)
                return (
                  (('vh' === s
                    ? Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
                    : Math.max(document.documentElement.clientWidth, window.innerWidth || 0)) /
                    100) *
                  o
                );
              return o;
            })(e, n, r, o);
          });
      })).forEach(function (n, i) {
        n.forEach(function (e, t) {
          ht(e) && (s[i] += e * ('-' === n[t - 1] ? -1 : 1));
        });
      }),
      s
    );
  }
  var wt = {
      placement: 'bottom',
      positionFixed: !1,
      eventsEnabled: !0,
      removeOnDestroy: !1,
      onCreate: function () {},
      onUpdate: function () {},
      modifiers: {
        shift: {
          order: 100,
          enabled: !0,
          fn: function (e) {
            var t = e.placement,
              n = t.split('-')[0],
              i = t.split('-')[1];
            if (i) {
              var r = e.offsets,
                o = r.reference,
                s = r.popper,
                a = -1 !== ['bottom', 'top'].indexOf(n),
                l = a ? 'left' : 'top',
                c = a ? 'width' : 'height',
                u = {start: Ve({}, l, o[l]), end: Ve({}, l, o[l] + o[c] - s[c])};
              e.offsets.popper = ze({}, s, u[i]);
            }
            return e;
          }
        },
        offset: {
          order: 200,
          enabled: !0,
          fn: function (e, t) {
            var n = t.offset,
              i = e.placement,
              r = e.offsets,
              o = r.popper,
              s = r.reference,
              a = i.split('-')[0],
              l = void 0;
            return (
              (l = ht(+n) ? [+n, 0] : bt(n, o, s, a)),
              'left' === a
                ? ((o.top += l[0]), (o.left -= l[1]))
                : 'right' === a
                ? ((o.top += l[0]), (o.left += l[1]))
                : 'top' === a
                ? ((o.left += l[0]), (o.top -= l[1]))
                : 'bottom' === a && ((o.left += l[0]), (o.top += l[1])),
              (e.popper = o),
              e
            );
          },
          offset: 0
        },
        preventOverflow: {
          order: 300,
          enabled: !0,
          fn: function (e, i) {
            var t = i.boundariesElement || We(e.instance.popper);
            e.instance.reference === t && (t = We(t));
            var n = lt('transform'),
              r = e.instance.popper.style,
              o = r.top,
              s = r.left,
              a = r[n];
            (r.top = ''), (r.left = ''), (r[n] = '');
            var l = $e(e.instance.popper, e.instance.reference, i.padding, t, e.positionFixed);
            (r.top = o), (r.left = s), (r[n] = a), (i.boundaries = l);
            var c = i.priority,
              u = e.offsets.popper,
              f = {
                primary: function (e) {
                  var t = u[e];
                  return (
                    u[e] < l[e] && !i.escapeWithReference && (t = Math.max(u[e], l[e])),
                    Ve({}, e, t)
                  );
                },
                secondary: function (e) {
                  var t = 'right' === e ? 'left' : 'top',
                    n = u[t];
                  return (
                    u[e] > l[e] &&
                      !i.escapeWithReference &&
                      (n = Math.min(u[t], l[e] - ('right' === e ? u.width : u.height))),
                    Ve({}, t, n)
                  );
                }
              };
            return (
              c.forEach(function (e) {
                var t = -1 !== ['left', 'top'].indexOf(e) ? 'primary' : 'secondary';
                u = ze({}, u, f[t](e));
              }),
              (e.offsets.popper = u),
              e
            );
          },
          priority: ['left', 'right', 'top', 'bottom'],
          padding: 5,
          boundariesElement: 'scrollParent'
        },
        keepTogether: {
          order: 400,
          enabled: !0,
          fn: function (e) {
            var t = e.offsets,
              n = t.popper,
              i = t.reference,
              r = e.placement.split('-')[0],
              o = Math.floor,
              s = -1 !== ['top', 'bottom'].indexOf(r),
              a = s ? 'right' : 'bottom',
              l = s ? 'left' : 'top',
              c = s ? 'width' : 'height';
            return (
              n[a] < o(i[l]) && (e.offsets.popper[l] = o(i[l]) - n[c]),
              n[l] > o(i[a]) && (e.offsets.popper[l] = o(i[a])),
              e
            );
          }
        },
        arrow: {
          order: 500,
          enabled: !0,
          fn: function (e, t) {
            var n;
            if (!pt(e.instance.modifiers, 'arrow', 'keepTogether')) return e;
            var i = t.element;
            if ('string' == typeof i) {
              if (!(i = e.instance.popper.querySelector(i))) return e;
            } else if (!e.instance.popper.contains(i))
              return (
                console.warn('WARNING: `arrow.element` must be child of its popper element!'), e
              );
            var r = e.placement.split('-')[0],
              o = e.offsets,
              s = o.popper,
              a = o.reference,
              l = -1 !== ['left', 'right'].indexOf(r),
              c = l ? 'height' : 'width',
              u = l ? 'Top' : 'Left',
              f = u.toLowerCase(),
              h = l ? 'left' : 'top',
              d = l ? 'bottom' : 'right',
              p = nt(i)[c];
            a[d] - p < s[f] && (e.offsets.popper[f] -= s[f] - (a[d] - p)),
              a[f] + p > s[d] && (e.offsets.popper[f] += a[f] + p - s[d]),
              (e.offsets.popper = Ge(e.offsets.popper));
            var m = a[f] + a[c] / 2 - p / 2,
              g = Pe(e.instance.popper),
              _ = parseFloat(g['margin' + u], 10),
              v = parseFloat(g['border' + u + 'Width'], 10),
              y = m - e.offsets.popper[f] - _ - v;
            return (
              (y = Math.max(Math.min(s[c] - p, y), 0)),
              (e.arrowElement = i),
              (e.offsets.arrow = (Ve((n = {}), f, Math.round(y)), Ve(n, h, ''), n)),
              e
            );
          },
          element: '[x-arrow]'
        },
        flip: {
          order: 600,
          enabled: !0,
          fn: function (p, m) {
            if (at(p.instance.modifiers, 'inner')) return p;
            if (p.flipped && p.placement === p.originalPlacement) return p;
            var g = $e(
                p.instance.popper,
                p.instance.reference,
                m.padding,
                m.boundariesElement,
                p.positionFixed
              ),
              _ = p.placement.split('-')[0],
              v = it(_),
              y = p.placement.split('-')[1] || '',
              E = [];
            switch (m.behavior) {
              case vt:
                E = [_, v];
                break;
              case yt:
                E = _t(_);
                break;
              case Et:
                E = _t(_, !0);
                break;
              default:
                E = m.behavior;
            }
            return (
              E.forEach(function (e, t) {
                if (_ !== e || E.length === t + 1) return p;
                (_ = p.placement.split('-')[0]), (v = it(_));
                var n,
                  i = p.offsets.popper,
                  r = p.offsets.reference,
                  o = Math.floor,
                  s =
                    ('left' === _ && o(i.right) > o(r.left)) ||
                    ('right' === _ && o(i.left) < o(r.right)) ||
                    ('top' === _ && o(i.bottom) > o(r.top)) ||
                    ('bottom' === _ && o(i.top) < o(r.bottom)),
                  a = o(i.left) < o(g.left),
                  l = o(i.right) > o(g.right),
                  c = o(i.top) < o(g.top),
                  u = o(i.bottom) > o(g.bottom),
                  f =
                    ('left' === _ && a) ||
                    ('right' === _ && l) ||
                    ('top' === _ && c) ||
                    ('bottom' === _ && u),
                  h = -1 !== ['top', 'bottom'].indexOf(_),
                  d =
                    !!m.flipVariations &&
                    ((h && 'start' === y && a) ||
                      (h && 'end' === y && l) ||
                      (!h && 'start' === y && c) ||
                      (!h && 'end' === y && u));
                (s || f || d) &&
                  ((p.flipped = !0),
                  (s || f) && (_ = E[t + 1]),
                  d && (y = 'end' === (n = y) ? 'start' : 'start' === n ? 'end' : n),
                  (p.placement = _ + (y ? '-' + y : '')),
                  (p.offsets.popper = ze(
                    {},
                    p.offsets.popper,
                    rt(p.instance.popper, p.offsets.reference, p.placement)
                  )),
                  (p = st(p.instance.modifiers, p, 'flip')));
              }),
              p
            );
          },
          behavior: 'flip',
          padding: 5,
          boundariesElement: 'viewport'
        },
        inner: {
          order: 700,
          enabled: !1,
          fn: function (e) {
            var t = e.placement,
              n = t.split('-')[0],
              i = e.offsets,
              r = i.popper,
              o = i.reference,
              s = -1 !== ['left', 'right'].indexOf(n),
              a = -1 === ['top', 'left'].indexOf(n);
            return (
              (r[s ? 'left' : 'top'] = o[n] - (a ? r[s ? 'width' : 'height'] : 0)),
              (e.placement = it(t)),
              (e.offsets.popper = Ge(r)),
              e
            );
          }
        },
        hide: {
          order: 800,
          enabled: !0,
          fn: function (e) {
            if (!pt(e.instance.modifiers, 'hide', 'preventOverflow')) return e;
            var t = e.offsets.reference,
              n = ot(e.instance.modifiers, function (e) {
                return 'preventOverflow' === e.name;
              }).boundaries;
            if (t.bottom < n.top || t.left > n.right || t.top > n.bottom || t.right < n.left) {
              if (!0 === e.hide) return e;
              (e.hide = !0), (e.attributes['x-out-of-boundaries'] = '');
            } else {
              if (!1 === e.hide) return e;
              (e.hide = !1), (e.attributes['x-out-of-boundaries'] = !1);
            }
            return e;
          }
        },
        computeStyle: {
          order: 850,
          enabled: !0,
          fn: function (e, t) {
            var n = t.x,
              i = t.y,
              r = e.offsets.popper,
              o = ot(e.instance.modifiers, function (e) {
                return 'applyStyle' === e.name;
              }).gpuAcceleration;
            void 0 !== o &&
              console.warn(
                'WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!'
              );
            var s = void 0 !== o ? o : t.gpuAcceleration,
              a = Je(We(e.instance.popper)),
              l = {position: r.position},
              c = {
                left: Math.floor(r.left),
                top: Math.round(r.top),
                bottom: Math.round(r.bottom),
                right: Math.floor(r.right)
              },
              u = 'bottom' === n ? 'top' : 'bottom',
              f = 'right' === i ? 'left' : 'right',
              h = lt('transform'),
              d = void 0,
              p = void 0;
            if (
              ((p = 'bottom' === u ? -a.height + c.bottom : c.top),
              (d = 'right' === f ? -a.width + c.right : c.left),
              s && h)
            )
              (l[h] = 'translate3d(' + d + 'px, ' + p + 'px, 0)'),
                (l[u] = 0),
                (l[f] = 0),
                (l.willChange = 'transform');
            else {
              var m = 'bottom' === u ? -1 : 1,
                g = 'right' === f ? -1 : 1;
              (l[u] = p * m), (l[f] = d * g), (l.willChange = u + ', ' + f);
            }
            var _ = {'x-placement': e.placement};
            return (
              (e.attributes = ze({}, _, e.attributes)),
              (e.styles = ze({}, l, e.styles)),
              (e.arrowStyles = ze({}, e.offsets.arrow, e.arrowStyles)),
              e
            );
          },
          gpuAcceleration: !0,
          x: 'bottom',
          y: 'right'
        },
        applyStyle: {
          order: 900,
          enabled: !0,
          fn: function (e) {
            var t, n;
            return (
              dt(e.instance.popper, e.styles),
              (t = e.instance.popper),
              (n = e.attributes),
              Object.keys(n).forEach(function (e) {
                !1 !== n[e] ? t.setAttribute(e, n[e]) : t.removeAttribute(e);
              }),
              e.arrowElement &&
                Object.keys(e.arrowStyles).length &&
                dt(e.arrowElement, e.arrowStyles),
              e
            );
          },
          onLoad: function (e, t, n, i, r) {
            var o = tt(r, t, e, n.positionFixed),
              s = et(
                n.placement,
                o,
                t,
                e,
                n.modifiers.flip.boundariesElement,
                n.modifiers.flip.padding
              );
            return (
              t.setAttribute('x-placement', s),
              dt(t, {position: n.positionFixed ? 'fixed' : 'absolute'}),
              n
            );
          },
          gpuAcceleration: void 0
        }
      }
    },
    Ct = (function () {
      function o(e, t) {
        var n = this,
          i = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : {};
        !(function (e, t) {
          if (!(e instanceof t)) throw new TypeError('Cannot call a class as a function');
        })(this, o),
          (this.scheduleUpdate = function () {
            return requestAnimationFrame(n.update);
          }),
          (this.update = ke(this.update.bind(this))),
          (this.options = ze({}, o.Defaults, i)),
          (this.state = {isDestroyed: !1, isCreated: !1, scrollParents: []}),
          (this.reference = e && e.jquery ? e[0] : e),
          (this.popper = t && t.jquery ? t[0] : t),
          (this.options.modifiers = {}),
          Object.keys(ze({}, o.Defaults.modifiers, i.modifiers)).forEach(function (e) {
            n.options.modifiers[e] = ze(
              {},
              o.Defaults.modifiers[e] || {},
              i.modifiers ? i.modifiers[e] : {}
            );
          }),
          (this.modifiers = Object.keys(this.options.modifiers)
            .map(function (e) {
              return ze({name: e}, n.options.modifiers[e]);
            })
            .sort(function (e, t) {
              return e.order - t.order;
            })),
          this.modifiers.forEach(function (e) {
            e.enabled && xe(e.onLoad) && e.onLoad(n.reference, n.popper, n.options, e, n.state);
          }),
          this.update();
        var r = this.options.eventsEnabled;
        r && this.enableEventListeners(), (this.state.eventsEnabled = r);
      }
      return (
        Ye(o, [
          {
            key: 'update',
            value: function () {
              return function () {
                if (!this.state.isDestroyed) {
                  var e = {
                    instance: this,
                    styles: {},
                    arrowStyles: {},
                    attributes: {},
                    flipped: !1,
                    offsets: {}
                  };
                  (e.offsets.reference = tt(
                    this.state,
                    this.popper,
                    this.reference,
                    this.options.positionFixed
                  )),
                    (e.placement = et(
                      this.options.placement,
                      e.offsets.reference,
                      this.popper,
                      this.reference,
                      this.options.modifiers.flip.boundariesElement,
                      this.options.modifiers.flip.padding
                    )),
                    (e.originalPlacement = e.placement),
                    (e.positionFixed = this.options.positionFixed),
                    (e.offsets.popper = rt(this.popper, e.offsets.reference, e.placement)),
                    (e.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute'),
                    (e = st(this.modifiers, e)),
                    this.state.isCreated
                      ? this.options.onUpdate(e)
                      : ((this.state.isCreated = !0), this.options.onCreate(e));
                }
              }.call(this);
            }
          },
          {
            key: 'destroy',
            value: function () {
              return function () {
                return (
                  (this.state.isDestroyed = !0),
                  at(this.modifiers, 'applyStyle') &&
                    (this.popper.removeAttribute('x-placement'),
                    (this.popper.style.position = ''),
                    (this.popper.style.top = ''),
                    (this.popper.style.left = ''),
                    (this.popper.style.right = ''),
                    (this.popper.style.bottom = ''),
                    (this.popper.style.willChange = ''),
                    (this.popper.style[lt('transform')] = '')),
                  this.disableEventListeners(),
                  this.options.removeOnDestroy && this.popper.parentNode.removeChild(this.popper),
                  this
                );
              }.call(this);
            }
          },
          {
            key: 'enableEventListeners',
            value: function () {
              return function () {
                this.state.eventsEnabled ||
                  (this.state = ut(this.reference, this.options, this.state, this.scheduleUpdate));
              }.call(this);
            }
          },
          {
            key: 'disableEventListeners',
            value: function () {
              return ft.call(this);
            }
          }
        ]),
        o
      );
    })();
  (Ct.Utils = ('undefined' != typeof window ? window : global).PopperUtils),
    (Ct.placements = mt),
    (Ct.Defaults = wt);
  var Tt,
    St,
    Dt,
    At,
    It,
    Ot,
    Nt,
    kt,
    xt,
    Pt,
    Lt,
    jt,
    Ht,
    Mt,
    Ft,
    Wt,
    Rt,
    Ut,
    Bt,
    qt,
    Kt,
    Qt,
    Yt,
    Vt,
    zt,
    Gt,
    Jt,
    Zt,
    Xt,
    $t,
    en,
    tn,
    nn,
    rn,
    on,
    sn,
    an,
    ln,
    cn,
    un,
    fn,
    hn,
    dn,
    pn,
    mn,
    gn,
    _n,
    vn,
    yn,
    En,
    bn,
    wn,
    Cn,
    Tn,
    Sn,
    Dn,
    An,
    In,
    On,
    Nn,
    kn,
    xn,
    Pn,
    Ln,
    jn,
    Hn,
    Mn,
    Fn,
    Wn,
    Rn,
    Un,
    Bn,
    qn,
    Kn,
    Qn,
    Yn,
    Vn,
    zn,
    Gn,
    Jn,
    Zn,
    Xn,
    $n,
    ei,
    ti,
    ni,
    ii,
    ri,
    oi,
    si,
    ai,
    li,
    ci,
    ui,
    fi,
    hi,
    di,
    pi,
    mi,
    gi,
    _i,
    vi,
    yi,
    Ei,
    bi,
    wi,
    Ci,
    Ti,
    Si,
    Di,
    Ai,
    Ii,
    Oi,
    Ni,
    ki,
    xi,
    Pi,
    Li,
    ji,
    Hi,
    Mi,
    Fi,
    Wi,
    Ri,
    Ui,
    Bi =
      ((St = 'dropdown'),
      (At = '.' + (Dt = 'bs.dropdown')),
      (It = '.data-api'),
      (Ot = (Tt = t).fn[St]),
      (Nt = new RegExp('38|40|27')),
      (kt = {
        HIDE: 'hide' + At,
        HIDDEN: 'hidden' + At,
        SHOW: 'show' + At,
        SHOWN: 'shown' + At,
        CLICK: 'click' + At,
        CLICK_DATA_API: 'click' + At + It,
        KEYDOWN_DATA_API: 'keydown' + At + It,
        KEYUP_DATA_API: 'keyup' + At + It
      }),
      (xt = 'disabled'),
      (Pt = 'show'),
      (Lt = 'dropup'),
      (jt = 'dropright'),
      (Ht = 'dropleft'),
      (Mt = 'dropdown-menu-right'),
      (Ft = 'position-static'),
      (Wt = '[data-toggle="dropdown"]'),
      (Rt = '.dropdown form'),
      (Ut = '.dropdown-menu'),
      (Bt = '.navbar-nav'),
      (qt = '.dropdown-menu .dropdown-item:not(.disabled):not(:disabled)'),
      (Kt = 'top-start'),
      (Qt = 'top-end'),
      (Yt = 'bottom-start'),
      (Vt = 'bottom-end'),
      (zt = 'right-start'),
      (Gt = 'left-start'),
      (Jt = {
        offset: 0,
        flip: !0,
        boundary: 'scrollParent',
        reference: 'toggle',
        display: 'dynamic'
      }),
      (Zt = {
        offset: '(number|string|function)',
        flip: 'boolean',
        boundary: '(string|element)',
        reference: '(string|element)',
        display: 'string'
      }),
      (Xt = (function () {
        function c(e, t) {
          (this._element = e),
            (this._popper = null),
            (this._config = this._getConfig(t)),
            (this._menu = this._getMenuElement()),
            (this._inNavbar = this._detectNavbar()),
            this._addEventListeners();
        }
        var e = c.prototype;
        return (
          (e.toggle = function () {
            if (!this._element.disabled && !Tt(this._element).hasClass(xt)) {
              var e = c._getParentFromElement(this._element),
                t = Tt(this._menu).hasClass(Pt);
              if ((c._clearMenus(), !t)) {
                var n = {relatedTarget: this._element},
                  i = Tt.Event(kt.SHOW, n);
                if ((Tt(e).trigger(i), !i.isDefaultPrevented())) {
                  if (!this._inNavbar) {
                    if ('undefined' == typeof Ct)
                      throw new TypeError(
                        'Bootstrap dropdown require Popper.js (https://popper.js.org)'
                      );
                    var r = this._element;
                    'parent' === this._config.reference
                      ? (r = e)
                      : we.isElement(this._config.reference) &&
                        ((r = this._config.reference),
                        'undefined' != typeof this._config.reference.jquery &&
                          (r = this._config.reference[0])),
                      'scrollParent' !== this._config.boundary && Tt(e).addClass(Ft),
                      (this._popper = new Ct(r, this._menu, this._getPopperConfig()));
                  }
                  'ontouchstart' in document.documentElement &&
                    0 === Tt(e).closest(Bt).length &&
                    Tt(document.body).children().on('mouseover', null, Tt.noop),
                    this._element.focus(),
                    this._element.setAttribute('aria-expanded', !0),
                    Tt(this._menu).toggleClass(Pt),
                    Tt(e).toggleClass(Pt).trigger(Tt.Event(kt.SHOWN, n));
                }
              }
            }
          }),
          (e.dispose = function () {
            Tt.removeData(this._element, Dt),
              Tt(this._element).off(At),
              (this._element = null),
              (this._menu = null) !== this._popper &&
                (this._popper.destroy(), (this._popper = null));
          }),
          (e.update = function () {
            (this._inNavbar = this._detectNavbar()),
              null !== this._popper && this._popper.scheduleUpdate();
          }),
          (e._addEventListeners = function () {
            var t = this;
            Tt(this._element).on(kt.CLICK, function (e) {
              e.preventDefault(), e.stopPropagation(), t.toggle();
            });
          }),
          (e._getConfig = function (e) {
            return (
              (e = l({}, this.constructor.Default, Tt(this._element).data(), e)),
              we.typeCheckConfig(St, e, this.constructor.DefaultType),
              e
            );
          }),
          (e._getMenuElement = function () {
            if (!this._menu) {
              var e = c._getParentFromElement(this._element);
              e && (this._menu = e.querySelector(Ut));
            }
            return this._menu;
          }),
          (e._getPlacement = function () {
            var e = Tt(this._element.parentNode),
              t = Yt;
            return (
              e.hasClass(Lt)
                ? ((t = Kt), Tt(this._menu).hasClass(Mt) && (t = Qt))
                : e.hasClass(jt)
                ? (t = zt)
                : e.hasClass(Ht)
                ? (t = Gt)
                : Tt(this._menu).hasClass(Mt) && (t = Vt),
              t
            );
          }),
          (e._detectNavbar = function () {
            return 0 < Tt(this._element).closest('.navbar').length;
          }),
          (e._getPopperConfig = function () {
            var t = this,
              e = {};
            'function' == typeof this._config.offset
              ? (e.fn = function (e) {
                  return (e.offsets = l({}, e.offsets, t._config.offset(e.offsets) || {})), e;
                })
              : (e.offset = this._config.offset);
            var n = {
              placement: this._getPlacement(),
              modifiers: {
                offset: e,
                flip: {enabled: this._config.flip},
                preventOverflow: {boundariesElement: this._config.boundary}
              }
            };
            return 'static' === this._config.display && (n.modifiers.applyStyle = {enabled: !1}), n;
          }),
          (c._jQueryInterface = function (t) {
            return this.each(function () {
              var e = Tt(this).data(Dt);
              if (
                (e || ((e = new c(this, 'object' == typeof t ? t : null)), Tt(this).data(Dt, e)),
                'string' == typeof t)
              ) {
                if ('undefined' == typeof e[t]) throw new TypeError('No method named "' + t + '"');
                e[t]();
              }
            });
          }),
          (c._clearMenus = function (e) {
            if (!e || (3 !== e.which && ('keyup' !== e.type || 9 === e.which)))
              for (
                var t = [].slice.call(document.querySelectorAll(Wt)), n = 0, i = t.length;
                n < i;
                n++
              ) {
                var r = c._getParentFromElement(t[n]),
                  o = Tt(t[n]).data(Dt),
                  s = {relatedTarget: t[n]};
                if ((e && 'click' === e.type && (s.clickEvent = e), o)) {
                  var a = o._menu;
                  if (
                    Tt(r).hasClass(Pt) &&
                    !(
                      e &&
                      (('click' === e.type && /input|textarea/i.test(e.target.tagName)) ||
                        ('keyup' === e.type && 9 === e.which)) &&
                      Tt.contains(r, e.target)
                    )
                  ) {
                    var l = Tt.Event(kt.HIDE, s);
                    Tt(r).trigger(l),
                      l.isDefaultPrevented() ||
                        ('ontouchstart' in document.documentElement &&
                          Tt(document.body).children().off('mouseover', null, Tt.noop),
                        t[n].setAttribute('aria-expanded', 'false'),
                        Tt(a).removeClass(Pt),
                        Tt(r).removeClass(Pt).trigger(Tt.Event(kt.HIDDEN, s)));
                  }
                }
              }
          }),
          (c._getParentFromElement = function (e) {
            var t,
              n = we.getSelectorFromElement(e);
            return n && (t = document.querySelector(n)), t || e.parentNode;
          }),
          (c._dataApiKeydownHandler = function (e) {
            if (
              (/input|textarea/i.test(e.target.tagName)
                ? !(
                    32 === e.which ||
                    (27 !== e.which &&
                      ((40 !== e.which && 38 !== e.which) || Tt(e.target).closest(Ut).length))
                  )
                : Nt.test(e.which)) &&
              (e.preventDefault(), e.stopPropagation(), !this.disabled && !Tt(this).hasClass(xt))
            ) {
              var t = c._getParentFromElement(this),
                n = Tt(t).hasClass(Pt);
              if (
                (n || (27 === e.which && 32 === e.which)) &&
                (!n || (27 !== e.which && 32 !== e.which))
              ) {
                var i = [].slice.call(t.querySelectorAll(qt));
                if (0 !== i.length) {
                  var r = i.indexOf(e.target);
                  38 === e.which && 0 < r && r--,
                    40 === e.which && r < i.length - 1 && r++,
                    r < 0 && (r = 0),
                    i[r].focus();
                }
              } else {
                if (27 === e.which) {
                  var o = t.querySelector(Wt);
                  Tt(o).trigger('focus');
                }
                Tt(this).trigger('click');
              }
            }
          }),
          s(c, null, [
            {
              key: 'VERSION',
              get: function () {
                return '4.1.3';
              }
            },
            {
              key: 'Default',
              get: function () {
                return Jt;
              }
            },
            {
              key: 'DefaultType',
              get: function () {
                return Zt;
              }
            }
          ]),
          c
        );
      })()),
      Tt(document)
        .on(kt.KEYDOWN_DATA_API, Wt, Xt._dataApiKeydownHandler)
        .on(kt.KEYDOWN_DATA_API, Ut, Xt._dataApiKeydownHandler)
        .on(kt.CLICK_DATA_API + ' ' + kt.KEYUP_DATA_API, Xt._clearMenus)
        .on(kt.CLICK_DATA_API, Wt, function (e) {
          e.preventDefault(), e.stopPropagation(), Xt._jQueryInterface.call(Tt(this), 'toggle');
        })
        .on(kt.CLICK_DATA_API, Rt, function (e) {
          e.stopPropagation();
        }),
      (Tt.fn[St] = Xt._jQueryInterface),
      (Tt.fn[St].Constructor = Xt),
      (Tt.fn[St].noConflict = function () {
        return (Tt.fn[St] = Ot), Xt._jQueryInterface;
      }),
      Xt),
    qi =
      ((en = 'modal'),
      (nn = '.' + (tn = 'bs.modal')),
      (rn = ($t = t).fn[en]),
      (on = {backdrop: !0, keyboard: !0, focus: !0, show: !0}),
      (sn = {backdrop: '(boolean|string)', keyboard: 'boolean', focus: 'boolean', show: 'boolean'}),
      (an = {
        HIDE: 'hide' + nn,
        HIDDEN: 'hidden' + nn,
        SHOW: 'show' + nn,
        SHOWN: 'shown' + nn,
        FOCUSIN: 'focusin' + nn,
        RESIZE: 'resize' + nn,
        CLICK_DISMISS: 'click.dismiss' + nn,
        KEYDOWN_DISMISS: 'keydown.dismiss' + nn,
        MOUSEUP_DISMISS: 'mouseup.dismiss' + nn,
        MOUSEDOWN_DISMISS: 'mousedown.dismiss' + nn,
        CLICK_DATA_API: 'click' + nn + '.data-api'
      }),
      (ln = 'modal-scrollbar-measure'),
      (cn = 'modal-backdrop'),
      (un = 'modal-open'),
      (fn = 'fade'),
      (hn = 'show'),
      (dn = '.modal-dialog'),
      (pn = '[data-toggle="modal"]'),
      (mn = '[data-dismiss="modal"]'),
      (gn = '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top'),
      (_n = '.sticky-top'),
      (vn = (function () {
        function r(e, t) {
          (this._config = this._getConfig(t)),
            (this._element = e),
            (this._dialog = e.querySelector(dn)),
            (this._backdrop = null),
            (this._isShown = !1),
            (this._isBodyOverflowing = !1),
            (this._ignoreBackdropClick = !1),
            (this._scrollbarWidth = 0);
        }
        var e = r.prototype;
        return (
          (e.toggle = function (e) {
            return this._isShown ? this.hide() : this.show(e);
          }),
          (e.show = function (e) {
            var t = this;
            if (!this._isTransitioning && !this._isShown) {
              $t(this._element).hasClass(fn) && (this._isTransitioning = !0);
              var n = $t.Event(an.SHOW, {relatedTarget: e});
              $t(this._element).trigger(n),
                this._isShown ||
                  n.isDefaultPrevented() ||
                  ((this._isShown = !0),
                  this._checkScrollbar(),
                  this._setScrollbar(),
                  this._adjustDialog(),
                  $t(document.body).addClass(un),
                  this._setEscapeEvent(),
                  this._setResizeEvent(),
                  $t(this._element).on(an.CLICK_DISMISS, mn, function (e) {
                    return t.hide(e);
                  }),
                  $t(this._dialog).on(an.MOUSEDOWN_DISMISS, function () {
                    $t(t._element).one(an.MOUSEUP_DISMISS, function (e) {
                      $t(e.target).is(t._element) && (t._ignoreBackdropClick = !0);
                    });
                  }),
                  this._showBackdrop(function () {
                    return t._showElement(e);
                  }));
            }
          }),
          (e.hide = function (e) {
            var t = this;
            if ((e && e.preventDefault(), !this._isTransitioning && this._isShown)) {
              var n = $t.Event(an.HIDE);
              if (($t(this._element).trigger(n), this._isShown && !n.isDefaultPrevented())) {
                this._isShown = !1;
                var i = $t(this._element).hasClass(fn);
                if (
                  (i && (this._isTransitioning = !0),
                  this._setEscapeEvent(),
                  this._setResizeEvent(),
                  $t(document).off(an.FOCUSIN),
                  $t(this._element).removeClass(hn),
                  $t(this._element).off(an.CLICK_DISMISS),
                  $t(this._dialog).off(an.MOUSEDOWN_DISMISS),
                  i)
                ) {
                  var r = we.getTransitionDurationFromElement(this._element);
                  $t(this._element)
                    .one(we.TRANSITION_END, function (e) {
                      return t._hideModal(e);
                    })
                    .emulateTransitionEnd(r);
                } else this._hideModal();
              }
            }
          }),
          (e.dispose = function () {
            $t.removeData(this._element, tn),
              $t(window, document, this._element, this._backdrop).off(nn),
              (this._config = null),
              (this._element = null),
              (this._dialog = null),
              (this._backdrop = null),
              (this._isShown = null),
              (this._isBodyOverflowing = null),
              (this._ignoreBackdropClick = null),
              (this._scrollbarWidth = null);
          }),
          (e.handleUpdate = function () {
            this._adjustDialog();
          }),
          (e._getConfig = function (e) {
            return (e = l({}, on, e)), we.typeCheckConfig(en, e, sn), e;
          }),
          (e._showElement = function (e) {
            var t = this,
              n = $t(this._element).hasClass(fn);
            (this._element.parentNode && this._element.parentNode.nodeType === Node.ELEMENT_NODE) ||
              document.body.appendChild(this._element),
              (this._element.style.display = 'block'),
              this._element.removeAttribute('aria-hidden'),
              (this._element.scrollTop = 0),
              n && we.reflow(this._element),
              $t(this._element).addClass(hn),
              this._config.focus && this._enforceFocus();
            var i = $t.Event(an.SHOWN, {relatedTarget: e}),
              r = function () {
                t._config.focus && t._element.focus(),
                  (t._isTransitioning = !1),
                  $t(t._element).trigger(i);
              };
            if (n) {
              var o = we.getTransitionDurationFromElement(this._element);
              $t(this._dialog).one(we.TRANSITION_END, r).emulateTransitionEnd(o);
            } else r();
          }),
          (e._enforceFocus = function () {
            var t = this;
            $t(document)
              .off(an.FOCUSIN)
              .on(an.FOCUSIN, function (e) {
                document !== e.target &&
                  t._element !== e.target &&
                  0 === $t(t._element).has(e.target).length &&
                  t._element.focus();
              });
          }),
          (e._setEscapeEvent = function () {
            var t = this;
            this._isShown && this._config.keyboard
              ? $t(this._element).on(an.KEYDOWN_DISMISS, function (e) {
                  27 === e.which && (e.preventDefault(), t.hide());
                })
              : this._isShown || $t(this._element).off(an.KEYDOWN_DISMISS);
          }),
          (e._setResizeEvent = function () {
            var t = this;
            this._isShown
              ? $t(window).on(an.RESIZE, function (e) {
                  return t.handleUpdate(e);
                })
              : $t(window).off(an.RESIZE);
          }),
          (e._hideModal = function () {
            var e = this;
            (this._element.style.display = 'none'),
              this._element.setAttribute('aria-hidden', !0),
              (this._isTransitioning = !1),
              this._showBackdrop(function () {
                $t(document.body).removeClass(un),
                  e._resetAdjustments(),
                  e._resetScrollbar(),
                  $t(e._element).trigger(an.HIDDEN);
              });
          }),
          (e._removeBackdrop = function () {
            this._backdrop && ($t(this._backdrop).remove(), (this._backdrop = null));
          }),
          (e._showBackdrop = function (e) {
            var t = this,
              n = $t(this._element).hasClass(fn) ? fn : '';
            if (this._isShown && this._config.backdrop) {
              if (
                ((this._backdrop = document.createElement('div')),
                (this._backdrop.className = cn),
                n && this._backdrop.classList.add(n),
                $t(this._backdrop).appendTo(document.body),
                $t(this._element).on(an.CLICK_DISMISS, function (e) {
                  t._ignoreBackdropClick
                    ? (t._ignoreBackdropClick = !1)
                    : e.target === e.currentTarget &&
                      ('static' === t._config.backdrop ? t._element.focus() : t.hide());
                }),
                n && we.reflow(this._backdrop),
                $t(this._backdrop).addClass(hn),
                !e)
              )
                return;
              if (!n) return void e();
              var i = we.getTransitionDurationFromElement(this._backdrop);
              $t(this._backdrop).one(we.TRANSITION_END, e).emulateTransitionEnd(i);
            } else if (!this._isShown && this._backdrop) {
              $t(this._backdrop).removeClass(hn);
              var r = function () {
                t._removeBackdrop(), e && e();
              };
              if ($t(this._element).hasClass(fn)) {
                var o = we.getTransitionDurationFromElement(this._backdrop);
                $t(this._backdrop).one(we.TRANSITION_END, r).emulateTransitionEnd(o);
              } else r();
            } else e && e();
          }),
          (e._adjustDialog = function () {
            var e = this._element.scrollHeight > document.documentElement.clientHeight;
            !this._isBodyOverflowing &&
              e &&
              (this._element.style.paddingLeft = this._scrollbarWidth + 'px'),
              this._isBodyOverflowing &&
                !e &&
                (this._element.style.paddingRight = this._scrollbarWidth + 'px');
          }),
          (e._resetAdjustments = function () {
            (this._element.style.paddingLeft = ''), (this._element.style.paddingRight = '');
          }),
          (e._checkScrollbar = function () {
            var e = document.body.getBoundingClientRect();
            (this._isBodyOverflowing = e.left + e.right < window.innerWidth),
              (this._scrollbarWidth = this._getScrollbarWidth());
          }),
          (e._setScrollbar = function () {
            var r = this;
            if (this._isBodyOverflowing) {
              var e = [].slice.call(document.querySelectorAll(gn)),
                t = [].slice.call(document.querySelectorAll(_n));
              $t(e).each(function (e, t) {
                var n = t.style.paddingRight,
                  i = $t(t).css('padding-right');
                $t(t)
                  .data('padding-right', n)
                  .css('padding-right', parseFloat(i) + r._scrollbarWidth + 'px');
              }),
                $t(t).each(function (e, t) {
                  var n = t.style.marginRight,
                    i = $t(t).css('margin-right');
                  $t(t)
                    .data('margin-right', n)
                    .css('margin-right', parseFloat(i) - r._scrollbarWidth + 'px');
                });
              var n = document.body.style.paddingRight,
                i = $t(document.body).css('padding-right');
              $t(document.body)
                .data('padding-right', n)
                .css('padding-right', parseFloat(i) + this._scrollbarWidth + 'px');
            }
          }),
          (e._resetScrollbar = function () {
            var e = [].slice.call(document.querySelectorAll(gn));
            $t(e).each(function (e, t) {
              var n = $t(t).data('padding-right');
              $t(t).removeData('padding-right'), (t.style.paddingRight = n || '');
            });
            var t = [].slice.call(document.querySelectorAll('' + _n));
            $t(t).each(function (e, t) {
              var n = $t(t).data('margin-right');
              'undefined' != typeof n && $t(t).css('margin-right', n).removeData('margin-right');
            });
            var n = $t(document.body).data('padding-right');
            $t(document.body).removeData('padding-right'),
              (document.body.style.paddingRight = n || '');
          }),
          (e._getScrollbarWidth = function () {
            var e = document.createElement('div');
            (e.className = ln), document.body.appendChild(e);
            var t = e.getBoundingClientRect().width - e.clientWidth;
            return document.body.removeChild(e), t;
          }),
          (r._jQueryInterface = function (n, i) {
            return this.each(function () {
              var e = $t(this).data(tn),
                t = l({}, on, $t(this).data(), 'object' == typeof n && n ? n : {});
              if ((e || ((e = new r(this, t)), $t(this).data(tn, e)), 'string' == typeof n)) {
                if ('undefined' == typeof e[n]) throw new TypeError('No method named "' + n + '"');
                e[n](i);
              } else t.show && e.show(i);
            });
          }),
          s(r, null, [
            {
              key: 'VERSION',
              get: function () {
                return '4.1.3';
              }
            },
            {
              key: 'Default',
              get: function () {
                return on;
              }
            }
          ]),
          r
        );
      })()),
      $t(document).on(an.CLICK_DATA_API, pn, function (e) {
        var t,
          n = this,
          i = we.getSelectorFromElement(this);
        i && (t = document.querySelector(i));
        var r = $t(t).data(tn) ? 'toggle' : l({}, $t(t).data(), $t(this).data());
        ('A' !== this.tagName && 'AREA' !== this.tagName) || e.preventDefault();
        var o = $t(t).one(an.SHOW, function (e) {
          e.isDefaultPrevented() ||
            o.one(an.HIDDEN, function () {
              $t(n).is(':visible') && n.focus();
            });
        });
        vn._jQueryInterface.call($t(t), r, this);
      }),
      ($t.fn[en] = vn._jQueryInterface),
      ($t.fn[en].Constructor = vn),
      ($t.fn[en].noConflict = function () {
        return ($t.fn[en] = rn), vn._jQueryInterface;
      }),
      vn),
    Ki =
      ((En = 'tooltip'),
      (wn = '.' + (bn = 'bs.tooltip')),
      (Cn = (yn = t).fn[En]),
      (Tn = 'bs-tooltip'),
      (Sn = new RegExp('(^|\\s)' + Tn + '\\S+', 'g')),
      (In = {
        animation: !0,
        template:
          '<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>',
        trigger: 'hover focus',
        title: '',
        delay: 0,
        html: !(An = {AUTO: 'auto', TOP: 'top', RIGHT: 'right', BOTTOM: 'bottom', LEFT: 'left'}),
        selector: !(Dn = {
          animation: 'boolean',
          template: 'string',
          title: '(string|element|function)',
          trigger: 'string',
          delay: '(number|object)',
          html: 'boolean',
          selector: '(string|boolean)',
          placement: '(string|function)',
          offset: '(number|string)',
          container: '(string|element|boolean)',
          fallbackPlacement: '(string|array)',
          boundary: '(string|element)'
        }),
        placement: 'top',
        offset: 0,
        container: !1,
        fallbackPlacement: 'flip',
        boundary: 'scrollParent'
      }),
      (Nn = 'out'),
      (kn = {
        HIDE: 'hide' + wn,
        HIDDEN: 'hidden' + wn,
        SHOW: (On = 'show') + wn,
        SHOWN: 'shown' + wn,
        INSERTED: 'inserted' + wn,
        CLICK: 'click' + wn,
        FOCUSIN: 'focusin' + wn,
        FOCUSOUT: 'focusout' + wn,
        MOUSEENTER: 'mouseenter' + wn,
        MOUSELEAVE: 'mouseleave' + wn
      }),
      (xn = 'fade'),
      (Pn = 'show'),
      (Ln = '.tooltip-inner'),
      (jn = '.arrow'),
      (Hn = 'hover'),
      (Mn = 'focus'),
      (Fn = 'click'),
      (Wn = 'manual'),
      (Rn = (function () {
        function i(e, t) {
          if ('undefined' == typeof Ct)
            throw new TypeError('Bootstrap tooltips require Popper.js (https://popper.js.org)');
          (this._isEnabled = !0),
            (this._timeout = 0),
            (this._hoverState = ''),
            (this._activeTrigger = {}),
            (this._popper = null),
            (this.element = e),
            (this.config = this._getConfig(t)),
            (this.tip = null),
            this._setListeners();
        }
        var e = i.prototype;
        return (
          (e.enable = function () {
            this._isEnabled = !0;
          }),
          (e.disable = function () {
            this._isEnabled = !1;
          }),
          (e.toggleEnabled = function () {
            this._isEnabled = !this._isEnabled;
          }),
          (e.toggle = function (e) {
            if (this._isEnabled)
              if (e) {
                var t = this.constructor.DATA_KEY,
                  n = yn(e.currentTarget).data(t);
                n ||
                  ((n = new this.constructor(e.currentTarget, this._getDelegateConfig())),
                  yn(e.currentTarget).data(t, n)),
                  (n._activeTrigger.click = !n._activeTrigger.click),
                  n._isWithActiveTrigger() ? n._enter(null, n) : n._leave(null, n);
              } else {
                if (yn(this.getTipElement()).hasClass(Pn)) return void this._leave(null, this);
                this._enter(null, this);
              }
          }),
          (e.dispose = function () {
            clearTimeout(this._timeout),
              yn.removeData(this.element, this.constructor.DATA_KEY),
              yn(this.element).off(this.constructor.EVENT_KEY),
              yn(this.element).closest('.modal').off('hide.bs.modal'),
              this.tip && yn(this.tip).remove(),
              (this._isEnabled = null),
              (this._timeout = null),
              (this._hoverState = null),
              (this._activeTrigger = null) !== this._popper && this._popper.destroy(),
              (this._popper = null),
              (this.element = null),
              (this.config = null),
              (this.tip = null);
          }),
          (e.show = function () {
            var t = this;
            if ('none' === yn(this.element).css('display'))
              throw new Error('Please use show on visible elements');
            var e = yn.Event(this.constructor.Event.SHOW);
            if (this.isWithContent() && this._isEnabled) {
              yn(this.element).trigger(e);
              var n = yn.contains(this.element.ownerDocument.documentElement, this.element);
              if (e.isDefaultPrevented() || !n) return;
              var i = this.getTipElement(),
                r = we.getUID(this.constructor.NAME);
              i.setAttribute('id', r),
                this.element.setAttribute('aria-describedby', r),
                this.setContent(),
                this.config.animation && yn(i).addClass(xn);
              var o =
                  'function' == typeof this.config.placement
                    ? this.config.placement.call(this, i, this.element)
                    : this.config.placement,
                s = this._getAttachment(o);
              this.addAttachmentClass(s);
              var a =
                !1 === this.config.container
                  ? document.body
                  : yn(document).find(this.config.container);
              yn(i).data(this.constructor.DATA_KEY, this),
                yn.contains(this.element.ownerDocument.documentElement, this.tip) ||
                  yn(i).appendTo(a),
                yn(this.element).trigger(this.constructor.Event.INSERTED),
                (this._popper = new Ct(this.element, i, {
                  placement: s,
                  modifiers: {
                    offset: {offset: this.config.offset},
                    flip: {behavior: this.config.fallbackPlacement},
                    arrow: {element: jn},
                    preventOverflow: {boundariesElement: this.config.boundary}
                  },
                  onCreate: function (e) {
                    e.originalPlacement !== e.placement && t._handlePopperPlacementChange(e);
                  },
                  onUpdate: function (e) {
                    t._handlePopperPlacementChange(e);
                  }
                })),
                yn(i).addClass(Pn),
                'ontouchstart' in document.documentElement &&
                  yn(document.body).children().on('mouseover', null, yn.noop);
              var l = function () {
                t.config.animation && t._fixTransition();
                var e = t._hoverState;
                (t._hoverState = null),
                  yn(t.element).trigger(t.constructor.Event.SHOWN),
                  e === Nn && t._leave(null, t);
              };
              if (yn(this.tip).hasClass(xn)) {
                var c = we.getTransitionDurationFromElement(this.tip);
                yn(this.tip).one(we.TRANSITION_END, l).emulateTransitionEnd(c);
              } else l();
            }
          }),
          (e.hide = function (e) {
            var t = this,
              n = this.getTipElement(),
              i = yn.Event(this.constructor.Event.HIDE),
              r = function () {
                t._hoverState !== On && n.parentNode && n.parentNode.removeChild(n),
                  t._cleanTipClass(),
                  t.element.removeAttribute('aria-describedby'),
                  yn(t.element).trigger(t.constructor.Event.HIDDEN),
                  null !== t._popper && t._popper.destroy(),
                  e && e();
              };
            if ((yn(this.element).trigger(i), !i.isDefaultPrevented())) {
              if (
                (yn(n).removeClass(Pn),
                'ontouchstart' in document.documentElement &&
                  yn(document.body).children().off('mouseover', null, yn.noop),
                (this._activeTrigger[Fn] = !1),
                (this._activeTrigger[Mn] = !1),
                (this._activeTrigger[Hn] = !1),
                yn(this.tip).hasClass(xn))
              ) {
                var o = we.getTransitionDurationFromElement(n);
                yn(n).one(we.TRANSITION_END, r).emulateTransitionEnd(o);
              } else r();
              this._hoverState = '';
            }
          }),
          (e.update = function () {
            null !== this._popper && this._popper.scheduleUpdate();
          }),
          (e.isWithContent = function () {
            return Boolean(this.getTitle());
          }),
          (e.addAttachmentClass = function (e) {
            yn(this.getTipElement()).addClass(Tn + '-' + e);
          }),
          (e.getTipElement = function () {
            return (this.tip = this.tip || yn(this.config.template)[0]), this.tip;
          }),
          (e.setContent = function () {
            var e = this.getTipElement();
            this.setElementContent(yn(e.querySelectorAll(Ln)), this.getTitle()),
              yn(e).removeClass(xn + ' ' + Pn);
          }),
          (e.setElementContent = function (e, t) {
            var n = this.config.html;
            'object' == typeof t && (t.nodeType || t.jquery)
              ? n
                ? yn(t).parent().is(e) || e.empty().append(t)
                : e.text(yn(t).text())
              : e[n ? 'html' : 'text'](t);
          }),
          (e.getTitle = function () {
            var e = this.element.getAttribute('data-original-title');
            return (
              e ||
                (e =
                  'function' == typeof this.config.title
                    ? this.config.title.call(this.element)
                    : this.config.title),
              e
            );
          }),
          (e._getAttachment = function (e) {
            return An[e.toUpperCase()];
          }),
          (e._setListeners = function () {
            var i = this;
            this.config.trigger.split(' ').forEach(function (e) {
              if ('click' === e)
                yn(i.element).on(i.constructor.Event.CLICK, i.config.selector, function (e) {
                  return i.toggle(e);
                });
              else if (e !== Wn) {
                var t = e === Hn ? i.constructor.Event.MOUSEENTER : i.constructor.Event.FOCUSIN,
                  n = e === Hn ? i.constructor.Event.MOUSELEAVE : i.constructor.Event.FOCUSOUT;
                yn(i.element)
                  .on(t, i.config.selector, function (e) {
                    return i._enter(e);
                  })
                  .on(n, i.config.selector, function (e) {
                    return i._leave(e);
                  });
              }
              yn(i.element)
                .closest('.modal')
                .on('hide.bs.modal', function () {
                  return i.hide();
                });
            }),
              this.config.selector
                ? (this.config = l({}, this.config, {trigger: 'manual', selector: ''}))
                : this._fixTitle();
          }),
          (e._fixTitle = function () {
            var e = typeof this.element.getAttribute('data-original-title');
            (this.element.getAttribute('title') || 'string' !== e) &&
              (this.element.setAttribute(
                'data-original-title',
                this.element.getAttribute('title') || ''
              ),
              this.element.setAttribute('title', ''));
          }),
          (e._enter = function (e, t) {
            var n = this.constructor.DATA_KEY;
            (t = t || yn(e.currentTarget).data(n)) ||
              ((t = new this.constructor(e.currentTarget, this._getDelegateConfig())),
              yn(e.currentTarget).data(n, t)),
              e && (t._activeTrigger['focusin' === e.type ? Mn : Hn] = !0),
              yn(t.getTipElement()).hasClass(Pn) || t._hoverState === On
                ? (t._hoverState = On)
                : (clearTimeout(t._timeout),
                  (t._hoverState = On),
                  t.config.delay && t.config.delay.show
                    ? (t._timeout = setTimeout(function () {
                        t._hoverState === On && t.show();
                      }, t.config.delay.show))
                    : t.show());
          }),
          (e._leave = function (e, t) {
            var n = this.constructor.DATA_KEY;
            (t = t || yn(e.currentTarget).data(n)) ||
              ((t = new this.constructor(e.currentTarget, this._getDelegateConfig())),
              yn(e.currentTarget).data(n, t)),
              e && (t._activeTrigger['focusout' === e.type ? Mn : Hn] = !1),
              t._isWithActiveTrigger() ||
                (clearTimeout(t._timeout),
                (t._hoverState = Nn),
                t.config.delay && t.config.delay.hide
                  ? (t._timeout = setTimeout(function () {
                      t._hoverState === Nn && t.hide();
                    }, t.config.delay.hide))
                  : t.hide());
          }),
          (e._isWithActiveTrigger = function () {
            for (var e in this._activeTrigger) if (this._activeTrigger[e]) return !0;
            return !1;
          }),
          (e._getConfig = function (e) {
            return (
              'number' ==
                typeof (e = l(
                  {},
                  this.constructor.Default,
                  yn(this.element).data(),
                  'object' == typeof e && e ? e : {}
                )).delay && (e.delay = {show: e.delay, hide: e.delay}),
              'number' == typeof e.title && (e.title = e.title.toString()),
              'number' == typeof e.content && (e.content = e.content.toString()),
              we.typeCheckConfig(En, e, this.constructor.DefaultType),
              e
            );
          }),
          (e._getDelegateConfig = function () {
            var e = {};
            if (this.config)
              for (var t in this.config)
                this.constructor.Default[t] !== this.config[t] && (e[t] = this.config[t]);
            return e;
          }),
          (e._cleanTipClass = function () {
            var e = yn(this.getTipElement()),
              t = e.attr('class').match(Sn);
            null !== t && t.length && e.removeClass(t.join(''));
          }),
          (e._handlePopperPlacementChange = function (e) {
            var t = e.instance;
            (this.tip = t.popper),
              this._cleanTipClass(),
              this.addAttachmentClass(this._getAttachment(e.placement));
          }),
          (e._fixTransition = function () {
            var e = this.getTipElement(),
              t = this.config.animation;
            null === e.getAttribute('x-placement') &&
              (yn(e).removeClass(xn),
              (this.config.animation = !1),
              this.hide(),
              this.show(),
              (this.config.animation = t));
          }),
          (i._jQueryInterface = function (n) {
            return this.each(function () {
              var e = yn(this).data(bn),
                t = 'object' == typeof n && n;
              if (
                (e || !/dispose|hide/.test(n)) &&
                (e || ((e = new i(this, t)), yn(this).data(bn, e)), 'string' == typeof n)
              ) {
                if ('undefined' == typeof e[n]) throw new TypeError('No method named "' + n + '"');
                e[n]();
              }
            });
          }),
          s(i, null, [
            {
              key: 'VERSION',
              get: function () {
                return '4.1.3';
              }
            },
            {
              key: 'Default',
              get: function () {
                return In;
              }
            },
            {
              key: 'NAME',
              get: function () {
                return En;
              }
            },
            {
              key: 'DATA_KEY',
              get: function () {
                return bn;
              }
            },
            {
              key: 'Event',
              get: function () {
                return kn;
              }
            },
            {
              key: 'EVENT_KEY',
              get: function () {
                return wn;
              }
            },
            {
              key: 'DefaultType',
              get: function () {
                return Dn;
              }
            }
          ]),
          i
        );
      })()),
      (yn.fn[En] = Rn._jQueryInterface),
      (yn.fn[En].Constructor = Rn),
      (yn.fn[En].noConflict = function () {
        return (yn.fn[En] = Cn), Rn._jQueryInterface;
      }),
      Rn),
    Qi =
      ((Bn = 'popover'),
      (Kn = '.' + (qn = 'bs.popover')),
      (Qn = (Un = t).fn[Bn]),
      (Yn = 'bs-popover'),
      (Vn = new RegExp('(^|\\s)' + Yn + '\\S+', 'g')),
      (zn = l({}, Ki.Default, {
        placement: 'right',
        trigger: 'click',
        content: '',
        template:
          '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>'
      })),
      (Gn = l({}, Ki.DefaultType, {content: '(string|element|function)'})),
      (Jn = 'fade'),
      (Xn = '.popover-header'),
      ($n = '.popover-body'),
      (ei = {
        HIDE: 'hide' + Kn,
        HIDDEN: 'hidden' + Kn,
        SHOW: (Zn = 'show') + Kn,
        SHOWN: 'shown' + Kn,
        INSERTED: 'inserted' + Kn,
        CLICK: 'click' + Kn,
        FOCUSIN: 'focusin' + Kn,
        FOCUSOUT: 'focusout' + Kn,
        MOUSEENTER: 'mouseenter' + Kn,
        MOUSELEAVE: 'mouseleave' + Kn
      }),
      (ti = (function (e) {
        var t, n;
        function i() {
          return e.apply(this, arguments) || this;
        }
        (n = e),
          ((t = i).prototype = Object.create(n.prototype)),
          ((t.prototype.constructor = t).__proto__ = n);
        var r = i.prototype;
        return (
          (r.isWithContent = function () {
            return this.getTitle() || this._getContent();
          }),
          (r.addAttachmentClass = function (e) {
            Un(this.getTipElement()).addClass(Yn + '-' + e);
          }),
          (r.getTipElement = function () {
            return (this.tip = this.tip || Un(this.config.template)[0]), this.tip;
          }),
          (r.setContent = function () {
            var e = Un(this.getTipElement());
            this.setElementContent(e.find(Xn), this.getTitle());
            var t = this._getContent();
            'function' == typeof t && (t = t.call(this.element)),
              this.setElementContent(e.find($n), t),
              e.removeClass(Jn + ' ' + Zn);
          }),
          (r._getContent = function () {
            return this.element.getAttribute('data-content') || this.config.content;
          }),
          (r._cleanTipClass = function () {
            var e = Un(this.getTipElement()),
              t = e.attr('class').match(Vn);
            null !== t && 0 < t.length && e.removeClass(t.join(''));
          }),
          (i._jQueryInterface = function (n) {
            return this.each(function () {
              var e = Un(this).data(qn),
                t = 'object' == typeof n ? n : null;
              if (
                (e || !/destroy|hide/.test(n)) &&
                (e || ((e = new i(this, t)), Un(this).data(qn, e)), 'string' == typeof n)
              ) {
                if ('undefined' == typeof e[n]) throw new TypeError('No method named "' + n + '"');
                e[n]();
              }
            });
          }),
          s(i, null, [
            {
              key: 'VERSION',
              get: function () {
                return '4.1.3';
              }
            },
            {
              key: 'Default',
              get: function () {
                return zn;
              }
            },
            {
              key: 'NAME',
              get: function () {
                return Bn;
              }
            },
            {
              key: 'DATA_KEY',
              get: function () {
                return qn;
              }
            },
            {
              key: 'Event',
              get: function () {
                return ei;
              }
            },
            {
              key: 'EVENT_KEY',
              get: function () {
                return Kn;
              }
            },
            {
              key: 'DefaultType',
              get: function () {
                return Gn;
              }
            }
          ]),
          i
        );
      })(Ki)),
      (Un.fn[Bn] = ti._jQueryInterface),
      (Un.fn[Bn].Constructor = ti),
      (Un.fn[Bn].noConflict = function () {
        return (Un.fn[Bn] = Qn), ti._jQueryInterface;
      }),
      ti),
    Yi =
      ((ii = 'scrollspy'),
      (oi = '.' + (ri = 'bs.scrollspy')),
      (si = (ni = t).fn[ii]),
      (ai = {offset: 10, method: 'auto', target: ''}),
      (li = {offset: 'number', method: 'string', target: '(string|element)'}),
      (ci = {
        ACTIVATE: 'activate' + oi,
        SCROLL: 'scroll' + oi,
        LOAD_DATA_API: 'load' + oi + '.data-api'
      }),
      (ui = 'dropdown-item'),
      (fi = 'active'),
      (hi = '[data-spy="scroll"]'),
      (di = '.active'),
      (pi = '.nav, .list-group'),
      (mi = '.nav-link'),
      (gi = '.nav-item'),
      (_i = '.list-group-item'),
      (vi = '.dropdown'),
      (yi = '.dropdown-item'),
      (Ei = '.dropdown-toggle'),
      (bi = 'offset'),
      (wi = 'position'),
      (Ci = (function () {
        function n(e, t) {
          var n = this;
          (this._element = e),
            (this._scrollElement = 'BODY' === e.tagName ? window : e),
            (this._config = this._getConfig(t)),
            (this._selector =
              this._config.target +
              ' ' +
              mi +
              ',' +
              this._config.target +
              ' ' +
              _i +
              ',' +
              this._config.target +
              ' ' +
              yi),
            (this._offsets = []),
            (this._targets = []),
            (this._activeTarget = null),
            (this._scrollHeight = 0),
            ni(this._scrollElement).on(ci.SCROLL, function (e) {
              return n._process(e);
            }),
            this.refresh(),
            this._process();
        }
        var e = n.prototype;
        return (
          (e.refresh = function () {
            var t = this,
              e = this._scrollElement === this._scrollElement.window ? bi : wi,
              r = 'auto' === this._config.method ? e : this._config.method,
              o = r === wi ? this._getScrollTop() : 0;
            (this._offsets = []),
              (this._targets = []),
              (this._scrollHeight = this._getScrollHeight()),
              [].slice
                .call(document.querySelectorAll(this._selector))
                .map(function (e) {
                  var t,
                    n = we.getSelectorFromElement(e);
                  if ((n && (t = document.querySelector(n)), t)) {
                    var i = t.getBoundingClientRect();
                    if (i.width || i.height) return [ni(t)[r]().top + o, n];
                  }
                  return null;
                })
                .filter(function (e) {
                  return e;
                })
                .sort(function (e, t) {
                  return e[0] - t[0];
                })
                .forEach(function (e) {
                  t._offsets.push(e[0]), t._targets.push(e[1]);
                });
          }),
          (e.dispose = function () {
            ni.removeData(this._element, ri),
              ni(this._scrollElement).off(oi),
              (this._element = null),
              (this._scrollElement = null),
              (this._config = null),
              (this._selector = null),
              (this._offsets = null),
              (this._targets = null),
              (this._activeTarget = null),
              (this._scrollHeight = null);
          }),
          (e._getConfig = function (e) {
            if ('string' != typeof (e = l({}, ai, 'object' == typeof e && e ? e : {})).target) {
              var t = ni(e.target).attr('id');
              t || ((t = we.getUID(ii)), ni(e.target).attr('id', t)), (e.target = '#' + t);
            }
            return we.typeCheckConfig(ii, e, li), e;
          }),
          (e._getScrollTop = function () {
            return this._scrollElement === window
              ? this._scrollElement.pageYOffset
              : this._scrollElement.scrollTop;
          }),
          (e._getScrollHeight = function () {
            return (
              this._scrollElement.scrollHeight ||
              Math.max(document.body.scrollHeight, document.documentElement.scrollHeight)
            );
          }),
          (e._getOffsetHeight = function () {
            return this._scrollElement === window
              ? window.innerHeight
              : this._scrollElement.getBoundingClientRect().height;
          }),
          (e._process = function () {
            var e = this._getScrollTop() + this._config.offset,
              t = this._getScrollHeight(),
              n = this._config.offset + t - this._getOffsetHeight();
            if ((this._scrollHeight !== t && this.refresh(), n <= e)) {
              var i = this._targets[this._targets.length - 1];
              this._activeTarget !== i && this._activate(i);
            } else {
              if (this._activeTarget && e < this._offsets[0] && 0 < this._offsets[0])
                return (this._activeTarget = null), void this._clear();
              for (var r = this._offsets.length; r--; ) {
                this._activeTarget !== this._targets[r] &&
                  e >= this._offsets[r] &&
                  ('undefined' == typeof this._offsets[r + 1] || e < this._offsets[r + 1]) &&
                  this._activate(this._targets[r]);
              }
            }
          }),
          (e._activate = function (t) {
            (this._activeTarget = t), this._clear();
            var e = this._selector.split(',');
            e = e.map(function (e) {
              return e + '[data-target="' + t + '"],' + e + '[href="' + t + '"]';
            });
            var n = ni([].slice.call(document.querySelectorAll(e.join(','))));
            n.hasClass(ui)
              ? (n.closest(vi).find(Ei).addClass(fi), n.addClass(fi))
              : (n.addClass(fi),
                n
                  .parents(pi)
                  .prev(mi + ', ' + _i)
                  .addClass(fi),
                n.parents(pi).prev(gi).children(mi).addClass(fi)),
              ni(this._scrollElement).trigger(ci.ACTIVATE, {relatedTarget: t});
          }),
          (e._clear = function () {
            var e = [].slice.call(document.querySelectorAll(this._selector));
            ni(e).filter(di).removeClass(fi);
          }),
          (n._jQueryInterface = function (t) {
            return this.each(function () {
              var e = ni(this).data(ri);
              if (
                (e || ((e = new n(this, 'object' == typeof t && t)), ni(this).data(ri, e)),
                'string' == typeof t)
              ) {
                if ('undefined' == typeof e[t]) throw new TypeError('No method named "' + t + '"');
                e[t]();
              }
            });
          }),
          s(n, null, [
            {
              key: 'VERSION',
              get: function () {
                return '4.1.3';
              }
            },
            {
              key: 'Default',
              get: function () {
                return ai;
              }
            }
          ]),
          n
        );
      })()),
      ni(window).on(ci.LOAD_DATA_API, function () {
        for (var e = [].slice.call(document.querySelectorAll(hi)), t = e.length; t--; ) {
          var n = ni(e[t]);
          Ci._jQueryInterface.call(n, n.data());
        }
      }),
      (ni.fn[ii] = Ci._jQueryInterface),
      (ni.fn[ii].Constructor = Ci),
      (ni.fn[ii].noConflict = function () {
        return (ni.fn[ii] = si), Ci._jQueryInterface;
      }),
      Ci),
    Vi =
      ((Di = '.' + (Si = 'bs.tab')),
      (Ai = (Ti = t).fn.tab),
      (Ii = {
        HIDE: 'hide' + Di,
        HIDDEN: 'hidden' + Di,
        SHOW: 'show' + Di,
        SHOWN: 'shown' + Di,
        CLICK_DATA_API: 'click' + Di + '.data-api'
      }),
      (Oi = 'dropdown-menu'),
      (Ni = 'active'),
      (ki = 'disabled'),
      (xi = 'fade'),
      (Pi = 'show'),
      (Li = '.dropdown'),
      (ji = '.nav, .list-group'),
      (Hi = '.active'),
      (Mi = '> li > .active'),
      (Fi = '[data-toggle="tab"], [data-toggle="pill"], [data-toggle="list"]'),
      (Wi = '.dropdown-toggle'),
      (Ri = '> .dropdown-menu .active'),
      (Ui = (function () {
        function i(e) {
          this._element = e;
        }
        var e = i.prototype;
        return (
          (e.show = function () {
            var n = this;
            if (
              !(
                (this._element.parentNode &&
                  this._element.parentNode.nodeType === Node.ELEMENT_NODE &&
                  Ti(this._element).hasClass(Ni)) ||
                Ti(this._element).hasClass(ki)
              )
            ) {
              var e,
                i,
                t = Ti(this._element).closest(ji)[0],
                r = we.getSelectorFromElement(this._element);
              if (t) {
                var o = 'UL' === t.nodeName ? Mi : Hi;
                i = (i = Ti.makeArray(Ti(t).find(o)))[i.length - 1];
              }
              var s = Ti.Event(Ii.HIDE, {relatedTarget: this._element}),
                a = Ti.Event(Ii.SHOW, {relatedTarget: i});
              if (
                (i && Ti(i).trigger(s),
                Ti(this._element).trigger(a),
                !a.isDefaultPrevented() && !s.isDefaultPrevented())
              ) {
                r && (e = document.querySelector(r)), this._activate(this._element, t);
                var l = function () {
                  var e = Ti.Event(Ii.HIDDEN, {relatedTarget: n._element}),
                    t = Ti.Event(Ii.SHOWN, {relatedTarget: i});
                  Ti(i).trigger(e), Ti(n._element).trigger(t);
                };
                e ? this._activate(e, e.parentNode, l) : l();
              }
            }
          }),
          (e.dispose = function () {
            Ti.removeData(this._element, Si), (this._element = null);
          }),
          (e._activate = function (e, t, n) {
            var i = this,
              r = ('UL' === t.nodeName ? Ti(t).find(Mi) : Ti(t).children(Hi))[0],
              o = n && r && Ti(r).hasClass(xi),
              s = function () {
                return i._transitionComplete(e, r, n);
              };
            if (r && o) {
              var a = we.getTransitionDurationFromElement(r);
              Ti(r).one(we.TRANSITION_END, s).emulateTransitionEnd(a);
            } else s();
          }),
          (e._transitionComplete = function (e, t, n) {
            if (t) {
              Ti(t).removeClass(Pi + ' ' + Ni);
              var i = Ti(t.parentNode).find(Ri)[0];
              i && Ti(i).removeClass(Ni),
                'tab' === t.getAttribute('role') && t.setAttribute('aria-selected', !1);
            }
            if (
              (Ti(e).addClass(Ni),
              'tab' === e.getAttribute('role') && e.setAttribute('aria-selected', !0),
              we.reflow(e),
              Ti(e).addClass(Pi),
              e.parentNode && Ti(e.parentNode).hasClass(Oi))
            ) {
              var r = Ti(e).closest(Li)[0];
              if (r) {
                var o = [].slice.call(r.querySelectorAll(Wi));
                Ti(o).addClass(Ni);
              }
              e.setAttribute('aria-expanded', !0);
            }
            n && n();
          }),
          (i._jQueryInterface = function (n) {
            return this.each(function () {
              var e = Ti(this),
                t = e.data(Si);
              if ((t || ((t = new i(this)), e.data(Si, t)), 'string' == typeof n)) {
                if ('undefined' == typeof t[n]) throw new TypeError('No method named "' + n + '"');
                t[n]();
              }
            });
          }),
          s(i, null, [
            {
              key: 'VERSION',
              get: function () {
                return '4.1.3';
              }
            }
          ]),
          i
        );
      })()),
      Ti(document).on(Ii.CLICK_DATA_API, Fi, function (e) {
        e.preventDefault(), Ui._jQueryInterface.call(Ti(this), 'show');
      }),
      (Ti.fn.tab = Ui._jQueryInterface),
      (Ti.fn.tab.Constructor = Ui),
      (Ti.fn.tab.noConflict = function () {
        return (Ti.fn.tab = Ai), Ui._jQueryInterface;
      }),
      Ui);
  !(function (e) {
    if ('undefined' == typeof e)
      throw new TypeError(
        "Bootstrap's JavaScript requires jQuery. jQuery must be included before Bootstrap's JavaScript."
      );
    var t = e.fn.jquery.split(' ')[0].split('.');
    if ((t[0] < 2 && t[1] < 9) || (1 === t[0] && 9 === t[1] && t[2] < 1) || 4 <= t[0])
      throw new Error(
        "Bootstrap's JavaScript requires at least jQuery v1.9.1 but less than v4.0.0"
      );
  })(t),
    (e.Util = we),
    (e.Alert = Ce),
    (e.Button = Te),
    (e.Carousel = Se),
    (e.Collapse = De),
    (e.Dropdown = Bi),
    (e.Modal = qi),
    (e.Popover = Qi),
    (e.Scrollspy = Yi),
    (e.Tab = Vi),
    (e.Tooltip = Ki),
    Object.defineProperty(e, '__esModule', {value: !0});
});
//# sourceMappingURL=bootstrap.bundle.min.js.map
/*!
 * metismenu - v2.7.9
 * A jQuery menu plugin
 * https://github.com/onokumus/metismenu#readme
 *
 * Made by Osman Nuri Okumus <onokumus@gmail.com> (https://github.com/onokumus)
 * Under MIT License
 */
!(function (n, e) {
  'object' == typeof exports && 'undefined' != typeof module
    ? (module.exports = e(require('jquery')))
    : 'function' == typeof define && define.amd
    ? define(['jquery'], e)
    : (n.metisMenu = e(n.jQuery));
})(this, function (n) {
  'use strict';
  function a(s) {
    for (var n = 1; n < arguments.length; n++) {
      var a = null != arguments[n] ? arguments[n] : {},
        e = Object.keys(a);
      'function' == typeof Object.getOwnPropertySymbols &&
        (e = e.concat(
          Object.getOwnPropertySymbols(a).filter(function (n) {
            return Object.getOwnPropertyDescriptor(a, n).enumerable;
          })
        )),
        e.forEach(function (n) {
          var e, i, t;
          (e = s),
            (t = a[(i = n)]),
            i in e
              ? Object.defineProperty(e, i, {
                  value: t,
                  enumerable: !0,
                  configurable: !0,
                  writable: !0
                })
              : (e[i] = t);
        });
    }
    return s;
  }
  var o,
    e,
    r,
    i,
    t,
    l,
    c,
    s,
    g = (function (t) {
      var e = 'transitionend',
        s = {
          TRANSITION_END: 'mmTransitionEnd',
          triggerTransitionEnd: function (n) {
            t(n).trigger(e);
          },
          supportsTransitionEnd: function () {
            return Boolean(e);
          }
        };
      function n(n) {
        var e = this,
          i = !1;
        return (
          t(this).one(s.TRANSITION_END, function () {
            i = !0;
          }),
          setTimeout(function () {
            i || s.triggerTransitionEnd(e);
          }, n),
          this
        );
      }
      return (
        (t.fn.mmEmulateTransitionEnd = n),
        (t.event.special[s.TRANSITION_END] = {
          bindType: e,
          delegateType: e,
          handle: function (n) {
            if (t(n.target).is(this)) return n.handleObj.handler.apply(this, arguments);
          }
        }),
        s
      );
    })((n = n && n.hasOwnProperty('default') ? n.default : n));
  return (
    (i = '.' + (r = e = 'metisMenu')),
    (t = (o = n).fn[e]),
    (l = {
      toggle: !0,
      preventDefault: !0,
      activeClass: 'active',
      collapseClass: 'collapse',
      collapseInClass: 'in',
      collapsingClass: 'collapsing',
      triggerElement: 'a',
      parentTrigger: 'li',
      subMenu: 'ul'
    }),
    (c = {
      SHOW: 'show' + i,
      SHOWN: 'shown' + i,
      HIDE: 'hide' + i,
      HIDDEN: 'hidden' + i,
      CLICK_DATA_API: 'click' + i + '.data-api'
    }),
    (s = (function () {
      function s(n, e) {
        (this.element = n), (this.config = a({}, l, e)), (this.transitioning = null), this.init();
      }
      var n = s.prototype;
      return (
        (n.init = function () {
          var a = this,
            r = this.config;
          o(this.element)
            .find(r.parentTrigger + '.' + r.activeClass)
            .has(r.subMenu)
            .children(r.subMenu)
            .addClass(r.collapseClass + ' ' + r.collapseInClass),
            o(this.element)
              .find(r.parentTrigger)
              .not('.' + r.activeClass)
              .has(r.subMenu)
              .children(r.subMenu)
              .addClass(r.collapseClass),
            o(this.element)
              .find(r.parentTrigger)
              .has(r.subMenu)
              .children(r.triggerElement)
              .on(c.CLICK_DATA_API, function (n) {
                var e = o(this),
                  i = e.parent(r.parentTrigger),
                  t = i.siblings(r.parentTrigger).children(r.triggerElement),
                  s = i.children(r.subMenu);
                r.preventDefault && n.preventDefault(),
                  'true' !== e.attr('aria-disabled') &&
                    (i.hasClass(r.activeClass)
                      ? (e.attr('aria-expanded', !1), a.hide(s))
                      : (a.show(s),
                        e.attr('aria-expanded', !0),
                        r.toggle && t.attr('aria-expanded', !1)),
                    r.onTransitionStart && r.onTransitionStart(n));
              });
        }),
        (n.show = function (n) {
          var e = this;
          if (!this.transitioning && !o(n).hasClass(this.config.collapsingClass)) {
            var i = o(n),
              t = o.Event(c.SHOW);
            if ((i.trigger(t), !t.isDefaultPrevented())) {
              i.parent(this.config.parentTrigger).addClass(this.config.activeClass),
                this.config.toggle &&
                  this.hide(
                    i
                      .parent(this.config.parentTrigger)
                      .siblings()
                      .children(this.config.subMenu + '.' + this.config.collapseInClass)
                  ),
                i
                  .removeClass(this.config.collapseClass)
                  .addClass(this.config.collapsingClass)
                  .height(0),
                this.setTransitioning(!0);
              i.height(n[0].scrollHeight)
                .one(g.TRANSITION_END, function () {
                  e.config &&
                    e.element &&
                    (i
                      .removeClass(e.config.collapsingClass)
                      .addClass(e.config.collapseClass + ' ' + e.config.collapseInClass)
                      .height(''),
                    e.setTransitioning(!1),
                    i.trigger(c.SHOWN));
                })
                .mmEmulateTransitionEnd(350);
            }
          }
        }),
        (n.hide = function (n) {
          var e = this;
          if (!this.transitioning && o(n).hasClass(this.config.collapseInClass)) {
            var i = o(n),
              t = o.Event(c.HIDE);
            if ((i.trigger(t), !t.isDefaultPrevented())) {
              i.parent(this.config.parentTrigger).removeClass(this.config.activeClass),
                i.height(i.height())[0].offsetHeight,
                i
                  .addClass(this.config.collapsingClass)
                  .removeClass(this.config.collapseClass)
                  .removeClass(this.config.collapseInClass),
                this.setTransitioning(!0);
              var s = function () {
                e.config &&
                  e.element &&
                  (e.transitioning && e.config.onTransitionEnd && e.config.onTransitionEnd(),
                  e.setTransitioning(!1),
                  i.trigger(c.HIDDEN),
                  i.removeClass(e.config.collapsingClass).addClass(e.config.collapseClass));
              };
              0 === i.height() || 'none' === i.css('display')
                ? s()
                : i.height(0).one(g.TRANSITION_END, s).mmEmulateTransitionEnd(350);
            }
          }
        }),
        (n.setTransitioning = function (n) {
          this.transitioning = n;
        }),
        (n.dispose = function () {
          o.removeData(this.element, r),
            o(this.element)
              .find(this.config.parentTrigger)
              .has(this.config.subMenu)
              .children(this.config.triggerElement)
              .off('click'),
            (this.transitioning = null),
            (this.config = null),
            (this.element = null);
        }),
        (s.jQueryInterface = function (t) {
          return this.each(function () {
            var n = o(this),
              e = n.data(r),
              i = a({}, l, n.data(), 'object' == typeof t && t ? t : {});
            if (
              (!e && /dispose/.test(t) && this.dispose(),
              e || ((e = new s(this, i)), n.data(r, e)),
              'string' == typeof t)
            ) {
              if (void 0 === e[t]) throw new Error('No method named "' + t + '"');
              e[t]();
            }
          });
        }),
        s
      );
    })()),
    (o.fn[e] = s.jQueryInterface),
    (o.fn[e].Constructor = s),
    (o.fn[e].noConflict = function () {
      return (o.fn[e] = t), s.jQueryInterface;
    }),
    s
  );
});
//# sourceMappingURL=metisMenu.min.js.map
/*! Copyright (c) 2011 Piotr Rochala (http://rocha.la)
 * Dual licensed under the MIT (http://www.opensource.org/licenses/mit-license.php)
 * and GPL (http://www.opensource.org/licenses/gpl-license.php) licenses.
 *
 * Version: 1.3.8
 *
 */
(function (e) {
  e.fn.extend({
    slimScroll: function (f) {
      var a = e.extend(
        {
          width: 'auto',
          height: '250px',
          size: '7px',
          color: '#000',
          position: 'right',
          distance: '1px',
          start: 'top',
          opacity: 0.4,
          alwaysVisible: !1,
          disableFadeOut: !1,
          railVisible: !1,
          railColor: '#333',
          railOpacity: 0.2,
          railDraggable: !0,
          railClass: 'slimScrollRail',
          barClass: 'slimScrollBar',
          wrapperClass: 'slimScrollDiv',
          allowPageScroll: !1,
          wheelStep: 20,
          touchScrollStep: 200,
          borderRadius: '7px',
          railBorderRadius: '7px'
        },
        f
      );
      this.each(function () {
        function v(d) {
          if (r) {
            d = d || window.event;
            var c = 0;
            d.wheelDelta && (c = -d.wheelDelta / 120);
            d.detail && (c = d.detail / 3);
            e(d.target || d.srcTarget || d.srcElement)
              .closest('.' + a.wrapperClass)
              .is(b.parent()) && n(c, !0);
            d.preventDefault && !k && d.preventDefault();
            k || (d.returnValue = !1);
          }
        }
        function n(d, g, e) {
          k = !1;
          var f = b.outerHeight() - c.outerHeight();
          g &&
            ((g = parseInt(c.css('top')) + ((d * parseInt(a.wheelStep)) / 100) * c.outerHeight()),
            (g = Math.min(Math.max(g, 0), f)),
            (g = 0 < d ? Math.ceil(g) : Math.floor(g)),
            c.css({top: g + 'px'}));
          l = parseInt(c.css('top')) / (b.outerHeight() - c.outerHeight());
          g = l * (b[0].scrollHeight - b.outerHeight());
          e &&
            ((g = d),
            (d = (g / b[0].scrollHeight) * b.outerHeight()),
            (d = Math.min(Math.max(d, 0), f)),
            c.css({top: d + 'px'}));
          b.scrollTop(g);
          b.trigger('slimscrolling', ~~g);
          w();
          p();
        }
        function x() {
          u = Math.max((b.outerHeight() / b[0].scrollHeight) * b.outerHeight(), 30);
          c.css({height: u + 'px'});
          var a = u == b.outerHeight() ? 'none' : 'block';
          c.css({display: a});
        }
        function w() {
          x();
          clearTimeout(B);
          l == ~~l
            ? ((k = a.allowPageScroll),
              C != l && b.trigger('slimscroll', 0 == ~~l ? 'top' : 'bottom'))
            : (k = !1);
          C = l;
          u >= b.outerHeight()
            ? (k = !0)
            : (c.stop(!0, !0).fadeIn('fast'), a.railVisible && m.stop(!0, !0).fadeIn('fast'));
        }
        function p() {
          a.alwaysVisible ||
            (B = setTimeout(function () {
              (a.disableFadeOut && r) || y || z || (c.fadeOut('slow'), m.fadeOut('slow'));
            }, 1e3));
        }
        var r,
          y,
          z,
          B,
          A,
          u,
          l,
          C,
          k = !1,
          b = e(this);
        if (b.parent().hasClass(a.wrapperClass)) {
          var q = b.scrollTop(),
            c = b.siblings('.' + a.barClass),
            m = b.siblings('.' + a.railClass);
          x();
          if (e.isPlainObject(f)) {
            if ('height' in f && 'auto' == f.height) {
              b.parent().css('height', 'auto');
              b.css('height', 'auto');
              var h = b.parent().parent().height();
              b.parent().css('height', h);
              b.css('height', h);
            } else
              'height' in f && ((h = f.height), b.parent().css('height', h), b.css('height', h));
            if ('scrollTo' in f) q = parseInt(a.scrollTo);
            else if ('scrollBy' in f) q += parseInt(a.scrollBy);
            else if ('destroy' in f) {
              c.remove();
              m.remove();
              b.unwrap();
              return;
            }
            n(q, !1, !0);
          }
        } else if (!(e.isPlainObject(f) && 'destroy' in f)) {
          a.height = 'auto' == a.height ? b.parent().height() : a.height;
          q = e('<div></div>')
            .addClass(a.wrapperClass)
            .css({position: 'relative', overflow: 'hidden', width: a.width, height: a.height});
          b.css({overflow: 'hidden', width: a.width, height: a.height});
          var m = e('<div></div>')
              .addClass(a.railClass)
              .css({
                width: a.size,
                height: '100%',
                position: 'absolute',
                top: 0,
                display: a.alwaysVisible && a.railVisible ? 'block' : 'none',
                'border-radius': a.railBorderRadius,
                background: a.railColor,
                opacity: a.railOpacity,
                zIndex: 90
              }),
            c = e('<div></div>')
              .addClass(a.barClass)
              .css({
                background: a.color,
                width: a.size,
                position: 'absolute',
                top: 0,
                opacity: a.opacity,
                display: a.alwaysVisible ? 'block' : 'none',
                'border-radius': a.borderRadius,
                BorderRadius: a.borderRadius,
                MozBorderRadius: a.borderRadius,
                WebkitBorderRadius: a.borderRadius,
                zIndex: 99
              }),
            h = 'right' == a.position ? {right: a.distance} : {left: a.distance};
          m.css(h);
          c.css(h);
          b.wrap(q);
          b.parent().append(c);
          b.parent().append(m);
          a.railDraggable &&
            c
              .bind('mousedown', function (a) {
                var b = e(document);
                z = !0;
                t = parseFloat(c.css('top'));
                pageY = a.pageY;
                b.bind('mousemove.slimscroll', function (a) {
                  currTop = t + a.pageY - pageY;
                  c.css('top', currTop);
                  n(0, c.position().top, !1);
                });
                b.bind('mouseup.slimscroll', function (a) {
                  z = !1;
                  p();
                  b.unbind('.slimscroll');
                });
                return !1;
              })
              .bind('selectstart.slimscroll', function (a) {
                a.stopPropagation();
                a.preventDefault();
                return !1;
              });
          m.hover(
            function () {
              w();
            },
            function () {
              p();
            }
          );
          c.hover(
            function () {
              y = !0;
            },
            function () {
              y = !1;
            }
          );
          b.hover(
            function () {
              r = !0;
              w();
              p();
            },
            function () {
              r = !1;
              p();
            }
          );
          b.bind('touchstart', function (a, b) {
            a.originalEvent.touches.length && (A = a.originalEvent.touches[0].pageY);
          });
          b.bind('touchmove', function (b) {
            k || b.originalEvent.preventDefault();
            b.originalEvent.touches.length &&
              (n((A - b.originalEvent.touches[0].pageY) / a.touchScrollStep, !0),
              (A = b.originalEvent.touches[0].pageY));
          });
          x();
          'bottom' === a.start
            ? (c.css({top: b.outerHeight() - c.outerHeight()}), n(0, !0))
            : 'top' !== a.start &&
              (n(e(a.start).position().top, null, !0), a.alwaysVisible || c.hide());
          window.addEventListener
            ? (this.addEventListener('DOMMouseScroll', v, !1),
              this.addEventListener('mousewheel', v, !1))
            : document.attachEvent('onmousewheel', v);
        }
      });
      return this;
    }
  });
  e.fn.extend({slimscroll: e.fn.slimScroll});
})(jQuery);
/*!
 * Bootstrap-select v1.13.2 (https://developer.snapappointments.com/bootstrap-select)
 *
 * Copyright 2012-2018 SnapAppointments, LLC
 * Licensed under MIT (https://github.com/snapappointments/bootstrap-select/blob/master/LICENSE)
 */

!(function (e, t) {
  void 0 === e && void 0 !== window && (e = window),
    'function' == typeof define && define.amd
      ? define(['jquery'], function (e) {
          return t(e);
        })
      : 'object' == typeof module && module.exports
      ? (module.exports = t(require('jquery')))
      : t(e.jQuery);
})(this, function (e) {
  !(function (F) {
    'use strict';
    var e,
      a,
      t,
      i = document.createElement('_');
    if ((i.classList.toggle('c3', !1), i.classList.contains('c3'))) {
      var s = DOMTokenList.prototype.toggle;
      DOMTokenList.prototype.toggle = function (e, t) {
        return 1 in arguments && !this.contains(e) == !t ? t : s.call(this, e);
      };
    }
    function S(e) {
      var t,
        i = [],
        s = e && e.options;
      if (e.multiple)
        for (var n = 0, o = s.length; n < o; n++) (t = s[n]).selected && i.push(t.value || t.text);
      else i = e.value;
      return i;
    }
    String.prototype.startsWith ||
      ((e = (function () {
        try {
          var e = {},
            t = Object.defineProperty,
            i = t(e, e, e) && t;
        } catch (e) {}
        return i;
      })()),
      (a = {}.toString),
      (t = function (e) {
        if (null == this) throw new TypeError();
        var t = String(this);
        if (e && '[object RegExp]' == a.call(e)) throw new TypeError();
        var i = t.length,
          s = String(e),
          n = s.length,
          o = 1 < arguments.length ? arguments[1] : void 0,
          l = o ? Number(o) : 0;
        l != l && (l = 0);
        var r = Math.min(Math.max(l, 0), i);
        if (i < n + r) return !1;
        for (var c = -1; ++c < n; ) if (t.charCodeAt(r + c) != s.charCodeAt(c)) return !1;
        return !0;
      }),
      e
        ? e(String.prototype, 'startsWith', {value: t, configurable: !0, writable: !0})
        : (String.prototype.startsWith = t)),
      Object.keys ||
        (Object.keys = function (e, t, i) {
          for (t in ((i = []), e)) i.hasOwnProperty.call(e, t) && i.push(t);
          return i;
        });
    var n = {useDefault: !1, _set: F.valHooks.select.set};
    F.valHooks.select.set = function (e, t) {
      return t && !n.useDefault && F(e).data('selected', !0), n._set.apply(this, arguments);
    };
    var y = null,
      o = (function () {
        try {
          return new Event('change'), !0;
        } catch (e) {
          return !1;
        }
      })();
    function $(e, t, i, s) {
      for (var n = ['content', 'subtext', 'tokens'], o = !1, l = 0; l < n.length; l++) {
        var r = n[l],
          c = e[r];
        if (
          c &&
          ((c = c.toString()),
          'content' === r && (c = c.replace(/<[^>]+>/g, '')),
          s && (c = d(c)),
          (c = c.toUpperCase()),
          (o = 'contains' === i ? 0 <= c.indexOf(t) : c.startsWith(t)))
        )
          break;
      }
      return o;
    }
    function O(e) {
      return parseInt(e, 10) || 0;
    }
    function d(e) {
      return (
        F.each(
          [
            {re: /[\xC0-\xC6]/g, ch: 'A'},
            {re: /[\xE0-\xE6]/g, ch: 'a'},
            {re: /[\xC8-\xCB]/g, ch: 'E'},
            {re: /[\xE8-\xEB]/g, ch: 'e'},
            {re: /[\xCC-\xCF]/g, ch: 'I'},
            {re: /[\xEC-\xEF]/g, ch: 'i'},
            {re: /[\xD2-\xD6]/g, ch: 'O'},
            {re: /[\xF2-\xF6]/g, ch: 'o'},
            {re: /[\xD9-\xDC]/g, ch: 'U'},
            {re: /[\xF9-\xFC]/g, ch: 'u'},
            {re: /[\xC7-\xE7]/g, ch: 'c'},
            {re: /[\xD1]/g, ch: 'N'},
            {re: /[\xF1]/g, ch: 'n'}
          ],
          function () {
            e = e ? e.replace(this.re, this.ch) : '';
          }
        ),
        e
      );
    }
    F.fn.triggerNative = function (e) {
      var t,
        i = this[0];
      i.dispatchEvent
        ? (o
            ? (t = new Event(e, {bubbles: !0}))
            : (t = document.createEvent('Event')).initEvent(e, !0, !1),
          i.dispatchEvent(t))
        : i.fireEvent
        ? (((t = document.createEventObject()).eventType = e), i.fireEvent('on' + e, t))
        : this.trigger(e);
    };
    var l = function (t) {
        var i = function (e) {
            return t[e];
          },
          e = '(?:' + Object.keys(t).join('|') + ')',
          s = RegExp(e),
          n = RegExp(e, 'g');
        return function (e) {
          return (e = null == e ? '' : '' + e), s.test(e) ? e.replace(n, i) : e;
        };
      },
      G = l({'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#x27;', '`': '&#x60;'}),
      f = l({'&amp;': '&', '&lt;': '<', '&gt;': '>', '&quot;': '"', '&#x27;': "'", '&#x60;': '`'}),
      E = {
        32: ' ',
        48: '0',
        49: '1',
        50: '2',
        51: '3',
        52: '4',
        53: '5',
        54: '6',
        55: '7',
        56: '8',
        57: '9',
        59: ';',
        65: 'A',
        66: 'B',
        67: 'C',
        68: 'D',
        69: 'E',
        70: 'F',
        71: 'G',
        72: 'H',
        73: 'I',
        74: 'J',
        75: 'K',
        76: 'L',
        77: 'M',
        78: 'N',
        79: 'O',
        80: 'P',
        81: 'Q',
        82: 'R',
        83: 'S',
        84: 'T',
        85: 'U',
        86: 'V',
        87: 'W',
        88: 'X',
        89: 'Y',
        90: 'Z',
        96: '0',
        97: '1',
        98: '2',
        99: '3',
        100: '4',
        101: '5',
        102: '6',
        103: '7',
        104: '8',
        105: '9'
      },
      C = 27,
      z = 13,
      T = 32,
      D = 9,
      H = 38,
      L = 40,
      _ = {success: !1, major: '3'};
    try {
      (_.full = (F.fn.dropdown.Constructor.VERSION || '').split(' ')[0].split('.')),
        (_.major = _.full[0]),
        (_.success = !0);
    } catch (e) {
      console.warn(
        "There was an issue retrieving Bootstrap's version. Ensure Bootstrap is being loaded before bootstrap-select and there is no namespace collision. If loading Bootstrap asynchronously, the version may need to be manually specified via $.fn.selectpicker.Constructor.BootstrapVersion.",
        e
      );
    }
    var q = {
        DISABLED: 'disabled',
        DIVIDER: 'divider',
        SHOW: 'open',
        DROPUP: 'dropup',
        MENU: 'dropdown-menu',
        MENURIGHT: 'dropdown-menu-right',
        MENULEFT: 'dropdown-menu-left',
        BUTTONCLASS: 'btn-default',
        POPOVERHEADER: 'popover-title'
      },
      N = {MENU: '.' + q.MENU};
    '4' === _.major &&
      ((q.DIVIDER = 'dropdown-divider'),
      (q.SHOW = 'show'),
      (q.BUTTONCLASS = 'btn-light'),
      (q.POPOVERHEADER = 'popover-header'));
    var A = new RegExp(H + '|' + L),
      P = new RegExp('^' + D + '$|' + C),
      c =
        (new RegExp(z + '|' + T),
        function (e, t) {
          var i = this;
          n.useDefault || ((F.valHooks.select.set = n._set), (n.useDefault = !0)),
            (this.$element = F(e)),
            (this.$newElement = null),
            (this.$button = null),
            (this.$menu = null),
            (this.options = t),
            (this.selectpicker = {
              main: {map: {newIndex: {}, originalIndex: {}}},
              current: {map: {}},
              search: {map: {}},
              view: {},
              keydown: {
                keyHistory: '',
                resetKeyHistory: {
                  start: function () {
                    return setTimeout(function () {
                      i.selectpicker.keydown.keyHistory = '';
                    }, 800);
                  }
                }
              }
            }),
            null === this.options.title && (this.options.title = this.$element.attr('title'));
          var s = this.options.windowPadding;
          'number' == typeof s && (this.options.windowPadding = [s, s, s, s]),
            (this.val = c.prototype.val),
            (this.render = c.prototype.render),
            (this.refresh = c.prototype.refresh),
            (this.setStyle = c.prototype.setStyle),
            (this.selectAll = c.prototype.selectAll),
            (this.deselectAll = c.prototype.deselectAll),
            (this.destroy = c.prototype.destroy),
            (this.remove = c.prototype.remove),
            (this.show = c.prototype.show),
            (this.hide = c.prototype.hide),
            this.init();
        });
    function r(e) {
      var o,
        l = arguments,
        r = e;
      if (([].shift.apply(l), !_.success)) {
        try {
          _.full = (F.fn.dropdown.Constructor.VERSION || '').split(' ')[0].split('.');
        } catch (e) {
          _.full = c.BootstrapVersion.split(' ')[0].split('.');
        }
        (_.major = _.full[0]),
          (_.success = !0),
          '4' === _.major &&
            ((q.DIVIDER = 'dropdown-divider'),
            (q.SHOW = 'show'),
            (q.BUTTONCLASS = 'btn-light'),
            (c.DEFAULTS.style = q.BUTTONCLASS = 'btn-light'),
            (q.POPOVERHEADER = 'popover-header'));
      }
      var t = this.each(function () {
        var e = F(this);
        if (e.is('select')) {
          var t = e.data('selectpicker'),
            i = 'object' == typeof r && r;
          if (t) {
            if (i) for (var s in i) i.hasOwnProperty(s) && (t.options[s] = i[s]);
          } else {
            var n = F.extend({}, c.DEFAULTS, F.fn.selectpicker.defaults || {}, e.data(), i);
            (n.template = F.extend(
              {},
              c.DEFAULTS.template,
              F.fn.selectpicker.defaults ? F.fn.selectpicker.defaults.template : {},
              e.data().template,
              i.template
            )),
              e.data('selectpicker', (t = new c(this, n)));
          }
          'string' == typeof r && (o = t[r] instanceof Function ? t[r].apply(t, l) : t.options[r]);
        }
      });
      return void 0 !== o ? o : t;
    }
    (c.VERSION = '1.13.2'),
      (c.BootstrapVersion = _.major),
      (c.DEFAULTS = {
        noneSelectedText: 'Nothing selected',
        noneResultsText: 'No results matched {0}',
        countSelectedText: function (e, t) {
          return 1 == e ? '{0} item selected' : '{0} items selected';
        },
        maxOptionsText: function (e, t) {
          return [
            1 == e ? 'Limit reached ({n} item max)' : 'Limit reached ({n} items max)',
            1 == t ? 'Group limit reached ({n} item max)' : 'Group limit reached ({n} items max)'
          ];
        },
        selectAllText: 'Select All',
        deselectAllText: 'Deselect All',
        doneButton: !1,
        doneButtonText: 'Close',
        multipleSeparator: ', ',
        styleBase: 'btn',
        style: q.BUTTONCLASS,
        size: 'auto',
        title: null,
        selectedTextFormat: 'values',
        width: !1,
        container: !1,
        hideDisabled: !1,
        showSubtext: !1,
        showIcon: !0,
        showContent: !0,
        dropupAuto: !0,
        header: !1,
        liveSearch: !1,
        liveSearchPlaceholder: null,
        liveSearchNormalize: !1,
        liveSearchStyle: 'contains',
        actionsBox: !1,
        iconBase: 'glyphicon',
        tickIcon: 'glyphicon-ok',
        showTick: !1,
        template: {caret: '<span class="caret"></span>'},
        maxOptions: !1,
        mobile: !1,
        selectOnTab: !1,
        dropdownAlignRight: !1,
        windowPadding: 0,
        virtualScroll: 600,
        display: !1
      }),
      '4' === _.major &&
        ((c.DEFAULTS.style = 'btn-light'),
        (c.DEFAULTS.iconBase = ''),
        (c.DEFAULTS.tickIcon = 'bs-ok-default')),
      (c.prototype = {
        constructor: c,
        init: function () {
          var i = this,
            e = this.$element.attr('id');
          this.$element.addClass('bs-select-hidden'),
            (this.multiple = this.$element.prop('multiple')),
            (this.autofocus = this.$element.prop('autofocus')),
            (this.$newElement = this.createDropdown()),
            this.createLi(),
            this.$element.after(this.$newElement).prependTo(this.$newElement),
            (this.$button = this.$newElement.children('button')),
            (this.$menu = this.$newElement.children(N.MENU)),
            (this.$menuInner = this.$menu.children('.inner')),
            (this.$searchbox = this.$menu.find('input')),
            this.$element.removeClass('bs-select-hidden'),
            !0 === this.options.dropdownAlignRight && this.$menu.addClass(q.MENURIGHT),
            void 0 !== e && this.$button.attr('data-id', e),
            this.checkDisabled(),
            this.clickListener(),
            this.options.liveSearch && this.liveSearchListener(),
            this.render(),
            this.setStyle(),
            this.setWidth(),
            this.options.container
              ? this.selectPosition()
              : this.$element.on('hide.bs.select', function () {
                  if (i.isVirtual()) {
                    var e = i.$menuInner[0],
                      t = e.firstChild.cloneNode(!1);
                    e.replaceChild(t, e.firstChild), (e.scrollTop = 0);
                  }
                }),
            this.$menu.data('this', this),
            this.$newElement.data('this', this),
            this.options.mobile && this.mobile(),
            this.$newElement.on({
              'hide.bs.dropdown': function (e) {
                i.$menuInner.attr('aria-expanded', !1), i.$element.trigger('hide.bs.select', e);
              },
              'hidden.bs.dropdown': function (e) {
                i.$element.trigger('hidden.bs.select', e);
              },
              'show.bs.dropdown': function (e) {
                i.$menuInner.attr('aria-expanded', !0), i.$element.trigger('show.bs.select', e);
              },
              'shown.bs.dropdown': function (e) {
                i.$element.trigger('shown.bs.select', e);
              }
            }),
            i.$element[0].hasAttribute('required') &&
              this.$element.on('invalid', function () {
                i.$button.addClass('bs-invalid'),
                  i.$element.on({
                    'shown.bs.select': function () {
                      i.$element.val(i.$element.val()).off('shown.bs.select');
                    },
                    'rendered.bs.select': function () {
                      this.validity.valid && i.$button.removeClass('bs-invalid'),
                        i.$element.off('rendered.bs.select');
                    }
                  }),
                  i.$button.on('blur.bs.select', function () {
                    i.$element.focus().blur(), i.$button.off('blur.bs.select');
                  });
              }),
            setTimeout(function () {
              i.$element.trigger('loaded.bs.select');
            });
        },
        createDropdown: function () {
          var e = this.multiple || this.options.showTick ? ' show-tick' : '',
            t = this.autofocus ? ' autofocus' : '',
            i = this.options.header
              ? '<div class="' +
                q.POPOVERHEADER +
                '"><button type="button" class="close" aria-hidden="true">&times;</button>' +
                this.options.header +
                '</div>'
              : '',
            s = this.options.liveSearch
              ? '<div class="bs-searchbox"><input type="text" class="form-control" autocomplete="off"' +
                (null === this.options.liveSearchPlaceholder
                  ? ''
                  : ' placeholder="' + G(this.options.liveSearchPlaceholder) + '"') +
                ' role="textbox" aria-label="Search"></div>'
              : '',
            n =
              this.multiple && this.options.actionsBox
                ? '<div class="bs-actionsbox"><div class="btn-group btn-group-sm btn-block"><button type="button" class="actions-btn bs-select-all btn ' +
                  q.BUTTONCLASS +
                  '">' +
                  this.options.selectAllText +
                  '</button><button type="button" class="actions-btn bs-deselect-all btn ' +
                  q.BUTTONCLASS +
                  '">' +
                  this.options.deselectAllText +
                  '</button></div></div>'
                : '',
            o =
              this.multiple && this.options.doneButton
                ? '<div class="bs-donebutton"><div class="btn-group btn-block"><button type="button" class="btn btn-sm ' +
                  q.BUTTONCLASS +
                  '">' +
                  this.options.doneButtonText +
                  '</button></div></div>'
                : '',
            l =
              '<div class="dropdown bootstrap-select' +
              e +
              '"><button type="button" class="' +
              this.options.styleBase +
              ' dropdown-toggle" ' +
              ('static' === this.options.display ? 'data-display="static"' : '') +
              'data-toggle="dropdown"' +
              t +
              ' role="button"><div class="filter-option"><div class="filter-option-inner"><div class="filter-option-inner-inner"></div></div> </div>' +
              ('4' === _.major
                ? ''
                : '<span class="bs-caret">' + this.options.template.caret + '</span>') +
              '</button><div class="' +
              q.MENU +
              ' ' +
              ('4' === _.major ? '' : q.SHOW) +
              '" role="combobox">' +
              i +
              s +
              n +
              '<div class="inner ' +
              q.SHOW +
              '" role="listbox" aria-expanded="false" tabindex="-1"><ul class="' +
              q.MENU +
              ' inner ' +
              ('4' === _.major ? q.SHOW : '') +
              '"></ul></div>' +
              o +
              '</div></div>';
          return F(l);
        },
        setPositionData: function () {
          this.selectpicker.view.canHighlight = [];
          for (var e = 0; e < this.selectpicker.current.data.length; e++) {
            var t = this.selectpicker.current.data[e],
              i = !0;
            'divider' === t.type
              ? ((i = !1), (t.height = this.sizeInfo.dividerHeight))
              : 'optgroup-label' === t.type
              ? ((i = !1), (t.height = this.sizeInfo.dropdownHeaderHeight))
              : (t.height = this.sizeInfo.liHeight),
              t.disabled && (i = !1),
              this.selectpicker.view.canHighlight.push(i),
              (t.position =
                (0 === e ? 0 : this.selectpicker.current.data[e - 1].position) + t.height);
          }
        },
        isVirtual: function () {
          return (
            (!1 !== this.options.virtualScroll &&
              this.selectpicker.main.elements.length >= this.options.virtualScroll) ||
            !0 === this.options.virtualScroll
          );
        },
        createView: function (C, e) {
          e = e || 0;
          var O = this;
          this.selectpicker.current = C ? this.selectpicker.search : this.selectpicker.main;
          var z,
            T,
            D = [];
          function i(e, t) {
            var i,
              s,
              n,
              o,
              l,
              r,
              c,
              a,
              d,
              h = O.selectpicker.current.elements.length,
              p = [],
              u = void 0,
              f = !0,
              m = O.isVirtual();
            (O.selectpicker.view.scrollTop = e),
              !0 === m &&
                O.sizeInfo.hasScrollBar &&
                O.$menu[0].offsetWidth > O.sizeInfo.totalMenuWidth &&
                ((O.sizeInfo.menuWidth = O.$menu[0].offsetWidth),
                (O.sizeInfo.totalMenuWidth = O.sizeInfo.menuWidth + O.sizeInfo.scrollBarWidth),
                O.$menu.css('min-width', O.sizeInfo.menuWidth)),
              (i = Math.ceil((O.sizeInfo.menuInnerHeight / O.sizeInfo.liHeight) * 1.5)),
              (s = Math.round(h / i) || 1);
            for (var v = 0; v < s; v++) {
              var g = (v + 1) * i;
              if ((v === s - 1 && (g = h), (p[v] = [v * i + (v ? 1 : 0), g]), !h)) break;
              void 0 === u &&
                e <= O.selectpicker.current.data[g - 1].position - O.sizeInfo.menuInnerHeight &&
                (u = v);
            }
            if (
              (void 0 === u && (u = 0),
              (l = [O.selectpicker.view.position0, O.selectpicker.view.position1]),
              (n = Math.max(0, u - 1)),
              (o = Math.min(s - 1, u + 1)),
              (O.selectpicker.view.position0 = Math.max(0, p[n][0]) || 0),
              (O.selectpicker.view.position1 = Math.min(h, p[o][1]) || 0),
              (r =
                l[0] !== O.selectpicker.view.position0 || l[1] !== O.selectpicker.view.position1),
              void 0 !== O.activeIndex &&
                ((T =
                  O.selectpicker.current.elements[
                    O.selectpicker.current.map.newIndex[O.prevActiveIndex]
                  ]),
                (D =
                  O.selectpicker.current.elements[
                    O.selectpicker.current.map.newIndex[O.activeIndex]
                  ]),
                (z =
                  O.selectpicker.current.elements[
                    O.selectpicker.current.map.newIndex[O.selectedIndex]
                  ]),
                t &&
                  (O.activeIndex !== O.selectedIndex &&
                    (D.classList.remove('active'),
                    D.firstChild && D.firstChild.classList.remove('active')),
                  (O.activeIndex = void 0)),
                O.activeIndex &&
                  O.activeIndex !== O.selectedIndex &&
                  z &&
                  z.length &&
                  (z.classList.remove('active'),
                  z.firstChild && z.firstChild.classList.remove('active'))),
              void 0 !== O.prevActiveIndex &&
                O.prevActiveIndex !== O.activeIndex &&
                O.prevActiveIndex !== O.selectedIndex &&
                T &&
                T.length &&
                (T.classList.remove('active'),
                T.firstChild && T.firstChild.classList.remove('active')),
              (t || r) &&
                ((c = O.selectpicker.view.visibleElements
                  ? O.selectpicker.view.visibleElements.slice()
                  : []),
                (O.selectpicker.view.visibleElements = O.selectpicker.current.elements.slice(
                  O.selectpicker.view.position0,
                  O.selectpicker.view.position1
                )),
                O.setOptionStatus(),
                (C || (!1 === m && t)) &&
                  ((a = c),
                  (d = O.selectpicker.view.visibleElements),
                  (f = !(
                    a.length === d.length &&
                    a.every(function (e, t) {
                      return e === d[t];
                    })
                  ))),
                (t || !0 === m) && f))
            ) {
              var b,
                w,
                x = O.$menuInner[0],
                I = document.createDocumentFragment(),
                k = x.firstChild.cloneNode(!1),
                $ =
                  !0 === m ? O.selectpicker.view.visibleElements : O.selectpicker.current.elements;
              x.replaceChild(k, x.firstChild);
              v = 0;
              for (var E = $.length; v < E; v++) I.appendChild($[v]);
              !0 === m &&
                ((b =
                  0 === O.selectpicker.view.position0
                    ? 0
                    : O.selectpicker.current.data[O.selectpicker.view.position0 - 1].position),
                (w =
                  O.selectpicker.view.position1 > h - 1
                    ? 0
                    : O.selectpicker.current.data[h - 1].position -
                      O.selectpicker.current.data[O.selectpicker.view.position1 - 1].position),
                (x.firstChild.style.marginTop = b + 'px'),
                (x.firstChild.style.marginBottom = w + 'px')),
                x.firstChild.appendChild(I);
            }
            if (((O.prevActiveIndex = O.activeIndex), O.options.liveSearch)) {
              if (C && t) {
                var S,
                  y = 0;
                O.selectpicker.view.canHighlight[y] ||
                  (y = 1 + O.selectpicker.view.canHighlight.slice(1).indexOf(!0)),
                  (S = O.selectpicker.view.visibleElements[y]),
                  O.selectpicker.view.currentActive &&
                    (O.selectpicker.view.currentActive.classList.remove('active'),
                    O.selectpicker.view.currentActive.firstChild &&
                      O.selectpicker.view.currentActive.firstChild.classList.remove('active')),
                  S &&
                    (S.classList.add('active'),
                    S.firstChild && S.firstChild.classList.add('active')),
                  (O.activeIndex = O.selectpicker.current.map.originalIndex[y]);
              }
            } else O.$menuInner.focus();
          }
          this.setPositionData(),
            i(e, !0),
            this.$menuInner.off('scroll.createView').on('scroll.createView', function (e, t) {
              O.noScroll || i(this.scrollTop, t), (O.noScroll = !1);
            }),
            F(window)
              .off('resize.createView')
              .on('resize.createView', function () {
                i(O.$menuInner[0].scrollTop);
              });
        },
        createLi: function () {
          var z,
            T = this,
            D = [],
            H = 0,
            L = 0,
            N = [],
            A = 0,
            P = 0,
            R = -1;
          this.selectpicker.view.titleOption ||
            (this.selectpicker.view.titleOption = document.createElement('option'));
          var W = {
              span: document.createElement('span'),
              subtext: document.createElement('small'),
              a: document.createElement('a'),
              li: document.createElement('li'),
              whitespace: document.createTextNode(' ')
            },
            e = W.span.cloneNode(!1),
            B = document.createDocumentFragment();
          (e.className = T.options.iconBase + ' ' + T.options.tickIcon + ' check-mark'),
            W.a.appendChild(e),
            W.a.setAttribute('role', 'option'),
            (W.subtext.className = 'text-muted'),
            (W.text = W.span.cloneNode(!1)),
            (W.text.className = 'text');
          var M = function (e, t, i, s) {
              var n = W.li.cloneNode(!1);
              return (
                e && (1 === e.nodeType || 11 === e.nodeType ? n.appendChild(e) : (n.innerHTML = e)),
                void 0 !== i && '' !== i && (n.className = i),
                null != s && n.classList.add('optgroup-' + s),
                n
              );
            },
            U = function (e, t, i) {
              var s = W.a.cloneNode(!0);
              return (
                e && (11 === e.nodeType ? s.appendChild(e) : s.insertAdjacentHTML('beforeend', e)),
                (void 0 !== t) & ('' !== t) && (s.className = t),
                '4' === _.major && s.classList.add('dropdown-item'),
                i && s.setAttribute('style', i),
                s
              );
            },
            V = function (e) {
              var t,
                i,
                s = W.text.cloneNode(!1);
              if (e.optionContent) s.innerHTML = e.optionContent;
              else {
                if (((s.textContent = e.text), e.optionIcon)) {
                  var n = W.whitespace.cloneNode(!1);
                  ((i = W.span.cloneNode(!1)).className = T.options.iconBase + ' ' + e.optionIcon),
                    B.appendChild(i),
                    B.appendChild(n);
                }
                e.optionSubtext &&
                  (((t = W.subtext.cloneNode(!1)).innerHTML = e.optionSubtext), s.appendChild(t));
              }
              return B.appendChild(s), B;
            };
          if (this.options.title && !this.multiple) {
            R--;
            var t = this.$element[0],
              i = !1,
              s = !this.selectpicker.view.titleOption.parentNode;
            if (s)
              (this.selectpicker.view.titleOption.className = 'bs-title-option'),
                (this.selectpicker.view.titleOption.value = ''),
                (i =
                  void 0 === F(t.options[t.selectedIndex]).attr('selected') &&
                  void 0 === this.$element.data('selected'));
            (s || 0 !== this.selectpicker.view.titleOption.index) &&
              t.insertBefore(this.selectpicker.view.titleOption, t.firstChild),
              i && (t.selectedIndex = 0);
          }
          var j = this.$element.find('option');
          j.each(function (e) {
            var t = F(this);
            if ((R++, !t.hasClass('bs-title-option'))) {
              var i,
                s,
                n = t.data(),
                o = this.className || '',
                l = G(this.style.cssText),
                r = n.content,
                c = this.textContent,
                a = n.tokens,
                d = n.subtext,
                h = n.icon,
                p = t.parent(),
                u = p[0],
                f = 'OPTGROUP' === u.tagName,
                m = f && u.disabled,
                v = this.disabled || m,
                g =
                  this.previousElementSibling && 'OPTGROUP' === this.previousElementSibling.tagName,
                b = p.data();
              if (!0 === n.hidden || (T.options.hideDisabled && ((v && !f) || m))) {
                (i = n.prevHiddenIndex),
                  t.next().data('prevHiddenIndex', void 0 !== i ? i : e),
                  R--,
                  g ||
                    (void 0 !== i &&
                      (y = j[i].previousElementSibling) &&
                      'OPTGROUP' === y.tagName &&
                      !y.disabled &&
                      (g = !0)),
                  g &&
                    'divider' !== N[N.length - 1].type &&
                    (R++,
                    D.push(M(!1, 0, q.DIVIDER, A + 'div')),
                    N.push({type: 'divider', optID: A}));
              } else {
                if (f && !0 !== n.divider) {
                  if (T.options.hideDisabled && v) {
                    if (void 0 === b.allOptionsDisabled) {
                      var w = p.children();
                      p.data('allOptionsDisabled', w.filter(':disabled').length === w.length);
                    }
                    if (p.data('allOptionsDisabled')) return void R--;
                  }
                  var x = ' ' + u.className || '';
                  if (!this.previousElementSibling) {
                    A += 1;
                    var I = u.label,
                      k = G(I),
                      $ = b.subtext,
                      E = b.icon;
                    0 !== e &&
                      0 < D.length &&
                      (R++,
                      D.push(M(!1, 0, q.DIVIDER, A + 'div')),
                      N.push({type: 'divider', optID: A})),
                      R++;
                    var S = (function (e) {
                      var t,
                        i,
                        s = W.text.cloneNode(!1);
                      if (((s.innerHTML = e.labelEscaped), e.labelIcon)) {
                        var n = W.whitespace.cloneNode(!1);
                        ((i = W.span.cloneNode(!1)).className =
                          T.options.iconBase + ' ' + e.labelIcon),
                          B.appendChild(i),
                          B.appendChild(n);
                      }
                      return (
                        e.labelSubtext &&
                          (((t = W.subtext.cloneNode(!1)).textContent = e.labelSubtext),
                          s.appendChild(t)),
                        B.appendChild(s),
                        B
                      );
                    })({labelEscaped: k, labelSubtext: $, labelIcon: E});
                    D.push(M(S, 0, 'dropdown-header' + x, A)),
                      N.push({content: k, subtext: $, type: 'optgroup-label', optID: A}),
                      (P = R - 1);
                  }
                  if ((T.options.hideDisabled && v) || !0 === n.hidden) return void R--;
                  (s = V({text: c, optionContent: r, optionSubtext: d, optionIcon: h})),
                    D.push(M(U(s, 'opt ' + o + x, l), 0, '', A)),
                    N.push({
                      content: r || c,
                      subtext: d,
                      tokens: a,
                      type: 'option',
                      optID: A,
                      headerIndex: P,
                      lastIndex: P + u.childElementCount,
                      originalIndex: e,
                      data: n
                    }),
                    H++;
                } else if (!0 === n.divider)
                  D.push(M(!1, 0, q.DIVIDER)), N.push({type: 'divider', originalIndex: e, data: n});
                else {
                  var y;
                  if (!g && T.options.hideDisabled)
                    if (void 0 !== (i = n.prevHiddenIndex))
                      (y = j[i].previousElementSibling) &&
                        'OPTGROUP' === y.tagName &&
                        !y.disabled &&
                        (g = !0);
                  g &&
                    'divider' !== N[N.length - 1].type &&
                    (R++,
                    D.push(M(!1, 0, q.DIVIDER, A + 'div')),
                    N.push({type: 'divider', optID: A})),
                    (s = V({text: c, optionContent: r, optionSubtext: d, optionIcon: h})),
                    D.push(M(U(s, o, l))),
                    N.push({
                      content: r || c,
                      subtext: d,
                      tokens: a,
                      type: 'option',
                      originalIndex: e,
                      data: n
                    }),
                    H++;
                }
                (T.selectpicker.main.map.newIndex[e] = R),
                  (T.selectpicker.main.map.originalIndex[R] = e);
                var C = N[N.length - 1];
                C.disabled = v;
                var O = 0;
                C.content && (O += C.content.length),
                  C.subtext && (O += C.subtext.length),
                  h && (O += 1),
                  L < O && ((L = O), (z = D[D.length - 1]));
              }
            }
          }),
            (this.selectpicker.main.elements = D),
            (this.selectpicker.main.data = N),
            (this.selectpicker.current = this.selectpicker.main),
            (this.selectpicker.view.widestOption = z),
            (this.selectpicker.view.availableOptionsCount = H);
        },
        findLis: function () {
          return this.$menuInner.find('.inner > li');
        },
        render: function () {
          var e = this,
            t = this.$element.find('option'),
            i = [],
            s = [];
          this.togglePlaceholder(), this.tabIndex();
          for (var n = 0, o = this.selectpicker.main.elements.length; n < o; n++) {
            var l = t[this.selectpicker.main.map.originalIndex[n]];
            if (
              l &&
              l.selected &&
              (i.push(l),
              (s.length < 100 && 'count' !== e.options.selectedTextFormat) || 1 === i.length)
            ) {
              if (
                e.options.hideDisabled &&
                (l.disabled || ('OPTGROUP' === l.parentNode.tagName && l.parentNode.disabled))
              )
                return;
              var r,
                c,
                a = this.selectpicker.main.data[n].data,
                d =
                  a.icon && e.options.showIcon
                    ? '<i class="' + e.options.iconBase + ' ' + a.icon + '"></i> '
                    : '';
              (r =
                e.options.showSubtext && a.subtext && !e.multiple
                  ? ' <small class="text-muted">' + a.subtext + '</small>'
                  : ''),
                (c = l.title
                  ? l.title
                  : a.content && e.options.showContent
                  ? a.content.toString()
                  : d + l.innerHTML.trim() + r),
                s.push(c);
            }
          }
          var h = this.multiple ? s.join(this.options.multipleSeparator) : s[0];
          if (
            (50 < i.length && (h += '...'),
            this.multiple && -1 !== this.options.selectedTextFormat.indexOf('count'))
          ) {
            var p = this.options.selectedTextFormat.split('>');
            if ((1 < p.length && i.length > p[1]) || (1 === p.length && 2 <= i.length)) {
              var u = this.selectpicker.view.availableOptionsCount;
              h = (
                'function' == typeof this.options.countSelectedText
                  ? this.options.countSelectedText(i.length, u)
                  : this.options.countSelectedText
              )
                .replace('{0}', i.length.toString())
                .replace('{1}', u.toString());
            }
          }
          null == this.options.title && (this.options.title = this.$element.attr('title')),
            'static' == this.options.selectedTextFormat && (h = this.options.title),
            h ||
              (h =
                void 0 !== this.options.title ? this.options.title : this.options.noneSelectedText),
            (this.$button[0].title = f(h.replace(/<[^>]*>?/g, '').trim())),
            (this.$button.find('.filter-option-inner-inner')[0].innerHTML = h),
            this.$element.trigger('rendered.bs.select');
        },
        setStyle: function (e, t) {
          this.$element.attr('class') &&
            this.$newElement.addClass(
              this.$element
                .attr('class')
                .replace(/selectpicker|mobile-device|bs-select-hidden|validate\[.*\]/gi, '')
            );
          var i = e || this.options.style;
          'add' == t
            ? this.$button.addClass(i)
            : 'remove' == t
            ? this.$button.removeClass(i)
            : (this.$button.removeClass(this.options.style), this.$button.addClass(i));
        },
        liHeight: function (e) {
          if (e || (!1 !== this.options.size && !this.sizeInfo)) {
            this.sizeInfo || (this.sizeInfo = {});
            var t = document.createElement('div'),
              i = document.createElement('div'),
              s = document.createElement('div'),
              n = document.createElement('ul'),
              o = document.createElement('li'),
              l = document.createElement('li'),
              r = document.createElement('li'),
              c = document.createElement('a'),
              a = document.createElement('span'),
              d =
                this.options.header && 0 < this.$menu.find('.' + q.POPOVERHEADER).length
                  ? this.$menu.find('.' + q.POPOVERHEADER)[0].cloneNode(!0)
                  : null,
              h = this.options.liveSearch ? document.createElement('div') : null,
              p =
                this.options.actionsBox &&
                this.multiple &&
                0 < this.$menu.find('.bs-actionsbox').length
                  ? this.$menu.find('.bs-actionsbox')[0].cloneNode(!0)
                  : null,
              u =
                this.options.doneButton &&
                this.multiple &&
                0 < this.$menu.find('.bs-donebutton').length
                  ? this.$menu.find('.bs-donebutton')[0].cloneNode(!0)
                  : null;
            if (
              ((this.sizeInfo.selectWidth = this.$newElement[0].offsetWidth),
              (a.className = 'text'),
              (c.className = 'dropdown-item ' + this.$element.find('option')[0].className),
              (t.className = this.$menu[0].parentNode.className + ' ' + q.SHOW),
              (t.style.width = this.sizeInfo.selectWidth + 'px'),
              'auto' === this.options.width && (i.style.minWidth = 0),
              (i.className = q.MENU + ' ' + q.SHOW),
              (s.className = 'inner ' + q.SHOW),
              (n.className = q.MENU + ' inner ' + ('4' === _.major ? q.SHOW : '')),
              (o.className = q.DIVIDER),
              (l.className = 'dropdown-header'),
              a.appendChild(document.createTextNode('Inner text')),
              c.appendChild(a),
              r.appendChild(c),
              l.appendChild(a.cloneNode(!0)),
              this.selectpicker.view.widestOption &&
                n.appendChild(this.selectpicker.view.widestOption.cloneNode(!0)),
              n.appendChild(r),
              n.appendChild(o),
              n.appendChild(l),
              d && i.appendChild(d),
              h)
            ) {
              var f = document.createElement('input');
              (h.className = 'bs-searchbox'),
                (f.className = 'form-control'),
                h.appendChild(f),
                i.appendChild(h);
            }
            p && i.appendChild(p),
              s.appendChild(n),
              i.appendChild(s),
              u && i.appendChild(u),
              t.appendChild(i),
              document.body.appendChild(t);
            var m,
              v = c.offsetHeight,
              g = l ? l.offsetHeight : 0,
              b = d ? d.offsetHeight : 0,
              w = h ? h.offsetHeight : 0,
              x = p ? p.offsetHeight : 0,
              I = u ? u.offsetHeight : 0,
              k = F(o).outerHeight(!0),
              $ = !!window.getComputedStyle && window.getComputedStyle(i),
              E = i.offsetWidth,
              S = $ ? null : F(i),
              y = {
                vert:
                  O($ ? $.paddingTop : S.css('paddingTop')) +
                  O($ ? $.paddingBottom : S.css('paddingBottom')) +
                  O($ ? $.borderTopWidth : S.css('borderTopWidth')) +
                  O($ ? $.borderBottomWidth : S.css('borderBottomWidth')),
                horiz:
                  O($ ? $.paddingLeft : S.css('paddingLeft')) +
                  O($ ? $.paddingRight : S.css('paddingRight')) +
                  O($ ? $.borderLeftWidth : S.css('borderLeftWidth')) +
                  O($ ? $.borderRightWidth : S.css('borderRightWidth'))
              },
              C = {
                vert:
                  y.vert +
                  O($ ? $.marginTop : S.css('marginTop')) +
                  O($ ? $.marginBottom : S.css('marginBottom')) +
                  2,
                horiz:
                  y.horiz +
                  O($ ? $.marginLeft : S.css('marginLeft')) +
                  O($ ? $.marginRight : S.css('marginRight')) +
                  2
              };
            (s.style.overflowY = 'scroll'),
              (m = i.offsetWidth - E),
              document.body.removeChild(t),
              (this.sizeInfo.liHeight = v),
              (this.sizeInfo.dropdownHeaderHeight = g),
              (this.sizeInfo.headerHeight = b),
              (this.sizeInfo.searchHeight = w),
              (this.sizeInfo.actionsHeight = x),
              (this.sizeInfo.doneButtonHeight = I),
              (this.sizeInfo.dividerHeight = k),
              (this.sizeInfo.menuPadding = y),
              (this.sizeInfo.menuExtras = C),
              (this.sizeInfo.menuWidth = E),
              (this.sizeInfo.totalMenuWidth = this.sizeInfo.menuWidth),
              (this.sizeInfo.scrollBarWidth = m),
              (this.sizeInfo.selectHeight = this.$newElement[0].offsetHeight),
              this.setPositionData();
          }
        },
        getSelectPosition: function () {
          var e,
            t = F(window),
            i = this.$newElement.offset(),
            s = F(this.options.container);
          this.options.container && !s.is('body')
            ? (((e = s.offset()).top += parseInt(s.css('borderTopWidth'))),
              (e.left += parseInt(s.css('borderLeftWidth'))))
            : (e = {top: 0, left: 0});
          var n = this.options.windowPadding;
          (this.sizeInfo.selectOffsetTop = i.top - e.top - t.scrollTop()),
            (this.sizeInfo.selectOffsetBot =
              t.height() -
              this.sizeInfo.selectOffsetTop -
              this.sizeInfo.selectHeight -
              e.top -
              n[2]),
            (this.sizeInfo.selectOffsetLeft = i.left - e.left - t.scrollLeft()),
            (this.sizeInfo.selectOffsetRight =
              t.width() -
              this.sizeInfo.selectOffsetLeft -
              this.sizeInfo.selectWidth -
              e.left -
              n[1]),
            (this.sizeInfo.selectOffsetTop -= n[0]),
            (this.sizeInfo.selectOffsetLeft -= n[3]);
        },
        setMenuSize: function (e) {
          this.getSelectPosition();
          var t,
            i,
            s,
            n,
            o,
            l,
            r,
            c = this.sizeInfo.selectWidth,
            a = this.sizeInfo.liHeight,
            d = this.sizeInfo.headerHeight,
            h = this.sizeInfo.searchHeight,
            p = this.sizeInfo.actionsHeight,
            u = this.sizeInfo.doneButtonHeight,
            f = this.sizeInfo.dividerHeight,
            m = this.sizeInfo.menuPadding,
            v = 0;
          if (
            (this.options.dropupAuto &&
              ((r = a * this.selectpicker.current.elements.length + m.vert),
              this.$newElement.toggleClass(
                q.DROPUP,
                this.sizeInfo.selectOffsetTop - this.sizeInfo.selectOffsetBot >
                  this.sizeInfo.menuExtras.vert &&
                  r + this.sizeInfo.menuExtras.vert + 50 > this.sizeInfo.selectOffsetBot
              )),
            'auto' === this.options.size)
          )
            (n =
              3 < this.selectpicker.current.elements.length
                ? 3 * this.sizeInfo.liHeight + this.sizeInfo.menuExtras.vert - 2
                : 0),
              (i = this.sizeInfo.selectOffsetBot - this.sizeInfo.menuExtras.vert),
              (s = n + d + h + p + u),
              (l = Math.max(n - m.vert, 0)),
              this.$newElement.hasClass(q.DROPUP) &&
                (i = this.sizeInfo.selectOffsetTop - this.sizeInfo.menuExtras.vert),
              (t = (o = i) - d - h - p - u - m.vert);
          else if (
            this.options.size &&
            'auto' != this.options.size &&
            this.selectpicker.current.elements.length > this.options.size
          ) {
            for (var g = 0; g < this.options.size; g++)
              'divider' === this.selectpicker.current.data[g].type && v++;
            (t = (i = a * this.options.size + v * f + m.vert) - m.vert),
              (o = i + d + h + p + u),
              (s = l = '');
          }
          'auto' === this.options.dropdownAlignRight &&
            this.$menu.toggleClass(
              q.MENURIGHT,
              this.sizeInfo.selectOffsetLeft > this.sizeInfo.selectOffsetRight &&
                this.sizeInfo.selectOffsetRight < this.$menu[0].offsetWidth - c
            ),
            this.$menu.css({'max-height': o + 'px', overflow: 'hidden', 'min-height': s + 'px'}),
            this.$menuInner.css({
              'max-height': t + 'px',
              'overflow-y': 'auto',
              'min-height': l + 'px'
            }),
            (this.sizeInfo.menuInnerHeight = t),
            this.selectpicker.current.data.length &&
              this.selectpicker.current.data[this.selectpicker.current.data.length - 1].position >
                this.sizeInfo.menuInnerHeight &&
              ((this.sizeInfo.hasScrollBar = !0),
              (this.sizeInfo.totalMenuWidth =
                this.sizeInfo.menuWidth + this.sizeInfo.scrollBarWidth),
              this.$menu.css('min-width', this.sizeInfo.totalMenuWidth)),
            this.dropdown && this.dropdown._popper && this.dropdown._popper.update();
        },
        setSize: function (e) {
          if (
            (this.liHeight(e),
            this.options.header && this.$menu.css('padding-top', 0),
            !1 !== this.options.size)
          ) {
            var t,
              i = this,
              s = F(window),
              n = 0;
            this.setMenuSize(),
              'auto' === this.options.size
                ? (this.$searchbox
                    .off('input.setMenuSize propertychange.setMenuSize')
                    .on('input.setMenuSize propertychange.setMenuSize', function () {
                      return i.setMenuSize();
                    }),
                  s
                    .off('resize.setMenuSize scroll.setMenuSize')
                    .on('resize.setMenuSize scroll.setMenuSize', function () {
                      return i.setMenuSize();
                    }))
                : this.options.size &&
                  'auto' != this.options.size &&
                  this.selectpicker.current.elements.length > this.options.size &&
                  (this.$searchbox.off('input.setMenuSize propertychange.setMenuSize'),
                  s.off('resize.setMenuSize scroll.setMenuSize')),
              e
                ? (n = this.$menuInner[0].scrollTop)
                : i.multiple ||
                  ('number' ==
                    typeof (t = i.selectpicker.main.map.newIndex[i.$element[0].selectedIndex]) &&
                    !1 !== i.options.size &&
                    (n =
                      (n = i.sizeInfo.liHeight * t) -
                      i.sizeInfo.menuInnerHeight / 2 +
                      i.sizeInfo.liHeight / 2)),
              i.createView(!1, n);
          }
        },
        setWidth: function () {
          var i = this;
          'auto' === this.options.width
            ? requestAnimationFrame(function () {
                i.$menu.css('min-width', '0'), i.liHeight(), i.setMenuSize();
                var e = i.$newElement.clone().appendTo('body'),
                  t = e.css('width', 'auto').children('button').outerWidth();
                e.remove(),
                  (i.sizeInfo.selectWidth = Math.max(i.sizeInfo.totalMenuWidth, t)),
                  i.$newElement.css('width', i.sizeInfo.selectWidth + 'px');
              })
            : 'fit' === this.options.width
            ? (this.$menu.css('min-width', ''),
              this.$newElement.css('width', '').addClass('fit-width'))
            : this.options.width
            ? (this.$menu.css('min-width', ''), this.$newElement.css('width', this.options.width))
            : (this.$menu.css('min-width', ''), this.$newElement.css('width', '')),
            this.$newElement.hasClass('fit-width') &&
              'fit' !== this.options.width &&
              this.$newElement.removeClass('fit-width');
        },
        selectPosition: function () {
          this.$bsContainer = F('<div class="bs-container" />');
          var s,
            n,
            o,
            l = this,
            r = F(this.options.container),
            e = function (e) {
              var t = {},
                i = l.options.display || F.fn.dropdown.Constructor.Default.display;
              l.$bsContainer
                .addClass(e.attr('class').replace(/form-control|fit-width/gi, ''))
                .toggleClass(q.DROPUP, e.hasClass(q.DROPUP)),
                (s = e.offset()),
                r.is('body')
                  ? (n = {top: 0, left: 0})
                  : (((n = r.offset()).top += parseInt(r.css('borderTopWidth')) - r.scrollTop()),
                    (n.left += parseInt(r.css('borderLeftWidth')) - r.scrollLeft())),
                (o = e.hasClass(q.DROPUP) ? 0 : e[0].offsetHeight),
                (_.major < 4 || 'static' === i) &&
                  ((t.top = s.top - n.top + o), (t.left = s.left - n.left)),
                (t.width = e[0].offsetWidth),
                l.$bsContainer.css(t);
            };
          this.$button.on('click.bs.dropdown.data-api', function () {
            l.isDisabled() ||
              (e(l.$newElement),
              l.$bsContainer
                .appendTo(l.options.container)
                .toggleClass(q.SHOW, !l.$button.hasClass(q.SHOW))
                .append(l.$menu));
          }),
            F(window).on('resize scroll', function () {
              e(l.$newElement);
            }),
            this.$element.on('hide.bs.select', function () {
              l.$menu.data('height', l.$menu.height()), l.$bsContainer.detach();
            });
        },
        setOptionStatus: function () {
          var e = this,
            t = this.$element.find('option');
          if (
            ((e.noScroll = !1),
            e.selectpicker.view.visibleElements && e.selectpicker.view.visibleElements.length)
          )
            for (var i = 0; i < e.selectpicker.view.visibleElements.length; i++) {
              var s = e.selectpicker.current.map.originalIndex[i + e.selectpicker.view.position0],
                n = t[s];
              if (n) {
                var o = this.selectpicker.main.map.newIndex[s],
                  l = this.selectpicker.main.elements[o];
                e.setDisabled(
                  s,
                  n.disabled || ('OPTGROUP' === n.parentNode.tagName && n.parentNode.disabled),
                  o,
                  l
                ),
                  e.setSelected(s, n.selected, o, l);
              }
            }
        },
        setSelected: function (e, t, i, s) {
          var n,
            o,
            l,
            r = void 0 !== this.activeIndex,
            c = this.activeIndex === e || (t && !this.multiple && !r);
          i || (i = this.selectpicker.main.map.newIndex[e]),
            s || (s = this.selectpicker.main.elements[i]),
            (l = s.firstChild),
            t && (this.selectedIndex = e),
            s.classList.toggle('selected', t),
            s.classList.toggle('active', c),
            c && ((this.selectpicker.view.currentActive = s), (this.activeIndex = e)),
            l &&
              (l.classList.toggle('selected', t),
              l.classList.toggle('active', c),
              l.setAttribute('aria-selected', t)),
            c ||
              (!r &&
                t &&
                void 0 !== this.prevActiveIndex &&
                ((n = this.selectpicker.main.map.newIndex[this.prevActiveIndex]),
                (o = this.selectpicker.main.elements[n]).classList.toggle('selected', t),
                o.classList.remove('active'),
                o.firstChild &&
                  (o.firstChild.classList.toggle('selected', t),
                  o.firstChild.classList.remove('active'))));
        },
        setDisabled: function (e, t, i, s) {
          var n;
          i || (i = this.selectpicker.main.map.newIndex[e]),
            s || (s = this.selectpicker.main.elements[i]),
            (n = s.firstChild),
            s.classList.toggle(q.DISABLED, t),
            n &&
              ('4' === _.major && n.classList.toggle(q.DISABLED, t),
              n.setAttribute('aria-disabled', t),
              t ? n.setAttribute('tabindex', -1) : n.setAttribute('tabindex', 0));
        },
        isDisabled: function () {
          return this.$element[0].disabled;
        },
        checkDisabled: function () {
          var e = this;
          this.isDisabled()
            ? (this.$newElement.addClass(q.DISABLED),
              this.$button.addClass(q.DISABLED).attr('tabindex', -1).attr('aria-disabled', !0))
            : (this.$button.hasClass(q.DISABLED) &&
                (this.$newElement.removeClass(q.DISABLED),
                this.$button.removeClass(q.DISABLED).attr('aria-disabled', !1)),
              -1 != this.$button.attr('tabindex') ||
                this.$element.data('tabindex') ||
                this.$button.removeAttr('tabindex')),
            this.$button.click(function () {
              return !e.isDisabled();
            });
        },
        togglePlaceholder: function () {
          var e = this.$element[0],
            t = e.selectedIndex,
            i = -1 === t;
          i || e.options[t].value || (i = !0), this.$button.toggleClass('bs-placeholder', i);
        },
        tabIndex: function () {
          this.$element.data('tabindex') !== this.$element.attr('tabindex') &&
            -98 !== this.$element.attr('tabindex') &&
            '-98' !== this.$element.attr('tabindex') &&
            (this.$element.data('tabindex', this.$element.attr('tabindex')),
            this.$button.attr('tabindex', this.$element.data('tabindex'))),
            this.$element.attr('tabindex', -98);
        },
        clickListener: function () {
          var E = this,
            t = F(document);
          function e() {
            E.options.liveSearch ? E.$searchbox.focus() : E.$menuInner.focus();
          }
          function i() {
            E.dropdown && E.dropdown._popper && E.dropdown._popper.state.isCreated
              ? e()
              : requestAnimationFrame(i);
          }
          t.data('spaceSelect', !1),
            this.$button.on('keyup', function (e) {
              /(32)/.test(e.keyCode.toString(10)) &&
                t.data('spaceSelect') &&
                (e.preventDefault(), t.data('spaceSelect', !1));
            }),
            this.$newElement.on('show.bs.dropdown', function () {
              3 < _.major &&
                !E.dropdown &&
                ((E.dropdown = E.$button.data('bs.dropdown')), (E.dropdown._menu = E.$menu[0]));
            }),
            this.$button.on('click.bs.dropdown.data-api', function () {
              E.$newElement.hasClass(q.SHOW) || E.setSize();
            }),
            this.$element.on('shown.bs.select', function () {
              E.$menuInner[0].scrollTop !== E.selectpicker.view.scrollTop &&
                (E.$menuInner[0].scrollTop = E.selectpicker.view.scrollTop),
                3 < _.major ? requestAnimationFrame(i) : e();
            }),
            this.$menuInner.on('click', 'li a', function (e, t) {
              var i = F(this),
                s = E.isVirtual() ? E.selectpicker.view.position0 : 0,
                n = E.selectpicker.current.map.originalIndex[i.parent().index() + s],
                o = S(E.$element[0]),
                l = E.$element.prop('selectedIndex'),
                r = !0;
              if (
                (E.multiple && 1 !== E.options.maxOptions && e.stopPropagation(),
                e.preventDefault(),
                !E.isDisabled() && !i.parent().hasClass(q.DISABLED))
              ) {
                var c = E.$element.find('option'),
                  a = c.eq(n),
                  d = a.prop('selected'),
                  h = a.parent('optgroup'),
                  p = h.find('option'),
                  u = E.options.maxOptions,
                  f = h.data('maxOptions') || !1;
                if (
                  (n === E.activeIndex && (t = !0),
                  t || ((E.prevActiveIndex = E.activeIndex), (E.activeIndex = void 0)),
                  E.multiple)
                ) {
                  if (
                    (a.prop('selected', !d), E.setSelected(n, !d), i.blur(), !1 !== u || !1 !== f)
                  ) {
                    var m = u < c.filter(':selected').length,
                      v = f < h.find('option:selected').length;
                    if ((u && m) || (f && v))
                      if (u && 1 == u) {
                        c.prop('selected', !1), a.prop('selected', !0);
                        for (var g = 0; g < c.length; g++) E.setSelected(g, !1);
                        E.setSelected(n, !0);
                      } else if (f && 1 == f) {
                        h.find('option:selected').prop('selected', !1), a.prop('selected', !0);
                        for (g = 0; g < p.length; g++) {
                          var b = p[g];
                          E.setSelected(c.index(b), !1);
                        }
                        E.setSelected(n, !0);
                      } else {
                        var w =
                            'string' == typeof E.options.maxOptionsText
                              ? [E.options.maxOptionsText, E.options.maxOptionsText]
                              : E.options.maxOptionsText,
                          x = 'function' == typeof w ? w(u, f) : w,
                          I = x[0].replace('{n}', u),
                          k = x[1].replace('{n}', f),
                          $ = F('<div class="notify"></div>');
                        x[2] &&
                          ((I = I.replace('{var}', x[2][1 < u ? 0 : 1])),
                          (k = k.replace('{var}', x[2][1 < f ? 0 : 1]))),
                          a.prop('selected', !1),
                          E.$menu.append($),
                          u &&
                            m &&
                            ($.append(F('<div>' + I + '</div>')),
                            (r = !1),
                            E.$element.trigger('maxReached.bs.select')),
                          f &&
                            v &&
                            ($.append(F('<div>' + k + '</div>')),
                            (r = !1),
                            E.$element.trigger('maxReachedGrp.bs.select')),
                          setTimeout(function () {
                            E.setSelected(n, !1);
                          }, 10),
                          $.delay(750).fadeOut(300, function () {
                            F(this).remove();
                          });
                      }
                  }
                } else c.prop('selected', !1), a.prop('selected', !0), E.setSelected(n, !0);
                !E.multiple || (E.multiple && 1 === E.options.maxOptions)
                  ? E.$button.focus()
                  : E.options.liveSearch && E.$searchbox.focus(),
                  r &&
                    ((o != S(E.$element[0]) && E.multiple) ||
                      (l != E.$element.prop('selectedIndex') && !E.multiple)) &&
                    ((y = [n, a.prop('selected'), o]), E.$element.triggerNative('change'));
              }
            }),
            this.$menu.on(
              'click',
              'li.' +
                q.DISABLED +
                ' a, .' +
                q.POPOVERHEADER +
                ', .' +
                q.POPOVERHEADER +
                ' :not(.close)',
              function (e) {
                e.currentTarget == this &&
                  (e.preventDefault(),
                  e.stopPropagation(),
                  E.options.liveSearch && !F(e.target).hasClass('close')
                    ? E.$searchbox.focus()
                    : E.$button.focus());
              }
            ),
            this.$menuInner.on('click', '.divider, .dropdown-header', function (e) {
              e.preventDefault(),
                e.stopPropagation(),
                E.options.liveSearch ? E.$searchbox.focus() : E.$button.focus();
            }),
            this.$menu.on('click', '.' + q.POPOVERHEADER + ' .close', function () {
              E.$button.click();
            }),
            this.$searchbox.on('click', function (e) {
              e.stopPropagation();
            }),
            this.$menu.on('click', '.actions-btn', function (e) {
              E.options.liveSearch ? E.$searchbox.focus() : E.$button.focus(),
                e.preventDefault(),
                e.stopPropagation(),
                F(this).hasClass('bs-select-all') ? E.selectAll() : E.deselectAll();
            }),
            this.$element.on({
              change: function () {
                E.render(), E.$element.trigger('changed.bs.select', y), (y = null);
              },
              focus: function () {
                E.$button.focus();
              }
            });
        },
        liveSearchListener: function () {
          var u = this,
            f = document.createElement('li');
          this.$button.on('click.bs.dropdown.data-api', function () {
            u.$searchbox.val() && u.$searchbox.val('');
          }),
            this.$searchbox.on(
              'click.bs.dropdown.data-api focus.bs.dropdown.data-api touchend.bs.dropdown.data-api',
              function (e) {
                e.stopPropagation();
              }
            ),
            this.$searchbox.on('input propertychange', function () {
              var e = u.$searchbox.val();
              if (
                ((u.selectpicker.search.map.newIndex = {}),
                (u.selectpicker.search.map.originalIndex = {}),
                (u.selectpicker.search.elements = []),
                (u.selectpicker.search.data = []),
                e)
              ) {
                var t = [],
                  i = e.toUpperCase(),
                  s = {},
                  n = [],
                  o = u._searchStyle(),
                  l = u.options.liveSearchNormalize;
                u._$lisSelected = u.$menuInner.find('.selected');
                for (var r = 0; r < u.selectpicker.main.data.length; r++) {
                  var c = u.selectpicker.main.data[r];
                  s[r] || (s[r] = $(c, i, o, l)),
                    s[r] &&
                      void 0 !== c.headerIndex &&
                      -1 === n.indexOf(c.headerIndex) &&
                      (0 < c.headerIndex &&
                        ((s[c.headerIndex - 1] = !0), n.push(c.headerIndex - 1)),
                      (s[c.headerIndex] = !0),
                      n.push(c.headerIndex),
                      (s[c.lastIndex + 1] = !0)),
                    s[r] && 'optgroup-label' !== c.type && n.push(r);
                }
                r = 0;
                for (var a = n.length; r < a; r++) {
                  var d = n[r],
                    h = n[r - 1],
                    p = ((c = u.selectpicker.main.data[d]), u.selectpicker.main.data[h]);
                  ('divider' !== c.type ||
                    ('divider' === c.type && p && 'divider' !== p.type && a - 1 !== r)) &&
                    (u.selectpicker.search.data.push(c),
                    t.push(u.selectpicker.main.elements[d]),
                    c.hasOwnProperty('originalIndex') &&
                      ((u.selectpicker.search.map.newIndex[c.originalIndex] = t.length - 1),
                      (u.selectpicker.search.map.originalIndex[t.length - 1] = c.originalIndex)));
                }
                (u.activeIndex = void 0),
                  (u.noScroll = !0),
                  u.$menuInner.scrollTop(0),
                  (u.selectpicker.search.elements = t),
                  u.createView(!0),
                  t.length ||
                    ((f.className = 'no-results'),
                    (f.innerHTML = u.options.noneResultsText.replace('{0}', '"' + G(e) + '"')),
                    u.$menuInner[0].firstChild.appendChild(f));
              } else u.$menuInner.scrollTop(0), u.createView(!1);
            });
        },
        _searchStyle: function () {
          return this.options.liveSearchStyle || 'contains';
        },
        val: function (e) {
          return void 0 !== e
            ? (this.$element.val(e).triggerNative('change'), this.$element)
            : this.$element.val();
        },
        changeAll: function (e) {
          if (this.multiple) {
            void 0 === e && (e = !0);
            var t = this.$element.find('option'),
              i = 0,
              s = 0,
              n = S(this.$element[0]);
            this.$element.addClass('bs-select-hidden');
            for (var o = 0; o < this.selectpicker.current.elements.length; o++) {
              var l = this.selectpicker.current.data[o],
                r = t[this.selectpicker.current.map.originalIndex[o]];
              r &&
                !r.disabled &&
                'divider' !== l.type &&
                (r.selected && i++, (r.selected = e), r.selected && s++);
            }
            this.$element.removeClass('bs-select-hidden'),
              i !== s &&
                (this.setOptionStatus(),
                this.togglePlaceholder(),
                (y = [null, null, n]),
                this.$element.triggerNative('change'));
          }
        },
        selectAll: function () {
          return this.changeAll(!0);
        },
        deselectAll: function () {
          return this.changeAll(!1);
        },
        toggle: function (e) {
          (e = e || window.event) && e.stopPropagation(),
            this.$button.trigger('click.bs.dropdown.data-api');
        },
        keydown: function (e) {
          var t,
            i,
            s,
            n,
            o,
            l = F(this),
            r = l.hasClass('dropdown-toggle'),
            c = (r ? l.closest('.dropdown') : l.closest(N.MENU)).data('this'),
            a = c.findLis(),
            d = !1,
            h = e.which === D && !r && !c.options.selectOnTab,
            p = A.test(e.which) || h,
            u = c.$menuInner[0].scrollTop,
            f = c.isVirtual(),
            m = !0 === f ? c.selectpicker.view.position0 : 0;
          if (
            (!(i = c.$newElement.hasClass(q.SHOW)) &&
              (p ||
                (48 <= e.which && e.which <= 57) ||
                (96 <= e.which && e.which <= 105) ||
                (65 <= e.which && e.which <= 90)) &&
              c.$button.trigger('click.bs.dropdown.data-api'),
            e.which === C &&
              i &&
              (e.preventDefault(), c.$button.trigger('click.bs.dropdown.data-api').focus()),
            p)
          ) {
            if (!a.length) return;
            void 0 ===
              (t =
                !0 === f
                  ? a.index(a.filter('.active'))
                  : c.selectpicker.current.map.newIndex[c.activeIndex]) && (t = -1),
              -1 !== t &&
                ((s = c.selectpicker.current.elements[t + m]).classList.remove('active'),
                s.firstChild && s.firstChild.classList.remove('active')),
              e.which === H
                ? (-1 !== t && t--,
                  t + m < 0 && (t += a.length),
                  c.selectpicker.view.canHighlight[t + m] ||
                    (-1 ===
                      (t = c.selectpicker.view.canHighlight.slice(0, t + m).lastIndexOf(!0) - m) &&
                      (t = a.length - 1)))
                : (e.which === L || h) &&
                  (++t + m >= c.selectpicker.view.canHighlight.length && (t = 0),
                  c.selectpicker.view.canHighlight[t + m] ||
                    (t = t + 1 + c.selectpicker.view.canHighlight.slice(t + m + 1).indexOf(!0))),
              e.preventDefault();
            var v = m + t;
            e.which === H
              ? 0 === m && t === a.length - 1
                ? ((c.$menuInner[0].scrollTop = c.$menuInner[0].scrollHeight),
                  (v = c.selectpicker.current.elements.length - 1))
                : (d = (o = (n = c.selectpicker.current.data[v]).position - n.height) < u)
              : (e.which === L || h) &&
                (0 === t
                  ? (v = c.$menuInner[0].scrollTop = 0)
                  : (d =
                      u <
                      (o =
                        (n = c.selectpicker.current.data[v]).position -
                        c.sizeInfo.menuInnerHeight))),
              (s = c.selectpicker.current.elements[v]) &&
                (s.classList.add('active'), s.firstChild && s.firstChild.classList.add('active')),
              (c.activeIndex = c.selectpicker.current.map.originalIndex[v]),
              (c.selectpicker.view.currentActive = s),
              d && (c.$menuInner[0].scrollTop = o),
              c.options.liveSearch ? c.$searchbox.focus() : l.focus();
          } else if (
            (!l.is('input') && !P.test(e.which)) ||
            (e.which === T && c.selectpicker.keydown.keyHistory)
          ) {
            var g,
              b,
              w = [];
            e.preventDefault(),
              (c.selectpicker.keydown.keyHistory += E[e.which]),
              c.selectpicker.keydown.resetKeyHistory.cancel &&
                clearTimeout(c.selectpicker.keydown.resetKeyHistory.cancel),
              (c.selectpicker.keydown.resetKeyHistory.cancel =
                c.selectpicker.keydown.resetKeyHistory.start()),
              (b = c.selectpicker.keydown.keyHistory),
              /^(.)\1+$/.test(b) && (b = b.charAt(0));
            for (var x = 0; x < c.selectpicker.current.data.length; x++) {
              var I = c.selectpicker.current.data[x];
              $(I, b, 'startsWith', !0) &&
                c.selectpicker.view.canHighlight[x] &&
                ((I.index = x), w.push(I.originalIndex));
            }
            if (w.length) {
              var k = 0;
              a.removeClass('active').find('a').removeClass('active'),
                1 === b.length &&
                  (-1 === (k = w.indexOf(c.activeIndex)) || k === w.length - 1 ? (k = 0) : k++),
                (g = c.selectpicker.current.map.newIndex[w[k]]),
                0 < u - (n = c.selectpicker.current.data[g]).position
                  ? ((o = n.position - n.height), (d = !0))
                  : ((o = n.position - c.sizeInfo.menuInnerHeight),
                    (d = n.position > u + c.sizeInfo.menuInnerHeight)),
                (s = c.selectpicker.current.elements[g]).classList.add('active'),
                s.firstChild && s.firstChild.classList.add('active'),
                (c.activeIndex = w[k]),
                s.firstChild.focus(),
                d && (c.$menuInner[0].scrollTop = o),
                l.focus();
            }
          }
          i &&
            ((e.which === T && !c.selectpicker.keydown.keyHistory) ||
              e.which === z ||
              (e.which === D && c.options.selectOnTab)) &&
            (e.which !== T && e.preventDefault(),
            (c.options.liveSearch && e.which === T) ||
              (c.$menuInner.find('.active a').trigger('click', !0),
              l.focus(),
              c.options.liveSearch || (e.preventDefault(), F(document).data('spaceSelect', !0))));
        },
        mobile: function () {
          this.$element.addClass('mobile-device');
        },
        refresh: function () {
          var e = F.extend({}, this.options, this.$element.data());
          (this.options = e),
            (this.selectpicker.main.map.newIndex = {}),
            (this.selectpicker.main.map.originalIndex = {}),
            this.createLi(),
            this.checkDisabled(),
            this.render(),
            this.setStyle(),
            this.setWidth(),
            this.setSize(!0),
            this.$element.trigger('refreshed.bs.select');
        },
        hide: function () {
          this.$newElement.hide();
        },
        show: function () {
          this.$newElement.show();
        },
        remove: function () {
          this.$newElement.remove(), this.$element.remove();
        },
        destroy: function () {
          this.$newElement.before(this.$element).remove(),
            this.$bsContainer ? this.$bsContainer.remove() : this.$menu.remove(),
            this.$element
              .off('.bs.select')
              .removeData('selectpicker')
              .removeClass('bs-select-hidden selectpicker');
        }
      });
    var h = F.fn.selectpicker;
    (F.fn.selectpicker = r),
      (F.fn.selectpicker.Constructor = c),
      (F.fn.selectpicker.noConflict = function () {
        return (F.fn.selectpicker = h), this;
      }),
      F(document)
        .off('keydown.bs.dropdown.data-api')
        .on(
          'keydown.bs.select',
          '.bootstrap-select [data-toggle="dropdown"], .bootstrap-select [role="listbox"], .bs-searchbox input',
          c.prototype.keydown
        )
        .on(
          'focusin.modal',
          '.bootstrap-select [data-toggle="dropdown"], .bootstrap-select [role="listbox"], .bs-searchbox input',
          function (e) {
            e.stopPropagation();
          }
        ),
      F(window).on('load.bs.select.data-api', function () {
        F('.selectpicker').each(function () {
          var e = F(this);
          r.call(e, e.data());
        });
      });
  })(e);
});
//# sourceMappingURL=bootstrap-select.js.map

jQuery(window).on('load', function () {
  $('#preloader').fadeOut(500);
  $('#main-wrapper').addClass('show');

  $('body').attr('data-sidebar-style') === 'mini'
    ? $('.hamburger').addClass('is-active')
    : $('.hamburger').removeClass('is-active');
});

(function ($) {
  'use strict';

  $('#menu').metisMenu();

  $('.nk-nav-scroll').slimscroll({
    position: 'right',
    size: '5px',
    height: '100%',
    color: 'transparent'
  });

  $('.nav-control').on('click', function () {
    $('#main-wrapper').toggleClass('menu-toggle');

    $('.hamburger').toggleClass('is-active');
  });

  $(function () {
    for (
      var nk = window.location,
        o = $('ul#menu a')
          .filter(function () {
            return this.href == nk;
          })
          .addClass('active')
          .parent()
          .addClass('active');
      ;

    ) {
      if (!o.is('li')) break;
      o = o.parent().addClass('in').parent().addClass('active');
    }
  });

  $(function () {
    var win_h = window.outerHeight;
    if (win_h > 0 ? win_h : screen.height) {
      $('.content-body').css('min-height', win_h + 60 + 'px');
    }
  });

  $('.selectpicker').selectpicker();

  $('[data-toggle="popover"]').popover();
  $('[data-toggle="tooltip"]').tooltip();

  const headerHight = $('.header').innerHeight();

  $(window).scroll(function () {
    if (
      $('body').attr('data-layout') === 'horizontal' &&
      $('body').attr('data-header-position') === 'static' &&
      $('body').attr('data-sidebar-position') === 'fixed'
    )
      $(this.window).scrollTop() >= headerHight
        ? $('.metismenu').addClass('fixed')
        : $('.metismenu').removeClass('fixed');
  });

  $('.sidebar-right-trigger').on('click', function () {
    $('.sidebar-right').toggleClass('show');
  });
})(jQuery);

const body = $('body');
const html = $('html');

function quixSettings({
  version,
  layout,
  navheaderBg,
  headerBg,
  sidebarStyle,
  sidebarBg,
  sidebarPosition,
  headerPosition,
  containerLayout,
  direction
}) {
  this.version = version || 'light';
  this.layout = layout || 'vertical';
  this.navheaderBg = navheaderBg || 'color_1';
  this.headerBg = headerBg || 'color_1';
  this.sidebarStyle = sidebarStyle || 'full';
  this.sidebarBg = sidebarBg || 'color_1';
  this.sidebarPosition = sidebarPosition || 'static';
  this.headerPosition = headerPosition || 'static';
  this.containerLayout = containerLayout || 'wide';
  this.direction = direction || 'ltr';

  this.manageVersion();
  this.manageLayout();
  this.manageNavHeaderBg();
  this.manageHeaderBg();
  this.manageSidebarStyle();
  this.manageSidebarBg();
  this.manageSidebarPosition();
  this.manageHeaderPosition();
  this.manageContainerLayout();
  this.manageRtlLayout();
  this.manageResponsiveSidebar();
}

quixSettings.prototype.manageVersion = function () {
  switch (this.version) {
    case 'light':
      body.attr('data-theme-version', 'light');
      break;
    case 'dark':
      body.attr('data-theme-version', 'dark');
      break;
    default:
      body.attr('data-theme-version', 'light');
  }
};

quixSettings.prototype.manageLayout = function () {
  switch (this.layout) {
    case 'horizontal':
      this.sidebarStyle === 'overlay'
        ? body.attr('data-sidebar-style', 'full')
        : body.attr('data-sidebar-style', `${this.sidebarStyle}`);
      body.attr('data-layout', 'horizontal');
      break;
    case 'vertical':
      body.attr('data-layout', 'vertical');
      break;
    default:
      body.attr('data-layout', 'vertical');
  }
};

quixSettings.prototype.manageNavHeaderBg = function () {
  switch (this.navheaderBg) {
    case 'color_1':
      body.attr('data-nav-headerbg', 'color_1');
      break;
    case 'color_2':
      body.attr('data-nav-headerbg', 'color_2');
      break;
    case 'color_3':
      body.attr('data-nav-headerbg', 'color_3');
      break;
    case 'color_4':
      body.attr('data-nav-headerbg', 'color_4');
      break;
    case 'color_5':
      body.attr('data-nav-headerbg', 'color_5');
      break;
    case 'color_6':
      body.attr('data-nav-headerbg', 'color_6');
      break;
    case 'color_7':
      body.attr('data-nav-headerbg', 'color_7');
      break;
    case 'color_8':
      body.attr('data-nav-headerbg', 'color_8');
      break;
    case 'color_9':
      body.attr('data-nav-headerbg', 'color_9');
      break;
    case 'color_10':
      body.attr('data-nav-headerbg', 'color_10');
      break;
    default:
      body.attr('data-nav-headerbg', 'color_1');
  }
};

quixSettings.prototype.manageHeaderBg = function () {
  switch (this.headerBg) {
    case 'color_1':
      body.attr('data-headerbg', 'color_1');
      break;
    case 'color_2':
      body.attr('data-headerbg', 'color_2');
      break;
    case 'color_3':
      body.attr('data-headerbg', 'color_3');
      break;
    case 'color_4':
      body.attr('data-headerbg', 'color_4');
      break;
    case 'color_5':
      body.attr('data-headerbg', 'color_5');
      break;
    case 'color_6':
      body.attr('data-headerbg', 'color_6');
      break;
    case 'color_7':
      body.attr('data-headerbg', 'color_7');
      break;
    case 'color_8':
      body.attr('data-headerbg', 'color_8');
      break;
    case 'color_9':
      body.attr('data-headerbg', 'color_9');
      break;
    case 'color_10':
      body.attr('data-headerbg', 'color_10');
      break;
    default:
      body.attr('data-headerbg', 'color_1');
  }
};

quixSettings.prototype.manageSidebarStyle = function () {
  switch (this.sidebarStyle) {
    case 'full':
      body.attr('data-sidebar-style', 'full');
      break;
    case 'mini':
      body.attr('data-sidebar-style', 'mini');
      break;
    case 'compact':
      body.attr('data-sidebar-style', 'compact');
      break;
    case 'overlay':
      this.layout === 'horizontal'
        ? body.attr('data-sidebar-style', 'full')
        : body.attr('data-sidebar-style', 'overlay');
      break;
    default:
      body.attr('data-sidebar-style', 'full');
  }
};

quixSettings.prototype.manageSidebarBg = function () {
  switch (this.sidebarBg) {
    case 'color_1':
      body.attr('data-sibebarbg', 'color_1');
      break;
    case 'color_2':
      body.attr('data-sibebarbg', 'color_2');
      break;
    case 'color_3':
      body.attr('data-sibebarbg', 'color_3');
      break;
    case 'color_4':
      body.attr('data-sibebarbg', 'color_4');
      break;
    case 'color_5':
      body.attr('data-sibebarbg', 'color_5');
      break;
    case 'color_6':
      body.attr('data-sibebarbg', 'color_6');
      break;
    case 'color_7':
      body.attr('data-sibebarbg', 'color_7');
      break;
    case 'color_8':
      body.attr('data-sibebarbg', 'color_8');
      break;
    case 'color_9':
      body.attr('data-sibebarbg', 'color_9');
      break;
    case 'color_10':
      body.attr('data-sibebarbg', 'color_10');
      break;
    default:
      body.attr('data-sibebarbg', 'color_1');
  }
};

quixSettings.prototype.manageSidebarPosition = function () {
  switch (this.sidebarPosition) {
    case 'fixed':
      this.sidebarStyle === 'overlay' && this.layout === 'vertical'
        ? body.attr('data-sidebar-position', 'static')
        : body.attr('data-sidebar-position', 'fixed');
      break;
    case 'static':
      body.attr('data-sidebar-position', 'static');
      break;
    default:
      body.attr('data-sidebar-position', 'static');
  }
};

quixSettings.prototype.manageHeaderPosition = function () {
  switch (this.headerPosition) {
    case 'fixed':
      body.attr('data-header-position', 'fixed');
      break;
    case 'static':
      body.attr('data-header-position', 'static');
      break;
    default:
      body.attr('data-header-position', 'static');
  }
};

quixSettings.prototype.manageContainerLayout = function () {
  switch (this.containerLayout) {
    case 'boxed':
      if (this.layout === 'vertical' && this.sidebarStyle === 'full') {
        body.attr('data-sidebar-style', 'overlay');
      }
      body.attr('data-container', 'boxed');
      break;
    case 'wide':
      body.attr('data-container', 'wide');
      break;
    default:
      body.attr('data-container', 'wide');
  }
};

quixSettings.prototype.manageRtlLayout = function () {
  switch (this.direction) {
    case 'rtl':
      html.attr('dir', 'rtl');
      html.addClass('rtl');
      body.attr('direction', 'rtl');
      break;
    case 'ltr':
      html.attr('dir', 'ltr');
      html.removeClass('rtl');
      body.attr('direction', 'ltr');
      break;
    default:
      html.attr('dir', 'ltr');
      body.attr('direction', 'ltr');
  }
};

quixSettings.prototype.manageResponsiveSidebar = function () {
  const innerWidth = $(window).innerWidth();
  if (innerWidth < 1200) {
    body.attr('data-layout', 'vertical');
    body.attr('data-container', 'wide');
  }

  if (innerWidth > 767 && innerWidth < 1200) {
    body.attr('data-sidebar-style', 'mini');
  }

  if (innerWidth < 768) {
    body.attr('data-sidebar-style', 'overlay');
  }
};

(function ($) {
  'use strict';

  new quixSettings({
    version: 'light', //2 options "light" and "dark"
    layout: 'vertical', //2 options, "vertical" and "horizontal"
    navheaderBg: 'color_1', //have 10 options, "color_1" to "color_10"
    headerBg: 'color_1', //have 10 options, "color_1" to "color_10"
    sidebarStyle: 'vertical', //defines how sidebar should look like, options are: "full", "compact", "mini" and "overlay". If layout is "horizontal", sidebarStyle won't take "overlay" argument anymore, this will turn into "full" automatically!
    sidebarBg: 'color_1', //have 10 options, "color_1" to "color_10"
    sidebarPosition: 'static', //have two options, "static" and "fixed"
    headerPosition: 'static', //have two options, "static" and "fixed"
    containerLayout: 'wide', //"boxed" and  "wide". If layout "vertical" and containerLayout "boxed", sidebarStyle will automatically turn into "overlay".
    direction: 'ltr' //"ltr" = Left to Right; "rtl" = Right to Left
  });
})(jQuery);

// // data-sibebarbg="color_2"

(function ($) {
  'use strict';

  const versionSelect = $('#theme_version');
  const layoutSelect = $('#theme_layout');
  const sidebarStyleSelect = $('#sidebar_style');
  const sidebarPositionSelect = $('#sidebar_position');
  const headerPositionSelect = $('#header_position');
  const containerLayoutSelect = $('#container_layout');
  const themeDirectionSelect = $('#theme_direction');

  versionSelect.on('change', function () {
    $('body').attr('data-theme-version', this.value);
  });

  sidebarPositionSelect.on('change', function () {
    $('body').attr('data-sidebar-position', this.value);
  });

  headerPositionSelect.on('change', function () {
    $('body').attr('data-header-position', this.value);
  });

  themeDirectionSelect.on('change', function () {
    $('html').attr('dir', this.value);
    $('html').attr('class', '');
    $('html').addClass(this.value);
    $('body').attr('direction', this.value);
  });

  layoutSelect.on('change', function () {
    if ($('body').attr('data-sidebar-style') === 'overlay') {
      $('body').attr('data-sidebar-style', 'full');
      $('body').attr('data-layout', this.value);
      return;
    }

    $('body').attr('data-layout', this.value);
  });

  containerLayoutSelect.on('change', function () {
    if (this.value === 'boxed') {
      // if($('body').attr('data-sidebar-style') === "overlay" && $('body').attr('data-layout') === "horizontal") {
      //     $('body').attr('data-sidebar-style', 'full');
      //     $('body').attr('data-container', this.value);
      //     return;
      // }

      if (
        $('body').attr('data-layout') === 'vertical' &&
        $('body').attr('data-sidebar-style') === 'full'
      ) {
        $('body').attr('data-sidebar-style', 'overlay');
        $('body').attr('data-container', this.value);
        return;
      }
    }

    $('body').attr('data-container', this.value);
  });

  sidebarStyleSelect.on('change', function () {
    if ($('body').attr('data-layout') === 'horizontal') {
      if (this.value === 'overlay') {
        alert('Sorry! Overlay is not possible in Horizontal layout.');
        return;
      }
    }

    if ($('body').attr('data-layout') === 'vertical') {
      if ($('body').attr('data-container') === 'boxed' && this.value === 'full') {
        alert('Sorry! Full menu is not available in Vertical Boxed layout.');
        return;
      }
    }

    $('body').attr('data-sidebar-style', this.value);
  });

  $('input[name="navigation_header"]').on('click', function () {
    $('body').attr('data-nav-headerbg', this.value);
  });

  $('input[name="header_bg"]').on('click', function () {
    $('body').attr('data-headerbg', this.value);
  });

  $('input[name="sidebar_bg"]').on('click', function () {
    $('body').attr('data-sibebarbg', this.value);
  });
})(jQuery);

var currentStep = 1;
var updateProgressBar;

function displayStep(stepNumber) {
  if (stepNumber >= 1 && stepNumber <= 10) {
    $('.step-' + currentStep).hide();
    $('.step-' + stepNumber).show();
    currentStep = stepNumber;
    updateProgressBar();
  }
}

$(document).ready(function () {
  $('#multi-step-form').find('.step').slice(1).hide();

  $('.next-step').click(function () {
    if (currentStep < 10) {
      $('.step-' + currentStep).addClass('animate__animated animate__fadeOutLeft');
      currentStep++;
      setTimeout(function () {
        $('.step').removeClass('animate__animated animate__fadeOutLeft').hide();
        $('.step-' + currentStep)
          .show()
          .addClass('animate__animated animate__fadeInRight');
        updateProgressBar();
      }, 500);
    }
  });

  $('.prev-step').click(function () {
    if (currentStep > 1) {
      $('.step-' + currentStep).addClass('animate__animated animate__fadeOutRight');
      currentStep--;
      setTimeout(function () {
        $('.step').removeClass('animate__animated animate__fadeOutRight').hide();
        $('.step-' + currentStep)
          .show()
          .addClass('animate__animated animate__fadeInLeft');
        updateProgressBar();
      }, 500);
    }
  });

  updateProgressBar = function () {
    var progressPercentage = ((currentStep - 1) / 2) * 100;
    $('.progress-bar').css('width', progressPercentage + '%');
  };
});
